const dataSectores =[
  {"name": "CZCZ003","y": -13.520454,"x": -71.9801165},
  {"name": "LBLO049-F","y": "","x": ""},
  {"name": "TCNA120","y": -18.0079288009315,"x": -70.2463708445992},
  {"name": "TRUJ146","y": -8.102448,"x": -79.0482633263965},
  {"name": "MDPM018","y": -12.593505,"x": -69.2040718310429},
  {"name": "LMLC003","y": -12.0903875,"x": -77.0461448438897},
  {"name": "LMLC003","y": -12.0885535,"x": -77.0466817943015},
  {"name": "CZWQ013","y": -13.539489,"x": -71.9411154104},
  {"name": "ICAX079-F","y": -14.058545,"x": -75.7444066461034},
  {"name": "ZONA SATURADA","y": -12.029683,"x": -76.949728151481},
  {"name": "ILIL030-F","y": -17.650275,"x": -71.3268664456617},
  {"name": "LMCO186","y": -11.9237515,"x": -77.0431715},
  {"name": "LMHU010","y": -11.108704,"x": -77.6077943819618},
  {"name": "PIUR126","y": -5.1650485,"x": -80.6614865937891},
  {"name": "PIUR129","y": -5.174363,"x": -80.6348481091827},
  {"name": "LMHU010","y": -11.1087325,"x": -77.607137203373},
  {"name": "LMHU010","y": -11.10933,"x": -77.6066329869792},
  {"name": "TRLH011-S // TRLH011","y": -8.1352065,"x": -79.0496498200663},
  {"name": "CBNV059-S //CBNV059","y": -9.131364,"x": -78.5366714559158},
  {"name": "PIUR185-F","y": -5.182086,"x": -80.6761856534216},
  {"name": "CBCB013","y": -9.066741,"x": -78.5817676066434},
  {"name": "LMJL112","y": -11.9748885,"x": -77.0035736366822},
  {"name": "LMJM001","y": -12.089282,"x": -77.0576136410516},
  {"name": "ICSB010-F","y": -14.0210135,"x": -75.7487761571087},
  {"name": "MDPM020","y": -12.590938,"x": -69.1992995731783},
  {"name": "LMLV130-F","y": -12.0646495,"x": -77.0136353549046},
  {"name": "PUPU083-F","y": -15.8734585,"x": -69.9846971584821},
  {"name": "PUPU084-F","y": -15.87029465,"x": -69.9843144374722},
  {"name": "AQPP002","y": -16.40605,"x": -71.4762563724861},
  {"name": "AQBR020","y": -16.410365,"x": -71.5199272618551},
  {"name": "LMJM003","y": -12.084725,"x": -77.055685229317},
  {"name": "LAMO056","y": -12.0878485,"x": -76.9556092695046},
  {"name": "LMLV116-F","y": -12.066976,"x": -77.0139063224215},
  {"name": "LMJM003","y": -12.0820445,"x": -77.056673712726},
  {"name": "MQMN020-S // MQMN020","y": -17.2018235,"x": -70.918635741742},
  {"name": "LMMG013","y": -12.094158,"x": -77.0703726934634},
  {"name": "ZONA SATURADA","y": -12.1353835,"x": -76.9586011452353},
  {"name": "LMLO087","y": -11.95621,"x": -77.08059275},
  {"name": "TCNA037","y": -18.042498,"x": -70.2527843550818},
  {"name": "TRLH012-S // TRLH012","y": -8.1365135,"x": -79.0461686608093},
  {"name": "ANSA003-F","y": -8.9888385,"x": -78.619204539128},
  {"name": "MDIN001-F","y": -13.1008915,"x": -70.3728120184194},
  {"name": "PUDE002-F","y": -16.5637625,"x": -69.0472600630962},
  {"name": "TRLE037","y": -8.069084,"x": -79.06190084722},
  {"name": "PIUS002","y": -4.901774,"x": -80.7038947695965},
  {"name": "PIUR003","y": -5.1871695,"x": -80.6677773104917},
  {"name": "CJCJ098-F","y": -7.1530705,"x": -78.5052464943925},
  {"name": "LMVS011","y": -12.2035815,"x": -76.9528092887861},
  {"name": "PIUS004","y": -4.8986205,"x": -80.6965230729167},
  {"name": "LMCA140-F","y": -12.015027,"x": -77.1028595061728},
  {"name": "LMCO185","y": -11.9257745,"x": -77.0466988105061},
  {"name": "LMCO185","y": -11.9232305,"x": -77.0448672970738},
  {"name": "CHI124","y": -6.789266,"x": -79.86489920967},
  {"name": "LMPP015","y": -11.86732315,"x": -77.0777600533929},
  {"name": "LMPP068-F","y": -11.88202615,"x": -77.0652645121451},
  {"name": "HYTB004-S // HYTB004","y": -12.0633628,"x": -75.2169061486395},
  {"name": "LMLC003","y": -12.0901985,"x": -77.0436878503378},
  {"name": "LMSC061","y": -12.127864,"x": -76.9819617812957},
  {"name": "LMSC080","y": -12.1130475,"x": -76.9871213163583},
  {"name": "LMAG014-F","y": -12.031509,"x": -77.0003827983695},
  {"name": "LMSC090","y": -12.1278425,"x": -76.9766235058426},
  {"name": "JNTB005-F","y": -12.0329405,"x": -75.2313423562706},
  {"name": "LMJM007","y": -12.0781365,"x": -77.0534710154967},
  {"name": "LMLP019","y": -12.070709,"x": -77.1096005510471},
  {"name": "LMLV009-S","y": -12.0778245,"x": -77.0177406796379},
  {"name": "LMLV009","y": -12.078535,"x": -77.0181579137168},
  {"name": "LMLC019","y": -12.082102,"x": -77.033465377445},
  {"name": "LMCN014-F","y": -13.0652325,"x": -76.353624244979},
  {"name": "CHI091","y": -6.7889195,"x": -79.8332403409639},
  {"name": "LMAT022","y": -12.0329145,"x": -76.932249354945},
  {"name": "CHI091","y": -6.786785,"x": -79.8348312925926},
  {"name": "ICSB007","y": -14.0294865,"x": -75.7389069292743},
  {"name": "LAMO083","y": -12.1083195,"x": -76.9456697256365},
  {"name": "CHI066","y": -6.766949,"x": -79.8673143885387},
  {"name": "CHI066","y": -6.766917,"x": -79.8664226214286},
  {"name": "LAMO002","y": -12.0683125,"x": -76.9558067548383},
  {"name": "PIUR178-F","y": -5.182052,"x": -80.6741459424671},
  {"name": "LMSC086","y": -12.1126365,"x": -76.9835266222785},
  {"name": "LMSC103","y": -12.1131525,"x": -76.9692741284333},
  {"name": "LMSQ033-R","y": -12.1138815,"x": -77.0006938074534},
  {"name": "AQCC085-F","y": -16.3284115,"x": -71.5703394275743},
  {"name": "AQCC099-F","y": -16.3294075,"x": -71.5618138212444},
  {"name": "LMCH069-S // LMCH069","y": -12.198609,"x": -77.0007599369501},
  {"name": "LMMP149","y": -11.9973665,"x": -77.0932176689624},
  {"name": "TCNA110-S // TCNA110","y": -18.03402325,"x": -70.2798770496741},
  {"name": "JNCH002-F","y": -12.0844873,"x": -75.209693706643},
  {"name": "LMVS088-F","y": -12.2170935,"x": -76.9344544894004},
  {"name": "LMJL033","y": -12.0051725,"x": -77.0142719090909},
  {"name": "PIUR166-F","y": -5.1641045,"x": -80.6688041428571},
  {"name": "LMJL215-F","y": -12.007068,"x": -76.9967001431818},
  {"name": "PUPU085-F","y": -15.8777275,"x": -69.9814348611771},
  {"name": "TCNA075-S // TCNA075","y": -18.0061986957655,"x": -70.2226575302162},
  {"name": "ZONA SATURADA","y": -16.4318425,"x": -71.5096621292808},
  {"name": "ZONA SATURADA","y": -12.216086,"x": -76.948266975226},
  {"name": "LMVM054-F","y": -12.1969185,"x": -76.9253446083041},
  {"name": "LMVM039-F","y": -12.1640799,"x": -76.9428357486755},
  {"name": "ZONA SATURADA","y": -10.7593255,"x": -77.7544669849684},
  {"name": "MDIN005-F","y": -13.0891005,"x": -70.3636751355108},
  {"name": "LMVT038-F","y": -11.850635,"x": -77.1262055823083},
  {"name": "PIUC156-F","y": -5.22285,"x": -80.6228836050725},
  {"name": "LMCH084-R","y": -12.1738575,"x": -77.0244920411402},
  {"name": "PIUR150","y": -5.156386,"x": -80.6232270382772},
  {"name": "TRLE033","y": -8.067555,"x": -79.0669976105909},
  {"name": "ZONA SATURADA","y": -13.1876125,"x": -74.2164140081035},
  {"name": "TRLE034","y": -8.0665325,"x": -79.06503088547},
  {"name": "PIUR009","y": -5.185684,"x": -80.6532833762969},
  {"name": "ZONA SATURADA","y": -6.768447,"x": -79.8744192691131},
  {"name": "PIUC134","y": -5.1853005,"x": -80.5896985840249},
  {"name": "ZONA SATURADA","y": -16.3881295,"x": -71.5658169332711},
  {"name": "LMJR189-F","y": -12.186262,"x": -76.9829215795303},
  {"name": "CHI060","y": -6.7732175,"x": -79.8421208853432},
  {"name": "CHI093","y": -6.791521,"x": -79.8419613391084},
  {"name": "ZONA SATURADA","y": -12.1596525,"x": -76.9877614902597},
  {"name": "LBPI015-F","y": -6.795857,"x": -79.8810662},
  {"name": "LLMO003-F","y": -8.1705985,"x": -79.0075839333644},
  {"name": "LMMP257-F","y": -11.9568305,"x": -77.0977557314101},
  {"name": "ZONA SATURADA","y": -16.44254,"x": -71.6253744892164},
  {"name": "CJCJ014","y": -7.158475,"x": -78.5104712605042},
  {"name": "LBET002-F","y": -6.9064985,"x": -79.868512140625},
  {"name": "LMAS012-F","y": -12.779917,"x": -76.598705674459},
  {"name": "LMAS014-F","y": -12.784876,"x": -76.5910772424019},
  {"name": "LMPH017-F","y": -12.310097,"x": -76.8384791084343},
  {"name": "LBPI008-F","y": -6.7974873,"x": -79.8930566079225},
  {"name": "SMTC012-F","y": -8.197454,"x": -76.5125443417708},
  {"name": "CZST022-F","y": -13.5256665,"x": -71.9814878799469},
  {"name": "AQBR058-F","y": -16.4327365,"x": -71.5120732238129},
  {"name": "AQMJ008-F","y": -16.3505794,"x": -72.1887914271816},
  {"name": "ZONA SATURADA","y": -16.3510535,"x": -72.1914044547003},
  {"name": "LBTU012-F","y": -6.752186,"x": -79.70167025},
  {"name": "ILIL026-F","y": -17.64695,"x": -71.3412237751447},
  {"name": "CHI088-S // CHI088","y": -6.78024,"x": -79.8334614134897},
  {"name": "AQAQ010-S // AQAQ010","y": -16.4039115,"x": -71.5294445931503},
  {"name": "AQLJ009-F","y": -16.4295775,"x": -71.8228632646493},
  {"name": "AQLJ010-F","y": -16.426364,"x": -71.8161248776548},
  {"name": "AQLJ011-F","y": -16.423959,"x": -71.8183432857493},
  {"name": "LBTU012-F","y": -6.752021,"x": -79.7042009719828},
  {"name": "AQLJ012-F","y": -16.4219635,"x": -71.811060832918},
  {"name": "SMTC003-F","y": -8.1843275,"x": -76.516776588686},
  {"name": "SMTC005-F","y": -8.1879475,"x": -76.5111167429907},
  {"name": "SMTC006-F","y": -8.187893,"x": -76.5141279234331},
  {"name": "LMSA056-F","y": -12.039052,"x": -76.9507365132692},
  {"name": "APAB029-F","y": -13.6389415,"x": -72.9014434805195},
  {"name": "SMTC009-F","y": -8.1892225,"x": -76.5116258167749},
  {"name": "LMPH016-F","y": -12.309705,"x": -76.8365780183673},
  {"name": "AQSB052-F","y": -16.4726257,"x": -71.5297710454357},
  {"name": "APTB004-F","y": -13.615936,"x": -72.8690899458204},
  {"name": "APTB005-F","y": -13.6153955,"x": -72.8721153000135},
  {"name": "APAB030-F","y": -13.6384645,"x": -72.8985186068549},
  {"name": "APAB031-F","y": -13.635285,"x": -72.897971925708},
  {"name": "APAB032-F","y": -13.6300965,"x": -72.8916925455445},
  {"name": "APAB033-F","y": -13.6337325,"x": -72.8883586369719},
  {"name": "AQMF033-F","y": -16.37789775,"x": -71.4950315821249},
  {"name": "APAB034-F","y": -13.6204725,"x": -72.8838763765},
  {"name": "APAB035-F","y": -13.6215495,"x": -72.8809519379993},
  {"name": "APAB036-F","y": -13.624508,"x": -72.8861121012954},
  {"name": "APTB001-F","y": -13.6178775,"x": -72.8774520963543},
  {"name": "MQMN065-F","y": -17.1957515,"x": -70.9618752637159},
  {"name": "LLSA008-F","y": -8.1859785,"x": -78.9870312612168},
  {"name": "APTB002-F","y": -13.622682,"x": -72.8757788919179},
  {"name": "APTB003-F","y": -13.6197445,"x": -72.8685906116453},
  {"name": "LBEP002-F","y": -6.928138,"x": -79.8659087654291},
  {"name": "LBEP001-F","y": -6.924679,"x": -79.867423016193},
  {"name": "AQCA040-F","y": -16.3350635,"x": -71.5420934031723},
  {"name": "APAB021-F","y": -13.6359055,"x": -72.8885276399254},
  {"name": "LLOT001-F","y": -7.903112,"x": -78.5694566901872},
  {"name": "LLOT002-F","y": -7.900168,"x": -78.5677503587404},
  {"name": "LLOT003-F","y": -7.904723,"x": -78.5667860559998},
  {"name": "ZONA SATURADA","y": -16.332144,"x": -71.5416168917241},
  {"name": "LMLV007","y": -12.073289,"x": -77.015708099972},
  {"name": "LLOT004-F","y": -7.903851,"x": -78.5645109270431},
  {"name": "LMSC028-S","y": -12.125547,"x": -76.9876902485737},
  {"name": "LLOT005-F","y": -7.908009,"x": -78.5637455843818},
  {"name": "LLOT006-F","y": -7.9045105,"x": -78.562296393094},
  {"name": "AQCM005-F","y": -16.622048,"x": -72.7133854909091},
  {"name": "LLOT007-F","y": -7.9018595,"x": -78.5612518111607},
  {"name": "LLOT008-F","y": -7.905253,"x": -78.5597880679157},
  {"name": "ZONA SATURADA","y": -13.5243285,"x": -71.9825174067448},
  {"name": "CBCB009-S","y": -9.0602345,"x": -78.5880640878086},
  {"name": "CBCB009","y": -9.0615515,"x": -78.586099133273},
  {"name": "AQMD013-F","y": -17.0292645,"x": -72.0153604488157},
  {"name": "AQMN001-F","y": -15.9793585,"x": -73.1744470385652},
  {"name": "ZONA SATURADA","y": -15.9799845,"x": -73.1723624594059},
  {"name": "ZONA SATURADA","y": -15.97938535,"x": -73.1732705147137},
  {"name": "AQSC019-F","y": -16.406932,"x": -71.5690364002329},
  {"name": "ZONA SATURADA","y": -16.408832,"x": -71.5683228719694},
  {"name": "AQSC020-F","y": -16.411004,"x": -71.5693744090909},
  {"name": "AQUC001-F","y": -16.44196,"x": -71.6242194701123},
  {"name": "ZONA SATURADA","y": -16.443371,"x": -71.6252003421223},
  {"name": "AYCA007-F","y": -13.18531,"x": -74.2151642686357},
  {"name": "AYHU009-F","y": -12.9422665,"x": -74.2440267842044},
  {"name": "CZSS036-F","y": -13.544156,"x": -71.9412648191601},
  {"name": "ZONA SATURADA","y": -13.5440895,"x": -71.942114080402},
  {"name": "CZST020-F","y": -13.5245395,"x": -71.9877670372753},
  {"name": "HNRP002-F","y": -9.296218,"x": -75.997633193427},
  {"name": "HNRP004-F","y": -9.2991415,"x": -75.9994713538982},
  {"name": "LBCH005-F","y": -6.7633425,"x": -79.828908082512},
  {"name": "LBCH011-F","y": -6.7647695,"x": -79.8493089327376},
  {"name": "LBCH012-F","y": -6.764306,"x": -79.84701325611},
  {"name": "ZONA SATURADA","y": -6.7659785,"x": -79.8466675848732},
  {"name": "LMSA064-F","y": -12.029776,"x": -76.949309153217},
  {"name": "LBCH014-F","y": -6.7593295,"x": -79.8650784992997},
  {"name": "LBCH024-F","y": -6.7688,"x": -79.8756851801706},
  {"name": "LBPI001-F","y": -6.792415,"x": -79.8918089942138},
  {"name": "LBPI002-F","y": -6.8057945,"x": -79.8837769660019},
  {"name": "LLHM006-F","y": -7.81645,"x": -78.0456803589722},
  {"name": "LLLE006-F","y": -8.0552475,"x": -79.0533544620132},
  {"name": "LLMO002-F","y": -8.1685335,"x": -79.0080418273148},
  {"name": "LLMO004-F","y": -8.1734205,"x": -79.0085254237938},
  {"name": "LLMO007-F","y": -8.1811085,"x": -79.0136827550887},
  {"name": "LMAG017-F","y": -12.035013,"x": -76.9992606629504},
  {"name": "ZONA SATURADA","y": -12.034687,"x": -77.0004023359031},
  {"name": "LMAT077-F","y": -12.05197,"x": -76.9581068472222},
  {"name": "LMAT077-F","y": -12.0526685,"x": -76.9558218594112},
  {"name": "LMAT081-F","y": -12.029308,"x": -76.9406877956757},
  {"name": "LMAT083-F","y": -12.029107,"x": -76.9356672806854},
  {"name": "ZONA SATURADA","y": -12.0280485,"x": -76.9325606958481},
  {"name": "LMAT221-F","y": -12.0573865,"x": -76.9604617374084},
  {"name": "LMAT221-F","y": -12.0599395,"x": -76.9558689087724},
  {"name": "ZONA SATURADA","y": -12.0576275,"x": -76.9614994291813},
  {"name": "ZONA SATURADA","y": -12.0586835,"x": -76.9599586815025},
  {"name": "LMBV034-F","y": -12.066343,"x": -77.1305674996935},
  {"name": "LMJL086-S // LMJL086","y": -11.9999985,"x": -77.0028981327617},
  {"name": "LMJR110-F","y": -12.146227,"x": -76.9692393123471},
  {"name": "LMJR126-F","y": -12.1361475,"x": -76.9566816711443},
  {"name": "LMSC372-F","y": -12.1567975,"x": -76.9948154703237},
  {"name": "LMSC372-F","y": -12.1582545,"x": -76.9945063848446},
  {"name": "ZONA SATURADA","y": -12.1579355,"x": -76.9952204808305},
  {"name": "LMSQ166-F","y": -12.1102605,"x": -77.0141396618009},
  {"name": "MQIL001-F","y": -17.6540675,"x": -71.3272264792676},
  {"name": "AQCA016","y": -16.3528025,"x": -71.5418985105356},
  {"name": "AQCC010-S // AQCC010","y": -16.382931,"x": -71.5550858317181},
  {"name": "LMAS015-F","y": -12.76835675,"x": -76.6076043816296},
  {"name": "AQCC005","y": -16.374786,"x": -71.5584032364865},
  {"name": "LLSA001-F","y": -8.211566,"x": -78.9759121929375},
  {"name": "LLSA002-F","y": -8.2141095,"x": -78.9790518741795},
  {"name": "LLSA003-F","y": -8.21741,"x": -78.9784009377352},
  {"name": "LLSA004-F","y": -8.2198155,"x": -78.9759219388603},
  {"name": "LLSA005-F","y": -8.2226345,"x": -78.9773022523678},
  {"name": "LLSA006-F","y": -8.220845,"x": -78.9742718991511},
  {"name": "LLSA007-F","y": -8.188113,"x": -78.9860715397351},
  {"name": "LMAS013-F","y": -12.7805295,"x": -76.5962655460204},
  {"name": "LLMO009-F","y": -8.1800915,"x": -78.992665948135},
  {"name": "LLMO010-F","y": -8.182697,"x": -78.9895505826594},
  {"name": "LLMO011-F","y": -8.1850265,"x": -78.9889671457451},
  {"name": "LLMO012-F","y": -8.182323,"x": -78.9942211671304},
  {"name": "LLMO013-F","y": -8.1853095,"x": -78.992116723179},
  {"name": "LLMO008-F","y": -8.178098,"x": -78.9952340611154},
  {"name": "ICSB001","y": -14.041249,"x": -75.7499740284091},
  {"name": "LMAS016-F","y": -12.748649,"x": -76.6252415105126},
  {"name": "ICSB002","y": -14.0374475,"x": -75.7508537252919},
  {"name": "ICSB003","y": -14.03757,"x": -75.7486044077421},
  {"name": "LMLR025-F","y": -12.2770785,"x": -76.833470322326},
  {"name": "JNHY002-F","y": -12.0450995,"x": -75.1951611307447},
  {"name": "CHPI001-S // CHPI001","y": -6.8384645,"x": -79.9353967434668},
  {"name": "LLLH009-F","y": -8.142062,"x": -79.0329637714514},
  {"name": "TRLH015-S // TRLH015","y": -8.143118,"x": -79.0309913867248},
  {"name": "SMRJ007-F","y": -6.0487645,"x": -77.1709397649182},
  {"name": "CJCJ043","y": -7.1797805,"x": -78.5005495210368},
  {"name": "AYAY017-S // AYAY017","y": -13.153447,"x": -74.2291197972143},
  {"name": "MQMN042-F","y": -17.198984,"x": -70.9482695959348},
  {"name": "SMTC008-F","y": -8.1912385,"x": -76.5258411},
  {"name": "SMTC013-F","y": -8.197052,"x": -76.5166920254657},
  {"name": "SMTC014-F","y": -8.198911,"x": -76.52188999305},
  {"name": "LMMF206-F","y": -12.1123495,"x": -77.0376620233517},
  {"name": "LMPH009-F","y": -12.3378435,"x": -76.8202503330761},
  {"name": "LMVS191-F","y": -12.2396465,"x": -76.9215509189768},
  {"name": "LMVS192-F","y": -12.2440675,"x": -76.9247942728255},
  {"name": "LMVS193-F","y": -12.243303,"x": -76.922197002331},
  {"name": "LMVS200-F","y": -12.2299355,"x": -76.9111927033987},
  {"name": "LMJR195-F","y": -12.1643295,"x": -76.9528361262122},
  {"name": "LMMP258-F","y": -11.957745,"x": -77.0996453548057},
  {"name": "LMMP259-F","y": -11.960581,"x": -77.1018537344891},
  {"name": "LMJL250-F","y": -11.9522665,"x": -76.9934036919386},
  {"name": "LMJL249-F","y": -11.953134,"x": -76.9952880580169},
  {"name": "LMJR015-S // LMJR015","y": -12.156645,"x": -76.9610439123219},
  {"name": "LMJR191-F","y": -12.131314,"x": -76.9635262763348},
  {"name": "LMAS017-F","y": -12.748258,"x": -76.6274212117117},
  {"name": "LMJR192-F","y": -12.1338295,"x": -76.9678585237676},
  {"name": "LMJR193-F","y": -12.1361565,"x": -76.9683624809184},
  {"name": "LMJR194-F","y": -12.160278,"x": -76.956025582411},
  {"name": "SMTC011-F","y": -8.192819,"x": -76.5184537522158},
  {"name": "LMLO043","y": -11.982449,"x": -77.0710877110904},
  {"name": "SMTC007-F","y": -8.190926,"x": -76.521656827965},
  {"name": "CJCJ020","y": -7.14894,"x": -78.5010360837934},
  {"name": "CJCJ030","y": -7.148448,"x": -78.5211444414894},
  {"name": "CJCJ030","y": -7.147589,"x": -78.5184701675803},
  {"name": "CJCJ032-S // CJCJ032","y": -7.147666,"x": -78.51602999628},
  {"name": "CJCJ029","y": -7.150949,"x": -78.5227964451579},
  {"name": "CJCJ029","y": -7.1515975,"x": -78.5213200430303},
  {"name": "CJCJ029","y": -7.1521645,"x": -78.5239949762526},
  {"name": "CJCJ029","y": -7.15374385,"x": -78.5226260414288},
  {"name": "CJCJ014","y": -7.158364,"x": -78.5071343625543},
  {"name": "LMLO042-S","y": -11.9817305,"x": -77.0691400897513},
  {"name": "AYJN007-S // AYJN007","y": -13.1544965,"x": -74.2152634294889},
  {"name": "LMSN001-F","y": -12.579216,"x": -76.6890014047126},
  {"name": "LBET005-F","y": -6.908888,"x": -79.8638707064751},
  {"name": "LBET003-F","y": -6.9048425,"x": -79.8630219619145},
  {"name": "CHI019-S // CHI019","y": -6.7679325,"x": -79.8586618954808},
  {"name": "LMPH006-F","y": -12.33032155,"x": -76.8302615372265},
  {"name": "LMPH007-F","y": -12.32511685,"x": -76.8342057745162},
  {"name": "PIUR200-F","y": -5.158392,"x": -80.6549697651905},
  {"name": "PUYN002-F","y": -16.256599,"x": -69.0986611998274},
  {"name": "PUYN001-F","y": -16.2513245,"x": -69.101238798418},
  {"name": "AQSA048-F","y": -16.3701087809434,"x": -71.5212401467374},
  {"name": "PUYN008-F","y": -16.251327,"x": -69.0909992764878},
  {"name": "LBPO007-F","y": -6.7547755,"x": -79.7734237860892},
  {"name": "LAMO007","y": -12.0683005,"x": -76.9479215580106},
  {"name": "PUYN011-F","y": -16.2488655,"x": -69.0887315204514},
  {"name": "PUYN014-F","y": -16.2521095,"x": -69.0849310421836},
  {"name": "PUYN009-F","y": -16.241583,"x": -69.0925677487715},
  {"name": "MDIN002-F","y": -13.101962,"x": -70.3686256931015},
  {"name": "PUYN012-F","y": -16.2404305,"x": -69.088751396479},
  {"name": "PUYN006-F","y": -16.2466945,"x": -69.092290119932},
  {"name": "JNTB050-F","y": -12.0497035,"x": -75.209379684028},
  {"name": "PUYN007-F","y": -16.2491695,"x": -69.0934821250562},
  {"name": "PUYN010-F","y": -16.2448415,"x": -69.0901181551714},
  {"name": "MDIN003-F","y": -13.096028,"x": -70.3691601295597},
  {"name": "PUYN013-F","y": -16.2446145,"x": -69.0852623718562},
  {"name": "PUYN003-F","y": -16.2476805,"x": -69.0965261810704},
  {"name": "PUYN004-F","y": -16.2543085,"x": -69.0933791399655},
  {"name": "PUYN005-F","y": -16.24509,"x": -69.0947595198666},
  {"name": "AQSA042-F","y": -16.3650614465311,"x": -71.5298902008241},
  {"name": "AQSA044-F","y": -16.3580331724343,"x": -71.5253409898625},
  {"name": "AQSA047-F","y": -16.3626414952646,"x": -71.5150532561995},
  {"name": "AQCC156-F","y": -16.3823544597129,"x": -71.5671284516875},
  {"name": "AQCC157-F","y": -16.3842427456796,"x": -71.5542577528437},
  {"name": "AQCC150-F","y": -16.3333915195867,"x": -71.5891457613937},
  {"name": "HYTB074-F","y": -12.059728,"x": -75.2235045879425},
  {"name": "AQCC152-F","y": -16.3855558889959,"x": -71.5778073840676},
  {"name": "AQCC148-F","y": -16.3223426712906,"x": -71.5983669262869},
  {"name": "AQCC151-F","y": -16.3701498662151,"x": -71.5659914489089},
  {"name": "PUHN004-F","y": -15.1991095249501,"x": -69.7638024106627},
  {"name": "AQCC153-F","y": -16.3537704229788,"x": -71.5565994109942},
  {"name": "AQCC146-F","y": -16.3916928207026,"x": -71.5580266183566},
  {"name": "PUHN001-F","y": -15.203601,"x": -69.7713092629093},
  {"name": "LLLH007-F","y": -8.1472105,"x": -79.0507345570426},
  {"name": "PUHN002-F","y": -15.198732,"x": -69.7675730519767},
  {"name": "PUHN003-F","y": -15.201693,"x": -69.7649652770645},
  {"name": "PUHN005-F","y": -15.204844,"x": -69.7611762863512},
  {"name": "PUHN006-F","y": -15.1986979,"x": -69.760181982464},
  {"name": "CJCJ014-S","y": -7.1589365,"x": -78.5086105999582},
  {"name": "PUHN007-F","y": -15.202195,"x": -69.7598410367647},
  {"name": "TCTR001-F","y": -17.48107,"x": -70.0344199433962},
  {"name": "AQMF032-F","y": -16.380764,"x": -71.5016210102638},
  {"name": "CJCJ022-S // CJCJ022","y": -7.151617,"x": -78.510109407541},
  {"name": "CJCJ018-S // CJCJ018","y": -7.1553175,"x": -78.5108733098126},
  {"name": "CJCJ019-S // CJCJ019","y": -7.15483,"x": -78.5082360202775},
  {"name": "LMAS018-F","y": -12.7461145,"x": -76.6295138436414},
  {"name": "LMAS009-F","y": -12.7823105,"x": -76.5938768923259},
  {"name": "PUZP002-F","y": -16.496353,"x": -69.1038040738217},
  {"name": "CJCJ008-S","y": -7.168359,"x": -78.5027734995588},
  {"name": "CJCJ008","y": -7.1702015,"x": -78.5021405553846},
  {"name": "CJCJ008","y": -7.169773,"x": -78.5006835246034},
  {"name": "CJCJ008","y": -7.168359,"x": -78.5012424973159},
  {"name": "CJCJ008","y": -7.1659305,"x": -78.5034635596713},
  {"name": "CHI029-S // CHI029","y": -6.782278,"x": -79.8467592100519},
  {"name": "CHI010-S // CHI010","y": -6.7846495,"x": -79.8664451296101},
  {"name": "LBTU011-F","y": -6.749291,"x": -79.7049874106896},
  {"name": "CHI012-S // CHI012","y": -6.770961,"x": -79.8578151845697},
  {"name": "CHI025-S // CHI025","y": -6.78571,"x": -79.8450988554013},
  {"name": "CHI020-S // CHI020","y": -6.781014,"x": -79.8428514922776},
  {"name": "LMLO020-S // LMLO020","y": -12.0014705,"x": -77.0779407448963},
  {"name": "LMMP043-S // LMMP043","y": -12.029297,"x": -77.0908698738709},
  {"name": "LBTU012-F","y": -6.7527975,"x": -79.7034030778576},
  {"name": "PUZP001-F","y": -16.4965025,"x": -69.1064652316066},
  {"name": "LBTU008-F","y": -6.747104,"x": -79.7052642857143},
  {"name": "LBTU009-F","y": -6.7467015,"x": -79.6979493647622},
  {"name": "LBTU010-F","y": -6.7487645,"x": -79.7025538697266},
  {"name": "LBTU010-F","y": -6.7494575,"x": -79.6997668710937},
  {"name": "LBTU010-F","y": -6.7498625,"x": -79.7023877237569},
  {"name": "LBTU010-F","y": -6.7500245,"x": -79.7005808783784},
  {"name": "LBTU010-F","y": -6.747102,"x": -79.70138805},
  {"name": "MDIN004-F","y": -13.094486,"x": -70.3660666541494},
  {"name": "LBTU012-F","y": -6.7516245,"x": -79.7010338811112},
  {"name": "LBTU013-F","y": -6.7518765,"x": -79.6978870227273},
  {"name": "ANCM003-F","y": -9.4768665,"x": -78.3034416274034},
  {"name": "TCTR003-F","y": -17.4728155,"x": -70.0309038256223},
  {"name": "LMMP285-F","y": -12.0275715,"x": -77.0502326286765},
  {"name": "TCTR002-F","y": -17.476617,"x": -70.0328154193751},
  {"name": "LMJM089-F","y": -12.0782455,"x": -77.0437514246907},
  {"name": "LMJM087-F","y": -12.0756405,"x": -77.0388992428493},
  {"name": "LMVS181-F","y": -12.235813,"x": -76.9335605196027},
  {"name": "LMMP281-F","y": -12.0299375,"x": -77.058713465573},
  {"name": "LMVS179-F","y": -12.2350035,"x": -76.9364711647795},
  {"name": "LMMP284-F","y": -12.024388,"x": -77.0512744780702},
  {"name": "TRLH008","y": -8.142004,"x": -79.0461295650656},
  {"name": "LMJL041","y": -12.011828,"x": -77.002739338593},
  {"name": "LMJM091-F","y": -12.072823,"x": -77.0410458426854},
  {"name": "CHI019-S // CHI019","y": -6.765484,"x": -79.8603710821704},
  {"name": "TRLH022-S // TRLH022","y": -8.133305,"x": -79.0441894329845},
  {"name": "CHI038-S // CHI038","y": -6.7684765,"x": -79.849481896237},
  {"name": "CHI018-S // CHI018","y": -6.762263,"x": -79.8557289027778},
  {"name": "CHI014-S // CHI014","y": -6.7655,"x": -79.8546752414168},
  {"name": "CHI046-S // CHI046","y": -6.76504,"x": -79.834968915392},
  {"name": "CHI046-S // CHI046","y": -6.7681435,"x": -79.8350318599764},
  {"name": "TRLH024-S // TRLH024","y": -8.130283,"x": -79.0467252246031},
  {"name": "CHI042-S // CHI042","y": -6.765993,"x": -79.8448359166667},
  {"name": "CHI035-S // CHI035","y": -6.7675945,"x": -79.829852372},
  {"name": "CHI035-S // CHI035","y": -6.768912,"x": -79.8311474686302},
  {"name": "PUJU001-F","y": -16.221186,"x": -69.4813816979247},
  {"name": "PUJU002-F","y": -16.218554,"x": -69.4753194800597},
  {"name": "PUJU003-F","y": -16.2192575,"x": -69.4697821380595},
  {"name": "PUJU004-F","y": -16.2191645,"x": -69.4650621354716},
  {"name": "PUJU005-F","y": -16.2150285,"x": -69.4644084367407},
  {"name": "PUJU006-F","y": -16.2168995,"x": -69.4628166691176},
  {"name": "PUJU007-F","y": -16.2124315,"x": -69.4611263347254},
  {"name": "PUJU008-F","y": -16.215272,"x": -69.4585127772749},
  {"name": "TRLH025-S // TRLH025","y": -8.12831715,"x": -79.0451124254906},
  {"name": "TRLH026-S // TRLH026","y": -8.129714,"x": -79.0412590405007},
  {"name": "PUJU009-F","y": -16.2140295,"x": -69.4564003095339},
  {"name": "PUJU010-F","y": -16.208655,"x": -69.4561320906682},
  {"name": "LMSC438-F","y": -12.149993,"x": -76.9869851092259},
  {"name": "CHI050-S // CHI050","y": -6.7724195,"x": -79.8412755102153},
  {"name": "LMAG071-F","y": -12.0502318,"x": -76.9972050130917},
  {"name": "HNCG002-F","y": -9.286828,"x": -76.0085207043269},
  {"name": "TRLH027-S // TRLH027","y": -8.1306365,"x": -79.0384853995278},
  {"name": "ICAX059-S // ICAX059","y": -14.096114,"x": -75.7496548208705},
  {"name": "HNRP001-F","y": -9.294232,"x": -75.9969740767832},
  {"name": "ZONA SATURADA","y": -9.296815,"x": -75.9972759709686},
  {"name": "ZONA SATURADA","y": -9.2959395,"x": -75.997809131864},
  {"name": "ZONA SATURADA","y": -9.295345,"x": -75.9977523667076},
  {"name": "ZONA SATURADA","y": -9.2958545,"x": -75.9983651710784},
  {"name": "LMJL197-F","y": -11.961454,"x": -77.0011662352941},
  {"name": "HNRP003-F","y": -9.2975185,"x": -76.0009735011231},
  {"name": "ZONA SATURADA","y": -9.300956,"x": -75.9999799545455},
  {"name": "ZONA SATURADA","y": -9.297583,"x": -75.999168660765},
  {"name": "HNRP005-F","y": -9.303012,"x": -76.0019473104396},
  {"name": "HNRP006-F","y": -9.301078,"x": -76.0031459178424},
  {"name": "TRLH127-S // TRLH127","y": -8.135623,"x": -79.037437663679},
  {"name": "HNCG001-F","y": -9.293585,"x": -76.0078679228787},
  {"name": "TBCR001-F","y": -3.6001692,"x": -80.4813538699009},
  {"name": "AQAQ024-S // AQAQ024","y": -16.4060355,"x": -71.5492311175539},
  {"name": "LBPO002-F","y": -6.767807,"x": -79.790402125576},
  {"name": "LBPO003-F","y": -6.76810905,"x": -79.7880523457246},
  {"name": "LBPO004-F","y": -6.752232,"x": -79.7790682785906},
  {"name": "LBPO005-F","y": -6.7527555,"x": -79.7763948337434},
  {"name": "LBPO006-F","y": -6.7530177,"x": -79.7733564139983},
  {"name": "LBCH052-F","y": -6.766868,"x": -79.7931471368853},
  {"name": "TBCR002-F","y": -3.602884,"x": -80.4809216889167},
  {"name": "LLLH002-F","y": -8.1240655,"x": -79.0466269648288},
  {"name": "TRLH003-S // TRLH003","y": -8.145138,"x": -79.0535064104886},
  {"name": "TRLH004-S // TRLH004","y": -8.142225,"x": -79.0562084314364},
  {"name": "TRLH005-S // TRLH005","y": -8.1392755,"x": -79.0598880011361},
  {"name": "TRLH006-S // TRLH006","y": -8.1461135,"x": -79.0479926546145},
  {"name": "TRLH007-S // TRLH007","y": -8.1429335,"x": -79.0517031938526},
  {"name": "LLLH008-F","y": -8.1496105,"x": -79.0485778482202},
  {"name": "TRLH009","y": -8.1403235,"x": -79.04943282595},
  {"name": "TRLH010-S // TRLH010","y": -8.1343865,"x": -79.0518869111808},
  {"name": "TRLH013-S // TRLH013","y": -8.139188,"x": -79.0417125307753},
  {"name": "TRLH014-S // TRLH014","y": -8.140946,"x": -79.0378323906099},
  {"name": "TRLH016-S // TRLH016","y": -8.1392205,"x": -79.0303158570618},
  {"name": "TRLH019","y": -8.13646,"x": -79.0303050539585},
  {"name": "TRLH020-S // TRLH020","y": -8.135726,"x": -79.0343532050498},
  {"name": "TRLH021-S // TRLH021","y": -8.1343655,"x": -79.0407175258879},
  {"name": "TRLH128","y": -8.1452185,"x": -79.0445647277755},
  {"name": "TRLH028-S // TRLH028","y": -8.130897,"x": -79.0358891606679},
  {"name": "TRLH029-S // TRLH029","y": -8.13961415,"x": -79.0554607090651},
  {"name": "TRLH030","y": -8.138624,"x": -79.0278343098265},
  {"name": "AMBA001-F","y": -5.634945,"x": -78.5353178640617},
  {"name": "AMBA002-F","y": -5.6386855,"x": -78.5349150583723},
  {"name": "AMBA003-F","y": -5.641132,"x": -78.5336191261183},
  {"name": "AMBA004-F","y": -5.6327835,"x": -78.5324924175297},
  {"name": "ANSA003-F","y": -8.9867005,"x": -78.6192981218862},
  {"name": "AMBA005-F","y": -5.6358385,"x": -78.5314526068815},
  {"name": "AMBA006-F","y": -5.6355345,"x": -78.5276242992634},
  {"name": "AMBA007-F","y": -5.6392485,"x": -78.5273537788221},
  {"name": "AMBA008-F","y": -5.6412115,"x": -78.528915760132},
  {"name": "AMBA009-F","y": -5.6316855,"x": -78.5301875123051},
  {"name": "AMBA010-F","y": -5.63626,"x": -78.5241019783654},
  {"name": "LBLO052-F","y": -6.7617725,"x": -79.8304464328358},
  {"name": "AMBA011-F","y": -5.637432,"x": -78.5211739289009},
  {"name": "AMBA012-F","y": -5.6428625,"x": -78.5236034822917},
  {"name": "LMVS125-F","y": -12.197149,"x": -76.9415461595975},
  {"name": "ANSA004-F","y": -8.984518,"x": -78.6131722799889},
  {"name": "AMBA013-F","y": -5.6449712,"x": -78.5252189277891},
  {"name": "AMBA014-F","y": -5.639051,"x": -78.5407897976951},
  {"name": "ANSA001-F","y": -8.997302,"x": -78.6169235042373},
  {"name": "ANSA001-F","y": -8.9937955,"x": -78.614093463356},
  {"name": "ANSA002-F","y": -8.9889295,"x": -78.6143215902633},
  {"name": "PIUR181-F","y": -5.180428,"x": -80.6829623452381},
  {"name": "ANSA005-F","y": -8.9883045,"x": -78.6121826532951},
  {"name": "ANSA006-F","y": -8.9870115,"x": -78.6102540111029},
  {"name": "ANSA007-F","y": -8.98186695,"x": -78.6009944544783},
  {"name": "ANSA007-F","y": -8.983731,"x": -78.6049097845345},
  {"name": "CJCJ042","y": -7.177001,"x": -78.5014579716261},
  {"name": "AMBG001-F","y": -5.7560255,"x": -78.4537974981343},
  {"name": "AMBG002-F","y": -5.7514785,"x": -78.4504046923311},
  {"name": "AMBG003-F","y": -5.753159,"x": -78.4469423744005},
  {"name": "AMBG004-F","y": -5.757346,"x": -78.4502537914831},
  {"name": "AMBG005-F","y": -5.755102,"x": -78.4443872967359},
  {"name": "ICAX060-S // ICAX060","y": -14.0920905,"x": -75.7473899530176},
  {"name": "LBLO001-F","y": -6.7481175,"x": -79.8350942249429},
  {"name": "AMBG006-F","y": -5.7581495,"x": -78.4458273021739},
  {"name": "AMBG007-F","y": -5.7611595,"x": -78.4483303273729},
  {"name": "AMBG008-F","y": -5.7548085,"x": -78.4402617723853},
  {"name": "AMBG009-F","y": -5.758525,"x": -78.4402975476744},
  {"name": "AMBG010-F","y": -5.757914,"x": -78.4369602080137},
  {"name": "AMBG011-F","y": -5.758728,"x": -78.4330299115696},
  {"name": "AMBG012-F","y": -5.760168,"x": -78.4266378610561},
  {"name": "AMBG013-F","y": -5.767085,"x": -78.4536160754397},
  {"name": "AMBG014-F","y": -5.768489,"x": -78.4506190715229},
  {"name": "LBLO008-F","y": -6.7565655,"x": -79.8381637417061},
  {"name": "AMBG015-F","y": -5.7685385,"x": -78.448136252311},
  {"name": "AMBG016-F","y": -5.764507,"x": -78.4460259783709},
  {"name": "AMBG017-F","y": -5.7618,"x": -78.4404090495156},
  {"name": "AMBG018-F","y": -5.762552,"x": -78.435085160812},
  {"name": "LBLO006-F","y": -6.7545825,"x": -79.8332711875241},
  {"name": "ICAX061","y": -14.0884005,"x": -75.7474514830345},
  {"name": "AMBG019-F","y": -5.76629185,"x": -78.4310165969327},
  {"name": "LBLO002-F","y": -6.7494045,"x": -79.8328759931274},
  {"name": "LBLO003-F","y": -6.751568,"x": -79.8352259203008},
  {"name": "LBLO004-F","y": -6.752062,"x": -79.8325877516287},
  {"name": "LBLO005-F","y": -6.7546585,"x": -79.8354984963735},
  {"name": "LBLO007-F","y": -6.7551315,"x": -79.8311547616449},
  {"name": "LBLO009-F","y": -6.758107,"x": -79.8382470775071},
  {"name": "LBLO010-F","y": -6.7581495,"x": -79.8405611289025},
  {"name": "LBLO011-F","y": -6.7565655,"x": -79.840305798212},
  {"name": "LBLO012-F","y": -6.7543725,"x": -79.8391904878671},
  {"name": "LBLO013-F","y": -6.75229,"x": -79.8388761863185},
  {"name": "LBLO014-F","y": -6.7557315,"x": -79.8424838841887},
  {"name": "LBLO015-F","y": -6.7532345,"x": -79.8416912857634},
  {"name": "LBLO016-F","y": -6.752542,"x": -79.8430366835227},
  {"name": "LBLO017-F","y": -6.7527685,"x": -79.8450359780781},
  {"name": "LBLO018-F","y": -6.7549975,"x": -79.8447382387987},
  {"name": "LBLO019-F","y": -6.7514255,"x": -79.8472771997273},
  {"name": "LBLO020-F","y": -6.7549855,"x": -79.8482391396361},
  {"name": "LBLO021-F","y": -6.7564,"x": -79.8485959148462},
  {"name": "LBLO053-F","y": -6.75789865,"x": -79.8225583877832},
  {"name": "LBLO022-F","y": -6.758244,"x": -79.8490554003651},
  {"name": "LBLO023-F","y": -6.760467,"x": -79.8483825277778},
  {"name": "LBLO024-F","y": -6.750058,"x": -79.8519244591242},
  {"name": "LBLO025-F","y": -6.753324,"x": -79.8522959117499},
  {"name": "LBLO026-F","y": -6.7573805,"x": -79.8520141982096},
  {"name": "LBLO027-F","y": -6.7577775,"x": -79.8547250183943},
  {"name": "LBLO028-F","y": -6.752045,"x": -79.8258914627242},
  {"name": "LBCH010-F","y": -6.771749,"x": -79.8289929521101},
  {"name": "LBLO029-F","y": -6.751321,"x": -79.8286070367647},
  {"name": "LBLO030-F","y": -6.753073,"x": -79.8289445657182},
  {"name": "LBLO031-F","y": -6.755572,"x": -79.8264340189908},
  {"name": "LBLO032-F","y": -6.75577,"x": -79.8239082847368},
  {"name": "LBCH019-F","y": -6.766181,"x": -79.8703954249603},
  {"name": "LBLO033-F","y": -6.7598415,"x": -79.8268578793413},
  {"name": "LBLO034-F","y": -6.756339,"x": -79.8286375997666},
  {"name": "LBLO035-F","y": -6.75948,"x": -79.8299569117397},
  {"name": "LBLO036-F","y": -6.74950105,"x": -79.8414988199837},
  {"name": "LBLO037-F","y": -6.7500605,"x": -79.837557713964},
  {"name": "LBCH020-F","y": -6.767548,"x": -79.8700856533768},
  {"name": "LBLO038-F","y": -6.74695065,"x": -79.8384962434748},
  {"name": "LBLO039-F","y": -6.746873,"x": -79.8406617833917},
  {"name": "CHI039-S // CHI039","y": -6.761376,"x": -79.8395538438735},
  {"name": "LBLO040-F","y": -6.747036,"x": -79.8283797152778},
  {"name": "LBLO041-F","y": -6.747248,"x": -79.8263986638298},
  {"name": "LBLO042-F","y": -6.7514665,"x": -79.848876559654},
  {"name": "PIUR182-F","y": -5.180067,"x": -80.6852465493345},
  {"name": "LBLO043-F","y": -6.749024,"x": -79.8444784273885},
  {"name": "LBLO044-F","y": -6.748967,"x": -79.8114368603936},
  {"name": "LBLO044-F","y": -6.7477368,"x": -79.8104966449215},
  {"name": "CHI044-S // CHI044","y": -6.758375,"x": -79.8351441936266},
  {"name": "LBLO045-F","y": -6.7472585,"x": -79.818570500412},
  {"name": "LBLO046-F","y": -6.7443245,"x": -79.8160540493974},
  {"name": "LBLO047-F","y": -6.752552,"x": -79.8231244685182},
  {"name": "ICAX082-F","y": -14.0887145,"x": -75.7500679265283},
  {"name": "LBLO048-F","y": -6.7513565,"x": -79.8142240422364},
  {"name": "LBLO049-F","y": -6.7489177,"x": -79.8217660702556},
  {"name": "CHI049","y": -6.7584715,"x": -79.8326669440133},
  {"name": "LBLO050-F","y": -6.7519819,"x": -79.8164258197446},
  {"name": "LBLO051-F","y": -6.750935,"x": -79.821288124425},
  {"name": "LBLO053-F","y": -6.755646,"x": -79.8209954342105},
  {"name": "LBLO054-F","y": -6.75423,"x": -79.8196180115036},
  {"name": "LBLO055-F","y": -6.74842555,"x": -79.8684141538831},
  {"name": "LBLO056-F","y": "","x": ""},
  {"name": "LBLO056-F","y": -6.75202795,"x": -79.8650192644729},
  {"name": "CHI056-S // CHI056","y": -6.7596235,"x": -79.8392874052805},
  {"name": "CHI072","y": -6.7568,"x": -79.8452503962968},
  {"name": "CHI073","y": -6.7588735,"x": -79.8433862575017},
  {"name": "CHI087-S // CHI087","y": -6.759063,"x": -79.8460284091347},
  {"name": "LBCH001-F","y": -6.764109,"x": -79.8226102947981},
  {"name": "LBCH002-F","y": -6.7601355,"x": -79.8225138758231},
  {"name": "LBCH003-F","y": -6.7612095,"x": -79.8243472725564},
  {"name": "LBCH004-F","y": -6.7620545,"x": -79.8268116447011},
  {"name": "LBPI005-F","y": -6.7869705,"x": -79.870634737445},
  {"name": "CHI005-S // CHI005","y": -6.7718305,"x": -79.8721528380361},
  {"name": "ZONA SATURADA","y": -6.76203,"x": -79.8286621699165},
  {"name": "LBCH006-F","y": -6.7646205,"x": -79.8256498773904},
  {"name": "CHI006","y": -6.7710555,"x": -79.8700603278302},
  {"name": "LBCH007-F","y": -6.7668465,"x": -79.8287277724041},
  {"name": "LBCH008-F","y": -6.7669295,"x": -79.8259079297287},
  {"name": "CHI008-S // CHI008","y": -6.7819645,"x": -79.866534550959},
  {"name": "CHI009-S // CHI009","y": -6.779441,"x": -79.86687797699},
  {"name": "LBCH009-F","y": -6.7687425,"x": -79.8276420137938},
  {"name": "CHI074","y": -6.761203,"x": -79.8431519378613},
  {"name": "CHI011-S // CHI011","y": -6.764061,"x": -79.8541339966711},
  {"name": "ZONA SATURADA","y": -6.764959,"x": -79.8489277840073},
  {"name": "ZONA SATURADA","y": -6.765885,"x": -79.8492240425661},
  {"name": "ZONA SATURADA","y": -6.765761,"x": -79.8481862998543},
  {"name": "ZONA SATURADA","y": -6.764565,"x": -79.8506038208913},
  {"name": "ZONA SATURADA","y": -6.7651345,"x": -79.8494471209677},
  {"name": "CHI013-S // CHI013","y": -6.7604065,"x": -79.8568516102669},
  {"name": "ZONA SATURADA","y": -6.7582705,"x": -79.8641068064252},
  {"name": "ZONA SATURADA","y": -6.7595695,"x": -79.8640299776817},
  {"name": "ZONA SATURADA","y": -6.7586075,"x": -79.8648509119492},
  {"name": "ZONA SATURADA","y": -6.7592695,"x": -79.8637938855422},
  {"name": "LMJR080-S // LMJR080","y": -12.19108075,"x": -76.9610970202599},
  {"name": "LBCH027-F","y": -6.762011,"x": -79.8480058446154},
  {"name": "CHI015-S // CHI015","y": -6.7719305,"x": -79.860048006677},
  {"name": "LBCH015-F","y": -6.761055,"x": -79.8665505814081},
  {"name": "LBCH016-F","y": -6.763009,"x": -79.8657270602346},
  {"name": "CHI016-S // CHI016","y": -6.7627745,"x": -79.8587002890583},
  {"name": "LBCH017-F","y": -6.762459,"x": -79.8693459182718},
  {"name": "CHI053-S // CHI053","y": -6.7722995,"x": -79.8381172682927},
  {"name": "CHI017-S // CHI017","y": -6.7599565,"x": -79.8617327210265},
  {"name": "CHI021-S // CHI021","y": -6.7844845,"x": -79.8391627080073},
  {"name": "CHI023-S // CHI023","y": -6.780645,"x": -79.8368243301887},
  {"name": "CHI024-S // CHI024","y": -6.7876425,"x": -79.8508624009507},
  {"name": "LBCH026-F","y": -6.760685,"x": -79.8516915427442},
  {"name": "CHI026-S // CHI026","y": -6.7846145,"x": -79.8429359849689},
  {"name": "LMVS005","y": -12.1938775,"x": -76.9533150403418},
  {"name": "CHI027","y": -6.7826255,"x": -79.8347059028123},
  {"name": "LBCH028-F","y": -6.762822,"x": -79.8509791871437},
  {"name": "CHI028-S // CHI028","y": -6.784604,"x": -79.8531750051253},
  {"name": "LBCH029-F","y": -6.776775,"x": -79.8656701374078},
  {"name": "LBCH030-F","y": -6.778713,"x": -79.8635846340156},
  {"name": "CJCJ063-F","y": -7.151472,"x": -78.5167809246074},
  {"name": "CHI030-S // CHI030","y": -6.781483,"x": -79.8387006747547},
  {"name": "LBCH031-F","y": -6.7791915,"x": -79.8614129577176},
  {"name": "CZCZ075-F","y": -13.524623,"x": -71.9487999318483},
  {"name": "CHI031-S // CHI031","y": -6.7865515,"x": -79.8474739706858},
  {"name": "LBCH032-F","y": -6.78177,"x": -79.8623289831701},
  {"name": "CHI032-S // CHI032","y": -6.7786635,"x": -79.8687949024927},
  {"name": "LBCH033-F","y": -6.7796675,"x": -79.8584370813005},
  {"name": "CHI033","y": -6.770424,"x": -79.8408676737892},
  {"name": "CHI036-S // CHI036","y": -6.774573,"x": -79.8397974073401},
  {"name": "CHI037","y": -6.765498,"x": -79.8363618057554},
  {"name": "LAMO054","y": -12.0967045,"x": -76.9517321037313},
  {"name": "LBCH040-F","y": -6.78501,"x": -79.8628702136824},
  {"name": "LBCH041-F","y": -6.784237,"x": -79.8565739842454},
  {"name": "CHI041","y": -6.76853,"x": -79.8381917136475},
  {"name": "LBCH042-F","y": -6.781235,"x": -79.8563340818818},
  {"name": "LBCH043-F","y": -6.780884,"x": -79.852354282946},
  {"name": "CHI043","y": -6.774425,"x": -79.8372882331122},
  {"name": "LBCH044-F","y": -6.779485,"x": -79.8552091235632},
  {"name": "LBCH045-F","y": -6.7694,"x": -79.7945129180124},
  {"name": "CHI045-S // CHI045","y": -6.765326,"x": -79.8308117305318},
  {"name": "LBCH046-F","y": -6.7652735,"x": -79.7959221974217},
  {"name": "CHI047","y": -6.7686485,"x": -79.8406713359173},
  {"name": "PIUR021","y": -5.1949875,"x": -80.6421158521059},
  {"name": "LBCH047-F","y": -6.7649815,"x": -79.8001424513054},
  {"name": "CHI048","y": -6.770208,"x": -79.8383599477846},
  {"name": "CHI058","y": -6.7701915,"x": -79.8371598650402},
  {"name": "LBCH048-F","y": -6.7676555,"x": -79.8010044861101},
  {"name": "LBCH049-F","y": -6.773882,"x": -79.809227974427},
  {"name": "LBCH050-F","y": -6.770592,"x": -79.8052498694239},
  {"name": "LBCH051-F","y": -6.7694155,"x": -79.8109784805938},
  {"name": "LBCH053-F","y": -6.7646335,"x": -79.8337822003774},
  {"name": "CHI055-S // CHI055","y": -6.7641275,"x": -79.836051951107},
  {"name": "CHI120","y": -6.769695,"x": -79.8586059247024},
  {"name": "CHI059","y": -6.7675355,"x": -79.8367386795454},
  {"name": "CHI061","y": -6.769478,"x": -79.8438769012821},
  {"name": "CHI086","y": -6.782561,"x": -79.854105041942},
  {"name": "TCNA071","y": -18.00219,"x": -70.2323994964827},
  {"name": "CHI063-S // CHI063","y": -6.7726205,"x": -79.8493548893138},
  {"name": "CHI067-S // CHI067","y": -6.772241,"x": -79.8668737557947},
  {"name": "CHI069","y": -6.7789055,"x": -79.8328093445262},
  {"name": "CHI071","y": -6.746972,"x": -79.8310048903272},
  {"name": "CHI076","y": -6.770491,"x": -79.8631888991514},
  {"name": "CHI077-S // CHI077","y": -6.772382,"x": -79.8541547169471},
  {"name": "CHI084-S // CHI084","y": -6.777541,"x": -79.834397261488},
  {"name": "CHI085-S // CHI085","y": -6.7894175,"x": -79.8527636554348},
  {"name": "CHIO145","y": -6.792064,"x": -79.8359885239726},
  {"name": "CHI089","y": -6.7800655,"x": -79.8314669464957},
  {"name": "CHI106","y": -6.773274,"x": -79.8735054577703},
  {"name": "CHI108","y": -6.776428,"x": -79.8420180113883},
  {"name": "CHI110","y": -6.7704425,"x": -79.8515286136364},
  {"name": "CHI111-S // CHI111","y": -6.8065265,"x": -79.8258349150266},
  {"name": "CHI125","y": -6.786012,"x": -79.8583797043147},
  {"name": "CHIO127-F","y": -6.7787235,"x": -79.8425475471175},
  {"name": "CHIO128-F","y": -6.7795035,"x": -79.8473586639085},
  {"name": "CHIO129-F","y": -6.779256,"x": -79.8495971609415},
  {"name": "CHIO137-F","y": -6.7747905,"x": -79.8649684950687},
  {"name": "CHIO138-F","y": -6.7754795,"x": -79.8619264615385},
  {"name": "CHIO139-F","y": -6.7752845,"x": -79.8601596584178},
  {"name": "CHIO140-F","y": -6.775921,"x": -79.8583508844844},
  {"name": "LMLV007","y": -12.0748825,"x": -77.0162410850769},
  {"name": "CHIO141-F","y": -6.7755945,"x": -79.8566969563783},
  {"name": "CHIO142-F","y": -6.775324,"x": -79.8547304975455},
  {"name": "CHIO143-F","y": -6.7763325,"x": -79.8532604273058},
  {"name": "CHIO144-F","y": -6.7783085,"x": -79.839476810724},
  {"name": "CHI022-S // CHI022","y": -6.783102,"x": -79.8488014504386},
  {"name": "LBFE001-F","y": -6.640155,"x": -79.791115465349},
  {"name": "JNPN004-F","y": -10.920802,"x": -74.8758936312248},
  {"name": "LBFE002-F","y": -6.6434145,"x": -79.7932157670316},
  {"name": "LBFE003-F","y": -6.636757,"x": -79.7905195969651},
  {"name": "LBFE004-F","y": -6.638084,"x": -79.7878054720473},
  {"name": "LMPP078-F","y": -11.9338515,"x": -77.0948308064203},
  {"name": "LBFE005-F","y": -6.635049,"x": -79.7878814853647},
  {"name": "CJCJ076-F","y": -7.146463,"x": -78.5021237854001},
  {"name": "LBFE006-F","y": -6.6326935,"x": -79.7904293251252},
  {"name": "LBFE007-F","y": -6.6317385,"x": -79.7871029515379},
  {"name": "LBFE008-F","y": -6.6360825,"x": -79.7925029657292},
  {"name": "LBFE009-F","y": -6.639102,"x": -79.7949626805288},
  {"name": "LMVS178-F","y": -12.2330085,"x": -76.9385331483126},
  {"name": "LMCO010-S // LMCO010","y": -11.9391555,"x": -77.0631962641813},
  {"name": "LBFE013-F","y": -6.628678,"x": -79.7879330503208},
  {"name": "LBFE014-F","y": -6.627252,"x": -79.7854570582901},
  {"name": "LBFE015-F","y": -6.6305075,"x": -79.7841145108911},
  {"name": "LBFE016-F","y": -6.634818,"x": -79.7844699251592},
  {"name": "LMPP075-F","y": -11.936083,"x": -77.0971281224051},
  {"name": "LBFE017-F","y": -6.6390275,"x": -79.784688758348},
  {"name": "LBFE018-F","y": -6.641635,"x": -79.7871313128834},
  {"name": "LBFE019-F","y": -6.644399,"x": -79.7873731394155},
  {"name": "LBFE020-F","y": -6.6443215,"x": -79.7912120159284},
  {"name": "LMPP086-F","y": -11.932051,"x": -77.0981742138575},
  {"name": "AQCC104-F","y": -16.33433,"x": -71.5506009596027},
  {"name": "LMVS188-F","y": -12.239381,"x": -76.9256700918367},
  {"name": "LMVS190-F","y": -12.241401,"x": -76.9259807652275},
  {"name": "LMCY021-F","y": -11.988108,"x": -76.7974085192639},
  {"name": "LAMO025-S // LAMO025","y": -12.075902,"x": -76.9477405053281},
  {"name": "AQYA015-F","y": -16.3923625,"x": -71.5527453148048},
  {"name": "LMLM009","y": -12.05953,"x": -77.0655578569519},
  {"name": "LMJL078 // LMJL078-S","y": -12.015883,"x": -77.0120829784483},
  {"name": "CJCJ001","y": -7.1830365,"x": -78.493143160591},
  {"name": "CJCJ002","y": -7.180575,"x": -78.4948231942644},
  {"name": "CJCJ003","y": -7.177158,"x": -78.4942743918478},
  {"name": "CJCJ004","y": -7.175823,"x": -78.497581816794},
  {"name": "CJCJ005","y": -7.172525,"x": -78.494507702237},
  {"name": "LMMP009","y": -12.020265,"x": -77.0569643057953},
  {"name": "CJCJ037","y": -7.167559,"x": -78.5096560310611},
  {"name": "CJCJ006","y": -7.1722535,"x": -78.498974641523},
  {"name": "CJCJ007","y": -7.17129,"x": -78.5032495818775},
  {"name": "CJCJ009","y": -7.1687725,"x": -78.5059867911969},
  {"name": "CJCJ010","y": -7.163059,"x": -78.5005584174616},
  {"name": "CJCJ011","y": -7.1631425,"x": -78.5057975680851},
  {"name": "CJCJ012","y": -7.16511,"x": -78.507678489594},
  {"name": "CJCJ060-F","y": -7.144835,"x": -78.5171679357864},
  {"name": "CJCJ038","y": -7.169677,"x": -78.5118265039933},
  {"name": "CJCJ021-S // CJCJ021","y": -7.148895,"x": -78.5050973548035},
  {"name": "CJCJ023","y": -7.1498545,"x": -78.5142423707579},
  {"name": "CJCJ031","y": -7.145401,"x": -78.5224598492823},
  {"name": "CJCJ033","y": -7.147035,"x": -78.5100825192604},
  {"name": "CJCJ036","y": -7.1662815,"x": -78.5133138411602},
  {"name": "PUPU006","y": -15.8382135,"x": -70.022596646042},
  {"name": "CJCJ041","y": -7.175676,"x": -78.5061764032767},
  {"name": "CJCJ044","y": -7.1816185,"x": -78.4986258776178},
  {"name": "CJCJ045","y": -7.1839445,"x": -78.4964525301733},
  {"name": "CJCJ047","y": -7.178651,"x": -78.49170667076},
  {"name": "CJCJ048","y": -7.166665,"x": -78.5009383742579},
  {"name": "CJCJ051","y": -7.1447195,"x": -78.5203446608099},
  {"name": "CJCJ054","y": -7.148797,"x": -78.5087880410019},
  {"name": "CJCJ055-F","y": -7.1610555,"x": -78.5248141962194},
  {"name": "CJCJ061-F","y": -7.1438195,"x": -78.5127171503932},
  {"name": "CJCJ056-F","y": -7.162196,"x": -78.5221205909091},
  {"name": "CJCJ096-F","y": -7.189112,"x": -78.4944308003356},
  {"name": "CJCJ057-F","y": -7.162984,"x": -78.5191882426168},
  {"name": "CJCJ058-F","y": -7.1655935,"x": -78.5167765454545},
  {"name": "CJCJ059-F","y": -7.1727995,"x": -78.5087772624365},
  {"name": "ICCP001-S // ICCP001","y": -13.4013975,"x": -76.1253329950069},
  {"name": "CJCJ062-F","y": -7.1501695,"x": -78.5178298446602},
  {"name": "CJCJ064-F","y": -7.158226,"x": -78.5264163773006},
  {"name": "CJCJ065-F","y": -7.156106,"x": -78.5275672973728},
  {"name": "CJCJ066-F","y": -7.1535015,"x": -78.5248509025445},
  {"name": "CJCJ067-F","y": -7.1478585,"x": -78.5263057505096},
  {"name": "CJCJ068-F","y": -7.144318,"x": -78.5262485481481},
  {"name": "CJCJ069-F","y": -7.139047,"x": -78.5256797587345},
  {"name": "CJCJ077-F","y": -7.1456025,"x": -78.4973327094075},
  {"name": "CJCJ078-F","y": -7.171144,"x": -78.4912700280958},
  {"name": "CJCJ079-F","y": -7.1726585,"x": -78.489809963708},
  {"name": "CJCJ104-F","y": -7.1535145,"x": -78.4942958703125},
  {"name": "CJCJ070-F","y": -7.163281,"x": -78.5128464181884},
  {"name": "MDPM035","y": -12.6038925,"x": -69.1896906742523},
  {"name": "CJCJ071-F","y": -7.161266,"x": -78.5078881826157},
  {"name": "CJCJ072-F","y": -7.177214,"x": -78.5075583692037},
  {"name": "CJCJ073-F","y": -7.1802945,"x": -78.5056828746914},
  {"name": "CJCJ105-F","y": -7.151129,"x": -78.4975374635174},
  {"name": "CJCJ074-F","y": -7.183087,"x": -78.5035832461093},
  {"name": "CJCJ095-F","y": -7.1905735,"x": -78.4886333470424},
  {"name": "CJCJ075-F","y": -7.1777825,"x": -78.4864457008714},
  {"name": "CJCJ090-F","y": -7.181706,"x": -78.4885521729068},
  {"name": "CJCJ091-F","y": -7.1822755,"x": -78.483803623378},
  {"name": "CJCJ092-F","y": -7.1864035,"x": -78.4844569798894},
  {"name": "CJCJ093-F","y": -7.1873305,"x": -78.4918189789444},
  {"name": "CJCJ094-F","y": -7.1891405,"x": -78.4816874014463},
  {"name": "CJCJ097-F","y": -7.1599295,"x": -78.5037449834616},
  {"name": "CJCJ099-F","y": -7.176158,"x": -78.5137436023538},
  {"name": "CJCJ100-F","y": -7.173412,"x": -78.5125614173433},
  {"name": "CJCJ101-F","y": -7.17399,"x": -78.5099202239169},
  {"name": "CJCJ102-F","y": -7.174048,"x": -78.506343992189},
  {"name": "CJCJ103-F","y": -7.174335,"x": -78.5008938636364},
  {"name": "CJJN001-F","y": -5.6956605,"x": -78.8081453453669},
  {"name": "MQMN001-S // MQMN001","y": -17.2102345,"x": -70.9439918933134},
  {"name": "CJJN002-F","y": -5.698832,"x": -78.809392994868},
  {"name": "CJJN003-F","y": -5.699327,"x": -78.807162625643},
  {"name": "CJJN004-F","y": -5.7015965,"x": -78.8102585160362},
  {"name": "UCCL012-F","y": -8.392886,"x": -74.5519870991928},
  {"name": "CJJN005-F","y": -5.7027455,"x": -78.8119082224053},
  {"name": "CJJN015-F","y": -5.712807,"x": -78.8093189742145},
  {"name": "CJJN006-F","y": -5.7037295,"x": -78.8069996290048},
  {"name": "CJJN007-F","y": -5.7064165,"x": -78.8089852317354},
  {"name": "CJJN012-F","y": -5.709682,"x": -78.8161313060606},
  {"name": "CJJN008-F","y": -5.7057775,"x": -78.8121428769632},
  {"name": "CJJN009-F","y": -5.7064435,"x": -78.8159431117216},
  {"name": "LMCO028","y": -11.9142785,"x": -77.0545235586762},
  {"name": "CJJN010-F","y": -5.705935,"x": -78.8058347721874},
  {"name": "CJJN011-F","y": -5.7085765,"x": -78.8126034419619},
  {"name": "CJJN013-F","y": -5.707811,"x": -78.8060864392496},
  {"name": "CJJN014-F","y": -5.709556,"x": -78.8095295482866},
  {"name": "CZST036-F","y": -13.533679,"x": -71.9718170507705},
  {"name": "CJJN016-F","y": -5.715378,"x": -78.8090654717489},
  {"name": "CJJN017-F","y": -5.711743,"x": -78.8070627882054},
  {"name": "CJJN018-F","y": -5.7139605,"x": -78.8060535164383},
  {"name": "LMBY027-S // LMBY027","y": -11.878231,"x": -77.0320812050789},
  {"name": "CJJN019-F","y": -5.7170345,"x": -78.8076281243358},
  {"name": "CJJN020-F","y": -5.7106095,"x": -78.8053477022863},
  {"name": "CJJN021-F","y": -5.713174,"x": -78.8038362776163},
  {"name": "JNCH001-F","y": -12.0878455,"x": -75.212883983965},
  {"name": "CJJN022-F","y": -5.71016,"x": -78.803624052492},
  {"name": "CJJN023-F","y": -5.7108975,"x": -78.8023357955992},
  {"name": "LMMP009-S","y": -12.019346,"x": -77.054469307947},
  {"name": "CJJN024-F","y": -5.707692,"x": -78.8015890735885},
  {"name": "CJJN025-F","y": -5.708968,"x": -78.8003156738095},
  {"name": "CJJN026-F","y": -5.7111715,"x": -78.7998992539327},
  {"name": "CJSI007-F","y": -5.1477075,"x": -79.0024211287527},
  {"name": "CJJN027-F","y": -5.701482,"x": -78.8038168663296},
  {"name": "ICCP002-S // ICCP002","y": -13.400402,"x": -76.1284682353472},
  {"name": "CJJN028-F","y": -5.7046505,"x": -78.8024453354885},
  {"name": "CJJN029-F","y": -5.707227,"x": -78.7980048797753},
  {"name": "CJJN030-F","y": -5.7106565,"x": -78.7964810337134},
  {"name": "CJJN031-F","y": -5.7137495,"x": -78.7995976599712},
  {"name": "CJJN032-F","y": -5.7143665,"x": -78.8021230969388},
  {"name": "CJJN033-F","y": -5.715621,"x": -78.8051548125347},
  {"name": "CJJN034-F","y": -5.714742,"x": -78.7955939932203},
  {"name": "CJJN035-F","y": -5.717771,"x": -78.7981852088235},
  {"name": "CJCH020-F","y": -6.566209,"x": -78.6522365996456},
  {"name": "CJJN036-F","y": -5.717316,"x": -78.8010587138643},
  {"name": "CJJN037-F","y": -5.7176525,"x": -78.8044355200635},
  {"name": "CJJN038-F","y": -5.719412,"x": -78.8032590747828},
  {"name": "CJSI001-F","y": -5.1408245,"x": -79.0074367996397},
  {"name": "CJSI002-F","y": -5.143636,"x": -79.0029113530369},
  {"name": "CZST037-F","y": -13.5333125,"x": -71.9752665722276},
  {"name": "CJCL006-F","y": -6.869098,"x": -78.1480088633427},
  {"name": "CJSI003-F","y": -5.142191,"x": -78.998457821463},
  {"name": "CJSI004-F","y": -5.1450145,"x": -79.0060221884637},
  {"name": "CJSI005-F","y": -5.1442835,"x": -79.00104281118},
  {"name": "CJSI006-F","y": -5.146183,"x": -78.9992738021347},
  {"name": "CJCH021-F","y": -6.5694025,"x": -78.6499175786377},
  {"name": "CJSI008-F","y": -5.1476675,"x": -79.0082542270318},
  {"name": "CJSI009-F","y": -5.1510835,"x": -78.9998743251547},
  {"name": "CJSI010-F","y": -5.15149705,"x": -78.9956549379916},
  {"name": "CJSI011-F","y": -5.154917,"x": -78.9954830984599},
  {"name": "CJBM001-F","y": -6.6718245,"x": -78.5283252762234},
  {"name": "CJBM002-F","y": -6.677251,"x": -78.5259698885794},
  {"name": "CJBM003-F","y": -6.6771,"x": -78.5210815224063},
  {"name": "CJBM004-F","y": -6.6770955,"x": -78.5176055214049},
  {"name": "CJBM005-F","y": -6.680468,"x": -78.5234464280966},
  {"name": "CJBM006-F","y": -6.6793555,"x": -78.5211953733163},
  {"name": "CJBM007-F","y": -6.6793425,"x": -78.5182738295683},
  {"name": "LMCA165-F","y": -12.051183,"x": -77.1017043759151},
  {"name": "CJBM008-F","y": -6.683026,"x": -78.5265153815805},
  {"name": "CJBM009-F","y": -6.6817965,"x": -78.5221484582452},
  {"name": "CJBM010-F","y": -6.6812645,"x": -78.5192793470025},
  {"name": "CJBM011-F","y": -6.6840965,"x": -78.5225634242175},
  {"name": "LMCA165-F","y": -12.050525,"x": -77.104484623823},
  {"name": "CJCV004-F","y": -6.376733,"x": -78.8185705585801},
  {"name": "CJBM012-F","y": -6.68555,"x": -78.5197563838586},
  {"name": "CJBM013-F","y": -6.689037,"x": -78.5253894247159},
  {"name": "CJBM014-F","y": -6.688019,"x": -78.5203480791971},
  {"name": "CJCL001-F","y": -6.856858,"x": -78.1455081029777},
  {"name": "LMSC051-S // LMSC051","y": -12.1334505,"x": -76.9888191641956},
  {"name": "JNTB064-F","y": -12.058749,"x": -75.2330829556512},
  {"name": "CJCV003-F","y": -6.374277,"x": -78.8136877446099},
  {"name": "CJCL002-F","y": -6.8613155,"x": -78.1471674611701},
  {"name": "CJCL003-F","y": -6.8608195,"x": -78.1446543681252},
  {"name": "CJCL004-F","y": -6.8656715,"x": -78.1472509927378},
  {"name": "CJCL005-F","y": -6.8656295,"x": -78.1445748468902},
  {"name": "HYTB069-F","y": -12.0626115,"x": -75.212618310681},
  {"name": "CJCL007-F","y": -6.868964,"x": -78.1456318321993},
  {"name": "CJCL008-F","y": -6.868831,"x": -78.1411465385753},
  {"name": "CJCV001-F","y": -6.374032,"x": -78.8103775064378},
  {"name": "CJCV002-F","y": -6.378032,"x": -78.8127085031791},
  {"name": "LMSA096-F","y": -12.0364055,"x": -76.9682059666722},
  {"name": "CJCH013-F","y": -6.5631965,"x": -78.6467983678414},
  {"name": "CJCV004-F","y": -6.3749665,"x": -78.8156996343979},
  {"name": "CJCV005-F","y": -6.3763815,"x": -78.8199145395189},
  {"name": "CJCV006-F","y": -6.377108,"x": -78.8165197688643},
  {"name": "CJCV007-F","y": -6.3789895,"x": -78.8216665231563},
  {"name": "HYHY006","y": -12.0634555,"x": -75.2033700791598},
  {"name": "CJCV008-F","y": -6.3791645,"x": -78.8191731715986},
  {"name": "CJCV009-F","y": -6.37949,"x": -78.8152201506622},
  {"name": "CJCV010-F","y": -6.3809295,"x": -78.8178962755352},
  {"name": "CJCV011-F","y": -6.383128,"x": -78.8224494078947},
  {"name": "HCAM008","y": -9.907758,"x": -76.2246183388447},
  {"name": "CJCV012-F","y": -6.38319,"x": -78.8177136695762},
  {"name": "CJCH014-F","y": -6.5576095,"x": -78.6600154210775},
  {"name": "CJCV013-F","y": -6.3867785,"x": -78.8162497872182},
  {"name": "CJCV014-F","y": -6.3901325,"x": -78.8176777460716},
  {"name": "CJCV015-F","y": -6.39191,"x": -78.8212351720683},
  {"name": "CJCV016-F","y": -6.39339,"x": -78.8151366775362},
  {"name": "CJCV017-F","y": -6.370634,"x": -78.8079657883628},
  {"name": "CJCV018-F","y": -6.3890705,"x": -78.8285110916314},
  {"name": "CJCV019-F","y": -6.38418,"x": -78.827073628624},
  {"name": "LMCA164-F","y": -12.049408,"x": -77.100614187399},
  {"name": "CJCH001-F","y": -6.5587915,"x": -78.6534375837893},
  {"name": "CJCH002-F","y": -6.560406,"x": -78.6534678687845},
  {"name": "CJCH003-F","y": -6.5621085,"x": -78.6538008890533},
  {"name": "CJCH004-F","y": -6.5615735,"x": -78.6507656666667},
  {"name": "HCHC013","y": -9.9279015,"x": -76.2367789438667},
  {"name": "CJCH005-F","y": -6.563996,"x": -78.6512969200493},
  {"name": "CJCH006-F","y": -6.5589925,"x": -78.649007253178},
  {"name": "CJCH007-F","y": -6.5605975,"x": -78.6488733989239},
  {"name": "CJCH008-F","y": -6.562342,"x": -78.6489448693907},
  {"name": "HUPM007-S // HUPM007","y": -9.962767,"x": -76.247540474803},
  {"name": "CJCH009-F","y": -6.5643985,"x": -78.6490105239919},
  {"name": "CJCH010-F","y": -6.566509,"x": -78.6491835833067},
  {"name": "CJCH011-F","y": -6.5589225,"x": -78.6456723559746},
  {"name": "CJCH012-F","y": -6.560694,"x": -78.6453174245094},
  {"name": "HCAM007","y": -9.908709,"x": -76.2312473993925},
  {"name": "CJCH015-F","y": -6.561494,"x": -78.6576970968723},
  {"name": "CJCH016-F","y": -6.5569195,"x": -78.6571428452091},
  {"name": "CJCH017-F","y": -6.555686,"x": -78.6529903404186},
  {"name": "CJCH018-F","y": -6.5575095,"x": -78.6498124360801},
  {"name": "CJCH019-F","y": -6.558328,"x": -78.6421034329268},
  {"name": "CJCB001-F","y": -7.6305945,"x": -78.0463924247532},
  {"name": "CJCB002-F","y": -7.626702,"x": -78.0411079506369},
  {"name": "CJCB003-F","y": -7.6237555,"x": -78.0447268771527},
  {"name": "CJCB004-F","y": -7.625323,"x": -78.0472653401445},
  {"name": "SMRJ009-F","y": -6.055779,"x": -77.1598540607907},
  {"name": "CJCB005-F","y": -7.6235415,"x": -78.0521367162366},
  {"name": "CJCB006-F","y": -7.621479,"x": -78.047044497908},
  {"name": "CJCB007-F","y": -7.6212025,"x": -78.0424966050725},
  {"name": "CJCB008-F","y": -7.6168655,"x": -78.0475288391587},
  {"name": "5017B03","y": -12.0918615,"x": -77.0340586325023},
  {"name": "CJCB009-F","y": -7.6114705,"x": -78.0521967369772},
  {"name": "CJCB010-F","y": -7.610844,"x": -78.0661874215215},
  {"name": "CJCB011-F","y": -7.635303,"x": -78.046061256081},
  {"name": "CJCB012-F","y": -7.606456,"x": -78.058358507411},
  {"name": "LMRC049-F","y": -12.0324695,"x": -77.0315120592107},
  {"name": "LMCA164-F","y": -12.0498695,"x": -77.1023369667969},
  {"name": "HCHC001","y": -9.9356505,"x": -76.2508416914654},
  {"name": "HCHC002-S // HCHC002","y": -9.9381815,"x": -76.2487534928749},
  {"name": "HCHC003","y": -9.9355225,"x": -76.2447588370332},
  {"name": "HCHC004-S // HCHC004","y": -9.9340085,"x": -76.2482593638316},
  {"name": "CBCB017","y": -9.06762915,"x": -78.5961637618101},
  {"name": "HCHC005-S // HCHC005","y": -9.931395,"x": -76.2479644422691},
  {"name": "HCHC006","y": -9.934028,"x": -76.2428825823641},
  {"name": "HUPM006-S // HUPM006","y": -9.951638,"x": -76.2529591836493},
  {"name": "HCHC007","y": -9.9323205,"x": -76.2404435161724},
  {"name": "HCAM016-S // HCAM016","y": -9.9410005,"x": -76.2405366691588},
  {"name": "HCHC008","y": -9.93062,"x": -76.2431606277778},
  {"name": "HUPM008-S // HUPM008","y": -9.965324,"x": -76.247023582549},
  {"name": "HUPM009-S // HUPM009","y": -9.9632855,"x": -76.2436191892212},
  {"name": "HCHC009-S // HCHC009","y": -9.9293365,"x": -76.2461273863347},
  {"name": "HUPM010","y": -9.9597555,"x": -76.2443503889748},
  {"name": "HCHC014","y": -9.9255235,"x": -76.2379864061677},
  {"name": "AQHU018","y": -16.436318,"x": -71.5609811686716},
  {"name": "HCHC010","y": -9.9266465,"x": -76.2447762626551},
  {"name": "HUPM011","y": -9.956583,"x": -76.2452553882017},
  {"name": "HCHC012","y": -9.9304615,"x": -76.2384557309953},
  {"name": "HCHC011-S // HCHC011","y": -9.9286175,"x": -76.2409779025754},
  {"name": "HUPM012-F","y": -9.9687445,"x": -76.2484843230129},
  {"name": "HCAM005-S // HCAM005","y": -9.9135655,"x": -76.2316021622718},
  {"name": "HCHC015","y": -9.925414,"x": -76.2424326260365},
  {"name": "HCHC016","y": -9.92341,"x": -76.2403362654255},
  {"name": "HCHC018","y": -9.9238195,"x": -76.2358127597706},
  {"name": "HCHC019-S // HCHC019","y": -9.917999,"x": -76.2379972493603},
  {"name": "HCHC020","y": -9.9196265,"x": -76.2353370428029},
  {"name": "HUHU023-F","y": -9.9398615,"x": -76.2553207378193},
  {"name": "HUHU024-F","y": -9.9371655,"x": -76.2537665},
  {"name": "HUPM001-S // HUPM001","y": -9.950194,"x": -76.2516527821114},
  {"name": "HUPM002-S // HUPM002","y": -9.9529375,"x": -76.2504709512221},
  {"name": "HUPM003-S // HUPM003","y": -9.9559585,"x": -76.2493031453301},
  {"name": "HUPM004-S // HUPM004","y": -9.9534675,"x": -76.2471305397141},
  {"name": "HUPM005-S // HUPM005","y": -9.959062,"x": -76.248290462924},
  {"name": "HCAM001","y": -9.9219907,"x": -76.2288649645525},
  {"name": "HUSL005-F","y": -9.9479458,"x": -76.2447642421891},
  {"name": "HULL001-S // HULL001","y": -9.9260445,"x": -76.2321337575677},
  {"name": "HUSL001-S // HUSL001","y": -9.9480835,"x": -76.2423845195823},
  {"name": "HNAM001-F","y": -9.9355675,"x": -76.236842935751},
  {"name": "HCAM002-S // HCAM002","y": -9.9194695,"x": -76.2313525128354},
  {"name": "HULL002-S // HULL002","y": -9.92913,"x": -76.23312134182},
  {"name": "HCAM006-S // HCAM006","y": -9.911724,"x": -76.2260547348481},
  {"name": "HUSL002-S // HUSL002","y": -9.9498615,"x": -76.2426014307375},
  {"name": "HNAM002-F","y": -9.93911415,"x": -76.2376083737042},
  {"name": "HCAM003-S // HCAM003","y": -9.917706,"x": -76.2273326993939},
  {"name": "HNAM003-F","y": -9.942301,"x": -76.2376306668317},
  {"name": "HCAM004-S // HCAM004","y": -9.9143235,"x": -76.2287514490635},
  {"name": "HNAM004-F","y": -9.945383,"x": -76.2393115044192},
  {"name": "HCAM009-S // HCAM009","y": -9.9467338,"x": -76.2442660974684},
  {"name": "HCAM010","y": -9.9454755,"x": -76.248858689233},
  {"name": "HCAM011-S // HCAM011","y": -9.9444255,"x": -76.2458133294036},
  {"name": "HCAM012-S // HCAM012","y": -9.9416675,"x": -76.2472143308194},
  {"name": "HCAM013-S // HCAM013","y": -9.944628,"x": -76.2411840180063},
  {"name": "HCAM014-S // HCAM014","y": -9.9426305,"x": -76.2433410361446},
  {"name": "HCAM015-S // HCAM015","y": -9.939563,"x": -76.2443979040931},
  {"name": "HCAM017-S // HCAM017","y": -9.939035,"x": -76.240437748915},
  {"name": "HCAM018","y": -9.9376715,"x": -76.2426541960028},
  {"name": "HUAM021-F","y": -9.923959,"x": -76.2312635270812},
  {"name": "SMRJ001-F","y": -6.059913,"x": -77.1705000263158},
  {"name": "SMRJ002-F","y": -6.0644635,"x": -77.1701960877193},
  {"name": "LMLV009","y": -12.0790685,"x": -77.0174613235887},
  {"name": "5017B03","y": -12.090497,"x": -77.0386992806926},
  {"name": "SMRJ003-F","y": -6.058299,"x": -77.1678469017467},
  {"name": "SMRJ004-F","y": -6.0642165,"x": -77.1668980714286},
  {"name": "SMRJ005-F","y": -6.0574395,"x": -77.1652204415098},
  {"name": "SMRJ006-F","y": -6.062404,"x": -77.1645604571871},
  {"name": "SMRJ008-F","y": -6.0520095,"x": -77.1603900087536},
  {"name": "SMRJ010-F","y": -6.0558315,"x": -77.1715918864864},
  {"name": "SMRJ011-F","y": -6.060641,"x": -77.1739437713675},
  {"name": "SMRJ012-F","y": -6.058255,"x": -77.1767528441392},
  {"name": "SMRJ012-F","y": -6.0619845,"x": -77.1785821502551},
  {"name": "SMRJ013-F","y": -6.065258,"x": -77.1832188088283},
  {"name": "SMRJ014-F","y": -6.0673935,"x": -77.1761989230775},
  {"name": "SMRJ015-F","y": -6.066897,"x": -77.1735471114207},
  {"name": "SMRJ016-F","y": -6.0686245,"x": -77.1661001041279},
  {"name": "SMRJ017-F","y": -6.0706755,"x": -77.170668845843},
  {"name": "UCYC003-F","y": -8.37797195,"x": -74.567205038297},
  {"name": "SMRJ018-F","y": -6.072915,"x": -77.1639013703727},
  {"name": "SMRJ019-F","y": -6.076036,"x": -77.1680170798753},
  {"name": "UCYC001-F","y": -8.374906,"x": -74.5640919498533},
  {"name": "UCYC002-F","y": -8.37868715,"x": -74.5635132320345},
  {"name": "CPYC001-S // CPYC001","y": -8.35518465,"x": -74.5770537686893},
  {"name": "UCYC004-F","y": -8.3809841,"x": -74.5633916621373},
  {"name": "CPYC002-S // CPYC002","y": -8.357054,"x": -74.5817973350451},
  {"name": "CPYC004-S // CPYC004","y": -8.36469735,"x": -74.5802142730387},
  {"name": "UCYC005-F","y": -8.379623,"x": -74.5702447861298},
  {"name": "CPYC005-S // CPYC005","y": -8.366561,"x": -74.5752609066022},
  {"name": "CPYC006","y": -8.36074155,"x": -74.5713087382691},
  {"name": "UCYC006-F","y": -8.384634,"x": -74.5679778906519},
  {"name": "CPYC007-S // CPYC007","y": -8.3669045,"x": -74.5594140092426},
  {"name": "UCYC007-F","y": -8.383958,"x": -74.5710406863939},
  {"name": "CPYC008-S // CPYC008","y": -8.367275,"x": -74.5557474886302},
  {"name": "UCYC008-F","y": -8.388348,"x": -74.5724740242242},
  {"name": "CPYC009-S // CPYC009","y": -8.368051,"x": -74.5664199353933},
  {"name": "UCYC010-F","y": -8.3735055,"x": -74.5578773734534},
  {"name": "CPYC010-S // CPYC010","y": -8.371837,"x": -74.5629364773982},
  {"name": "UCYC011-F","y": -8.376253,"x": -74.5594828447203},
  {"name": "UCYC009-F","y": -8.36310015,"x": -74.5617646361119},
  {"name": "UCYC012-F","y": -8.38077925,"x": -74.5581942467672},
  {"name": "UCYC013-F","y": -8.36071285,"x": -74.5664331952435},
  {"name": "UCMN006-F","y": -8.397105,"x": -74.5694863758052},
  {"name": "SMJU006-F","y": -7.179346,"x": -76.7272444222421},
  {"name": "SMJU001-F","y": -7.17235115,"x": -76.7280407590162},
  {"name": "SMJU002-F","y": -7.1723515,"x": -76.724139232196},
  {"name": "SMJU003-F","y": -7.175935,"x": -76.7303122048506},
  {"name": "SMJU004-F","y": -7.176023,"x": -76.7264508868465},
  {"name": "SMJU005-F","y": -7.176824,"x": -76.7232259623295},
  {"name": "HYCH010","y": -12.087064,"x": -75.20709142931},
  {"name": "SMJU007-F","y": -7.181391,"x": -76.7243138966165},
  {"name": "SMJU008-F","y": -7.182683,"x": -76.7269976553926},
  {"name": "SMJU009-F","y": -7.1801235,"x": -76.7307268649591},
  {"name": "TCNA074-S // TCNA074","y": -18.00718115,"x": -70.2365057964731},
  {"name": "SMJU010-F","y": -7.1805665,"x": -76.7345294312546},
  {"name": "SMJU011-F","y": -7.171326,"x": -76.734879048062},
  {"name": "JNPN005-F","y": -10.9185375,"x": -74.8742172987143},
  {"name": "SMJU012-F","y": -7.1767645,"x": -76.7382496732871},
  {"name": "SMJU013-F","y": -7.1804525,"x": -76.7387702474709},
  {"name": "SMJU014-F","y": -7.184226,"x": -76.7299390266272},
  {"name": "CPMN006-S // CPMN006","y": -8.4137515,"x": -74.5563974599601},
  {"name": "SMJU015-F","y": -7.18567035,"x": -76.7343382793204},
  {"name": "SMJU016-F","y": -7.188678,"x": -76.7341716225691},
  {"name": "CPMN001-S // CPMN001","y": -8.408699,"x": -74.5578362427409},
  {"name": "HYCH011","y": -12.0862765,"x": -75.2049346598361},
  {"name": "UCMN001-F","y": -8.396858,"x": -74.5489831207904},
  {"name": "UCMN002-F","y": -8.397702,"x": -74.5434525707929},
  {"name": "CPMN002-S // CPMN002","y": -8.4076895,"x": -74.5539552183512},
  {"name": "UCMN003-F","y": -8.3972395,"x": -74.538962275567},
  {"name": "CPMN003-S // CPMN003","y": -8.4083892,"x": -74.5496528372507},
  {"name": "CPMN004-S // CPMN004","y": -8.41194655,"x": -74.5472752914946},
  {"name": "TCPC001-F","y": -18.0079155,"x": -70.2258030669258},
  {"name": "UCMN004-F","y": -8.400043,"x": -74.5367715142562},
  {"name": "CPMN005-S // CPMN005","y": -8.4128985,"x": -74.5512196053635},
  {"name": "UCMN005-F","y": -8.3961165,"x": -74.5328116715312},
  {"name": "UCMN007-F","y": -8.3965265,"x": -74.5651694222667},
  {"name": "UCCL018-F","y": -8.397826,"x": -74.5568160209994},
  {"name": "UCMN008-F","y": -8.40178365,"x": -74.5627789962987},
  {"name": "UCMN009-F","y": -8.401756,"x": -74.5668499544695},
  {"name": "UCMN010-F","y": -8.4011675,"x": -74.5706852232849},
  {"name": "UCMN011-F","y": -8.4031035,"x": -74.5566556327956},
  {"name": "UCMN012-F","y": -8.40299405,"x": -74.5593187110348},
  {"name": "UCMN012-F","y": -8.40576765,"x": -74.5568623549617},
  {"name": "UCMN013-F","y": -8.4057205,"x": -74.565189613484},
  {"name": "UCMN014-F","y": -8.4004005,"x": -74.5527626619187},
  {"name": "UCMN015-F","y": -8.403767,"x": -74.5514306918482},
  {"name": "UCMN016-F","y": -8.4063365,"x": -74.5621475810559},
  {"name": "UCMN017-F","y": -8.410718,"x": -74.5634787182608},
  {"name": "UCMN018-F","y": -8.415784,"x": -74.5664664361096},
  {"name": "UCMN019-F","y": -8.413799,"x": -74.5607273325782},
  {"name": "JNTB038-F","y": -12.029546,"x": -75.2214682893348},
  {"name": "UCMN020-F","y": -8.401978,"x": -74.5480949378378},
  {"name": "UCCL021-F","y": -8.412956,"x": -74.5666304498147},
  {"name": "UCMN021-F","y": -8.401451,"x": -74.5444553946985},
  {"name": "UCMN022-F","y": -8.4026565,"x": -74.541016896188},
  {"name": "LLLR011-F","y": -8.088322,"x": -78.9615553904264},
  {"name": "UCMN023-F","y": -8.406333,"x": -74.5436979391277},
  {"name": "CPCL001-S // CPCL001","y": -8.3860759,"x": -74.5301134985272},
  {"name": "UCCL001","y": -8.369913,"x": -74.5473798764637},
  {"name": "UCCL002-S // UCCL002","y": -8.368563,"x": -74.5402939734065},
  {"name": "CPCL002","y": -8.384346,"x": -74.5327305947978},
  {"name": "UCCL003","y": -8.3716145,"x": -74.5417674810486},
  {"name": "UCCL019-F","y": -8.4058445,"x": -74.5702607352682},
  {"name": "CPCL004-S // CPCL004","y": -8.379549,"x": -74.5394450569361},
  {"name": "CPCL003-S // CPCL003","y": -8.382647,"x": -74.5364622688788},
  {"name": "UCCL007","y": -8.3768442,"x": -74.5493502397287},
  {"name": "UCCL004","y": -8.3729395,"x": -74.5446698465909},
  {"name": "CPCL005","y": -8.3768975,"x": -74.5386574777557},
  {"name": "CPCL030-F","y": -8.3865115,"x": -74.5349037201564},
  {"name": "UCCL005","y": -8.37319075,"x": -74.5491068733444},
  {"name": "UCCL006","y": -8.3765545,"x": -74.5452045364322},
  {"name": "UCCL008","y": -8.3805955,"x": -74.5436490891595},
  {"name": "CPCL032-F","y": -8.3896685,"x": -74.5378054700255},
  {"name": "JNTB048-F","y": -12.0500765,"x": -75.2134229111544},
  {"name": "UCCL009","y": -8.380951,"x": -74.5469398637736},
  {"name": "UCCL010","y": -8.3801945,"x": -74.5503936617186},
  {"name": "ANCB047-F","y": -9.07999055,"x": -78.5861485239998},
  {"name": "JNHY015-F","y": -12.047071,"x": -75.1872144894958},
  {"name": "CPCL006","y": -8.3801865,"x": -74.5353369208085},
  {"name": "CPCL007","y": -8.38138105,"x": -74.5310449614648},
  {"name": "CPCL008-S // CPCL008","y": -8.383396,"x": -74.5283474084492},
  {"name": "LMJL194-F","y": -11.993739,"x": -77.0161198377538},
  {"name": "CPCL010","y": -8.3778105,"x": -74.5285723213445},
  {"name": "UCCL011-F","y": -8.3906,"x": -74.5306809888677},
  {"name": "CPCL011","y": -8.378228,"x": -74.5331410735294},
  {"name": "CPCL012-S // CPCL012","y": -8.375033,"x": -74.537536750774},
  {"name": "UCCL013-F","y": -8.37383335,"x": -74.5536052521516},
  {"name": "PIUR040","y": -5.1858705,"x": -80.6312476285403},
  {"name": "CPCL013-S // CPCL013","y": -8.372728,"x": -74.5359246209755},
  {"name": "JNJA009-F","y": -11.7799265,"x": -75.5000173493691},
  {"name": "UCCL014-F","y": -8.3790017,"x": -74.5549009145877},
  {"name": "CPCL015","y": -8.3742195,"x": -74.5260043435792},
  {"name": "UCCL015-F","y": -8.3825195,"x": -74.5542286168605},
  {"name": "UCCL016-F","y": -8.3912025,"x": -74.5635925429992},
  {"name": "UCCL017-F","y": -8.3961521,"x": -74.5622988552734},
  {"name": "CPCL029-F","y": -8.3848645,"x": -74.5376786165828},
  {"name": "CPCL014-S // CPCL014","y": -8.3747355,"x": -74.5312077740394},
  {"name": "UCCL022-F","y": -8.4087745,"x": -74.5784625903208},
  {"name": "UCCL023-F","y": -8.41138,"x": -74.5780644172662},
  {"name": "UCCL020-F","y": -8.408989,"x": -74.5693748833557},
  {"name": "CPCL020-F","y": -8.388393,"x": -74.5532914716457},
  {"name": "CPCL021-F","y": -8.38758,"x": -74.5497967776599},
  {"name": "CPCL022-F","y": -8.3873225,"x": -74.5467930583722},
  {"name": "CPCL023-F","y": -8.392502,"x": -74.5479022545501},
  {"name": "CPCL024-F","y": -8.393925,"x": -74.5447268173195},
  {"name": "CPCL025-F","y": -8.38952365,"x": -74.5432371484476},
  {"name": "CPCL026-F","y": -8.388324,"x": -74.5415909277934},
  {"name": "CPCL027-F","y": -8.3851,"x": -74.5453138809831},
  {"name": "CPCL028-F","y": -8.3843605,"x": -74.5408728620708},
  {"name": "CPCL031-F","y": -8.3881865,"x": -74.5361629035509},
  {"name": "CPCL033-F","y": -8.392449,"x": -74.5397197099078},
  {"name": "CPCL034-F","y": -8.3932835,"x": -74.5360172253937},
  {"name": "CPCL035-F","y": -8.3903445,"x": -74.5336683886469},
  {"name": "CPCL009","y": -8.3795135,"x": -74.5256623050358},
  {"name": "JNTM001-F","y": -11.4193825,"x": -75.697113605079},
  {"name": "JNTM002-F","y": -11.41782,"x": -75.694299842623},
  {"name": "JNTM003-F","y": -11.4227355,"x": -75.6941589523224},
  {"name": "JNTM004-F","y": -11.4253185,"x": -75.6926284887848},
  {"name": "JNTM005-F","y": -11.4181915,"x": -75.6907980158178},
  {"name": "JNTM006-F","y": -11.420154,"x": -75.6882268688299},
  {"name": "JNTM007-F","y": -11.4167235,"x": -75.6856725879643},
  {"name": "JNTM008-F","y": -11.417921,"x": -75.6806284432206},
  {"name": "LMCA142-F","y": -12.016982,"x": -77.0993764224138},
  {"name": "HYHY033-S // HYHY033","y": -12.0746765,"x": -75.2058188483403},
  {"name": "JNTM009-F","y": -11.4139495,"x": -75.6833567148359},
  {"name": "JNTM010-F","y": -11.40848945,"x": -75.6828217404884},
  {"name": "JNTM011-F","y": -11.416639,"x": -75.698822024372},
  {"name": "JNTM012-F","y": -11.4123785,"x": -75.6863539390069},
  {"name": "JNTM013-F","y": -11.4145105,"x": -75.6865925366818},
  {"name": "JNTM014-F","y": -11.419777,"x": -75.6852707858852},
  {"name": "JNTM015-F","y": -11.4226545,"x": -75.6858670382883},
  {"name": "JNTM023-F","y": -11.3976525,"x": -75.6863744134753},
  {"name": "JNTM016-F","y": -11.4286085,"x": -75.6912325067809},
  {"name": "JNTM017-F","y": -11.432471,"x": -75.6922200459913},
  {"name": "JNTM018-F","y": -11.415586,"x": -75.6804773559908},
  {"name": "JNTM019-F","y": -11.4121095,"x": -75.6806335104839},
  {"name": "JNTM020-F","y": -11.409191,"x": -75.6792208967326},
  {"name": "JNTM021-F","y": -11.4072705,"x": -75.6810366827846},
  {"name": "JNTM022-F","y": -11.401615,"x": -75.6841610572555},
  {"name": "JNTM024-F","y": -11.3892295,"x": -75.6884834493127},
  {"name": "JNTM025-F","y": -11.4226125,"x": -75.6883089781277},
  {"name": "AYCO001-F","y": -15.0155285,"x": -73.7833202510417},
  {"name": "AYCO002-F","y": -15.015852,"x": -73.7799463585679},
  {"name": "AYCO003-F","y": -15.0184945,"x": -73.7805358929279},
  {"name": "ICMC008-F","y": -15.3646925,"x": -75.1638051636871},
  {"name": "JNJA010-F","y": -11.781702,"x": -75.4997906428796},
  {"name": "AYCO004-F","y": -15.018186,"x": -73.7842599733259},
  {"name": "AYCO005-F","y": -15.0181195,"x": -73.7870415589811},
  {"name": "AYCO006-F","y": -15.0215995,"x": -73.7814646308397},
  {"name": "AYCO007-F","y": -15.0181335,"x": -73.7764659899818},
  {"name": "LRYM009-F","y": -5.886869,"x": -76.1152007704172},
  {"name": "AYCO008-F","y": -15.010651,"x": -73.7774516},
  {"name": "AYCO009-F","y": -15.012446,"x": -73.7836903955704},
  {"name": "LRYM001-F","y": -5.883405,"x": -76.1290312977724},
  {"name": "LRYM002-F","y": -5.8869865,"x": -76.1282623486262},
  {"name": "LRYM003-F","y": -5.89013785,"x": -76.1282493007533},
  {"name": "LRYM004-F","y": -5.883525,"x": -76.1262043503165},
  {"name": "LRYM005-F","y": -5.8844455,"x": -76.1227773808243},
  {"name": "LRYM006-F","y": -5.887922,"x": -76.1228649123134},
  {"name": "LRYM007-F","y": -5.890883,"x": -76.124749895003},
  {"name": "LRYM008-F","y": -5.8907955,"x": -76.1206024732824},
  {"name": "JNJA012-F","y": -11.7835925,"x": -75.4962900350885},
  {"name": "LRYM010-F","y": -5.89066,"x": -76.114499990476},
  {"name": "LRYM011-F","y": -5.8871815,"x": -76.1115234011408},
  {"name": "LRYM012-F","y": -5.887826,"x": -76.1073339423842},
  {"name": "LRYM020-F","y": -5.896724,"x": -76.1209680506276},
  {"name": "LRYM013-F","y": -5.8912535,"x": -76.1077542227625},
  {"name": "ICCP016-F","y": -13.3999975,"x": -76.1418334702538},
  {"name": "LRYM014-F","y": -5.893957,"x": -76.1066929067734},
  {"name": "LRYM015-F","y": -5.896934,"x": -76.1054898952181},
  {"name": "LRYM016-F","y": -5.9005915,"x": -76.127975131672},
  {"name": "LRYM017-F","y": -5.9035745,"x": -76.1243283938131},
  {"name": "LRYM022-F","y": -5.8966595,"x": -76.1119518236702},
  {"name": "LRYM018-F","y": -5.898743,"x": -76.1250127485987},
  {"name": "LRYM019-F","y": -5.9016755,"x": -76.1208686017391},
  {"name": "CHPN001","y": -13.4062295,"x": -76.1285168558698},
  {"name": "LRYM021-F","y": -5.9016985,"x": -76.1172685066785},
  {"name": "ICCP004","y": -13.3987865,"x": -76.1309275496752},
  {"name": "LRYM023-F","y": -5.899082,"x": -76.1163624178785},
  {"name": "LRYM024-F","y": -5.9041305,"x": -76.1135025150639},
  {"name": "LRYM025-F","y": -5.899122,"x": -76.1092508365192},
  {"name": "LRYM026-F","y": -5.901799,"x": -76.1083168914904},
  {"name": "ICCP005","y": -13.398385,"x": -76.1371732878262},
  {"name": "LRYM027-F","y": -5.9060905,"x": -76.1100269264397},
  {"name": "LRYM028-F","y": -5.908675,"x": -76.1069448651708},
  {"name": "LRYM029-F","y": -5.902069,"x": -76.1049924341693},
  {"name": "LRYM030-F","y": -5.899022,"x": -76.1021868250254},
  {"name": "ICCP015-F","y": -13.395728,"x": -76.140796464253},
  {"name": "PAOX005-F","y": -10.5811885,"x": -75.4035349741656},
  {"name": "LRYM031-F","y": -5.903708,"x": -76.1018389539859},
  {"name": "LRYM032-F","y": -5.9063335,"x": -76.1036331968144},
  {"name": "PACT001-F","y": -10.576209,"x": -75.408931203933},
  {"name": "ICCP003-S // ICCP003","y": -13.405832,"x": -76.1306865304355},
  {"name": "ICCP006","y": -13.4018025,"x": -76.1356923282759},
  {"name": "ICCP007-S // ICCP007","y": -13.4013155,"x": -76.1392472868137},
  {"name": "ICCP009","y": -13.3894105,"x": -76.1440326666865},
  {"name": "ICCP010","y": -13.393776,"x": -76.1437835255234},
  {"name": "ICCP011","y": -13.390441,"x": -76.1466603445421},
  {"name": "ICCP012-F","y": -13.395699,"x": -76.1466959330357},
  {"name": "PAOX002-F","y": -10.574296,"x": -75.3994732796496},
  {"name": "ICCP013-F","y": -13.3977915,"x": -76.1435702260688},
  {"name": "ICCP014-F","y": -13.392374,"x": -76.1495328975309},
  {"name": "HURP017-F","y": -9.3214795,"x": -75.9937601607857},
  {"name": "HURP018-F","y": -9.333279,"x": -75.9907528224876},
  {"name": "JNPK001-F","y": -10.9237055,"x": -74.8747172887353},
  {"name": "JNPK002-F","y": -10.9267195,"x": -74.8767710371972},
  {"name": "ICMC015-F","y": -15.377499,"x": -75.1581261325449},
  {"name": "JNPK003-F","y": -10.923852,"x": -74.8698831662388},
  {"name": "JNPK004-F","y": -10.9259745,"x": -74.8710281074654},
  {"name": "JNPK005-F","y": -10.929175,"x": -74.8743645260376},
  {"name": "JNPK006-F","y": -10.93178,"x": -74.8721028122089},
  {"name": "JNPK007-F","y": -10.93469225,"x": -74.8682462991079},
  {"name": "PAOX001-F","y": -10.576046,"x": -75.4055162966075},
  {"name": "PAOX003-F","y": -10.5762475,"x": -75.4011449708981},
  {"name": "PAOX004-F","y": -10.579005,"x": -75.3997197671127},
  {"name": "PAOX006-F","y": -10.581319,"x": -75.3969480013624},
  {"name": "PAOX007-F","y": -10.5708485,"x": -75.4056898626515},
  {"name": "PAOX008-F","y": -10.5826814,"x": -75.4060298616622},
  {"name": "SMBV001-F","y": -7.0634005,"x": -76.5924085527077},
  {"name": "HYTB005-S // HYTB005","y": -12.0598787,"x": -75.2179765883265},
  {"name": "SMBV002-F","y": -7.0660285,"x": -76.5879915974138},
  {"name": "ICMC004-F","y": -15.368775,"x": -75.1566373245056},
  {"name": "SMBV003-F","y": -7.066211,"x": -76.5848351333969},
  {"name": "SMBV004-F","y": -7.0646455,"x": -76.5828187450221},
  {"name": "SMBV005-F","y": -7.059548,"x": -76.5899444379372},
  {"name": "SMBV006-F","y": -7.05408,"x": -76.5913515128135},
  {"name": "SMBV007-F","y": -7.054377,"x": -76.5861442522899},
  {"name": "ICMC001-F","y": -15.3720915,"x": -75.1589478465909},
  {"name": "ICMC002-F","y": -15.369474,"x": -75.1592267755177},
  {"name": "ICMC003-F","y": -15.367095,"x": -75.16080908413},
  {"name": "ICMC005-F","y": -15.365539,"x": -75.1570173530061},
  {"name": "ICMC006-F","y": -15.364022,"x": -75.1599430938866},
  {"name": "ICMC007-F","y": -15.3676095,"x": -75.164087977926},
  {"name": "ICMC009-F","y": -15.3595455,"x": -75.1758452621951},
  {"name": "ICMC010-F","y": -15.3635865,"x": -75.162253884777},
  {"name": "ICMC011-F","y": -15.3636175,"x": -75.1675393069447},
  {"name": "ICMC012-F","y": -15.3661478,"x": -75.1746784081539},
  {"name": "ICMC013-F","y": -15.3695775,"x": -75.165220944996},
  {"name": "ICMC014-F","y": -15.374911,"x": -75.1564198643531},
  {"name": "JNPN001-F","y": -10.9226687,"x": -74.8806682377837},
  {"name": "JNPN002-F","y": -10.917998,"x": -74.8813061175472},
  {"name": "JNPN003-F","y": -10.92091385,"x": -74.8790634330417},
  {"name": "JNJA014-F","y": -11.7860285,"x": -75.4931017269737},
  {"name": "SMBS001-F","y": -6.4940055,"x": -76.3571108630207},
  {"name": "SMBS002-F","y": -6.4944425,"x": -76.3540682008203},
  {"name": "SMBS003-F","y": -6.4968645,"x": -76.3548735930315},
  {"name": "SMBS008-F","y": -6.501176,"x": -76.3468230742976},
  {"name": "SMBS004-F","y": -6.496419,"x": -76.3483634564534},
  {"name": "SMBS005-F","y": -6.4977305,"x": -76.3511256649478},
  {"name": "SMTP053-F","y": -6.48635,"x": -76.3465618829787},
  {"name": "HYCH001","y": -12.078264,"x": -75.2055995888379},
  {"name": "SMBS006-F","y": -6.494573,"x": -76.3418855833585},
  {"name": "SMBS007-F","y": -6.4968555,"x": -76.343424746972},
  {"name": "SMBS009-F","y": -6.5051325,"x": -76.3480488055227},
  {"name": "SMTP037-F","y": -6.487015,"x": -76.3533041257821},
  {"name": "SMTP038-F","y": -6.491931,"x": -76.3539702151999},
  {"name": "SMTP039-F","y": -6.4920105,"x": -76.3499833883672},
  {"name": "SMTP054-F","y": -6.484193,"x": -76.3432878915453},
  {"name": "SMTP055-F","y": -6.49049,"x": -76.3435914916628},
  {"name": "HYCH005","y": -12.0811105,"x": -75.2047367404139},
  {"name": "SMTP056-F","y": -6.492013,"x": -76.345901699187},
  {"name": "JNJA002-F","y": -11.7758715,"x": -75.5007334094293},
  {"name": "JNJA008-F","y": -11.776853,"x": -75.5028109873494},
  {"name": "JNCH003-F","y": -12.0832455,"x": -75.2156944597577},
  {"name": "HYCH004-S // HYCH004","y": -12.0805835,"x": -75.2079198723545},
  {"name": "JNCH004-F","y": -12.0853334,"x": -75.2150459962652},
  {"name": "JNCH005-F","y": -12.0820483,"x": -75.2122982489113},
  {"name": "HYCH006","y": -12.079404,"x": -75.202093139434},
  {"name": "JNCH006-F","y": -12.082841,"x": -75.210756748506},
  {"name": "HYCH007-S // HYCH007","y": -12.0840368,"x": -75.2062366398803},
  {"name": "HYCH008","y": -12.0808935,"x": -75.19975271},
  {"name": "HYCH012","y": -12.0853345,"x": -75.2033517231486},
  {"name": "HYCH013-S // HYCH013","y": -12.0847355,"x": -75.2014060283974},
  {"name": "HYCH014","y": -12.0845075,"x": -75.1986254920509},
  {"name": "HYCH015-S  // HYCH015","y": -12.0883395,"x": -75.2046132982291},
  {"name": "JNJA013-F","y": -11.7858735,"x": -75.490472182843},
  {"name": "JNJA015-F","y": -11.7896935,"x": -75.4877340177431},
  {"name": "JNTB001-F","y": -12.0300235,"x": -75.2392307964626},
  {"name": "HYTB001-S // HYTB001","y": -12.0520025,"x": -75.2120732530893},
  {"name": "HYTB002-S // HYTB002","y": -12.0550065,"x": -75.2098147218996},
  {"name": "HYTB049-F","y": -12.0411135,"x": -75.2288128280125},
  {"name": "JNTB002-F","y": -12.030235,"x": -75.2363582222582},
  {"name": "HYTB003-S // HYTB003","y": -12.064908,"x": -75.2152021113681},
  {"name": "JNTB003-F","y": -12.0273455,"x": -75.239674165017},
  {"name": "JNTB004-F","y": -12.0289845,"x": -75.2340748985519},
  {"name": "JNTB006-F","y": -12.0298075,"x": -75.2305198539367},
  {"name": "HYTB006-S // HYTB006","y": -12.0578745,"x": -75.2199574235107},
  {"name": "HYTB007-S // HYTB007","y": -12.0497185,"x": -75.2251292058947},
  {"name": "JNTB007-F","y": -12.047317,"x": -75.2207146957328},
  {"name": "HYTB008-S // HYTB008","y": -12.046806,"x": -75.2288236278715},
  {"name": "JNTB008-F","y": -12.0245885,"x": -75.2334743092293},
  {"name": "HYTB009","y": -12.0461975,"x": -75.2258230075984},
  {"name": "JNTB009-F","y": -12.0447465,"x": -75.2217783625675},
  {"name": "JNTB063-F","y": -12.062162,"x": -75.2333002181286},
  {"name": "JNTB010-F","y": -12.0440315,"x": -75.2179411344086},
  {"name": "JNTB011-F","y": -12.035856,"x": -75.2293695065144},
  {"name": "JNTB011-F","y": -12.0350285,"x": -75.2282043208863},
  {"name": "JNTB012-F","y": -12.0344705,"x": -75.2258553288913},
  {"name": "JNTB013-F","y": -12.0323805,"x": -75.2267989438575},
  {"name": "JNTB014-F","y": -12.029759,"x": -75.2287071087786},
  {"name": "JNTB015-F","y": -12.0672615,"x": -75.2237886155462},
  {"name": "JNTB022-F","y": -12.021607,"x": -75.2326392779218},
  {"name": "JNTB016-F","y": -12.0652615,"x": -75.2231997662722},
  {"name": "JNTB017-F","y": -12.0627665,"x": -75.222002948388},
  {"name": "JNTB018-F","y": -12.0615965,"x": -75.2208497151155},
  {"name": "JNTB019-F","y": -12.0645625,"x": -75.2202121553816},
  {"name": "JNTB020-F","y": -12.0666415,"x": -75.2191130397332},
  {"name": "JNTB021-F","y": -12.0222085,"x": -75.2375998709895},
  {"name": "JNTB028-F","y": -12.0695325,"x": -75.2227329966446},
  {"name": "JNTB023-F","y": -12.0189135,"x": -75.2273441812463},
  {"name": "JNTB024-F","y": -12.0223935,"x": -75.2282360239595},
  {"name": "JNTB025-F","y": -12.025567,"x": -75.2264102677682},
  {"name": "JNTB049-F","y": -12.0487305,"x": -75.2142534951376},
  {"name": "JNTB026-F","y": -12.030823,"x": -75.2249273374201},
  {"name": "JNTB027-F","y": -12.0686085,"x": -75.2261233680376},
  {"name": "JNTB042-F","y": -12.0395855,"x": -75.2220864739264},
  {"name": "JNTB029-F","y": -12.0690845,"x": -75.2201269737871},
  {"name": "JNTB034-F","y": -12.027753,"x": -75.2252106567944},
  {"name": "JNTB035-F","y": -12.0255525,"x": -75.2233701163856},
  {"name": "JNTB036-F","y": -12.0208335,"x": -75.2229235853604},
  {"name": "JNTB037-F","y": -12.0240335,"x": -75.2183758301557},
  {"name": "JNTB039-F","y": -12.030667,"x": -75.2199092448828},
  {"name": "JNTB040-F","y": -12.0368565,"x": -75.225778377478},
  {"name": "JNTB041-F","y": -12.040215,"x": -75.225704643617},
  {"name": "HYTB052-F","y": -12.051656,"x": -75.2340827470484},
  {"name": "JNTB043-F","y": -12.0388265,"x": -75.2186941814915},
  {"name": "JNTB044-F","y": -12.036067,"x": -75.2213399798686},
  {"name": "JNTB045-F","y": -12.0492155,"x": -75.2178020067783},
  {"name": "JNTB046-F","y": -12.046978,"x": -75.2143794284497},
  {"name": "JNTB047-F","y": -12.051921,"x": -75.2169875372792},
  {"name": "HYTB048-F","y": -12.041082,"x": -75.2316897965564},
  {"name": "HYTB050-F","y": -12.044496,"x": -75.2327977517212},
  {"name": "HYTB051-F","y": -12.0487813,"x": -75.2307854538557},
  {"name": "JNTB051-F","y": -12.048765,"x": -75.2076918367591},
  {"name": "JNTB052-F","y": -12.0508185,"x": -75.2063783904317},
  {"name": "HYTB053-F","y": -12.0539565,"x": -75.2295993280633},
  {"name": "HYTB053-F","y": -12.051553,"x": -75.2309256857284},
  {"name": "JNTB053-F","y": -12.043851,"x": -75.2401017947415},
  {"name": "JNTB054-F","y": -12.04339,"x": -75.2344477842986},
  {"name": "LAMO029","y": -12.069173,"x": -76.9370405789474},
  {"name": "HYTB054-F","y": -12.05525405,"x": -75.2267193900437},
  {"name": "JNTB055-F","y": -12.0455185,"x": -75.2358034030527},
  {"name": "HYTB055-F","y": -12.0572975,"x": -75.2298808902027},
  {"name": "JNTB056-F","y": -12.049447,"x": -75.2338322645631},
  {"name": "HYTB056-F","y": -12.058904,"x": -75.2288490049773},
  {"name": "JNTB057-F","y": -12.0513615,"x": -75.2376823634589},
  {"name": "HYTB057-F","y": -12.0568323,"x": -75.2259527738836},
  {"name": "HYTB058-F","y": -12.052123,"x": -75.2237631230985},
  {"name": "HYTB059-F","y": -12.051285,"x": -75.2200373240674},
  {"name": "JNTB059-F","y": -12.0550075,"x": -75.2341295548933},
  {"name": "HYTB060-F","y": -12.053172,"x": -75.2225255361445},
  {"name": "JNTB060-F","y": -12.054699,"x": -75.2370910766416},
  {"name": "HYTB061-F","y": -12.0555655,"x": -75.2223852315763},
  {"name": "JNTB061-F","y": -12.0582255,"x": -75.237307375},
  {"name": "HYTB062-F","y": -12.0545815,"x": -75.2196596883819},
  {"name": "HZHU018-F","y": -9.524569,"x": -77.5262253370776},
  {"name": "JNTB062-F","y": -12.060383,"x": -75.2348254065934},
  {"name": "HYTB063-F","y": -12.053499,"x": -75.2153828496454},
  {"name": "HYTB064-F","y": -12.0554315,"x": -75.2164159553352},
  {"name": "HYTB065-F","y": -12.057374,"x": -75.2157458842252},
  {"name": "JNTB065-F","y": -12.0570655,"x": -75.2316708027728},
  {"name": "HYTB066-F","y": -12.056384,"x": -75.2136194821374},
  {"name": "JNTB066-F","y": -12.0545315,"x": -75.2315327094891},
  {"name": "HYTB067-F","y": -12.058798,"x": -75.2146847956416},
  {"name": "JNTB067-F","y": -12.063705,"x": -75.2262075119636},
  {"name": "HYTB068-F","y": -12.0603415,"x": -75.2132969694907},
  {"name": "JNTB068-F","y": -12.065278,"x": -75.2281879811105},
  {"name": "JNTB069-F","y": -12.066013,"x": -75.2264059449907},
  {"name": "HYTB070-F","y": -12.0596675,"x": -75.2118462002579},
  {"name": "HYTB071-F","y": -12.062104,"x": -75.2295325086089},
  {"name": "HYTB072-F","y": -12.060873,"x": -75.2268753224316},
  {"name": "HYTB073-F","y": -12.0583402,"x": -75.2241896791842},
  {"name": "HYTB075-F","y": -12.0605525,"x": -75.2223136858892},
  {"name": "JNLO001-F","y": -11.519321,"x": -75.9008391525724},
  {"name": "HYHY001","y": -12.0390985,"x": -75.1897683933652},
  {"name": "ANCM007-F","y": -9.476082,"x": -78.2999200698429},
  {"name": "JNHY001-F","y": -12.045079,"x": -75.1981530333923},
  {"name": "HYHY002-S // HYHY002","y": -12.04234175,"x": -75.1924801014151},
  {"name": "HYHY003","y": -12.0477431,"x": -75.1935070208717},
  {"name": "JNHY003-F","y": -12.0493605,"x": -75.1885763422163},
  {"name": "HYHY004","y": -12.050504,"x": -75.1984051837501},
  {"name": "JNHY004-F","y": -12.0638745,"x": -75.1986467361227},
  {"name": "HYHY005","y": -12.0521005,"x": -75.2002368842799},
  {"name": "JNHY005-F","y": -12.0649285,"x": -75.1978273658537},
  {"name": "JNHY006-F","y": -12.05236,"x": -75.1955364915886},
  {"name": "JNHY007-F","y": -12.0501615,"x": -75.1918036644422},
  {"name": "HYHY007-S // HYHY007","y": -12.063299,"x": -75.2064989631623},
  {"name": "JNHY008-F","y": -12.052268,"x": -75.1893833680334},
  {"name": "JNHY024-F","y": -12.056132,"x": -75.1930369620142},
  {"name": "JNHY009-F","y": -12.037328,"x": -75.1966890218983},
  {"name": "HYHY010","y": -12.0673325,"x": -75.2049989979256},
  {"name": "JNHY010-F","y": -12.0382545,"x": -75.1938355524476},
  {"name": "HZHU019-F","y": -9.525904,"x": -77.5263698075103},
  {"name": "JNHY011-F","y": -12.0367685,"x": -75.1916904742857},
  {"name": "HYHY011-S // HYHY011","y": -12.0550645,"x": -75.2028329758523},
  {"name": "HYHY012","y": -12.0560865,"x": -75.2006724646726},
  {"name": "JNHY012-F","y": -12.0340555,"x": -75.190254783557},
  {"name": "HYHY013","y": -12.059139,"x": -75.2067815494279},
  {"name": "JNHY013-F","y": -12.04583,"x": -75.187562630579},
  {"name": "HYHY014","y": -12.059476,"x": -75.2041030739278},
  {"name": "JNHY014-F","y": -12.0516565,"x": -75.1863030658017},
  {"name": "HYHY015-S // HYHY015","y": -12.0611465,"x": -75.2009872859477},
  {"name": "JNHY016-F","y": -12.0725865,"x": -75.2304338566989},
  {"name": "JNHY017-F","y": -12.072308,"x": -75.2270678715681},
  {"name": "HYHY018-S // HYHY018","y": -12.0702325,"x": -75.2162162157525},
  {"name": "JNHY018-F","y": -12.074375,"x": -75.2281743766798},
  {"name": "JNHY019-F","y": -12.0766435,"x": -75.2282830267322},
  {"name": "HYHY019-S // HYHY019","y": -12.073093,"x": -75.2184693544478},
  {"name": "LMLV140-F","y": -12.06354,"x": -77.0150357107108},
  {"name": "HYHY020","y": -12.076779,"x": -75.2213132701238},
  {"name": "JNHY020-F","y": -12.0741605,"x": -75.2240779968815},
  {"name": "HYHY021-S // HYHY021","y": -12.077992,"x": -75.2257672629623},
  {"name": "JNHY021-F","y": -12.0607735,"x": -75.1969204592153},
  {"name": "HYHY022-S // HYHY022","y": -12.075058,"x": -75.2168126331771},
  {"name": "JNHY022-F","y": -12.059143,"x": -75.1933210028831},
  {"name": "HYHY023-S // HYHY023","y": -12.073909,"x": -75.2138269384464},
  {"name": "JNHY023-F","y": -12.0571315,"x": -75.1959815896205},
  {"name": "JNHY025-F","y": -12.0564005,"x": -75.188662037777},
  {"name": "JNHY034-F","y": -12.07419,"x": -75.2096451412831},
  {"name": "JNHY026-F","y": -12.057086,"x": -75.186596515625},
  {"name": "JNHY027-F","y": -12.0592785,"x": -75.1893769365547},
  {"name": "HYHY028-S // HYHY028","y": -12.0757895,"x": -75.212398112438},
  {"name": "JNHY028-F","y": -12.027582,"x": -75.188887868932},
  {"name": "JNHY029-F","y": -12.0238675,"x": -75.1914353144288},
  {"name": "HYHY029","y": -12.0770385,"x": -75.2138920190277},
  {"name": "JNHY030-F","y": -12.0242105,"x": -75.186753251639},
  {"name": "JNHY031-F","y": -12.069169,"x": -75.2140143204989},
  {"name": "JNHY032-F","y": -12.07087,"x": -75.2123744485853},
  {"name": "JNHY033-F","y": -12.0736715,"x": -75.2115377640532},
  {"name": "HYHY034-S // HYHY034","y": -12.076396,"x": -75.2070283375882},
  {"name": "HYHY035","y": -12.077256,"x": -75.2093585561885},
  {"name": "JNHY035-F","y": -12.071295,"x": -75.2059930227273},
  {"name": "HYHY036-S // HYHY036","y": -12.0540585,"x": -75.204638161527},
  {"name": "JNHY036-F","y": -12.0662215,"x": -75.2085728582942},
  {"name": "HYHY037","y": -12.0625605,"x": -75.2096323429784},
  {"name": "JNHY040-F","y": -12.044738,"x": -75.1914826730361},
  {"name": "SMTP002-F","y": -6.4755005,"x": -76.3721624798772},
  {"name": "SMTP036-F","y": -6.4964948,"x": -76.3612108097546},
  {"name": "SMTP003-F","y": -6.470859,"x": -76.3658537432392},
  {"name": "SMTP004-F","y": -6.470501,"x": -76.3602376493898},
  {"name": "SMTP005-F","y": -6.4806685,"x": -76.3709515617875},
  {"name": "SMTP006-F","y": -6.4778685,"x": -76.3686741366236},
  {"name": "SMTP022-F","y": -6.4922255,"x": -76.3604134769681},
  {"name": "SMTP057-F","y": -6.487184,"x": -76.3763796112205},
  {"name": "SMTP007-F","y": -6.474923,"x": -76.3666726310256},
  {"name": "SMTP008-F","y": -6.473072,"x": -76.3633121214099},
  {"name": "SMTP009-F","y": -6.484417,"x": -76.3684909382637},
  {"name": "SMTP010-F","y": -6.4830685,"x": -76.3667883317157},
  {"name": "SMTP011-F","y": -6.4803955,"x": -76.3649556658515},
  {"name": "ZONA SATURADA","y": -12.2128175,"x": -76.9366444126506},
  {"name": "SMTP012-F","y": -6.4778295,"x": -76.3626082243691},
  {"name": "SMTP013-F","y": -6.4751885,"x": -76.3590487116846},
  {"name": "SMTP014-F","y": -6.486896,"x": -76.3663217323891},
  {"name": "SMTP015-F","y": -6.482621,"x": -76.3620474746379},
  {"name": "SMTP016-F","y": -6.479694,"x": -76.3588398405338},
  {"name": "ICAX001-S // ICAX001","y": -14.0858495,"x": -75.7253223766312},
  {"name": "SMTP017-F","y": -6.4865865,"x": -76.3644870438797},
  {"name": "SMTP018-F","y": -6.485709,"x": -76.3617636805239},
  {"name": "SMTP019-F","y": -6.4827345,"x": -76.3584266800074},
  {"name": "SMTP020-F","y": -6.4899215,"x": -76.3625542571214},
  {"name": "SMTP021-F","y": -6.4854745,"x": -76.3579716556959},
  {"name": "SMTP023-F","y": -6.4890795,"x": -76.3595505514085},
  {"name": "SMTP024-F","y": -6.487134,"x": -76.3563666076296},
  {"name": "SMTP025-F","y": -6.4844335,"x": -76.3754873848898},
  {"name": "SMTP026-F","y": -6.485585,"x": -76.3719209533764},
  {"name": "SMTP027-F","y": -6.4875115,"x": -76.3705886460606},
  {"name": "SMTP028-F","y": -6.490019,"x": -76.368946221223},
  {"name": "SMTP029-F","y": -6.4936755,"x": -76.3724257076479},
  {"name": "SMTP030-F","y": -6.493503,"x": -76.3685669710425},
  {"name": "SMTP031-F","y": -6.4930765,"x": -76.3654315016243},
  {"name": "SMTP032-F","y": -6.4976385,"x": -76.3691936649076},
  {"name": "SMTP033-F","y": -6.5021755,"x": -76.3653496499491},
  {"name": "SMTP034-F","y": -6.49846,"x": -76.3645104011573},
  {"name": "SMTP035-F","y": -6.4944135,"x": -76.3630456955128},
  {"name": "SMTP058-F","y": -6.4899985,"x": -76.375528268418},
  {"name": "SMTP059-F","y": -6.492795,"x": -76.3760487589928},
  {"name": "SMTP060-F","y": -6.4963555,"x": -76.3767244984277},
  {"name": "SMTP061-F","y": -6.4971365,"x": -76.3780080807506},
  {"name": "SMTP062-F","y": -6.500189,"x": -76.3779697798327},
  {"name": "ICAX002-S // ICAX002","y": -14.083811,"x": -75.7244322673245},
  {"name": "SMTP063-F","y": -6.5021765,"x": -76.3700800833757},
  {"name": "SMTP064-F","y": -6.5068775,"x": -76.3684307734614},
  {"name": "AQMF006-S // AQMF006","y": -16.3932895,"x": -71.5256617484457},
  {"name": "LMLM207-F","y": -12.0391405,"x": -77.0502248478546},
  {"name": "LMLM206-F","y": -12.037758,"x": -77.0509083959871},
  {"name": "ICAX003-S // ICAX003","y": -14.0817855,"x": -75.7233959630005},
  {"name": "LMLM206-F","y": -12.0379255,"x": -77.0528192347329},
  {"name": "LMLR026-F","y": -12.2889355,"x": -76.8522287802139},
  {"name": "LMLR027-F","y": -12.2911465,"x": -76.8530800625},
  {"name": "LMSC434-F","y": -12.1390665,"x": -77.0128208690552},
  {"name": "LMRC062-F","y": -12.040621,"x": -77.0253626052854},
  {"name": "LMLC080-F","y": -12.087652,"x": -77.0373782299259},
  {"name": "LMLM023-S // LMLM023","y": -12.055309,"x": -77.0589534418774},
  {"name": "LMCO036-S // LMCO036","y": -11.9085885,"x": -77.0454114523759},
  {"name": "AYJN004-S // AYJN004","y": -13.1502305,"x": -74.2148232653836},
  {"name": "AYJN005-S // AYJN005","y": -13.151996,"x": -74.2166841555038},
  {"name": "AYJN006-S //AYJN006","y": -13.152349,"x": -74.2138843885249},
  {"name": "ICAX005","y": -14.073123,"x": -75.7249059570538},
  {"name": "ICAX006-S // ICAX006","y": -14.078368,"x": -75.727239804991},
  {"name": "ICAX007-S // ICAX007","y": -14.0741635,"x": -75.7283003826123},
  {"name": "ICAX009","y": -14.0582255,"x": -75.7325830255184},
  {"name": "AYJN008-S // AYJN008","y": -13.155844,"x": -74.2168503480682},
  {"name": "ICAX004-S // ICAX004","y": -14.078569,"x": -75.7244544042077},
  {"name": "AYJN009-S // AYJN009","y": -13.1574485,"x": -74.2181867360262},
  {"name": "AYJN010-F","y": -13.1474527,"x": -74.2137155259699},
  {"name": "AYJN011-F","y": -13.1525545,"x": -74.2124223408742},
  {"name": "AYJN012-F","y": -13.1514995,"x": -74.2159641215277},
  {"name": "ICAX010","y": -14.0577295,"x": -75.7459090099403},
  {"name": "PUJL019-F","y": -15.479814,"x": -70.1429533552937},
  {"name": "ICAX011-S // ICAX011","y": -14.0585735,"x": -75.7487693573664},
  {"name": "ICAX012","y": -14.054667,"x": -75.7492135077233},
  {"name": "ICAX013","y": -14.054271,"x": -75.7486967817221},
  {"name": "ICAX013","y": -14.0545085,"x": -75.7462060607042},
  {"name": "ICAX013","y": -14.053314,"x": -75.7477474520777},
  {"name": "ICAX015-S // ICAX015","y": -14.073914,"x": -75.7216678211253},
  {"name": "ICAX029","y": -14.1032305,"x": -75.7227579778929},
  {"name": "ICAX072-F","y": -14.0997825,"x": -75.7516594709987},
  {"name": "ICAX016-S // ICAX016","y": -14.056646,"x": -75.7406120618449},
  {"name": "ICAX017","y": -14.0523095,"x": -75.7592328353256},
  {"name": "ICAX018","y": -14.0582195,"x": -75.7361018633266},
  {"name": "ICAX019-S // ICAX019","y": -14.0750585,"x": -75.7440784205621},
  {"name": "ICAX020-S // ICAX020","y": -14.070228,"x": -75.7362776896873},
  {"name": "ICAX021-S // ICAX021","y": -14.07927,"x": -75.7481361938493},
  {"name": "ICAX030","y": -14.096372,"x": -75.7219948367882},
  {"name": "ICAX022-S // ICAX022","y": -14.0685525,"x": -75.7286851414474},
  {"name": "ICAX023-S // ICAX023","y": -14.077327,"x": -75.7413932535254},
  {"name": "ICAX024","y": -14.079395,"x": -75.7383147463321},
  {"name": "ICAX025-S // ICAX025","y": -14.0844975,"x": -75.742223808393},
  {"name": "ICAX026","y": -14.07991,"x": -75.7409194757844},
  {"name": "ICAX027-S // ICAX027","y": -14.100117,"x": -75.7218337489314},
  {"name": "ICAX028-S // ICAX028","y": -14.101626,"x": -75.7228108569862},
  {"name": "ICAX031","y": -14.0974685,"x": -75.7200782965799},
  {"name": "ICSB006-S // ICSB006","y": -14.030997,"x": -75.7382352243328},
  {"name": "ICAX033-S // ICAX033","y": -14.052806,"x": -75.7439855058234},
  {"name": "ICAX034-S // ICAX034","y": -14.0548605,"x": -75.7354024987589},
  {"name": "ICAX035-S // ICAX035","y": -14.0657635,"x": -75.7362704165326},
  {"name": "ICAX036","y": -14.066735,"x": -75.731356178743},
  {"name": "ICAX037-S // ICAX037","y": -14.0692405,"x": -75.7347202605294},
  {"name": "ICAX038","y": -14.0722935,"x": -75.7307113819721},
  {"name": "ICAX039","y": -14.0721765,"x": -75.7229298330442},
  {"name": "ICAX040-S // ICAX040","y": -14.076964,"x": -75.7211096021889},
  {"name": "PUJL020-F","y": -15.4822485,"x": -70.1431705787508},
  {"name": "ICAX041","y": -14.0788495,"x": -75.7366939750475},
  {"name": "ICAX042-S // ICAX042","y": -14.0834785,"x": -75.7374264385593},
  {"name": "PUJL021-F","y": -15.48515,"x": -70.1446377252856},
  {"name": "ICAX043-S // ICAX043","y": -14.0804655,"x": -75.7330923619733},
  {"name": "ICAX044","y": -14.0843375,"x": -75.7285484289976},
  {"name": "ICAX045-S // ICAX045","y": -14.0824415,"x": -75.7266983927878},
  {"name": "ANCB004-F","y": -9.05052805,"x": -78.5777375846233},
  {"name": "ICAX046","y": -14.0812085,"x": -75.7512577856435},
  {"name": "ICAX048-S // ICAX048","y": -14.0684615,"x": -75.7420604089665},
  {"name": "ICAX049","y": -14.063928,"x": -75.7426495472779},
  {"name": "ICAX050-S // ICAX050","y": -14.0886,"x": -75.745371682465},
  {"name": "PUJL028-F","y": -15.4895335,"x": -70.141928961701},
  {"name": "ICAX051","y": -14.090108,"x": -75.7422394076655},
  {"name": "ICAX052","y": -14.0650985,"x": -75.7246057168607},
  {"name": "LMSA045","y": -12.033169,"x": -76.9607515130112},
  {"name": "ICSB005-S // ICSB005","y": -14.0331085,"x": -75.7394237100281},
  {"name": "ICAX058","y": -14.073868,"x": -75.7515092817939},
  {"name": "ICAX053","y": -14.067569,"x": -75.7271548962328},
  {"name": "ICAX054","y": -14.068771,"x": -75.7249197038688},
  {"name": "AYAC011-F","y": -13.1675565,"x": -74.1974017610631},
  {"name": "AYAY051-F","y": -13.127503,"x": -74.227559428365},
  {"name": "ICAX055","y": -14.070133,"x": -75.7272548216338},
  {"name": "ICAX056","y": -14.0696205,"x": -75.7229097128859},
  {"name": "ICAX057-S // ICAX057","y": -14.0853165,"x": -75.7449072922709},
  {"name": "ICAX062","y": -14.045684,"x": -75.7457718738834},
  {"name": "PUJL029-F","y": -15.489709,"x": -70.136569035616},
  {"name": "AYAY015","y": -13.1487855,"x": -74.2254456449697},
  {"name": "ICAX063","y": -14.04359,"x": -75.7406683535566},
  {"name": "ICAX066","y": -14.107081,"x": -75.7247528206522},
  {"name": "ICAX067","y": -14.107211,"x": -75.7223193408508},
  {"name": "ICAX068-F","y": -14.0392175,"x": -75.7432364519231},
  {"name": "ICSB008-S // ICSB008","y": -14.019411,"x": -75.7590609766845},
  {"name": "ICAX069-F","y": -14.041218,"x": -75.7419321384956},
  {"name": "ICAX070-F","y": -14.1006755,"x": -75.7201064173625},
  {"name": "ICAX071-F","y": -14.076444,"x": -75.7483843922487},
  {"name": "ICAX073-F","y": -14.098048,"x": -75.7473338962713},
  {"name": "ICAX074-F","y": -14.0828845,"x": -75.7394509665585},
  {"name": "ICAX075-F","y": -14.0787335,"x": -75.7389850453493},
  {"name": "AYAY026","y": -13.152183,"x": -74.2244547333015},
  {"name": "ICAX076-F","y": -14.064921,"x": -75.7278770742883},
  {"name": "ZONA SATURADA","y": -11.99896,"x": -77.0019736077464},
  {"name": "ICSB013-F","y": -14.043595,"x": -75.7552967445932},
  {"name": "ICAX077-F","y": -14.0617625,"x": -75.7309314583333},
  {"name": "ICAX078-F","y": -14.0614695,"x": -75.7277997845787},
  {"name": "ICAX079-F","y": -14.0611145,"x": -75.746914345939},
  {"name": "ICAX080-F","y": -14.054752,"x": -75.7474328296042},
  {"name": "ICAX081-F","y": -14.079492,"x": -75.7193649079974},
  {"name": "ICAX083-F","y": -14.077104,"x": -75.7521014298332},
  {"name": "AYAY018-S // AYAY018","y": -13.151968,"x": -74.2215077440875},
  {"name": "ICAX084-F","y": -14.079231,"x": -75.7668283260072},
  {"name": "AYAY001-S // AYAY001","y": -13.135424,"x": -74.2316272366548},
  {"name": "AYAY002","y": -13.136615,"x": -74.2273394101423},
  {"name": "HZHU001-F","y": -9.5275305,"x": -77.5352118913043},
  {"name": "AYAY003-S // AYAY003","y": -13.13837,"x": -74.2249896549458},
  {"name": "CZSS012","y": -13.5407255,"x": -71.9291741379622},
  {"name": "AYAY004-S // AYAY004","y": -13.138995,"x": -74.2303965091527},
  {"name": "HVHV006-F","y": -12.7857245,"x": -74.9708866607207},
  {"name": "AYAY005-S // AYAY005","y": -13.1405565,"x": -74.2273656808572},
  {"name": "AYAY007-S // AYAY007","y": -13.142006,"x": -74.2297373994453},
  {"name": "AYAY008-S // AYAY008","y": -13.1451715,"x": -74.2250209137931},
  {"name": "AYAC017-F","y": -13.1461705,"x": -74.2063153680331},
  {"name": "AYAY010-S // AYAY010","y": -13.145224,"x": -74.2278926017243},
  {"name": "AYAC010-F","y": -13.156805,"x": -74.1971979070659},
  {"name": "AYHU007-F","y": -12.9401205,"x": -74.2473748583333},
  {"name": "AYAY019-S // AYAY019","y": -13.1557465,"x": -74.2222098902048},
  {"name": "AYAY011-S // AYAY011","y": -13.1473325,"x": -74.2302930699002},
  {"name": "ANCB049-F","y": -9.0761082,"x": -78.6002117357602},
  {"name": "AYAC012-F","y": -13.1638865,"x": -74.1974932088423},
  {"name": "CBNV025-S // CBNV025","y": -9.12092565,"x": -78.5256392223165},
  {"name": "AYAY012-S // AYAY012","y": -13.146849,"x": -74.227290670791},
  {"name": "AYAY013-S // AYAY013","y": -13.1514075,"x": -74.2319785577736},
  {"name": "HZHU001-F","y": -9.5291945,"x": -77.5346387984581},
  {"name": "AYAC013-F","y": -13.1602645,"x": -74.2003574213287},
  {"name": "AYAY014-S // AYAY014","y": -13.150343,"x": -74.2288555060976},
  {"name": "ICTG012","y": -14.043777,"x": -75.7099307140288},
  {"name": "AYAC014-F","y": -13.1563155,"x": -74.2009101832936},
  {"name": "AYAC015-F","y": -13.152367,"x": -74.2009199012064},
  {"name": "AYAC019-F","y": -13.160571,"x": -74.215156074884},
  {"name": "CBNV026-S // CBNV026","y": -9.12062535,"x": -78.5236533578985},
  {"name": "AYAC016-F","y": -13.15456,"x": -74.1958369739955},
  {"name": "AYAY016-S // AYAY016","y": -13.153421,"x": -74.2310509502112},
  {"name": "LMLV141-F","y": -12.063329,"x": -77.0158341459656},
  {"name": "AYAY027-F","y": -13.15534,"x": -74.2275702631619},
  {"name": "AYAC018-F","y": -13.1543105,"x": -74.2075327514395},
  {"name": "AYAY019-S // AYAY019","y": -13.153708,"x": -74.2196679610952},
  {"name": "AYAY028-F","y": -13.157028,"x": -74.2220948679818},
  {"name": "CBCB046","y": -9.093083,"x": -78.5726261240244},
  {"name": "AYAY029-F","y": -13.159455,"x": -74.2172086182924},
  {"name": "ICSB004-S // ICSB004","y": -14.032665,"x": -75.7363257725299},
  {"name": "AYAY020-S // AYAY020","y": -13.1562335,"x": -74.2340061614053},
  {"name": "PUJL030-F","y": -15.4904465,"x": -70.1394591858142},
  {"name": "AYAY021-S // AYAY021","y": -13.157441,"x": -74.2315521629458},
  {"name": "LMAG057-F","y": -12.0306025,"x": -76.9627449676259},
  {"name": "AYAY022-S // AYAY022","y": -13.159079,"x": -74.2342801779049},
  {"name": "AYAY025-S // AYAY025","y": -13.163648,"x": -74.2320200530303},
  {"name": "AYAY033-F","y": -13.168747,"x": -74.2298235252693},
  {"name": "AYAY036-F","y": -13.143051,"x": -74.2314400598938},
  {"name": "AYAY046-F","y": -13.163324,"x": -74.2345509364952},
  {"name": "AYAY047-F","y": -13.1656805,"x": -74.2336691962188},
  {"name": "AYAY049-F","y": -13.1306875,"x": -74.2332748654146},
  {"name": "LMSC053-S","y": -12.132976,"x": -76.9852169365048},
  {"name": "AYSB020-S // AYSB020","y": -13.178604,"x": -74.2076722304707},
  {"name": "AYAY050-F","y": -13.1276305,"x": -74.231431777027},
  {"name": "AYAY052-F","y": -13.1620095,"x": -74.238559731315},
  {"name": "AYAY053-F","y": -13.1575875,"x": -74.2367800479484},
  {"name": "AYAY054-F","y": -13.153101,"x": -74.2347286814588},
  {"name": "AYAC005-S // AYAC005","y": -13.1644605,"x": -74.2141672878316},
  {"name": "AYAY055-F","y": -13.1488375,"x": -74.233248782546},
  {"name": "AYHU008-F","y": -12.941426,"x": -74.2514122534243},
  {"name": "AYAY056-F","y": -13.1454565,"x": -74.2327834244446},
  {"name": "AQCA024","y": -16.376751973144,"x": -71.5475394144428},
  {"name": "LMCA143-F","y": -12.0157185,"x": -77.0994528336278},
  {"name": "HVDH001-F","y": -12.3912748,"x": -74.8633955997674},
  {"name": "LMCO014","y": -11.934823,"x": -77.0598261055901},
  {"name": "HVDH002-F","y": -12.3945475,"x": -74.8621763098454},
  {"name": "HVDH003-F","y": -12.387628,"x": -74.8576362388908},
  {"name": "AYAC002-S // AYAC002","y": -13.1616995,"x": -74.213600336224},
  {"name": "AYAC003-S // AYAC003","y": -13.160899,"x": -74.2098945239058},
  {"name": "ICSB011-F","y": -14.02408245,"x": -75.7505198240498},
  {"name": "AYAC004-S // AYAC004","y": -13.1640935,"x": -74.2170085365385},
  {"name": "AYAC006-S // AYAC006","y": -13.1650415,"x": -74.2118904342621},
  {"name": "AYAC007-S // AYAC007","y": -13.169446,"x": -74.2047588077166},
  {"name": "AYAC008-S // AYAC008","y": -13.1697465,"x": -74.1998496704043},
  {"name": "AYAC009-S // AYAC009","y": -13.1698865,"x": -74.1974784764259},
  {"name": "HVPP001-F","y": -12.40043,"x": -74.8732159186471},
  {"name": "PUJL044-F","y": -15.481089,"x": -70.1180491058444},
  {"name": "HVPP002-F","y": -12.3963332,"x": -74.8723085614076},
  {"name": "HVPP003-F","y": -12.3977215,"x": -74.8680174879029},
  {"name": "HVPP004-F","y": -12.397863,"x": -74.8647679529796},
  {"name": "HVHV009-F","y": -12.7841425,"x": -74.9648273685832},
  {"name": "HVPP005-F","y": -12.4036275,"x": -74.8655842774685},
  {"name": "ICSB012-F","y": -14.0245095,"x": -75.7481798737102},
  {"name": "HVHV007-F","y": -12.786075,"x": -74.9686404950804},
  {"name": "HVPP006-F","y": -12.3938107,"x": -74.8671092912378},
  {"name": "HVHV001-F","y": -12.788163,"x": -74.9792043784461},
  {"name": "HVHV010-F","y": -12.78348,"x": -74.963174068},
  {"name": "HVHV002-F","y": -12.7874233,"x": -74.9777266385848},
  {"name": "HVHV003-F","y": -12.7874233,"x": -74.9758985799119},
  {"name": "HVHV004-F","y": -12.786522,"x": -74.9743538016066},
  {"name": "HVHV005-F","y": -12.7867155,"x": -74.9724734754108},
  {"name": "LMLM194-F","y": -12.0396625,"x": -77.0683530769231},
  {"name": "HVHV008-F","y": -12.7842191,"x": -74.966253034081},
  {"name": "LMCA048-S // LMCA048","y": -11.998225,"x": -77.1195566618166},
  {"name": "HVHV011-F","y": -12.783487,"x": -74.960316936722},
  {"name": "AYSB002","y": -13.166889,"x": -74.2203793694702},
  {"name": "HVHV012-F","y": -12.7836565,"x": -74.9723282724667},
  {"name": "HVHV013-F","y": -12.7833167,"x": -74.9695051263119},
  {"name": "HVHV014-F","y": -12.7817725,"x": -74.9712289124088},
  {"name": "AYPU001-F","y": -14.6988765,"x": -74.1336655483565},
  {"name": "AYPU006-F","y": -14.6918565,"x": -74.1252327817774},
  {"name": "AYSB003","y": -13.1660895,"x": -74.2167589005218},
  {"name": "AYPU002-F","y": -14.696435,"x": -74.1252748051616},
  {"name": "CBNV027-S // CBNV027","y": -9.1251882,"x": -78.5219486327709},
  {"name": "AYPU003-F","y": -14.696776,"x": -74.1215670865115},
  {"name": "AYPU003-F","y": -14.69298795,"x": -74.1208167577023},
  {"name": "AYPU004-F","y": -14.694066,"x": -74.1257041755967},
  {"name": "ICPA001-F","y": -13.8357785,"x": -76.247915469114},
  {"name": "LMLV124-F","y": -12.0658405,"x": -77.0151590288003},
  {"name": "AYPU005-F","y": -14.692142,"x": -74.1296130449003},
  {"name": "AYSB006-S // AYSB006","y": -13.1702775,"x": -74.2129704581801},
  {"name": "AYSB007-S // AYSB007","y": -13.168818,"x": -74.2115977387353},
  {"name": "AYPU007-F","y": -14.688543,"x": -74.1206513110896},
  {"name": "AYPU008-F","y": -14.686712,"x": -74.1258095385716},
  {"name": "AYSB001","y": -13.1685795,"x": -74.2222849090113},
  {"name": "ICPA002-F","y": -13.83521,"x": -76.2516502301166},
  {"name": "AYSB004-S // AYSB004","y": -13.1697415,"x": -74.2186631085526},
  {"name": "AYSB005","y": -13.17093205,"x": -74.2148287483846},
  {"name": "AYSB005","y": -13.168645,"x": -74.2167032889696},
  {"name": "ZONA SATURADA","y": -12.029297,"x": -76.9503597937439},
  {"name": "AYSB008-S // AYSB008","y": -13.1746605,"x": -74.2178968405979},
  {"name": "LMCA144-F","y": -12.013991,"x": -77.1004210910736},
  {"name": "LMLO115","y": -11.9507625,"x": -77.0728420843611},
  {"name": "AYSB009-S // AYSB009","y": -13.1733595,"x": -74.215552794318},
  {"name": "LMLM013-S","y": -12.0548115,"x": -77.0791412059194},
  {"name": "AYSB010-S // AYSB010","y": -13.1731395,"x": -74.2130398732235},
  {"name": "APAH002-F","y": -13.6571265,"x": -73.3780104216026},
  {"name": "AYSB011-S // AYSB011","y": -13.1729245,"x": -74.20790950723},
  {"name": "AYSB012-S // AYSB012","y": -13.1719415,"x": -74.2049740184502},
  {"name": "LMJR160-F","y": -12.1826471,"x": -76.9592455428465},
  {"name": "AYSB015-S // AYSB015","y": -13.176336,"x": -74.207422436319},
  {"name": "AYSB016","y": -13.173906,"x": -74.2013271190072},
  {"name": "AYSB017-S // AYSB017","y": -13.1745915,"x": -74.1974563685994},
  {"name": "AYSB019-S // AYSB019","y": -13.180143,"x": -74.2131733876317},
  {"name": "AYSB021-S // AYSB021","y": -13.1786155,"x": -74.2025075982502},
  {"name": "ICTA008-F","y": -13.708243,"x": -76.1463405914942},
  {"name": "AYSB022-S // AYSB022","y": -13.178738,"x": -74.1975765437159},
  {"name": "AYSB023-F","y": -13.1672535,"x": -74.2228183471831},
  {"name": "AYSB024-F","y": -13.166337,"x": -74.2202050715577},
  {"name": "AYSB025-F","y": -13.165674,"x": -74.2182177003707},
  {"name": "AYSB026-F","y": -13.1771305,"x": -74.2144202714026},
  {"name": "PUJL031-F","y": -15.490863,"x": -70.1417411025641},
  {"name": "AYSB027-F","y": -13.179262,"x": -74.1997830061237},
  {"name": "AYSB028-F","y": -13.176945,"x": -74.2105551097889},
  {"name": "AYSB029-F","y": -13.180531,"x": -74.20682425},
  {"name": "CZCZ077-F","y": -13.5235256294308,"x": -71.9750886829058},
  {"name": "ICSU001-F","y": -13.4226605,"x": -76.1718154876171},
  {"name": "LMCH082-R","y": -12.173214,"x": -77.0220330430384},
  {"name": "ICSU002-F","y": -13.425411,"x": -76.1667486690991},
  {"name": "ICTG005","y": -14.0324415,"x": -75.696787849135},
  {"name": "ICSB009","y": -14.0197815,"x": -75.756181039282},
  {"name": "ICSU003-F","y": -13.4282435,"x": -76.1634216213521},
  {"name": "PUJL032-F","y": -15.490836,"x": -70.1355834252266},
  {"name": "ICSU004-F","y": -13.4270735,"x": -76.1590357938536},
  {"name": "ICTA009-F","y": -13.7072085,"x": -76.1491048733333},
  {"name": "CHCH006","y": -13.418279,"x": -76.1409869830389},
  {"name": "PIUT031-F","y": -4.594645,"x": -81.2486120952226},
  {"name": "ICTG001","y": -14.030925,"x": -75.7044261397131},
  {"name": "ICTG006","y": -14.037305,"x": -75.7042356863652},
  {"name": "ICTG002","y": -14.0313226,"x": -75.6993921927016},
  {"name": "ICTG004","y": -14.0335697,"x": -75.7010931282114},
  {"name": "ICTG008","y": -14.0401755,"x": -75.7042123691557},
  {"name": "ICTG003","y": -14.034705,"x": -75.7049218284753},
  {"name": "ICTG014-F","y": -14.041429,"x": -75.7208098022414},
  {"name": "ICTG007","y": -14.038031,"x": -75.6999615266065},
  {"name": "ICPN015-F","y": -14.0533045,"x": -75.7233126199331},
  {"name": "ICTG011","y": -14.040001,"x": -75.7105819751773},
  {"name": "ZONA SATURADA","y": -11.942618,"x": -77.0762147154564},
  {"name": "ICTG013","y": -14.04192505,"x": -75.708353981329},
  {"name": "ICTG010","y": -14.036671,"x": -75.7101974559478},
  {"name": "ICTG016-F","y": -14.0490605,"x": -75.7238609360993},
  {"name": "ICTG015-F","y": -14.0499655,"x": -75.7266464553011},
  {"name": "LMJL025","y": -12.006327,"x": -77.0042270019098},
  {"name": "ICPA003-F","y": -13.8411635,"x": -76.2559003632113},
  {"name": "ICTA001-F","y": -13.7175575,"x": -76.1514365007364},
  {"name": "ICTA002-F","y": -13.716029,"x": -76.1470018731557},
  {"name": "LMLM013","y": -12.053177,"x": -77.0789418295833},
  {"name": "ICTA003-F","y": -13.7165285,"x": -76.1423185360027},
  {"name": "ICTA004-F","y": -13.714889,"x": -76.1510777940574},
  {"name": "ICPN003","y": -14.051864,"x": -75.7021791291906},
  {"name": "ICTA005-F","y": -13.709641,"x": -76.1502026561351},
  {"name": "ICTA006-F","y": -13.712071,"x": -76.1484011837833},
  {"name": "ICTA007-F","y": -13.7136475,"x": -76.1441110375661},
  {"name": "CBNV029-S // CBNV029","y": -9.125278,"x": -78.5201014381035},
  {"name": "ICJB001","y": -14.030008,"x": -75.7341965052409},
  {"name": "ICPN001","y": -14.048843,"x": -75.7012591183589},
  {"name": "ICPN002","y": -14.0426405,"x": -75.7010617733472},
  {"name": "LMLM013","y": -12.057341,"x": -77.079608796899},
  {"name": "ICPN004","y": -14.040688,"x": -75.6972309746262},
  {"name": "PUJL045-F","y": -15.483429,"x": -70.1164629529123},
  {"name": "ICPN005","y": -14.049289,"x": -75.7058558169466},
  {"name": "ICPN006","y": -14.0445255,"x": -75.6994429309684},
  {"name": "ICPN007","y": -14.05196,"x": -75.695699422842},
  {"name": "ICPN008","y": -14.045974,"x": -75.7062399468547},
  {"name": "ICTG009","y": -14.04215455,"x": -75.7043340797556},
  {"name": "LMMP115","y": -11.9435495,"x": -77.0857459109446},
  {"name": "ICPN009","y": -14.0455575,"x": -75.6981072028113},
  {"name": "LMAG060-F","y": -12.029445,"x": -76.9594922400879},
  {"name": "ICPC001-F","y": -13.7059955,"x": -76.2063077292531},
  {"name": "ICPN010-S // ICPN010","y": -14.05142,"x": -75.699221409568},
  {"name": "PUJL033-F","y": -15.4927435,"x": -70.137719410828},
  {"name": "ICPN011","y": -14.0473225,"x": -75.6965079897267},
  {"name": "ICPN012","y": -14.045974,"x": -75.7026918237968},
  {"name": "ICPN013","y": -14.0493775,"x": -75.696528848401},
  {"name": "ICPN014-F","y": -14.0528425,"x": -75.7262266425968},
  {"name": "AQYA014","y": -16.401357101327,"x": -71.555694078959},
  {"name": "AYHU001-F","y": -12.933067,"x": -74.2517843362055},
  {"name": "LMCH029-R","y": -12.186735,"x": -77.0091778662487},
  {"name": "AYHU002-F","y": -12.9363475,"x": -74.2551029550071},
  {"name": "LMBY028-S // LMBY028","y": -11.8803685,"x": -77.0339261197917},
  {"name": "AYHU003-F","y": -12.9357065,"x": -74.2490934652464},
  {"name": "LMLM013","y": -12.0514405,"x": -77.0775414893191},
  {"name": "AYHU005-F","y": -12.93674,"x": -74.2461102720588},
  {"name": "PIUR049-S // PIUR049","y": -5.1692355,"x": -80.6463461503161},
  {"name": "AYHU006-F","y": -12.939467,"x": -74.2499182570016},
  {"name": "AYHU006-F","y": -12.9378435,"x": -74.2481681183631},
  {"name": "ZONA SATURADA","y": -12.9388735,"x": -74.2493064600569},
  {"name": "ICPC015-F","y": -13.722392,"x": -76.2029295755945},
  {"name": "PUJL034-F","y": -15.4930725,"x": -70.1402074686401},
  {"name": "ZONA SATURADA","y": -12.9406455,"x": -74.2458154980903},
  {"name": "AYHU010-F","y": -12.943812,"x": -74.2464956979167},
  {"name": "ICPC002-F","y": -13.7067065,"x": -76.2028216804979},
  {"name": "ICPC003-F","y": -13.708837,"x": -76.2071313208457},
  {"name": "MDTB005-F","y": -12.589704,"x": -69.2106761248145},
  {"name": "ICPC004-F","y": -13.7086585,"x": -76.2028348131108},
  {"name": "CBNV060","y": -9.13079215,"x": -78.5402824777166},
  {"name": "ICPC005-F","y": -13.7092195,"x": -76.2002777465752},
  {"name": "ICPC006-F","y": -13.711922,"x": -76.2066782036713},
  {"name": "APAH001-F","y": -13.657328,"x": -73.3838154614743},
  {"name": "ICPC008-F","y": -13.7126835,"x": -76.1999132622222},
  {"name": "ICPC010-F","y": -13.7147725,"x": -76.2074327284046},
  {"name": "PIUC123","y": -5.175754,"x": -80.608661080266},
  {"name": "ICPC011-F","y": -13.7143585,"x": -76.204558026084},
  {"name": "ICPC013-F","y": -13.7163425,"x": -76.2009071120208},
  {"name": "ICPC014-F","y": -13.7196255,"x": -76.2009493821586},
  {"name": "ICPC016-F","y": -13.7189605,"x": -76.2047757466705},
  {"name": "PUJL035-F","y": -15.4930965,"x": -70.1429680013201},
  {"name": "ICPC017-F","y": -13.718311,"x": -76.2096383096378},
  {"name": "LMLO052","y": -11.9751295,"x": -77.0679892086964},
  {"name": "ICPC018-F","y": -13.7171965,"x": -76.2142689519616},
  {"name": "PIUC120","y": -5.1801215,"x": -80.6126995724437},
  {"name": "ICPC019-F","y": -13.713367,"x": -76.2174022992487},
  {"name": "ICPC020-F","y": -13.7193655,"x": -76.2161267043384},
  {"name": "ICPC021-F","y": -13.719782,"x": -76.219004544037},
  {"name": "PUJL037-F","y": -15.4949075,"x": -70.1342580919851},
  {"name": "LMLM006","y": -12.066553,"x": -77.0683856116182},
  {"name": "ZONA SATURADA","y": -12.0366015,"x": -76.9525881696429},
  {"name": "ICSA001-F","y": -13.98925785,"x": -75.7741459995266},
  {"name": "ICSA002-F","y": -13.9852595,"x": -75.7726292370091},
  {"name": "ICSA003-F","y": -13.987096,"x": -75.7695314194608},
  {"name": "PUJL036-F","y": -15.493062,"x": -70.134967455408},
  {"name": "ICSA004-F","y": -13.9880991,"x": -75.7662661024074},
  {"name": "LMAG053-F","y": -12.0563835,"x": -77.006711060835},
  {"name": "ANCR012-F","y": -9.0537954,"x": -77.8007692493396},
  {"name": "LMCO133-S //�LMCO133","y": -11.9602485,"x": -77.0476640365168},
  {"name": "LMMP063-S // LMMP063","y": -12.014568,"x": -77.0855979271136},
  {"name": "LLCP006-F","y": -7.229631,"x": -79.4215598031531},
  {"name": "LMMP062-S // LMMP062","y": -12.015335,"x": -77.082986217672},
  {"name": "LMCO187-S // LMCO187","y": -11.918577,"x": -77.0435892249909},
  {"name": "LMLV150-F","y": -12.0619,"x": -77.0234283701571},
  {"name": "LMCO057-S //�LMCO057","y": -11.9156905,"x": -77.0428154033493},
  {"name": "PIUC121","y": -5.1812895,"x": -80.6106147587565},
  {"name": "LMCO144-S // LMCO144","y": -11.942072,"x": -77.0457286586742},
  {"name": "LMCO145-S //�LMCO145","y": -11.94538,"x": -77.0491477955407},
  {"name": "LMCO146-S //�LMCO146","y": -11.945071,"x": -77.0463167993142},
  {"name": "LMMP128-S","y": -11.9845815,"x": -77.0846703833883},
  {"name": "LMSL035-F","y": -12.065951,"x": -76.9941434947831},
  {"name": "LMLV152-F","y": -12.0813445,"x": -77.0061789903791},
  {"name": "LMMP055-S //�LMMP055","y": -12.018299,"x": -77.0841606759715},
  {"name": "AQMM002","y": -16.40725,"x": -71.5075851976063},
  {"name": "AQMF004-S // AQMF004","y": -16.396765,"x": -71.5209348025135},
  {"name": "LMCO007-S // LMCO007","y": -11.9437235,"x": -77.0655341269711},
  {"name": "LMLR028-F","y": -12.2974535,"x": -76.8514681304453},
  {"name": "PIUC129","y": -5.230754,"x": -80.631515375923},
  {"name": "ANCR001-F","y": -9.0370398,"x": -77.8136959311472},
  {"name": "CBNV061-S // CBNV061","y": -9.11591195,"x": -78.5130531084636},
  {"name": "AQMF025","y": -16.3779535,"x": -71.5087708801268},
  {"name": "ANCR012-F","y": -9.0519195,"x": -77.8043431801576},
  {"name": "LMLV007-S","y": -12.0758885,"x": -77.0155505698977},
  {"name": "ANCR013-F","y": -9.0531555,"x": -77.8101463461042},
  {"name": "LMLM006-S","y": -12.0661625,"x": -77.0716291678095},
  {"name": "LMCO006","y": -11.9438325,"x": -77.0640659370539},
  {"name": "LMLV151-F","y": -12.0671605,"x": -77.0248195284377},
  {"name": "AQSC005","y": -16.4294785,"x": -71.5656607207417},
  {"name": "PIUR048","y": -5.163091,"x": -80.6360409166667},
  {"name": "PUJL038-F","y": -15.4949495,"x": -70.1376883193384},
  {"name": "LAMO065-S //�LAMO065","y": -12.0720125,"x": -76.8844337561917},
  {"name": "PUJL046-F","y": -15.4874355,"x": -70.1150041032039},
  {"name": "LMAG067-F","y": -12.0559825,"x": -77.0042360040437},
  {"name": "LMAG066-F","y": -12.0580685,"x": -77.0046424193198},
  {"name": "LMLV153-F","y": -12.085266,"x": -77.0105480227699},
  {"name": "ANCR014-F","y": -9.03206115,"x": -77.8157377857114},
  {"name": "LMCH082-R","y": -12.1720255,"x": -77.0225149680107},
  {"name": "APAH003-F","y": -13.661002,"x": -73.3813664543429},
  {"name": "ANCR015-F","y": -9.0380268,"x": -77.8198666865452},
  {"name": "ANCR016-F","y": -9.04228215,"x": -77.81794503762},
  {"name": "AQCC006-R","y": -16.388486,"x": -71.5559131831572},
  {"name": "LMBA010-S // LMBA010","y": -12.1387881,"x": -77.0249510596471},
  {"name": "PUJL039-F","y": -15.4829555,"x": -70.1225216150906},
  {"name": "LMMP144-S // LMMP144","y": -11.9962495,"x": -77.0892748864478},
  {"name": "LMMP142-S // LMMP142","y": -11.9936455,"x": -77.0872789409952},
  {"name": "LMMP143-S // LMMP143","y": -11.994116,"x": -77.0852693677577},
  {"name": "LBMT005-F","y": -6.15294125,"x": -79.7150572460392},
  {"name": "PUJL040-F","y": -15.4860125,"x": -70.1221906844793},
  {"name": "LMMP125","y": -11.983251,"x": -77.0932229371891},
  {"name": "PUJL041-F","y": -15.4888515,"x": -70.1210473204853},
  {"name": "PIUT012-F","y": -4.5852395,"x": -81.2695216338947},
  {"name": "LMMP125-S","y": -11.9833825,"x": -77.0959897626092},
  {"name": "PUPU081-F","y": -15.8810775,"x": -70.0036394918752},
  {"name": "LMB�018-S","y": -12.062456,"x": -77.0576874408867},
  {"name": "LMB�018","y": -12.0634385,"x": -77.0592403809122},
  {"name": "LMAG072-F","y": -12.029238,"x": -76.9900800015625},
  {"name": "LBMT001-F","y": -6.147367,"x": -79.7157111364102},
  {"name": "LBMT002-F","y": -6.150365,"x": -79.7114407708975},
  {"name": "PIOC012-F","y": -5.18763,"x": -80.6755104313725},
  {"name": "PUPU082-F","y": -15.885903,"x": -70.0044816655173},
  {"name": "LBMT006-F","y": -6.1530695,"x": -79.718905286802},
  {"name": "LBMT007-F","y": -6.155016,"x": -79.7160392284898},
  {"name": "LBMT008-F","y": -6.157273,"x": -79.718696416395},
  {"name": "PUJL042-F","y": -15.4844725,"x": -70.1188972038556},
  {"name": "PUPU086-F","y": -15.874025,"x": -69.9775346255016},
  {"name": "APAH004-F","y": -13.6611305,"x": -73.3777354014374},
  {"name": "PUPU078-F","y": -15.843493,"x": -70.032404050152},
  {"name": "PUPU079-F","y": -15.842214,"x": -70.0385503285004},
  {"name": "PUJL043-F","y": -15.486783,"x": -70.1184925237042},
  {"name": "PUPU080-F","y": -15.8743635,"x": -70.0036983424746},
  {"name": "LMCO084","y": -11.936831,"x": -77.0560870442844},
  {"name": "PUJL047-F","y": -15.479452,"x": -70.115239849068},
  {"name": "AQCC144-F","y": -16.3496220660845,"x": -71.5560411618198},
  {"name": "ZONA SATURADA","y": -7.814982,"x": -78.0462144143981},
  {"name": "ZONA SATURADA","y": -8.171322,"x": -79.0083050277143},
  {"name": "ZONA SATURADA","y": -8.171679,"x": -79.0067304774985},
  {"name": "LMCO194-F","y": -11.944439,"x": -77.068870834179},
  {"name": "AQSC015","y": -16.4273555,"x": -71.5757333693003},
  {"name": "CZCZ017","y": -13.5239855,"x": -71.9525922076376},
  {"name": "PUAN002-F","y": -14.6313305,"x": -69.445761375},
  {"name": "PUJL048-F","y": -15.483491,"x": -70.1136575625648},
  {"name": "PUAN001-F","y": -14.6298145,"x": -69.4479047837615},
  {"name": "LLFM003-F","y": -8.0880869,"x": -79.0225532160165},
  {"name": "PUAN003-F","y": -14.63358,"x": -69.4470537357143},
  {"name": "PUAN004-F","y": -14.6357155,"x": -69.445905724947},
  {"name": "PUAN005-F","y": -14.635319,"x": -69.448088271288},
  {"name": "AQSC012","y": -16.4138521485075,"x": -71.5760519845327},
  {"name": "LMAG055-F","y": -12.0440835,"x": -76.9866953194051},
  {"name": "LMJL020","y": -11.9969085,"x": -77.0073717741236},
  {"name": "LLFM004-F","y": -8.0870216,"x": -79.018856987408},
  {"name": "LLHC010-F","y": -8.087625,"x": -79.0877396124108},
  {"name": "LLFM002-F","y": -8.088155,"x": -79.0285193941667},
  {"name": "LMAG056-F","y": -12.045052,"x": -76.9859640943314},
  {"name": "JNPG009-F","y": -11.4373335,"x": -74.4926745471698},
  {"name": "PRCT003-F","y": -5.26429,"x": -80.6763450631547},
  {"name": "PUJL049-F","y": -15.47666,"x": -70.1147943288464},
  {"name": "CBNV031-S // CBNV031","y": -9.1273311,"x": -78.5149414490836},
  {"name": "LMJL041","y": -12.0118365,"x": -77.0028903574561},
  {"name": "LMAG059-F","y": -12.0274255,"x": -76.9615828370623},
  {"name": "LMJR078-S // LMJR078","y": -12.1886315,"x": -76.9626917650215},
  {"name": "PUJL015-F","y": -15.479806,"x": -70.1497341868932},
  {"name": "LMSC038-S","y": -12.127374,"x": -76.9890602462148},
  {"name": "LMSC125-S","y": -12.100016,"x": -76.9702249428571},
  {"name": "LMAG058-F","y": -12.0288725,"x": -76.9636811690834},
  {"name": "PIUR172-F","y": -5.1698115,"x": -80.6554023385378},
  {"name": "SRJL006-F","y": -15.4934075,"x": -70.1223623206432},
  {"name": "PUJL050-F","y": -15.477625,"x": -70.1109440090628},
  {"name": "PIUT008-F","y": -4.5837325,"x": -81.2672972860378},
  {"name": "LLCP002-F","y": -7.223973,"x": -79.4290375895321},
  {"name": "CBNV069-S // CBNV069","y": -9.1410445,"x": -78.5055063983902},
  {"name": "LMHL015-F","y": -11.5014805,"x": -77.2117795457638},
  {"name": "CZKI001-F","y": -12.6126315,"x": -73.7974713114774},
  {"name": "CZKI002-F","y": -12.618669,"x": -73.7899372255546},
  {"name": "CZKI003-F","y": -12.6204865,"x": -73.7860742269864},
  {"name": "CZKI004-F","y": -12.616997,"x": -73.7820116871692},
  {"name": "CZKI005-F","y": -12.611853,"x": -73.7743352920057},
  {"name": "LMAG061-F","y": -12.033535,"x": -76.9878965381697},
  {"name": "CZES005-F","y": -14.788621,"x": -71.4114754847909},
  {"name": "CZES004-F","y": -14.7844025,"x": -71.4065195293856},
  {"name": "CZES009-F","y": -14.7903405,"x": -71.4101300432292},
  {"name": "PIUR023","y": -5.1988545,"x": -80.6446733568791},
  {"name": "CZES002-F","y": -14.7857455,"x": -71.4125601390853},
  {"name": "LLMO001-F","y": -8.1695395,"x": -79.010910443126},
  {"name": "CZES013-F","y": -14.793991,"x": -71.4073175543073},
  {"name": "PIUR173-F","y": -5.17256,"x": -80.654915860665},
  {"name": "PIUR128","y": -5.187095,"x": -80.6464745142466},
  {"name": "LMAG062-F","y": -12.0356805,"x": -76.9875310663766},
  {"name": "TCNA164-F","y": -18.06739315,"x": -70.2997103022727},
  {"name": "AQCC064-F","y": -16.37170285,"x": -71.5552094523598},
  {"name": "CBNV032","y": -9.12100355,"x": -78.5208040940817},
  {"name": "PIUR179-F","y": -5.184852,"x": -80.6743390715923},
  {"name": "LMAG063-F","y": -12.027665,"x": -76.9580598981471},
  {"name": "PUJL051-F","y": -15.4811015,"x": -70.111647401149},
  {"name": "LLHC008-F","y": -8.024499,"x": -79.0662366511393},
  {"name": "PUJL052-F","y": -15.484426,"x": -70.1100363822928},
  {"name": "PRCT004-F","y": -5.2668395,"x": -80.6797955105674},
  {"name": "LMVS118-F","y": -12.1996501,"x": -76.9466163012667},
  {"name": "CBNV033-S // CBNV033","y": -9.12269245,"x": -78.5207739158135},
  {"name": "PIUR180-F","y": -5.18119,"x": -80.6805505142249},
  {"name": "AQCA004-S // AQCA004","y": -16.383596,"x": -71.5468200514085},
  {"name": "TCNA109-S // TCNA109","y": -18.0486795,"x": -70.2599178942906},
  {"name": "PUJL053-F","y": -15.475867,"x": -70.1502620646035},
  {"name": "LMCA172-F","y": -12.043594,"x": -77.1207656452841},
  {"name": "LMBR009-F","y": -10.7505197,"x": -77.7606493165071},
  {"name": "LLHC001-F","y": -8.0874025,"x": -79.0526630080962},
  {"name": "LLHC005-F","y": -8.0179275,"x": -79.068888916114},
  {"name": "PIUT016-F","y": -4.5806515,"x": -81.2717092186423},
  {"name": "LLHC006-F","y": -8.0204755,"x": -79.0687778474744},
  {"name": "LLHC007-F","y": -8.022834,"x": -79.0679270974429},
  {"name": "LLMO005-F","y": -8.178044,"x": -79.0155317093062},
  {"name": "LLMO006-F","y": -8.180622,"x": -79.0117718495483},
  {"name": "AQSB045-F","y": -16.430566,"x": -71.5370869042228},
  {"name": "LLFM007-F","y": -8.0861005,"x": -79.0268850434552},
  {"name": "CBNV034","y": -9.121397,"x": -78.5181324010538},
  {"name": "LLFM008-F","y": -8.0836125,"x": -79.0271855837483},
  {"name": "LLMO014-F","y": -8.1792935,"x": -79.0105140466989},
  {"name": "LMVS013","y": -12.2013065,"x": -76.9484518593934},
  {"name": "LLVI001-F","y": -8.4246145,"x": -78.7821073901499},
  {"name": "LLFM012-F","y": -8.0806175,"x": -79.0268853255569},
  {"name": "LLVI007-F","y": -8.4109835,"x": -78.7553702319211},
  {"name": "LLVI002-F","y": -8.424956,"x": -78.7773281802459},
  {"name": "LMLM193-F","y": -12.041572,"x": -77.0679762724632},
  {"name": "LLFM009-F","y": -8.0852325,"x": -79.0298892729234},
  {"name": "PIUT010-F","y": -4.587992,"x": -81.2679714201822},
  {"name": "LLVI003-F","y": -8.417882,"x": -78.7522516657018},
  {"name": "LLVI008-F","y": -8.4121615,"x": -78.7473511512535},
  {"name": "LLVI004-F","y": -8.4145375,"x": -78.749608478651},
  {"name": "PIUT001-F","y": -4.581587,"x": -81.2567062366969},
  {"name": "AQSC013","y": -16.4194397195585,"x": -71.5697368799617},
  {"name": "LLVI005-F","y": -8.4156165,"x": -78.7544894166328},
  {"name": "PUJL054-F","y": -15.4734445,"x": -70.1482719323686},
  {"name": "PIUT002-F","y": -4.584218,"x": -81.2557823176567},
  {"name": "LMCH067-S","y": -12.180293,"x": -76.9984485654027},
  {"name": "LLVI006-F","y": -8.4135775,"x": -78.7532152777313},
  {"name": "LLFM010-F","y": -8.081512,"x": -79.0317767607272},
  {"name": "PIUT009-F","y": -4.5882215,"x": -81.265337960931},
  {"name": "LAMO001-S // LAMO001","y": -12.064417,"x": -76.9577888595156},
  {"name": "AQSC016","y": -16.4107578193665,"x": -71.5515485146657},
  {"name": "LLFM011-F","y": -8.080795,"x": -79.0290972066324},
  {"name": "LMAG064-F","y": -12.024263,"x": -76.9510953983146},
  {"name": "LMVS173-F","y": -12.238187,"x": -76.9164872458685},
  {"name": "PIUT003-F","y": -4.5882335,"x": -81.2565045198248},
  {"name": "PIUT004-F","y": -4.5898095,"x": -81.2550508629624},
  {"name": "PIUT005-F","y": -4.59071,"x": -81.2580186984733},
  {"name": "PIUT006-F","y": -4.5854465,"x": -81.2575785227074},
  {"name": "PIUT007-F","y": -4.5850855,"x": -81.2622492572225},
  {"name": "PIUT011-F","y": -4.589527,"x": -81.2719115756614},
  {"name": "PIUT013-F","y": -4.5848785,"x": -81.2732375762634},
  {"name": "PIUT014-F","y": -4.5819325,"x": -81.2691169238181},
  {"name": "PIUT015-F","y": -4.5825455,"x": -81.2730338636139},
  {"name": "PIUT017-F","y": -4.5797805,"x": -81.2671143282407},
  {"name": "PIUT018-F","y": -4.57706,"x": -81.2674585880282},
  {"name": "PIUT019-F","y": -4.577984,"x": -81.2709011199765},
  {"name": "PIUR116","y": -5.1926055,"x": -80.6395672005604},
  {"name": "PIUT020-F","y": -4.5773165,"x": -81.2737053195652},
  {"name": "PIUT021-F","y": -4.5784505,"x": -81.2759799033865},
  {"name": "AQCC034","y": -16.372541801461,"x": -71.5550764200109},
  {"name": "PIUT024-F","y": -4.5742185,"x": -81.2703237432432},
  {"name": "PIUT025-F","y": -4.573974,"x": -81.2741082607218},
  {"name": "PIUT026-F","y": -4.5945795,"x": -81.2508118731762},
  {"name": "PIUT027-F","y": -4.591959,"x": -81.2542342097156},
  {"name": "PUJL055-F","y": -15.4763755,"x": -70.145845416052},
  {"name": "PIUC149-F","y": -5.2280515,"x": -80.6403542130735},
  {"name": "PIUT028-F","y": -4.5946675,"x": -81.2529970279123},
  {"name": "ZONA SATURADA","y": -10.7506495,"x": -77.7581700914045},
  {"name": "PIUT029-F","y": -4.594243,"x": -81.2567100920949},
  {"name": "LMVS201-F","y": -12.216058,"x": -76.9292341005587},
  {"name": "AMCH016-F","y": -6.2209335,"x": -77.8667662132546},
  {"name": "LMLO076","y": -11.9634195,"x": -77.0752509008391},
  {"name": "LMLO056","y": -11.9753425,"x": -77.081697924855},
  {"name": "AMCH014-F","y": -6.223189,"x": -77.8730168335377},
  {"name": "LMCH063-S","y": -12.1688555,"x": -77.0009765214797},
  {"name": "AMCH002-F","y": -6.2306015,"x": -77.8763790821717},
  {"name": "AMCH003-F","y": -6.226718,"x": -77.8705807701069},
  {"name": "AMCH005-F","y": -6.2260445,"x": -77.8662515013793},
  {"name": "AMCH006-F","y": -6.2287725,"x": -77.8651692941149},
  {"name": "AMCH007-F","y": -6.233612,"x": -77.8729142929402},
  {"name": "AMCH008-F","y": -6.2312105,"x": -77.8643771548221},
  {"name": "AMCH012-F","y": -6.2234295,"x": -77.8741472338271},
  {"name": "LMLO076","y": -11.9629385,"x": -77.0744836184211},
  {"name": "AMCH009-F","y": -6.2352255,"x": -77.8668006172065},
  {"name": "AMCH010-F","y": -6.2347175,"x": -77.8709461926677},
  {"name": "CBNV037-S // CBNV037","y": -9.11701425,"x": -78.512573710786},
  {"name": "LAMO008-S // LAMO008","y": -12.0658895,"x": -76.9459176235923},
  {"name": "AMCH011-F","y": -6.2258025,"x": -77.8778478236619},
  {"name": "LMHU010","y": -11.109214,"x": -77.6032689271968},
  {"name": "AMCH013-F","y": -6.220125,"x": -77.8741143560823},
  {"name": "LMCO015","y": -11.926689,"x": -77.0525598455149},
  {"name": "LAMO003-S // LAMO003","y": -12.063316,"x": -76.9540062566687},
  {"name": "AMCH015-F","y": -6.2172075,"x": -77.8675348570492},
  {"name": "SRJL013-F","y": -15.5060165,"x": -70.1286224864512},
  {"name": "ZONA SATURADA","y": -12.10953,"x": -77.0126250305007},
  {"name": "AMCH017-F","y": -6.217964,"x": -77.8643515357178},
  {"name": "LMHU010","y": -11.1083325,"x": -77.6039683599633},
  {"name": "AMCH018-F","y": -6.2112985,"x": -77.864163981884},
  {"name": "AMCH019-F","y": -6.208974,"x": -77.8613883654147},
  {"name": "AMCH020-F","y": -6.211638,"x": -77.8577311296296},
  {"name": "AMCH021-F","y": -6.2153975,"x": -77.8604179895494},
  {"name": "LMJL195-F","y": -11.9789555,"x": -77.0140955002683},
  {"name": "AMCH022-F","y": -6.2189995,"x": -77.8605883077396},
  {"name": "PUJL056-F","y": -15.4755265,"x": -70.1423956225701},
  {"name": "AMCH023-F","y": -6.237883,"x": -77.8641015180525},
  {"name": "AMCH024-F","y": -6.241086,"x": -77.8724420877493},
  {"name": "AMCH025-F","y": -6.232753,"x": -77.8579919077158},
  {"name": "PIUR183-F","y": -5.2035805,"x": -80.6396157584079},
  {"name": "PUJL057-F","y": -15.4765505,"x": -70.139030482615},
  {"name": "JNJA011-F","y": -11.780351,"x": -75.49317594974},
  {"name": "LMJL117-S // LMJL117","y": -11.9690925,"x": -77.0072584351475},
  {"name": "CBNV038","y": -9.11939125,"x": -78.5124424030267},
  {"name": "CBNV041-S // CBNV041","y": -9.122476,"x": -78.5084634866198},
  {"name": "LMSA065-F","y": -12.029277,"x": -76.9464992532164},
  {"name": "PUSM018-F","y": -15.474705,"x": -70.1264037690219},
  {"name": "LMSC055-S // LMSC055","y": -12.1356605,"x": -76.9886805971897},
  {"name": "PIUR184-F","y": -5.2014365,"x": -80.6381631690705},
  {"name": "LAMO004","y": -12.0666565,"x": -76.9519550610156},
  {"name": "LAMO005-S // LAMO005","y": -12.060853,"x": -76.9493448572144},
  {"name": "PUSM020-F","y": -15.4666855,"x": -70.1219369928881},
  {"name": "LMJR119-F","y": -12.1394445,"x": -76.9661870850328},
  {"name": "TRLH023","y": -8.1307725,"x": -79.048942598571},
  {"name": "CBNV042-S // CBNV042","y": -9.1202284,"x": -78.5069381781779},
  {"name": "PIUC151-F","y": -5.186501,"x": -80.5959656197183},
  {"name": "CBNV045-S // CBNV045","y": -9.10945885,"x": -78.5116589866608},
  {"name": "PRCT001-F","y": -5.261348,"x": -80.675596554385},
  {"name": "TRHC009","y": -8.0940125,"x": -79.0553805527253},
  {"name": "ANCB049-F","y": -9.0761425,"x": -78.5972699216127},
  {"name": "PUSM023-F","y": -15.472135,"x": -70.1223309846518},
  {"name": "LAMO007-S","y": -12.066418,"x": -76.9483637095376},
  {"name": "AQCC003-S // AQCC003","y": -16.373649,"x": -71.5619036353202},
  {"name": "ZONA SATURADA","y": -12.146507,"x": -76.9698765566144},
  {"name": "ZONA SATURADA","y": -8.056312,"x": -79.0529002044782},
  {"name": "LMCO085","y": -11.9381725,"x": -77.0542756577522},
  {"name": "TRHC008","y": -8.0985405,"x": -79.0569733506049},
  {"name": "LAMO006-S // LAMO006","y": -12.0641715,"x": -76.9482524959239},
  {"name": "CBNV046-S // CBNV046","y": -9.11359325,"x": -78.5062968651934},
  {"name": "CBNV045-S // CBNV045","y": -9.11214085,"x": -78.5074757759838},
  {"name": "ZONA SATURADA","y": -16.6229775,"x": -72.7112798886036},
  {"name": "AQCM005-F","y": -16.6216515,"x": -72.7134748405512},
  {"name": "LMCO023","y": -11.9252955,"x": -77.0631792025106},
  {"name": "SRJL001-F","y": -15.4896225,"x": -70.130683348205},
  {"name": "LAMO009-S // LAMO009","y": -12.0596495,"x": -76.9447947702648},
  {"name": "LMLV094-F","y": -12.0842845,"x": -77.016870884375},
  {"name": "PIUR121","y": -5.181618,"x": -80.6774864923077},
  {"name": "SRJL002-F","y": -15.4895255,"x": -70.1271396443595},
  {"name": "AQMJ005-F","y": -16.365183,"x": -72.1918498826979},
  {"name": "ZONA SATURADA","y": -16.3606175,"x": -72.188896838682},
  {"name": "CBNV047-S // CBNV047","y": -9.1154484,"x": -78.5079641262569},
  {"name": "ZONA SATURADA","y": -17.0301155,"x": -72.0156821582734},
  {"name": "LMSA040","y": -12.0394745,"x": -76.9665395847571},
  {"name": "ZONA SATURADA","y": -13.523632,"x": -71.9857055544693},
  {"name": "CBNV049-S // CBNV049","y": -9.11771995,"x": -78.5044648942473},
  {"name": "AQMJ007-F","y": -16.3543155,"x": -72.1885612128114},
  {"name": "SRJL003-F","y": -15.4921605,"x": -70.1290452921121},
  {"name": "ZONA SATURADA","y": -16.35765,"x": -72.1894526465517},
  {"name": "AQCM006-F","y": -16.6225475,"x": -72.7081908362353},
  {"name": "LAMO010-S // LAMO010","y": -12.063172,"x": -76.9442084137642},
  {"name": "ZONA SATURADA","y": -16.622673,"x": -72.7100538504909},
  {"name": "JNPG011-F","y": -11.4146565,"x": -74.4887075075058},
  {"name": "CBNV061-S // CBNV061","y": -9.11471105,"x": -78.5131280512302},
  {"name": "PIUR170-F","y": -5.164257,"x": -80.6533534934487},
  {"name": "SRJL004-F","y": -15.4910205,"x": -70.1246979145838},
  {"name": "PIUR174-F","y": -5.191128,"x": -80.6646280706055},
  {"name": "PIUR175-F","y": -5.19233,"x": -80.6598772430238},
  {"name": "LLHM004-F","y": -7.81102,"x": -78.0447787041919},
  {"name": "CBNV062","y": -9.1082979,"x": -78.5340676656289},
  {"name": "SRJL005-F","y": -15.494717,"x": -70.1268412755102},
  {"name": "ZONA SATURADA","y": -8.183779,"x": -79.0114870654069},
  {"name": "ZONA SATURADA","y": -8.174033,"x": -79.0095508555224},
  {"name": "ZONA SATURADA","y": -8.174644,"x": -79.0092641153465},
  {"name": "ZONA SATURADA","y": -8.1702115,"x": -79.0062223408395},
  {"name": "ZONA SATURADA","y": -12.06724865,"x": -77.1322644659135},
  {"name": "PIUR171-F","y": -5.165685,"x": -80.6559523030234},
  {"name": "PIUR176-F","y": -5.19339,"x": -80.6631935571618},
  {"name": "PIUR177-F","y": -5.195248,"x": -80.6598563393329},
  {"name": "CBNV063-S // CBNV063","y": -9.10791335,"x": -78.5308606263805},
  {"name": "PIBE001-F","y": -4.888254,"x": -80.6797637165111},
  {"name": "PIBE002-F","y": -4.8910545,"x": -80.6793122822042},
  {"name": "PIBE003-F","y": -4.8915425,"x": -80.6764172601093},
  {"name": "PRCT002-F","y": -5.2633645,"x": -80.6735746182357},
  {"name": "PIBE004-F","y": -4.887874,"x": -80.6749133210206},
  {"name": "CBNV064-S // CBNV064","y": -9.1122744,"x": -78.5181051005365},
  {"name": "PIBE005-F","y": -4.887764,"x": -80.6776927841027},
  {"name": "PIUC137-F","y": -5.203982,"x": -80.6187548286857},
  {"name": "PIUC138-F","y": -5.2068895,"x": -80.6193830859375},
  {"name": "LAMO011-S // LAMO011","y": -12.0680945,"x": -76.9656714523142},
  {"name": "PIUC139-F","y": -5.210245,"x": -80.620311880668},
  {"name": "PIUC150-F","y": -5.185796,"x": -80.5981080725651},
  {"name": "PIUC140-F","y": -5.2126795,"x": -80.621393391523},
  {"name": "PIUC147-F","y": -5.220863,"x": -80.6247456037859},
  {"name": "PIUC141-F","y": -5.211138,"x": -80.6251783344838},
  {"name": "PIUC142-F","y": -5.209469,"x": -80.6235511327034},
  {"name": "PIUC143-F","y": -5.20722,"x": -80.6234305338201},
  {"name": "PIUC144-F","y": -5.2055295,"x": -80.623016003319},
  {"name": "PIUC145-F","y": -5.2164185,"x": -80.6227317493165},
  {"name": "PIUC146-F","y": -5.2183165,"x": -80.6242954587074},
  {"name": "PRCT005-F","y": -5.267335,"x": -80.6776741872662},
  {"name": "PRCT006-F","y": -5.2662395,"x": -80.6752050140711},
  {"name": "PRCT007-F","y": -5.2687995,"x": -80.6759310369565},
  {"name": "PRCT008-F","y": -5.267473,"x": -80.673193672585},
  {"name": "PICH001-F","y": -5.0889255,"x": -80.1646642003891},
  {"name": "PICH002-F","y": -5.090758,"x": -80.1685029689503},
  {"name": "PICH024-F","y": -5.1047325,"x": -80.1697202951936},
  {"name": "PICH003-F","y": -5.091483,"x": -80.1663963676874},
  {"name": "ZONA SATURADA","y": -16.3342065,"x": -71.5859437941502},
  {"name": "PUAZ008-F","y": -14.9101905,"x": -70.1935285383881},
  {"name": "PICH004-F","y": -5.0921045,"x": -80.1629731153042},
  {"name": "PICH005-F","y": -5.093661,"x": -80.1689703864734},
  {"name": "LMCO006","y": -11.9432375,"x": -77.0641827612686},
  {"name": "PICH022-F","y": -5.097468,"x": -80.1739068783537},
  {"name": "PICH006-F","y": -5.094776,"x": -80.1651820305643},
  {"name": "PICH007-F","y": -5.0951705,"x": -80.1626691321638},
  {"name": "PICH008-F","y": -5.093743,"x": -80.1600202358356},
  {"name": "LAMO012-S // LAMO012","y": -12.074436,"x": -76.9690785912633},
  {"name": "PICH009-F","y": -5.0967415,"x": -80.168909918602},
  {"name": "LMCO008","y": -11.9397555,"x": -77.0661422845666},
  {"name": "PICH023-F","y": -5.1016605,"x": -80.1712578118581},
  {"name": "PICH010-F","y": -5.0975785,"x": -80.1640609752957},
  {"name": "LMCO015","y": -11.929567,"x": -77.0539486866227},
  {"name": "APAB002-F","y": -13.636,"x": -72.8780243636299},
  {"name": "PICH011-F","y": -5.0974575,"x": -80.1590128460692},
  {"name": "PICH012-F","y": -5.099004,"x": -80.1702498120179},
  {"name": "PICH013-F","y": -5.099815,"x": -80.1664171886373},
  {"name": "LMCO107","y": -11.9479585,"x": -77.0563963235661},
  {"name": "PICH014-F","y": -5.100793,"x": -80.1611721268657},
  {"name": "PICH015-F","y": -5.1025185,"x": -80.1630213327739},
  {"name": "APAB003-F","y": -13.6361955,"x": -72.8814115965298},
  {"name": "PICH025-F","y": -5.1028115,"x": -80.166866457388},
  {"name": "CBCB001-S // CBCB001","y": -9.0487425,"x": -78.5879808696197},
  {"name": "PICH026-F","y": -5.1014555,"x": -80.1568812120934},
  {"name": "PICH016-F","y": -5.0850955,"x": -80.1548476184476},
  {"name": "PICH017-F","y": -5.087287,"x": -80.1563447954545},
  {"name": "PICH018-F","y": -5.088126,"x": -80.1617138030712},
  {"name": "PICH019-F","y": -5.0898905,"x": -80.1590000423337},
  {"name": "PICH020-F","y": -5.0901545,"x": -80.1719691637597},
  {"name": "PICH021-F","y": -5.0934935,"x": -80.1724545368747},
  {"name": "SRJL007-F","y": -15.4976285,"x": -70.1254411697297},
  {"name": "SRJL009-F","y": -15.499502,"x": -70.1333950567788},
  {"name": "ZONA SATURADA","y": -16.410118,"x": -71.5700824746121},
  {"name": "AQCC070-F","y": -16.336111,"x": -71.5865934853387},
  {"name": "PUAZ006-F","y": -14.910972,"x": -70.1991424281046},
  {"name": "PUAZ009-F","y": -14.9160525,"x": -70.1914036324964},
  {"name": "AQCC088-F","y": -16.4001795,"x": -71.5742310086207},
  {"name": "PILU003-F","y": -5.3967785,"x": -80.7391906632422},
  {"name": "ZONA SATURADA","y": -16.399954,"x": -71.5718085598871},
  {"name": "ZONA SATURADA","y": -16.3985515,"x": -71.5716777005255},
  {"name": "ZONA SATURADA","y": -16.3990315,"x": -71.5762539166796},
  {"name": "ZONA SATURADA","y": -16.400657,"x": -71.5759859060572},
  {"name": "CZCZ004","y": -13.508997,"x": -71.9600920938874},
  {"name": "PUAZ007-F","y": -14.907528,"x": -70.1968854556385},
  {"name": "TRHC010","y": -8.0984905,"x": -79.062986427041},
  {"name": "APAB004-F","y": -13.635321,"x": -72.8833705414302},
  {"name": "PUAZ001-F","y": -14.903231,"x": -70.1916621159208},
  {"name": "PUAZ010-F","y": -14.913445,"x": -70.1978397777901},
  {"name": "MDPM041-F","y": -12.59358325,"x": -69.1749348052444},
  {"name": "PUAZ002-F","y": -14.906298,"x": -70.1947566099541},
  {"name": "SRJL008-F","y": -15.495745,"x": -70.1219412234335},
  {"name": "LAMO013-S // LAMO013","y": -12.0698185,"x": -76.9595562574454},
  {"name": "PUAZ003-F","y": -14.9029235,"x": -70.1974811222981},
  {"name": "PUAZ004-F","y": -14.9057235,"x": -70.2003418729526},
  {"name": "MDPM041-F","y": -12.58853015,"x": -69.1831321080807},
  {"name": "PUAZ005-F","y": -14.9099005,"x": -70.203398204858},
  {"name": "PUAZ011-F","y": -14.916455,"x": -70.2003258144567},
  {"name": "CBCB002","y": -9.0527875,"x": -78.5848577723548},
  {"name": "PUAZ012-F","y": -14.917247,"x": -70.2039528475303},
  {"name": "PUAZ013-F","y": -14.9202215,"x": -70.2003619175057},
  {"name": "PUAZ014-F","y": -14.918461,"x": -70.1960311659981},
  {"name": "PIUP004-F","y": -5.098447,"x": -81.1069461921699},
  {"name": "PUAZ015-F","y": -14.92123,"x": -70.194818064969},
  {"name": "PUAZ016-F","y": -14.9235905,"x": -70.1956631929067},
  {"name": "PUAZ017-F","y": -14.9259455,"x": -70.1999116026534},
  {"name": "APAB001-F","y": -13.6365815,"x": -72.8750659752451},
  {"name": "LAMO016-S // LAMO016","y": -12.074143,"x": -76.9734454630703},
  {"name": "APAB005-F","y": -13.6375055,"x": -72.8844420926788},
  {"name": "LAMO069","y": -12.0758885,"x": -76.8993394184672},
  {"name": "APAB010-F","y": -13.6424065,"x": -72.8909153355694},
  {"name": "APAB021-F","y": -13.635888,"x": -72.8886258821138},
  {"name": "SRJL010-F","y": -15.5020275,"x": -70.1293919478146},
  {"name": "AQCM011-F","y": -16.6130175,"x": -72.6979574923168},
  {"name": "APAB006-F","y": -13.638953,"x": -72.8806631591636},
  {"name": "APAB007-F","y": -13.638537,"x": -72.8874681187384},
  {"name": "APAB008-F","y": -13.6410615,"x": -72.881129620549},
  {"name": "APAB009-F","y": -13.642111,"x": -72.8867334067797},
  {"name": "APAB016-F","y": -13.6278905,"x": -72.8825812155525},
  {"name": "APAB011-F","y": -13.633002,"x": -72.8765230610733},
  {"name": "CBCB004","y": -9.08673,"x": -78.5673135556545},
  {"name": "SRJL011-F","y": -15.5010635,"x": -70.1272893854531},
  {"name": "AQSB051-F","y": -16.4576385,"x": -71.5161271865061},
  {"name": "APAB012-F","y": -13.629109,"x": -72.8776490463526},
  {"name": "LMJL133-S // LMJL133","y": -11.964538,"x": -76.9967550585615},
  {"name": "CBNV059-S //CBNV059","y": -9.12765955,"x": -78.5368148900604},
  {"name": "LMSB047","y": -12.0955275,"x": -76.9830646206685},
  {"name": "LMJL134-S // LMJL134","y": -11.9660175,"x": -76.9940243606749},
  {"name": "MDPM041-F","y": -12.59277625,"x": -69.1773659616229},
  {"name": "APAB013-F","y": -13.6274545,"x": -72.8756262249258},
  {"name": "CBCB005","y": -9.0889295,"x": -78.5683147118464},
  {"name": "APAB014-F","y": -13.625457,"x": -72.8720730940031},
  {"name": "PUAY001-F","y": -14.8838455,"x": -70.5926652468554},
  {"name": "LMPC018-F","y": -12.084865,"x": -76.8778392946058},
  {"name": "APAB015-F","y": -13.6280055,"x": -72.8792243443144},
  {"name": "APAB017-F","y": -13.6285685,"x": -72.8861160256065},
  {"name": "LAMO069","y": -12.0775425,"x": -76.9037271437182},
  {"name": "APAB022-F","y": -13.638015,"x": -72.8904992506053},
  {"name": "APAB023-F","y": -13.64198,"x": -72.8947600708235},
  {"name": "PUAY006-F","y": -14.8884815,"x": -70.5843134085249},
  {"name": "APAB018-F","y": -13.635432,"x": -72.8926966834172},
  {"name": "APAB019-F","y": -13.6330235,"x": -72.8803484985276},
  {"name": "PIUC130","y": -5.190612,"x": -80.6100991182352},
  {"name": "APAB020-F","y": -13.634925,"x": -72.8704838768993},
  {"name": "AQBR023","y": -16.427112487008,"x": -71.5134119111961},
  {"name": "APAB024-F","y": -13.6454345,"x": -72.8986707316176},
  {"name": "APAB025-F","y": -13.628568,"x": -72.8884018934657},
  {"name": "APAB026-F","y": -13.63187,"x": -72.8861718597897},
  {"name": "PUAY002-F","y": -14.880279,"x": -70.5937595804679},
  {"name": "AQCA054-F","y": -16.3722599757551,"x": -71.5481654179466},
  {"name": "APAB027-F","y": -13.6337115,"x": -72.8922956859375},
  {"name": "APAB028-F","y": -13.6377815,"x": -72.8951575081018},
  {"name": "TCAL001-F","y": -17.999659,"x": -70.2619746564109},
  {"name": "TCAL002-F","y": -17.997425,"x": -70.2589451010786},
  {"name": "TCAL003-F","y": -17.9947935,"x": -70.2565558860896},
  {"name": "TCAL004-F","y": -17.9930155,"x": -70.2540701195383},
  {"name": "AQCM009-F","y": -16.6272515,"x": -72.7106243032551},
  {"name": "LAMO090-F","y": -12.087145,"x": -76.8881820669014},
  {"name": "PUAY003-F","y": -14.878699,"x": -70.5890640410158},
  {"name": "PUAY004-F","y": -14.8823745,"x": -70.5888503330493},
  {"name": "PUAY005-F","y": -14.8837865,"x": -70.5855370087948},
  {"name": "CHCH001-S // CHCH001","y": -13.4171695,"x": -76.1295940828351},
  {"name": "AQCM010-F","y": -16.6312395,"x": -72.7112940398333},
  {"name": "AQCM012-F","y": -16.6042655,"x": -72.7008805592906},
  {"name": "AQCM016-F","y": -16.591618,"x": -72.7060865579223},
  {"name": "AQCM002-F","y": -16.6169585,"x": -72.7061927153527},
  {"name": "LAMO094-F","y": -12.088371,"x": -76.9034165419992},
  {"name": "AQCM003-F","y": -16.6193735,"x": -72.7120161150903},
  {"name": "CZST015","y": -13.5374895,"x": -71.9816464564286},
  {"name": "CZSS023","y": -13.541807,"x": -71.9309102555288},
  {"name": "AQCM004-F","y": -16.6203515,"x": -72.7079849563469},
  {"name": "AQCM007-F","y": -16.624742,"x": -72.7136669163877},
  {"name": "AQCM008-F","y": -16.62524,"x": -72.7078406441281},
  {"name": "AQUC002-F","y": -16.444695,"x": -71.6229701326511},
  {"name": "AQUC003-F","y": -16.4462135,"x": -71.6179814545128},
  {"name": "AQCM013-F","y": -16.5982835,"x": -72.6987671717108},
  {"name": "AQSB034-F","y": -16.4492775,"x": -71.529703736129},
  {"name": "AQCM014-F","y": -16.601621,"x": -72.6924875257353},
  {"name": "AQCM015-F","y": -16.5974235,"x": -72.701384060435},
  {"name": "AQUC004-F","y": -16.4521715,"x": -71.6170366769697},
  {"name": "SRJL012-F","y": -15.500207,"x": -70.124015459204},
  {"name": "CZPI005-F","y": -12.5225288,"x": -73.8217742100773},
  {"name": "AQSB038-F","y": -16.4694155,"x": -71.5268474370946},
  {"name": "AQMF021","y": -16.3917434645985,"x": -71.5117836954519},
  {"name": "AQYA016-F","y": -16.3964385,"x": -71.5537014371585},
  {"name": "AQYA017-F","y": -16.4072335,"x": -71.56571809029},
  {"name": "AQSB047-F","y": -16.4526684,"x": -71.5365708975205},
  {"name": "PUJL078-F","y": -15.4887171715263,"x": -70.113019757671},
  {"name": "AQSB033-F","y": -16.44716315,"x": -71.5296686381188},
  {"name": "AQSB028-F","y": -16.44989,"x": -71.5264381430348},
  {"name": "AQSB036-F","y": -16.454987,"x": -71.5190091931461},
  {"name": "AQSB037-F","y": -16.457179,"x": -71.5219336073549},
  {"name": "AQSB029-F","y": -16.4719835,"x": -71.5259669271429},
  {"name": "LMSC011-S // LMSC011","y": -12.133952,"x": -77.0050130704633},
  {"name": "PILU004-F","y": -5.4014295,"x": -80.7450882384749},
  {"name": "AQSB030-F","y": -16.489035,"x": -71.5056725890418},
  {"name": "LMSB048","y": -12.09918425,"x": -76.9804444710675},
  {"name": "AQSB043-F","y": -16.4477715,"x": -71.5221306656435},
  {"name": "AQSB031-F","y": -16.4460372,"x": -71.5237087027114},
  {"name": "LMAN003-F","y": -11.7777895,"x": -77.1687922659871},
  {"name": "ANCB001-F","y": -9.0477728,"x": -78.5740801882253},
  {"name": "AQSB032-F","y": -16.445678,"x": -71.5266818969424},
  {"name": "AQCC026","y": -16.3746482050485,"x": -71.5575821269564},
  {"name": "AQSB035-F","y": -16.451427,"x": -71.5292928295002},
  {"name": "AQYU001-F","y": -16.3086979,"x": -71.6109346491013},
  {"name": "AQSB039-F","y": -16.468648,"x": -71.5239180007187},
  {"name": "AQSB046-F","y": -16.4338208,"x": -71.5378452708397},
  {"name": "LMAN004-F","y": -11.779168,"x": -77.1637799300429},
  {"name": "CZCZ002","y": -13.5263405,"x": -71.944656256129},
  {"name": "AQSB040-F","y": -16.467216,"x": -71.5532687279034},
  {"name": "AQSB041-F","y": -16.4670855,"x": -71.5497634014829},
  {"name": "AQSB042-F","y": -16.4463095,"x": -71.5192560978723},
  {"name": "AQSB044-F","y": -16.445471,"x": -71.5214336500646},
  {"name": "AQSB048-F","y": -16.456529,"x": -71.5380611919424},
  {"name": "AQHU011","y": -16.433136602264,"x": -71.5631527723271},
  {"name": "AQSB049-F","y": -16.4506035,"x": -71.5223055841317},
  {"name": "AQSB050-F","y": -16.4616546,"x": -71.5209425343581},
  {"name": "AQUC005-F","y": -16.4514735,"x": -71.6143304524465},
  {"name": "AQUC006-F","y": -16.4546603,"x": -71.613180078023},
  {"name": "AQYU002-F","y": -16.309949,"x": -71.6158855117597},
  {"name": "AQYU003-F","y": -16.3086023,"x": -71.6187842859519},
  {"name": "AQYU004-F","y": -16.305127,"x": -71.6164204606884},
  {"name": "AQYU005-F","y": -16.3076175,"x": -71.6100102485093},
  {"name": "LMAN007-F","y": -11.7740655,"x": -77.1714907607616},
  {"name": "AQYU006-F","y": -16.31112,"x": -71.6034751296296},
  {"name": "SRJL015-F","y": -15.513705,"x": -70.1281056923715},
  {"name": "AQMF016","y": -16.3915284197605,"x": -71.5112831490914},
  {"name": "AQPP030","y": -16.4168128469415,"x": -71.514316263271},
  {"name": "CBCB006","y": -9.05806335,"x": -78.5785293147509},
  {"name": "LMSC086","y": -12.1121975,"x": -76.9828408152493},
  {"name": "AQCC033","y": -16.3420994410085,"x": -71.5837349986898},
  {"name": "MDPM017","y": -12.596282,"x": -69.1989304238878},
  {"name": "PIMA005-F","y": -4.1073225,"x": -81.0461541983607},
  {"name": "LAMO069-S","y": -12.0718095,"x": -76.9032822883037},
  {"name": "AQCA017","y": -16.391297884158,"x": -71.5466968649932},
  {"name": "AQMF017","y": -16.3905351167605,"x": -71.5122911535599},
  {"name": "AQBR022","y": -16.414046524499,"x": -71.5209514929114},
  {"name": "CBNV066-S // CBNV066","y": -9.1350057,"x": -78.5088457292273},
  {"name": "LAMO015-S // LAMO015","y": -12.0698655,"x": -76.9702312631161},
  {"name": "LMMP228-F","y": -12.0055495,"x": -77.0931108561828},
  {"name": "CHCH002-S // CHCH002","y": -13.4149405,"x": -76.1340113419868},
  {"name": "PUJL061-F","y": -15.5104565,"x": -70.1220496780869},
  {"name": "CHCH005","y": -13.4196615,"x": -76.1333750370404},
  {"name": "LMJL163-S // LMJL163","y": -11.95204,"x": -76.9899881962884},
  {"name": "LAMO016-S // LAMO016","y": -12.0795945,"x": -76.9727319012859},
  {"name": "LMSC134","y": -12.109471,"x": -76.9778367926431},
  {"name": "LMAG040-F","y": -12.037647,"x": -76.9937243077194},
  {"name": "CBCB010","y": -9.0650565,"x": -78.5809920636991},
  {"name": "CBNV067-S // CBNV067","y": -9.13817285,"x": -78.5133672754096},
  {"name": "CBNV068-S // CBNV068","y": -9.13921,"x": -78.5079599847582},
  {"name": "PUJL058-F","y": -15.5181545,"x": -70.1188023150612},
  {"name": "PUJL059-F","y": -15.51415,"x": -70.1205117250921},
  {"name": "LAMO017-S // LAMO017","y": -12.0742445,"x": -76.9654932554182},
  {"name": "PUJL063-F","y": -15.507483,"x": -70.1253102855149},
  {"name": "LAMO054","y": -12.104606,"x": -76.9494378712766},
  {"name": "LAMO018-S // LAMO018","y": -12.0657605,"x": -76.9619974262006},
  {"name": "LAMO019AS","y": -12.0669245,"x": -76.9411995421964},
  {"name": "PUJL064-F","y": -15.5068495,"x": -70.122902231062},
  {"name": "LMSC134","y": -12.1097215,"x": -76.9754027279453},
  {"name": "CBNV068-S // CBNV068","y": -9.13932295,"x": -78.5057833985008},
  {"name": "CBNV068-S // CBNV068","y": -9.1375792,"x": -78.5063882258422},
  {"name": "LAMO019BS","y": -12.0695065,"x": -76.9401262084334},
  {"name": "LAMO020-S // LAMO020","y": -12.0686885,"x": -76.9453162425484},
  {"name": "LMSC040-S // LMSC040","y": -12.132352,"x": -76.9968966859745},
  {"name": "CBCB007","y": -9.05593685,"x": -78.5897146782634},
  {"name": "CBCB008-S // CBCB008","y": -9.056714,"x": -78.5853286861997},
  {"name": "PUJL065-F","y": -15.5037555,"x": -70.1255152921288},
  {"name": "LMBY035-S // LMBY035","y": -11.8868775,"x": -77.0336926413761},
  {"name": "PIUP003-F","y": -5.0901775,"x": -81.1040886074745},
  {"name": "LMCA173-F","y": -12.039645,"x": -77.1231117556948},
  {"name": "TCNA070","y": -18.0030765,"x": -70.2305640195146},
  {"name": "PUJL082-F","y": -15.5055915,"x": -70.131791674775},
  {"name": "PUJL084-F","y": -15.4972135,"x": -70.128652391145},
  {"name": "PUJL083-F","y": -15.5036195,"x": -70.1328578507669},
  {"name": "LAMO021-S // LAMO021","y": -12.075724,"x": -76.9544289338172},
  {"name": "AQCA051-F","y": -16.381078434338,"x": -71.5518340291803},
  {"name": "LMSC015-S // LMSC015","y": -12.113797,"x": -76.9934138021791},
  {"name": "CHI051-S","y": -6.7757565,"x": -79.8456013296489},
  {"name": "PUJL085-F","y": -15.497511,"x": -70.1297878269641},
  {"name": "LAMO069","y": -12.073742,"x": -76.9040805458199},
  {"name": "PUJL086-F","y": -15.494888,"x": -70.1311213117114},
  {"name": "PIUP005-F","y": -5.094514,"x": -81.102205142283},
  {"name": "MQIL030-F","y": -17.6592736419686,"x": -71.3181112117439},
  {"name": "ZONA SATURADA","y": -8.1695125,"x": -79.0095567539633},
  {"name": "TRHC007","y": -8.090449,"x": -79.0894715688803},
  {"name": "CBCB012-S // CBCB012","y": -9.065142,"x": -78.5869629579439},
  {"name": "PUJL087-F","y": -15.491927,"x": -70.131706653825},
  {"name": "LLLE021-F","y": -8.071251,"x": -79.0694694569801},
  {"name": "PUJL088-F","y": -15.5001035,"x": -70.1553120614456},
  {"name": "AQCC141-F","y": -16.399131,"x": -71.5814897374449},
  {"name": "LAMO061","y": -12.0678485,"x": -76.9146323730554},
  {"name": "CBCB011-S // CBCB011","y": -9.065293,"x": -78.5839203525618},
  {"name": "TCNA118","y": -18.0398692649045,"x": -70.2547153405216},
  {"name": "TCNA119","y": -18.041402112182,"x": -70.2477813017816},
  {"name": "PIUP014-F","y": -5.0910065,"x": -81.1153599956673},
  {"name": "PUJL089-F","y": -15.4978155,"x": -70.1536916947629},
  {"name": "LMAT101-F","y": -12.0548045,"x": -76.9440079136345},
  {"name": "PIOC001-F","y": -5.1980865,"x": -80.6561063092731},
  {"name": "CBCB014","y": -9.0671543,"x": -78.5853781891503},
  {"name": "LAMO052-S // LAMO052","y": -12.09547,"x": -76.9415919761043},
  {"name": "LMSC003-S // LMSC003","y": -12.132123,"x": -77.0099269911392},
  {"name": "LMSC110-S","y": -12.1046815,"x": -76.9635195457897},
  {"name": "PUJL090-F","y": -15.498015,"x": -70.1506465205362},
  {"name": "MDPM011","y": -12.5926705,"x": -69.1898174474366},
  {"name": "PISH001-F","y": -5.555155,"x": -80.8245703624352},
  {"name": "PIUR160-F","y": -5.166343,"x": -80.6662329882815},
  {"name": "PUJL091-F","y": -15.4958715,"x": -70.1477531990446},
  {"name": "LAMO022-S // LAMO022","y": -12.0780535,"x": -76.9279612849505},
  {"name": "CBCB015","y": -9.0664265,"x": -78.58937871875},
  {"name": "LAMO023-S // LAMO023","y": -12.085595,"x": -76.937741304398},
  {"name": "PUJL115-F","y": -15.47817,"x": -70.1590258956922},
  {"name": "LMPL009","y": -12.0731225,"x": -77.067482998453},
  {"name": "LMCO108","y": -11.944445,"x": -77.05894735},
  {"name": "PUJL092-F","y": -15.4966285,"x": -70.1615177644986},
  {"name": "TRLE037","y": -8.069426,"x": -79.0617259764017},
  {"name": "PIUP006-F","y": -5.0903215,"x": -81.1010207521713},
  {"name": "LAMO024-S","y": -12.067616,"x": -76.9367823298539},
  {"name": "PUJL093-F","y": -15.4978175,"x": -70.1594327539746},
  {"name": "PIUC115","y": -5.1818435,"x": -80.6222309431428},
  {"name": "PIUC117","y": -5.1829225,"x": -80.6124845158898},
  {"name": "PIUP007-F","y": -5.0981025,"x": -81.1032502190901},
  {"name": "TCNA121","y": -18.0089671966065,"x": -70.256970848934},
  {"name": "PIUR127","y": -5.1671135,"x": -80.629438733525},
  {"name": "PIUR122","y": -5.185717,"x": -80.641731587114},
  {"name": "PIUR164-F","y": -5.1751435,"x": -80.6452366850584},
  {"name": "PIUR152-S // PIUR152","y": -5.1759325,"x": -80.6784565303755},
  {"name": "TBZT001-F","y": -3.713281,"x": -80.7371198964554},
  {"name": "AMCH001-F","y": -6.226757,"x": -77.8746535942371},
  {"name": "PUJL094-F","y": -15.496257,"x": -70.1583839955996},
  {"name": "LAMO030-S // LAMO030","y": -12.0705755,"x": -76.94313705346},
  {"name": "LAMO055-S","y": -12.0955895,"x": -76.9456635469656},
  {"name": "AQSC021-F","y": -16.4276275,"x": -71.5711077423077},
  {"name": "ANNC016-F","y": -9.1332251,"x": -78.514582644222},
  {"name": "PIUR035","y": -5.1993855,"x": -80.6402897043702},
  {"name": "AQCC128-F","y": -16.337083,"x": -71.5526151232637},
  {"name": "LLLE004-F","y": -8.0523635,"x": -79.0535335345774},
  {"name": "JNST005-F","y": -11.25357275,"x": -74.6399733802853},
  {"name": "PUJL095-F","y": -15.4953655,"x": -70.1555707560241},
  {"name": "LMLV117-F","y": -12.066633,"x": -77.013385027928},
  {"name": "PUJL096-F","y": -15.4946395,"x": -70.150999269521},
  {"name": "LMSC016-S // LMSC016","y": -12.1161065,"x": -76.9940968698937},
  {"name": "LMSC291-F","y": -12.14697,"x": -76.9840348392846},
  {"name": "PUJL097-F","y": -15.49483,"x": -70.1461590127954},
  {"name": "AQCC136-F","y": -16.377379,"x": -71.5577277098364},
  {"name": "LAMO032-S // LAMO032","y": -12.084826,"x": -76.9292329389244},
  {"name": "CBNV066-S // CBNV066","y": -9.1363428,"x": -78.5085294739581},
  {"name": "JNST011-F","y": -11.24600055,"x": -74.6373146233204},
  {"name": "TRLE040","y": -8.0751775,"x": -79.05879787108},
  {"name": "PIOC003-F","y": -5.2018685,"x": -80.6562631683388},
  {"name": "PUJL098-F","y": -15.495146,"x": -70.1637601770642},
  {"name": "LMAT105-F","y": -12.0211635,"x": -76.8900246586317},
  {"name": "JNST006-F","y": -11.256921,"x": -74.6412666368249},
  {"name": "LMAN008-F","y": -11.777632,"x": -77.1652843742764},
  {"name": "JNST001-F","y": -11.25736465,"x": -74.6477679734794},
  {"name": "LMCA174-F","y": -12.0407325,"x": -77.1232030769773},
  {"name": "JNST002-F","y": -11.2594617,"x": -74.643185279608},
  {"name": "CHCH003","y": -13.4128775,"x": -76.12889781325},
  {"name": "JNST003-F","y": -11.2622283,"x": -74.6426848999479},
  {"name": "JNST004-F","y": -11.2535429,"x": -74.6436971459989},
  {"name": "LAMO033-S // LAMO033","y": -12.07937,"x": -76.9518969892963},
  {"name": "PIUC133","y": -5.183368,"x": -80.5937054128929},
  {"name": "JNST007-F","y": -11.2610633,"x": -74.6392586205445},
  {"name": "LMSC032-S // LMSC032","y": -12.125408,"x": -76.9897922251429},
  {"name": "LAMO071","y": -12.091014,"x": -76.9256141066536},
  {"name": "JNST008-F","y": -11.25731135,"x": -74.6374335173339},
  {"name": "JNST009-F","y": -11.25044005,"x": -74.637091549856},
  {"name": "LMSC022-S","y": -12.1203365,"x": -76.9925612081522},
  {"name": "JNST010-F","y": -11.25382115,"x": -74.6370468220941},
  {"name": "JNST012-F","y": -11.24578,"x": -74.6351514499587},
  {"name": "LMLV119-F","y": -12.066606,"x": -77.0124593063116},
  {"name": "AQCC067-F","y": -16.324088,"x": -71.5904847801557},
  {"name": "LAMO034-S // LAMO034","y": -12.070666,"x": -76.9473307513638},
  {"name": "LAMO069","y": -12.073577,"x": -76.9009723283308},
  {"name": "LAMO041-S // LAMO041","y": -12.1047425,"x": -76.9466162620877},
  {"name": "AQCC142-F","y": -16.4032854354435,"x": -71.5746352742433},
  {"name": "LAMO042-S // LAMO042","y": -12.103063,"x": -76.9383123063166},
  {"name": "TCCN003-F","y": -17.983148,"x": -70.2386631269777},
  {"name": "PUJL099-F","y": -15.4920445,"x": -70.16474275543},
  {"name": "PIOC002-F","y": -5.1989715,"x": -80.6513975398502},
  {"name": "LMAN009-F","y": -11.772427,"x": -77.1727605812977},
  {"name": "HUAB006-F","y": -10.1297435,"x": -76.2021694641883},
  {"name": "HUAB004-F","y": -10.10854115,"x": -76.208357078193},
  {"name": "PIUR029","y": -5.1965125,"x": -80.6328492715444},
  {"name": "LAMO071","y": -12.0919285,"x": -76.9263852972798},
  {"name": "HUAB005-F","y": -10.131799,"x": -76.2077192142857},
  {"name": "HUAB007-F","y": -10.1223281,"x": -76.2068209165553},
  {"name": "HUAB008-F","y": -10.11595335,"x": -76.20777326683},
  {"name": "LMSC042-S // LMSC042","y": -12.129285,"x": -76.9895335352757},
  {"name": "LMJL023-S // LMJL023","y": -12.0031,"x": -77.0008977647059},
  {"name": "CZPI006-F","y": -12.51975265,"x": -73.8287877158627},
  {"name": "LAMO071-S","y": -12.093394,"x": -76.9249554033483},
  {"name": "PACH014-F","y": -10.6852815,"x": -76.240758262285},
  {"name": "LMSC017-S // LMSC017","y": -12.117167,"x": -76.9910293961988},
  {"name": "CZPI001-F","y": -12.5207773,"x": -73.8418374727157},
  {"name": "PACH015-F","y": -10.6898925,"x": -76.2417225942458},
  {"name": "PIUR047","y": -5.1691745,"x": -80.6299520444295},
  {"name": "CBCB016","y": -9.0657115,"x": -78.5924979907204},
  {"name": "PUJL100-F","y": -15.4878515,"x": -70.1654351395844},
  {"name": "LMSC018-S // LMSC018","y": -12.117209,"x": -76.9951320637877},
  {"name": "LMJL162-S","y": -11.9539555,"x": -76.9915921178377},
  {"name": "LMCO117-S","y": -11.960837,"x": -77.0550732878734},
  {"name": "PUJL101-F","y": -15.4854935,"x": -70.1612789862496},
  {"name": "PIUR031","y": -5.1983485,"x": -80.6265963052732},
  {"name": "CZPI002-F","y": -12.52482535,"x": -73.8373550987779},
  {"name": "PUJL104-F","y": -15.487088,"x": -70.1552918590754},
  {"name": "CZPI003-F","y": -12.52500315,"x": -73.8265687304882},
  {"name": "CZPI004-F","y": -12.5257295,"x": -73.8201759836333},
  {"name": "AQCC133-F","y": -16.3276385,"x": -71.5911167403856},
  {"name": "CZPI007-F","y": -12.51794615,"x": -73.8234486950553},
  {"name": "CZPI008-F","y": -12.5158085,"x": -73.8273527856807},
  {"name": "MQSG005-F","y": -17.1808062451172,"x": -70.9292500294709},
  {"name": "MQMN060-F","y": -17.2046544149548,"x": -70.922778114228},
  {"name": "MQMN059-F","y": -17.1974964911052,"x": -70.9163170755603},
  {"name": "MQMN058-F","y": -17.1981496070647,"x": -70.9221781142284},
  {"name": "LAMO046-S // LAMO046","y": -12.100935,"x": -76.94079939426},
  {"name": "LLLE013-F","y": -8.074122,"x": -79.0415840680798},
  {"name": "MQMN055-F","y": -17.2122869731542,"x": -70.9497446354814},
  {"name": "MQMN054-F","y": -17.2132470368568,"x": -70.9424054208723},
  {"name": "ANNC016-F","y": -9.1316501,"x": -78.5131408543755},
  {"name": "SMTP053-F","y": -6.48635,"x": -76.3465618829787},
  {"name": "CBCB017","y": -9.06677185,"x": -78.5933285200864},
  {"name": "AQCC077-F","y": -16.325496,"x": -71.5692301229924},
  {"name": "HUAB001-F","y": -10.1198965,"x": -76.2057783701456},
  {"name": "HUAB002-F","y": -10.1287865,"x": -76.2045547277328},
  {"name": "AQCC100-F","y": -16.3285595,"x": -71.5592629512037},
  {"name": "ANNC016-F","y": -9.13433155,"x": -78.515759325302},
  {"name": "CBCB021-S // CBCB021","y": -9.07089005,"x": -78.5835052183929},
  {"name": "HUAB003-F","y": -10.129805,"x": -76.2072218632913},
  {"name": "ANNC017-F","y": -9.12212115,"x": -78.5000068255158},
  {"name": "CBCB047","y": -9.094823,"x": -78.5711745816841},
  {"name": "LAMO047-S // LAMO047","y": -12.106522,"x": -76.9395714475703},
  {"name": "CBCB018","y": -9.0691285,"x": -78.5929980108959},
  {"name": "LMCA061-S // LMCA061","y": -12.043639,"x": -77.1001619351154},
  {"name": "PIUP008-F","y": -5.09685,"x": -81.099568065407},
  {"name": "LMSC019-S // LMSC019","y": -12.1186685,"x": -76.9915615613994},
  {"name": "LMCO118-S // LMCO118","y": -11.960605,"x": -77.0560337384501},
  {"name": "HZHU003-F","y": -9.527251,"x": -77.527576056464},
  {"name": "CBCB019","y": -9.069359,"x": -78.5896282818092},
  {"name": "TCNA038-S // TCNA038","y": -18.04079485,"x": -70.2539554167675},
  {"name": "MDPM037","y": -12.603766,"x": -69.1980645851063},
  {"name": "SMTP037-F","y": -6.48701485,"x": -76.3533037828576},
  {"name": "SMTP054-F","y": -6.484193,"x": -76.3432878915453},
  {"name": "SMTP055-F","y": -6.49049,"x": -76.3435914916628},
  {"name": "SMTP056-F","y": -6.492013,"x": -76.3459027673267},
  {"name": "SMMR001-F","y": -6.468168,"x": -76.3967225159134},
  {"name": "LMSC021-S // LMSC021","y": -12.1197205,"x": -76.9945496020037},
  {"name": "SMMR002-F","y": -6.4700605,"x": -76.3985124616321},
  {"name": "LAMO061","y": -12.0690185,"x": -76.9111508164564},
  {"name": "CHCH015-F","y": -13.42142,"x": -76.1352484639228},
  {"name": "LMSC020-S // LMSC020","y": -12.1189395,"x": -76.9963395681972},
  {"name": "PUJL102-F","y": -15.490053,"x": -70.1600283852068},
  {"name": "AQCC086-F","y": -16.331155,"x": -71.5741449694918},
  {"name": "AQBR079-F","y": -16.439278,"x": -71.5259135},
  {"name": "PUJL103-F","y": -15.4879315,"x": -70.1591346995732},
  {"name": "PUJL109-F","y": -15.490572,"x": -70.1471604453125},
  {"name": "LMSM025-S // LMSM025","y": -12.07356,"x": -77.082197341303},
  {"name": "AQCC076-F","y": -16.3223451,"x": -71.5652315973684},
  {"name": "CBCB021-S // CBCB021","y": -9.06971765,"x": -78.5850442626266},
  {"name": "MQMN023-S // MQMN023","y": -17.2093355,"x": -70.941139032864},
  {"name": "SMTP038-F","y": -6.491931,"x": -76.3539620972754},
  {"name": "SMTP039-F","y": -6.4920175,"x": -76.3499608564406},
  {"name": "TCCN001-F","y": -17.981532,"x": -70.2425589258704},
  {"name": "TCCN002-F","y": -17.9809405,"x": -70.2403619002785},
  {"name": "PUJL105-F","y": -15.491645,"x": -70.155848438193},
  {"name": "TCGA003-F","y": -18.061611,"x": -70.2582275691259},
  {"name": "LMSA037","y": -12.038718,"x": -76.9697192793771},
  {"name": "AQCC079-F","y": -16.3263598,"x": -71.566219632827},
  {"name": "TCGA009-F","y": -18.0635405,"x": -70.2412187672878},
  {"name": "CBCB022","y": -9.072711,"x": -78.5857433318272},
  {"name": "LAMO071","y": -12.094843,"x": -76.9272678157895},
  {"name": "PUJL106-F","y": -15.486937,"x": -70.1505521847826},
  {"name": "LMCA009-S // LMCA009","y": -12.010082,"x": -77.0952724495516},
  {"name": "LMJL112","y": -11.974256,"x": -77.0080374196775},
  {"name": "LMCO118-S // LMCO118","y": -11.962896,"x": -77.0579847397959},
  {"name": "LLLE014-F","y": -8.076509,"x": -79.040224178911},
  {"name": "PUJL107-F","y": -15.4904325,"x": -70.1513248742491},
  {"name": "5116B03-S // 5116B03","y": -12.097803,"x": -77.044783541035},
  {"name": "LMSC023-S // LMSC023","y": -12.1200795,"x": -76.9896812981838},
  {"name": "LMSC043-S // LMSC043","y": -12.130973,"x": -76.9917756818898},
  {"name": "LMJL160-S // LMJL160","y": -11.957698,"x": -76.9843831673554},
  {"name": "PUJL108-F","y": -15.4884695,"x": -70.145659482582},
  {"name": "CBCB025","y": -9.06784185,"x": -78.5983039082994},
  {"name": "LMSC024-S // LMSC024","y": -12.1222055,"x": -76.9937774341878},
  {"name": "JNCM001-F","y": -11.063311,"x": -75.3390450304001},
  {"name": "JNCM002-F","y": -11.0619485,"x": -75.3364597945556},
  {"name": "JNCM003-F","y": -11.060697,"x": -75.3349847305014},
  {"name": "AQCC105-F","y": -16.331913,"x": -71.5487774509725},
  {"name": "CHCH012-F","y": -13.4121788,"x": -76.1420479430002},
  {"name": "JNCM004-F","y": -11.059066,"x": -75.3315417129401},
  {"name": "JNCM005-F","y": -11.0558515,"x": -75.3309965685583},
  {"name": "JNCM006-F","y": -11.0563035,"x": -75.3284230685241},
  {"name": "JNMZ001-F","y": -11.3250205,"x": -74.532686270112},
  {"name": "JNST014-F","y": -11.236788,"x": -74.6348389873595},
  {"name": "JNCM007-F","y": -11.055278,"x": -75.3260401777689},
  {"name": "JNCM008-F","y": -11.067144,"x": -75.3384885436803},
  {"name": "JNCM009-F","y": -11.0722295,"x": -75.3380767273847},
  {"name": "JNMZ002-F","y": -11.323888,"x": -74.5279847274902},
  {"name": "CBCB056","y": -9.10243,"x": -78.5574330547606},
  {"name": "JNMZ003-F","y": -11.3295431,"x": -74.5298372480207},
  {"name": "CHCH016-F","y": -13.424751,"x": -76.1338329412118},
  {"name": "JNST013-F","y": -11.2478845,"x": -74.6343771380372},
  {"name": "AQCC087-F","y": -16.3311945,"x": -71.5699618591027},
  {"name": "LAMO048-S // LAMO048","y": -12.116362,"x": -76.9334454200503},
  {"name": "CBCB026","y": -9.069666,"x": -78.5978979950411},
  {"name": "LAMO049-S","y": -12.0956615,"x": -76.9503290971664},
  {"name": "LAMO050","y": -12.1008655,"x": -76.9477398246229},
  {"name": "LAMO051-S // LAMO051","y": -12.0926945,"x": -76.9514260812408},
  {"name": "PUJL110-F","y": -15.4808255,"x": -70.1643430593125},
  {"name": "CBCB027","y": -9.072003,"x": -78.6003164881196},
  {"name": "LMSC025-S // LMSC025","y": -12.121998,"x": -76.9909287266976},
  {"name": "CBCB034","y": -9.0744335,"x": -78.6006539842932},
  {"name": "PIUR079","y": -5.1887555,"x": -80.6574825573495},
  {"name": "CBCB034","y": -9.07367,"x": -78.6039355077907},
  {"name": "AQSB019","y": -16.4557175,"x": -71.5165743457171},
  {"name": "CBCB040","y": -9.0815895,"x": -78.5784618771663},
  {"name": "PUJL111-F","y": -15.4824845,"x": -70.1618196342937},
  {"name": "CHCH023-F","y": -13.4116585,"x": -76.1361598691834},
  {"name": "CHCH013-F","y": -13.413994,"x": -76.1396570829277},
  {"name": "CBCB041-S // CBCB041","y": -9.0798095,"x": -78.5764734567426},
  {"name": "LMSC026-S","y": -12.1224925,"x": -76.9865598890397},
  {"name": "CHCH017-F","y": -13.421482,"x": -76.1296784362466},
  {"name": "LLLE015-F","y": -8.070759,"x": -79.0485744953941},
  {"name": "CHCH018-F","y": -13.4223835,"x": -76.1277037120843},
  {"name": "CHCH019-F","y": -13.4257655,"x": -76.1306380173392},
  {"name": "CHCH020-F","y": -13.427234,"x": -76.1354877421796},
  {"name": "CHCH021-F","y": -13.429211,"x": -76.1331103355039},
  {"name": "AQCA044-F","y": -16.327918,"x": -71.5422346875928},
  {"name": "CBCB042-S // CBCB042","y": -9.0764564,"x": -78.5732260308009},
  {"name": "LMSC027","y": -12.123008,"x": -76.9890508685239},
  {"name": "CBCB046","y": -9.0911225,"x": -78.5736494686984},
  {"name": "PUJL112-F","y": -15.4832065,"x": -70.1538971695804},
  {"name": "AQBR049-F","y": -16.4177155,"x": -71.5281851762855},
  {"name": "AQLJ006-F","y": -16.502065,"x": -71.8388906925429},
  {"name": "LMCO119","y": -11.9641955,"x": -77.0574288653133},
  {"name": "AQBR048-F","y": -16.41523,"x": -71.5284566595987},
  {"name": "LLLE016-F","y": -8.067318,"x": -79.048336787447},
  {"name": "CBCB049-S // CBCB049","y": -9.0976465,"x": -78.5670756446175},
  {"name": "LMMF045","y": -12.111773,"x": -77.0280256860077},
  {"name": "AQCC078-F","y": -16.322532,"x": -71.5574162599688},
  {"name": "LMCA010-S // LMCA010","y": -12.0113385,"x": -77.0930016563021},
  {"name": "CBCB057","y": -9.1032885,"x": -78.5617019323556},
  {"name": "CBCB050-S // CBCB050","y": -9.10054665,"x": -78.5659092472205},
  {"name": "PUJL113-F","y": -15.4806685,"x": -70.1587269789419},
  {"name": "AQCA031-F","y": -16.3508205,"x": -71.5502664887695},
  {"name": "CBCB057","y": -9.1014345,"x": -78.5622776468008},
  {"name": "LLLE017-F","y": -8.067084,"x": -79.0454516381937},
  {"name": "PACH001-F","y": -10.6887275,"x": -76.2564664676027},
  {"name": "PACH002-F","y": -10.688522,"x": -76.2588096356624},
  {"name": "AQMJ013-F","y": -16.3309748,"x": -72.1955033361155},
  {"name": "PACH003-F","y": -10.684847,"x": -76.257171393241},
  {"name": "LMCA011","y": -12.012121,"x": -77.0970115631877},
  {"name": "PIUP009-F","y": -5.093492,"x": -81.0980040384401},
  {"name": "CBCB058-S // CBCB058","y": -9.10438,"x": -78.5660879602649},
  {"name": "PACH004-F","y": -10.6820725,"x": -76.2561697256337},
  {"name": "PACH005-F","y": -10.682737,"x": -76.2542238215252},
  {"name": "PACH006-F","y": -10.683144,"x": -76.2501466399756},
  {"name": "PACH007-F","y": -10.685794,"x": -76.2480692841443},
  {"name": "PACH008-F","y": -10.6838135,"x": -76.244360385314},
  {"name": "PACH009-F","y": -10.6869975,"x": -76.2445885461158},
  {"name": "TCNA112-S // TCNA112","y": -18.0393274,"x": -70.2798925476445},
  {"name": "PACH010-F","y": -10.6888615,"x": -76.2433712287908},
  {"name": "AQCC089-F","y": -16.401243,"x": -71.5776591212465},
  {"name": "LMCA015-S // LMCA015","y": -12.0137055,"x": -77.0900905633235},
  {"name": "PACH011-F","y": -10.692674,"x": -76.2627368089265},
  {"name": "PACH012-F","y": -10.689181,"x": -76.2513892813827},
  {"name": "TCNA113-S // TCNA113","y": -18.0408438,"x": -70.2788190678837},
  {"name": "PACH013-F","y": -10.689945,"x": -76.246557465798},
  {"name": "CHCH022-F","y": -13.43204775,"x": -76.1326509444154},
  {"name": "PIUR195-F","y": -5.1639545,"x": -80.632446167695},
  {"name": "PIUR196-F","y": -5.162639,"x": -80.6519128618611},
  {"name": "PIUR197-F","y": -5.20677,"x": -80.6341918480352},
  {"name": "AQCA049-F","y": -16.351164,"x": -71.5467818073395},
  {"name": "PIUR198-F","y": -5.2060775,"x": -80.6324865146026},
  {"name": "PIUR199-F","y": -5.2089695,"x": -80.6351449300082},
  {"name": "AQMA015-F","y": -16.347005,"x": -72.2024120897624},
  {"name": "AQCA032-F","y": -16.3474515,"x": -71.5492968386064},
  {"name": "AQSA041-F","y": -16.367297,"x": -71.5272890442466},
  {"name": "MDPM019","y": -12.592994,"x": -69.1992339568952},
  {"name": "LMCA175-F","y": -12.039671,"x": -77.1261347801252},
  {"name": "AQSA036-F","y": -16.3608965,"x": -71.5122846844559},
  {"name": "AQSC022-F","y": -16.4256524,"x": -71.5729262288142},
  {"name": "AQSA037-F","y": -16.368057,"x": -71.506076087976},
  {"name": "AQSA039-F","y": -16.3792525,"x": -71.5242303952047},
  {"name": "AQCA034-F","y": -16.345101,"x": -71.5491197417219},
  {"name": "AQCA035-F","y": -16.345151,"x": -71.5450336082957},
  {"name": "AQCA036-F","y": -16.347683,"x": -71.54132849791},
  {"name": "AQCA041-F","y": -16.3330175,"x": -71.5386705448033},
  {"name": "AQCA050-F","y": -16.3516315,"x": -71.5431764058215},
  {"name": "AQSA040-F","y": -16.370713,"x": -71.5243242700639},
  {"name": "AQAQ037-F","y": -16.3953105,"x": -71.5339081774458},
  {"name": "AQCA037-F","y": -16.343911,"x": -71.5410904861483},
  {"name": "AQCA039-F","y": -16.339426,"x": -71.5458134949345},
  {"name": "LMSC029-S // LMSC029","y": -12.1233285,"x": -76.9977085852574},
  {"name": "AQCA030-F","y": -16.355395,"x": -71.5508597973707},
  {"name": "AQCC065-F","y": -16.326402,"x": -71.5929918421847},
  {"name": "AQCA042-F","y": -16.3250555,"x": -71.5409188835352},
  {"name": "AQCA043-F","y": -16.3271445,"x": -71.5445582702141},
  {"name": "AQCC066-F","y": -16.32283,"x": -71.5936187371439},
  {"name": "AQCA045-F","y": -16.32899,"x": -71.5402686431253},
  {"name": "LLLE018-F","y": -8.064549,"x": -79.0476994468077},
  {"name": "AQCA046-F","y": -16.326519,"x": -71.5361204803646},
  {"name": "AQCC073-F","y": -16.334406,"x": -71.5954121783199},
  {"name": "AQCA047-F","y": -16.3342735,"x": -71.5444481421536},
  {"name": "AQCA048-F","y": -16.3481235,"x": -71.5445480646829},
  {"name": "AQCC069-F","y": -16.31874325,"x": -71.590359359616},
  {"name": "AQCC071-F","y": -16.331001,"x": -71.5831334137839},
  {"name": "AQCC072-F","y": -16.3372985,"x": -71.589311257506},
  {"name": "PUJL114-F","y": -15.4798475,"x": -70.15364211243},
  {"name": "LMSC030-S // LMSC030","y": -12.1236805,"x": -76.9950187439931},
  {"name": "AQCA053-F","y": -16.3406395,"x": -71.5481431158088},
  {"name": "AQCC080-F","y": -16.325633,"x": -71.5631831331521},
  {"name": "CBCB058-S // CBCB058","y": -9.103737,"x": -78.5628544953139},
  {"name": "AQCC058-F","y": -16.3818995,"x": -71.5741195281849},
  {"name": "LMCA176-F","y": -12.0424975,"x": -77.1252286330038},
  {"name": "AQCC103-F","y": -16.3330285,"x": -71.5565664905686},
  {"name": "AQCC059-F","y": -16.385135,"x": -71.5739681206295},
  {"name": "AQCC068-F","y": -16.3231256,"x": -71.5881682741309},
  {"name": "PUJL116-F","y": -15.4761595,"x": -70.1617915245897},
  {"name": "AQCC081-F","y": -16.325404,"x": -71.5600723575871},
  {"name": "AQCC082-F","y": -16.3253451,"x": -71.5568147046039},
  {"name": "AQMJ014-F","y": -16.329646,"x": -72.1977843138686},
  {"name": "AQMD006-F","y": -17.0142975,"x": -72.0098673806438},
  {"name": "PUJL117-F","y": -15.471521,"x": -70.160273028496},
  {"name": "AQCC083-F","y": -16.324385,"x": -71.5542367425699},
  {"name": "AQCC098-F","y": -16.3330415,"x": -71.5593590844485},
  {"name": "AQCC084-F","y": -16.3242157,"x": -71.5509812833127},
  {"name": "AQCC101-F","y": -16.329117,"x": -71.5557924039307},
  {"name": "AQCC102-F","y": -16.3302435,"x": -71.5543947067308},
  {"name": "AQCC090-F","y": -16.39688,"x": -71.5761979078573},
  {"name": "AQCC091-F","y": -16.396565,"x": -71.5722200529206},
  {"name": "PUJL118-F","y": -15.475175,"x": -70.1581471840243},
  {"name": "AQCC093-F","y": -16.3499295,"x": -71.5545665811383},
  {"name": "AQCC094-F","y": -16.345635,"x": -71.5547210080551},
  {"name": "AQCC120-F","y": -16.313091,"x": -71.6055654978669},
  {"name": "AQCC095-F","y": -16.34395,"x": -71.55237018083},
  {"name": "PUJL119-F","y": -15.4733245,"x": -70.1539695050031},
  {"name": "AQCC096-F","y": -16.328531,"x": -71.5651082569966},
  {"name": "AQCC097-F","y": -16.331812,"x": -71.5653018599379},
  {"name": "LLLE019-F","y": -8.0634255,"x": -79.0504878118812},
  {"name": "AQCC106-F","y": -16.3193485,"x": -71.5929740183028},
  {"name": "LMLO053-S // LMLO053","y": -11.976331,"x": -77.0708433144544},
  {"name": "AQCC107-F","y": -16.3314265,"x": -71.5977911268284},
  {"name": "AQCC108-F","y": -16.3305596,"x": -71.5855407895465},
  {"name": "PUJL120-F","y": -15.476043,"x": -70.1539965386561},
  {"name": "AQCC109-F","y": -16.3336005,"x": -71.58216374585},
  {"name": "AQCC117-F","y": -16.3177335,"x": -71.6015302559453},
  {"name": "AQCC110-F","y": -16.344198,"x": -71.5890861460348},
  {"name": "LLLE020-F","y": -8.0686065,"x": -79.0689879730191},
  {"name": "AQPP014","y": -16.418896,"x": -71.5017066981674},
  {"name": "AQCC122-F","y": -16.3167085,"x": -71.6088581619329},
  {"name": "AQCC111-F","y": -16.346663,"x": -71.5857012664676},
  {"name": "PUDE011-F","y": -16.564385,"x": -69.0392719284349},
  {"name": "AQCC118-F","y": -16.3151102,"x": -71.6007518366354},
  {"name": "AQCC119-F","y": -16.3147705,"x": -71.6028139491743},
  {"name": "AQMA013-F","y": -16.3310135,"x": -72.1905667360481},
  {"name": "LMLV129-F","y": -12.065246,"x": -77.0141460814915},
  {"name": "LMSC031-S // LMSC031","y": -12.126129,"x": -76.9931622960679},
  {"name": "PUJL122-F","y": -15.4702205,"x": -70.1436638745275},
  {"name": "AQCC121-F","y": -16.3110634,"x": -71.6081979664011},
  {"name": "AQCC123-F","y": -16.3120176,"x": -71.6126710446922},
  {"name": "LMAT102-F","y": -12.06132,"x": -76.9366440084484},
  {"name": "AQCC130-F","y": -16.3944145,"x": -71.5604838992256},
  {"name": "AQMJ009-F","y": -16.3465,"x": -72.1850900375536},
  {"name": "AQCC124-F","y": -16.3296215,"x": -71.5511985975746},
  {"name": "AQCC125-F","y": -16.331049,"x": -71.5461953871277},
  {"name": "PUJL123-F","y": -15.467005,"x": -70.1408233404538},
  {"name": "PUJL124-F","y": -15.4709375,"x": -70.1389221588488},
  {"name": "AQCH001-F","y": -16.4637,"x": -71.4910199865823},
  {"name": "AQCC139-F","y": -16.326508,"x": -71.5772790011025},
  {"name": "AQCC126-F","y": -16.3351185,"x": -71.549615523632},
  {"name": "LMCA016","y": -12.0146825,"x": -77.0928241246411},
  {"name": "AQJH001-F","y": -16.4555395,"x": -71.5508937624545},
  {"name": "AQCC131-F","y": -16.3188493,"x": -71.5951124295038},
  {"name": "AQCC127-F","y": -16.339592,"x": -71.5507761007112},
  {"name": "AQBR050-F","y": -16.4176625,"x": -71.5310283088193},
  {"name": "AQCC129-F","y": -16.3492515,"x": -71.5739648921037},
  {"name": "AQCC132-F","y": -16.321165,"x": -71.5866037665977},
  {"name": "AQMM025-F","y": -16.4041072,"x": -71.4910697214232},
  {"name": "AQCC134-F","y": -16.3906295,"x": -71.5763927367886},
  {"name": "AQBR052-F","y": -16.420577,"x": -71.5310552342995},
  {"name": "AQBR051-F","y": -16.4204545,"x": -71.5273426844612},
  {"name": "AQCC135-F","y": -16.3892295,"x": -71.5719418732022},
  {"name": "AQCC140-F","y": -16.33292,"x": -71.5792675420537},
  {"name": "AQCC137-F","y": -16.325081,"x": -71.5840589176232},
  {"name": "PISH011-F","y": -5.567276,"x": -80.8206388280327},
  {"name": "AQCC138-F","y": -16.3243995,"x": -71.5732763015692},
  {"name": "TRLE011","y": -8.060186,"x": -79.058152214821},
  {"name": "AQCH002-F","y": -16.4692545,"x": -71.48438059375},
  {"name": "AQCH003-F","y": -16.471546,"x": -71.4872106793587},
  {"name": "AQMA002-F","y": -16.3232741,"x": -72.178908027868},
  {"name": "AQJH002-F","y": -16.4609325,"x": -71.5539537164376},
  {"name": "AQLJ001-F","y": -16.4940085,"x": -71.8350572440476},
  {"name": "LLLE022-F","y": -8.069702,"x": -79.0721630871135},
  {"name": "AQLJ002-F","y": -16.4944035,"x": -71.8404575089839},
  {"name": "PIHN001-F","y": -5.2375695,"x": -79.4513039179735},
  {"name": "AQLJ003-F","y": -16.495928,"x": -71.8443472148463},
  {"name": "AQLJ004-F","y": -16.498632,"x": -71.8381695888158},
  {"name": "LMSC034-S // LMSC034","y": -12.1260175,"x": -76.9994664375479},
  {"name": "AQMA003-F","y": -16.327852,"x": -72.1818006954902},
  {"name": "AQMA017-F","y": -16.3538505,"x": -72.195822903246},
  {"name": "AQLJ005-F","y": -16.4983,"x": -71.8431328690879},
  {"name": "AQBR061-F","y": -16.445814,"x": -71.517486},
  {"name": "LMSC033-S // LMSC033","y": -12.124772,"x": -76.9980931437406},
  {"name": "AQMA016-F","y": -16.3447855,"x": -72.1946832721275},
  {"name": "PUJL075-F","y": -15.4903894209502,"x": -70.1166821667229},
  {"name": "AQBR062-F","y": -16.447623,"x": -71.5156821428426},
  {"name": "AQMA005-F","y": -16.3376405,"x": -72.1919136329696},
  {"name": "AQMA006-F","y": -16.3333935,"x": -72.1838927472315},
  {"name": "AQBR063-F","y": -16.449073,"x": -71.513555463807},
  {"name": "AQMA012-F","y": -16.3265715,"x": -72.1945658377882},
  {"name": "PIUS059-F","y": -4.907649,"x": -80.6816519310019},
  {"name": "AQPP040","y": -16.425547,"x": -71.5121980468336},
  {"name": "AQBR064-F","y": -16.45229,"x": -71.5127161607095},
  {"name": "APCH005-F","y": -14.110116,"x": -72.2403141055336},
  {"name": "AQPP017","y": -16.4328755,"x": -71.5058911162634},
  {"name": "AQBR079-F","y": -16.438697,"x": -71.5279812050864},
  {"name": "AQBR065-F","y": -16.4171195,"x": -71.5194904258905},
  {"name": "AQBR080-F","y": -16.4410765,"x": -71.524059027027},
  {"name": "AQMA004-F","y": -16.3327925,"x": -72.188573971196},
  {"name": "LMCO015","y": -11.9263655,"x": -77.0539608763383},
  {"name": "AQMD007-F","y": -17.0187032,"x": -72.006120786358},
  {"name": "AQMA007-F","y": -16.338434,"x": -72.1856358047619},
  {"name": "AQMJ001-F","y": -16.3855525,"x": -72.2021104283336},
  {"name": "AQBR068-F","y": -16.42679,"x": -71.5442091581233},
  {"name": "PIUS060-F","y": -4.9108065,"x": -80.6810731995108},
  {"name": "AQBR079-F","y": -16.4387325,"x": -71.5258157902299},
  {"name": "AQBR079-F","y": -16.439187,"x": -71.525890925},
  {"name": "AQMA019-F","y": -16.3228675,"x": -72.1737812801236},
  {"name": "AQMA008-F","y": -16.343641,"x": -72.1858849308349},
  {"name": "AQMA009-F","y": -16.316064,"x": -72.1921775593929},
  {"name": "AQMA011-F","y": -16.3220657,"x": -72.1933597476866},
  {"name": "AQBR070-F","y": -16.429593,"x": -71.5448473778135},
  {"name": "AQMA018-F","y": -16.319162,"x": -72.1748652115582},
  {"name": "AQBR071-F","y": -16.4292165,"x": -71.5418675860171},
  {"name": "AQBR076-F","y": -16.427347,"x": -71.5325847369255},
  {"name": "CHI097-S // CHI097","y": -6.7959305,"x": -79.8359945076614},
  {"name": "AQMA001-F","y": -16.322788,"x": -72.1823429106918},
  {"name": "PIUR161-F","y": -5.1693905,"x": -80.6507561225911},
  {"name": "AQMJ002-F","y": -16.383178,"x": -72.1991051723357},
  {"name": "LAMO095-F","y": -12.093579,"x": -76.8975619009052},
  {"name": "LMLV127-F","y": -12.065205,"x": -77.0127859570836},
  {"name": "AQMJ003-F","y": -16.3769305,"x": -72.1983100733016},
  {"name": "AQMJ004-F","y": -16.3656925,"x": -72.1946343052699},
  {"name": "AQMJ006-F","y": -16.3608665,"x": -72.1911768519853},
  {"name": "LMSC044-S // LMSC044","y": -12.132077,"x": -76.9901158928571},
  {"name": "AQMJ010-F","y": -16.3440195,"x": -72.1768743164717},
  {"name": "AQMJ011-F","y": -16.339381,"x": -72.1730297812272},
  {"name": "AQMJ012-F","y": -16.3418905,"x": -72.1916202536825},
  {"name": "PUJL072-F","y": -15.4979663101711,"x": -70.1172215200509},
  {"name": "AQMM014-F","y": -16.3962505,"x": -71.5089990252144},
  {"name": "AQMM015-F","y": -16.396607,"x": -71.5055768820838},
  {"name": "LMCO025","y": -11.9193305,"x": -77.0580180973234},
  {"name": "AQNP003-F","y": -16.5719315,"x": -72.7114686956425},
  {"name": "AQMD002-F","y": -17.01162,"x": -72.0161316448198},
  {"name": "AQMM020-F","y": -16.404392,"x": -71.4935438130156},
  {"name": "PUJL073-F","y": -15.5013409065262,"x": -70.1159481845924},
  {"name": "AQMM016-F","y": -16.398642,"x": -71.5037410121723},
  {"name": "AQMD019-F","y": -17.009409,"x": -72.00670975},
  {"name": "AQMM019-F","y": -16.4011979,"x": -71.4938222549373},
  {"name": "AQMM026-F","y": -16.3981385,"x": -71.4895249923575},
  {"name": "PIUS061-F","y": -4.9115475,"x": -80.6844710246575},
  {"name": "AQMD003-F","y": -17.015081,"x": -72.0185742186649},
  {"name": "AQMD004-F","y": -17.011381,"x": -72.0126202815177},
  {"name": "PITG001-F","y": -4.9268365,"x": -80.344563192002},
  {"name": "AQMM018-F","y": -16.3999335,"x": -71.499474765233},
  {"name": "LMPC019-F","y": -12.0863765,"x": -76.8723876620512},
  {"name": "AQMM023-F","y": -16.3947182,"x": -71.4938502087457},
  {"name": "LMCA017","y": -12.0161415,"x": -77.0947566144578},
  {"name": "AQMM017-F","y": -16.3978295,"x": -71.5001493010952},
  {"name": "LMSA102-F","y": -12.0309735,"x": -76.9601470190975},
  {"name": "AQMM024-F","y": -16.3977295,"x": -71.4940014683018},
  {"name": "AQMM025-F","y": -16.4021125,"x": -71.4892184283177},
  {"name": "LLLE023-F","y": -8.048493,"x": -79.0578967761834},
  {"name": "AQMM025-F","y": -16.4041252,"x": -71.4913076522727},
  {"name": "AQMN002-F","y": -15.9821785,"x": -73.1710340197115},
  {"name": "AQMD005-F","y": -17.0175295,"x": -72.0150490187436},
  {"name": "AQSA030-S // AQSA030","y": -16.363726,"x": -71.5215679737439},
  {"name": "PUJL071-F","y": -15.4943522520463,"x": -70.1177912502354},
  {"name": "AQPP062-F","y": -16.4141745,"x": -71.4869000996849},
  {"name": "AQME001-F","y": -17.1038025,"x": -71.9016985986491},
  {"name": "AQPP018","y": -16.4050295,"x": -71.4760441871895},
  {"name": "AQMD001-F","y": -17.010443,"x": -72.0190319312816},
  {"name": "AQME002-F","y": -17.0974015,"x": -71.9092438971939},
  {"name": "PITG002-F","y": -4.9275775,"x": -80.3406093132475},
  {"name": "LMSA103-F","y": -12.030569,"x": -76.9559180674712},
  {"name": "AQMF027-F","y": -16.3931375,"x": -71.50898048481},
  {"name": "PUJL079-F","y": -15.4949016246936,"x": -70.1115976530276},
  {"name": "AYAN002-F","y": -12.624336,"x": -73.7890249913295},
  {"name": "AQMD009-F","y": -17.02028295,"x": -72.0172370764146},
  {"name": "AQMD010-F","y": -17.02543285,"x": -72.0143346571275},
  {"name": "AQMD011-F","y": -17.0260585,"x": -72.0165934887599},
  {"name": "AQMD012-F","y": -17.024893,"x": -72.0189893839396},
  {"name": "AQMD017-F","y": -17.0200635,"x": -72.0018754655569},
  {"name": "PUJL076-F","y": -15.4936622488725,"x": -70.1153341878805},
  {"name": "PUJL070-F","y": -15.4924920591944,"x": -70.1201473699279},
  {"name": "AQMD014-F","y": -17.02051335,"x": -72.0103053537944},
  {"name": "PUMC005-F","y": -14.0684725,"x": -70.4229684901722},
  {"name": "AQMD015-F","y": -17.0235395,"x": -72.0093132532122},
  {"name": "AQPP063-F","y": -16.414533,"x": -71.4802507065725},
  {"name": "AQMD016-F","y": -17.0281475,"x": -72.0100601550317},
  {"name": "AQMD018-F","y": -17.0138255,"x": -72.0034816039916},
  {"name": "AQMD020-F","y": -17.0182395,"x": -72.0185233522625},
  {"name": "AQMD021-F","y": -17.0170275,"x": -72.0006744520727},
  {"name": "AQNP001-F","y": -16.5849025,"x": -72.708047313885},
  {"name": "AQNP002-F","y": -16.5754675,"x": -72.7143532593598},
  {"name": "LMSA100-F","y": -12.0341025,"x": -76.9647717778434},
  {"name": "AQPP065-F","y": -16.4182075,"x": -71.4827234510359},
  {"name": "AQPP066-F","y": -16.4192,"x": -71.4861675147807},
  {"name": "AQPP067-F","y": -16.42235,"x": -71.4891568451128},
  {"name": "AQPP069-F","y": -16.4243715,"x": -71.4922411544996},
  {"name": "PUJL067-F","y": -15.4994216264199,"x": -70.1205593933429},
  {"name": "AQPP070-F","y": -16.4344755,"x": -71.4887409518606},
  {"name": "PUJL074-F","y": -15.5034753144294,"x": -70.1131127606207},
  {"name": "AQPP071-F","y": -16.433562,"x": -71.4833873504383},
  {"name": "LMSA099-F","y": -12.0378215,"x": -76.9658347877706},
  {"name": "AQPP072-F","y": -16.4317015,"x": -71.4868175607379},
  {"name": "AQSA033","y": -16.3723155,"x": -71.5205566511119},
  {"name": "PUJL068-F","y": -15.5024631529346,"x": -70.1201868691996},
  {"name": "PUJL077-F","y": -15.4990498355241,"x": -70.1132571015372},
  {"name": "PUJL081-F","y": -15.4997051619365,"x": -70.1072901947721},
  {"name": "AQPP073-F","y": -16.4312185,"x": -71.4901077150042},
  {"name": "CZPI009-F","y": -12.51269685,"x": -73.8261169000631},
  {"name": "AQSD001-F","y": -16.445064,"x": -71.4957414727506},
  {"name": "PUJL066-F","y": -15.5055297484256,"x": -70.120714018045},
  {"name": "PUJL069-F","y": -15.5047871338003,"x": -70.1166673749443},
  {"name": "PUJL060-F","y": -15.513014784805,"x": -70.115506532294},
  {"name": "PUJL062-F","y": -15.5087356594296,"x": -70.1172762777603},
  {"name": "PUJL080-F","y": -15.5009848138053,"x": -70.1097623907402},
  {"name": "PIUP011-F","y": -5.0960995,"x": -81.0948085467766},
  {"name": "PIUP010-F","y": -5.089718,"x": -81.0975969330709},
  {"name": "AYAN001-F","y": -12.622921,"x": -73.7930297386731},
  {"name": "LMSC035-S // LMSC035","y": -12.126279,"x": -76.9972132682118},
  {"name": "AQPP022","y": -16.4074225,"x": -71.4839225486733},
  {"name": "AQPP008-S // AQPP008","y": -16.414893,"x": -71.5007015282847},
  {"name": "AQAQ004-S // AQAQ004","y": -16.414418,"x": -71.5421267907635},
  {"name": "AQAQ025","y": -16.4261415,"x": -71.5563108745603},
  {"name": "AQAQ006-S // AQAQ006","y": -16.408393,"x": -71.5333015153994},
  {"name": "AQAQ007","y": -16.4066065,"x": -71.5363928815714},
  {"name": "LMCO026","y": -11.918089,"x": -77.0510140813659},
  {"name": "AQAQ009","y": -16.4065635,"x": -71.527083240849},
  {"name": "AQPP003-S // AQPP003","y": -16.4126855,"x": -71.5138834127798},
  {"name": "AQPP004-S // AQPP004","y": -16.4165405,"x": -71.5118276473547},
  {"name": "AQAQ015-S // AQAQ015","y": -16.399978,"x": -71.5251224066637},
  {"name": "AQAQ016-S // AQAQ016","y": -16.403232,"x": -71.5224184631355},
  {"name": "AQAQ020","y": -16.4137965,"x": -71.5476868419834},
  {"name": "AQAQ021","y": -16.3958475,"x": -71.5425681778717},
  {"name": "AQAQ026","y": -16.4108505,"x": -71.5303491844078},
  {"name": "AQAQ022","y": -16.4009995,"x": -71.5494779424227},
  {"name": "AQPP023","y": -16.4103545,"x": -71.4832037650899},
  {"name": "AQPP011","y": -16.4216445,"x": -71.5104095739563},
  {"name": "AQAQ023-S // AQAQ023","y": -16.4003945,"x": -71.5444093739754},
  {"name": "PIUP012-F","y": -5.0941515,"x": -81.0939839101891},
  {"name": "PIUP013-F","y": -5.091044,"x": -81.0942789502885},
  {"name": "AYAN003-F","y": -12.62581,"x": -73.7878812930601},
  {"name": "AQAQ027","y": -16.4113165,"x": -71.526844196452},
  {"name": "LMCA027","y": -12.024698,"x": -77.0928427839949},
  {"name": "AQPP016","y": -16.423281,"x": -71.505099281746},
  {"name": "AQAQ028","y": -16.4087305,"x": -71.525852944655},
  {"name": "LMSA066-F","y": -12.030529,"x": -76.9460540590796},
  {"name": "LMSC328-F","y": -12.1658065,"x": -76.9904422523697},
  {"name": "AQAQ029","y": -16.4090385,"x": -71.5205612126399},
  {"name": "AQPP031","y": -16.407681,"x": -71.4948018621652},
  {"name": "AQAQ030-S // AQAQ030","y": -16.4069855,"x": -71.51761808125},
  {"name": "AQPP009","y": -16.4210195,"x": -71.5146214965798},
  {"name": "AQAQ031-S // AQAQ031","y": -16.4088135,"x": -71.5146247037782},
  {"name": "LMCA177-F","y": -12.0425665,"x": -77.1228872962921},
  {"name": "AQAQ032","y": -16.413088,"x": -71.5318440328049},
  {"name": "LMAN011-F","y": -11.7759765,"x": -77.184589683217},
  {"name": "AQPP001-S // AQPP001","y": -16.4087335,"x": -71.4757424555986},
  {"name": "AQPP005-S // AQPP005","y": -16.412075,"x": -71.5094379165515},
  {"name": "AQPP006-S // AQPP006","y": -16.4147945,"x": -71.5100749536774},
  {"name": "AQPP007","y": -16.414376,"x": -71.5068744835807},
  {"name": "AQPP025","y": -16.4058695,"x": -71.479814698506},
  {"name": "PUMC003-F","y": -14.0630355,"x": -70.4216383913307},
  {"name": "PISH002-F","y": -5.5541065,"x": -80.8219254459585},
  {"name": "AQPP013","y": -16.4191635,"x": -71.5065620456811},
  {"name": "AQPP015","y": -16.42119,"x": -71.5011108639322},
  {"name": "AQPP019-S // AQPP019","y": -16.4109635,"x": -71.4887850102864},
  {"name": "LMSA101-F","y": -12.0324275,"x": -76.959250084719},
  {"name": "AQPP020","y": -16.4069585,"x": -71.4886106536714},
  {"name": "PUMC002-F","y": -14.0663775,"x": -70.4186893823156},
  {"name": "AQPP021","y": -16.405066,"x": -71.4841497341707},
  {"name": "AQSB016","y": -16.440542,"x": -71.5309894988086},
  {"name": "AQPP024-S // AQPP024","y": -16.409851,"x": -71.4797311},
  {"name": "PITG003-F","y": -4.927075,"x": -80.3380350137937},
  {"name": "AQPP039","y": -16.42346,"x": -71.5135560584465},
  {"name": "AQPP026","y": -16.4127355,"x": -71.5026492878445},
  {"name": "AQSB018","y": -16.4503535,"x": -71.5241724206819},
  {"name": "AQSB017","y": -16.45312,"x": -71.5309885371391},
  {"name": "AQPP027","y": -16.41121,"x": -71.5024229609135},
  {"name": "LMCA062","y": -12.0432605,"x": -77.1027609316268},
  {"name": "AQPP028","y": -16.4087225,"x": -71.5007903568643},
  {"name": "AQPP029","y": -16.411924,"x": -71.4998224625407},
  {"name": "AQPP032","y": -16.4070835,"x": -71.4921455595848},
  {"name": "PISH012-F","y": -5.5710675,"x": -80.8226066972236},
  {"name": "AQPP037","y": -16.418765,"x": -71.4982883396546},
  {"name": "AQPP033","y": -16.4122505,"x": -71.4972066660672},
  {"name": "AQSA028","y": -16.366934,"x": -71.5169988342667},
  {"name": "AQPP034","y": -16.4116375,"x": -71.4944340870332},
  {"name": "LMLM032-S // LMLM032","y": -12.048163,"x": -77.0745501896735},
  {"name": "AQPP035","y": -16.4155745,"x": -71.4960213308149},
  {"name": "AQSB020","y": -16.457998,"x": -71.5190409470921},
  {"name": "AQSB021","y": -16.459921,"x": -71.5210804389423},
  {"name": "AQSA029-S // AQSA029","y": -16.365984,"x": -71.5193898212556},
  {"name": "AQPP036-S // AQPP036","y": -16.4149325,"x": -71.4929903813101},
  {"name": "AQPP038","y": -16.408392,"x": -71.4975656862786},
  {"name": "AQPP041","y": -16.426247,"x": -71.5098330195997},
  {"name": "AQPP042","y": -16.417133,"x": -71.4889779941378},
  {"name": "CZWQ014","y": -13.538972,"x": -71.9387502544814},
  {"name": "AQSB022","y": -16.4600795,"x": -71.5242288179012},
  {"name": "CZWQ012","y": -13.537683,"x": -71.9472526872318},
  {"name": "AQPP043","y": -16.4182235,"x": -71.4927812557534},
  {"name": "PIUS040-F","y": -4.904894,"x": -80.6753395119018},
  {"name": "AQPP044","y": -16.420961,"x": -71.4965753012387},
  {"name": "LMLM040","y": -12.0483965,"x": -77.0565480207129},
  {"name": "AQPP045","y": -16.425264,"x": -71.5022385400413},
  {"name": "AQPP046","y": -16.424423,"x": -71.4979889540332},
  {"name": "AQPP047","y": -16.4254025,"x": -71.4944865029914},
  {"name": "AQPP048","y": -16.4281675,"x": -71.4983720088028},
  {"name": "AQSB023","y": -16.449922,"x": -71.533546445727},
  {"name": "AQSB024","y": -16.448497,"x": -71.5246815276618},
  {"name": "AQSA017","y": -16.3775235,"x": -71.5212339870503},
  {"name": "AQSA013","y": -16.381235,"x": -71.5251725904228},
  {"name": "AQSB001","y": -16.436521,"x": -71.534429300367},
  {"name": "PIUS039-F","y": -4.906648,"x": -80.6784415818146},
  {"name": "AQSB003","y": -16.4475045,"x": -71.5344301277376},
  {"name": "AQSB004","y": -16.45117,"x": -71.5383946704295},
  {"name": "AQSB015","y": -16.441804,"x": -71.5339702370326},
  {"name": "AQSB025","y": -16.443622,"x": -71.5318505495206},
  {"name": "LMCA018","y": -12.0176755,"x": -77.0964737689214},
  {"name": "AQSB026","y": -16.44156,"x": -71.5277371366048},
  {"name": "LMSA001","y": -12.044566,"x": -76.9817621915198},
  {"name": "AQSA001-S // AQSA001","y": -16.3878555,"x": -71.5268534038087},
  {"name": "AQSA002","y": -16.386352,"x": -71.522139508427},
  {"name": "AQSA003-S // AQSA003","y": -16.383925,"x": -71.5247903161092},
  {"name": "AQSA004-S // AQSA004","y": -16.3833915,"x": -71.5183165194204},
  {"name": "LMSA002","y": -12.042611,"x": -76.979891838854},
  {"name": "AQSA016","y": -16.3764055,"x": -71.5234866478873},
  {"name": "AQSA005","y": -16.3798795,"x": -71.5194501710988},
  {"name": "AQSA006-S // AQSA006","y": -16.3761345,"x": -71.516235936718},
  {"name": "AQSA007-S // AQSA007","y": -16.3792405,"x": -71.5158392089194},
  {"name": "AQSA011-S // AQSA011","y": -16.380586,"x": -71.5286087856828},
  {"name": "AQSA012","y": -16.3784505,"x": -71.5265330008084},
  {"name": "AQCA012","y": -16.3877295,"x": -71.5487364242815},
  {"name": "LMSA034","y": -12.0450075,"x": -76.9722061744014},
  {"name": "CZES008-F","y": -14.7906625,"x": -71.4087068782452},
  {"name": "AQSA018","y": -16.3743005,"x": -71.5203523429812},
  {"name": "AQSA019","y": -16.3748925,"x": -71.5182068033199},
  {"name": "AQSA020","y": -16.372529,"x": -71.5169958814006},
  {"name": "AQSA022","y": -16.3701495,"x": -71.5066055062657},
  {"name": "AQSA023-S // AQSA023","y": -16.372061,"x": -71.5070943234818},
  {"name": "PUPU025","y": -15.8521165,"x": -70.0162913658241},
  {"name": "AQSA024-S // AQSA024","y": -16.3698915,"x": -71.5104267525063},
  {"name": "AQSA025","y": -16.3722685,"x": -71.5128994198113},
  {"name": "PUDE012-F","y": -16.5573132,"x": -69.040700692958},
  {"name": "AQSA026","y": -16.374267,"x": -71.5125648197209},
  {"name": "AQSA027","y": -16.374433,"x": -71.50958816173},
  {"name": "AQSA031","y": -16.3686565,"x": -71.5265329664269},
  {"name": "AQSA032","y": -16.370639,"x": -71.5260957433981},
  {"name": "LMVS117-F","y": -12.1956765,"x": -76.9489602077944},
  {"name": "AQSA034","y": -16.3759275,"x": -71.5265767301313},
  {"name": "LMJL115-S // LMJL115","y": -11.973174,"x": -77.0107365368272},
  {"name": "AQSA035","y": -16.3784425,"x": -71.5295268853439},
  {"name": "AQBR001","y": -16.42416,"x": -71.5228398398693},
  {"name": "AQBR021","y": -16.4118625,"x": -71.5251255285877},
  {"name": "AQBR029","y": -16.444064,"x": -71.5099292902346},
  {"name": "PISH004-F","y": -5.557145,"x": -80.8193124116479},
  {"name": "AQBR045","y": -16.434511,"x": -71.5244976864638},
  {"name": "AQCA013","y": -16.3560125,"x": -71.5455327451017},
  {"name": "PISH007-F","y": -5.562463,"x": -80.8242532263804},
  {"name": "AQBR030","y": -16.4440745,"x": -71.5155767909037},
  {"name": "AQBR032","y": -16.4360395,"x": -71.5239346590909},
  {"name": "AQBR040-S // AQBR040","y": -16.428803,"x": -71.5273582568101},
  {"name": "AQBR041","y": -16.430621,"x": -71.525529840135},
  {"name": "AQBR036","y": -16.425382,"x": -71.5173305588774},
  {"name": "AQBR031","y": -16.4386375,"x": -71.5229891988369},
  {"name": "LMSA003-S // LMSA003","y": -12.045939,"x": -76.979090420412},
  {"name": "PISH003-F","y": -5.5544505,"x": -80.8192772268145},
  {"name": "LLCP007-F","y": -7.231297,"x": -79.418251333485},
  {"name": "AQCA029","y": -16.3713135,"x": -71.5465729221453},
  {"name": "AQBR033","y": -16.4442305,"x": -71.5239387854882},
  {"name": "AQBR037","y": -16.427447,"x": -71.5220745199205},
  {"name": "AQBR038","y": -16.429027,"x": -71.5205439085635},
  {"name": "AQBR039","y": -16.42702,"x": -71.5267926777876},
  {"name": "AQBR042","y": -16.431929,"x": -71.5288615309829},
  {"name": "AQCC053","y": -16.348324,"x": -71.5621122129789},
  {"name": "AQBR043","y": -16.429497,"x": -71.5320926732598},
  {"name": "AQBR044","y": -16.4329645,"x": -71.5253868932584},
  {"name": "AQBR046","y": -16.436019,"x": -71.5276110493858},
  {"name": "AQBR047","y": -16.434512,"x": -71.5297053922363},
  {"name": "AQCA011","y": -16.371319,"x": -71.537650479845},
  {"name": "AQCA003-S // AQCA003","y": -16.3815155,"x": -71.5386624923727},
  {"name": "AQCA018-S // AQCA018","y": -16.3761425,"x": -71.5516067507102},
  {"name": "AQCA015-S // AQCA015","y": -16.359661,"x": -71.5463668508272},
  {"name": "AQCA001-S // AQCA001","y": -16.370801,"x": -71.5433683354484},
  {"name": "PISH005-F","y": -5.557148,"x": -80.8213886057293},
  {"name": "LMSA005","y": -12.0426385,"x": -76.9763926556777},
  {"name": "AQCA020","y": -16.3433615,"x": -71.5448135809806},
  {"name": "AQCA002-S // AQCA002","y": -16.3783425,"x": -71.5436517557583},
  {"name": "AQCA009-S // AQCA009","y": -16.391539,"x": -71.5499248815109},
  {"name": "AQCA010-S // AQCA010","y": -16.3915115,"x": -71.5472361234779},
  {"name": "AQCA005-S // AQCA005","y": -16.364527,"x": -71.5449478971198},
  {"name": "LMCA028-S // LMCA028","y": -12.0250775,"x": -77.0971949735206},
  {"name": "AQCA006-S // AQCA006","y": -16.3602175,"x": -71.5418937616091},
  {"name": "PISH006-F","y": -5.556611,"x": -80.8237551742447},
  {"name": "LMSA013","y": -12.048602,"x": -76.969968737095},
  {"name": "AQCA007","y": -16.3842025,"x": -71.5503167496449},
  {"name": "AQCA008-S // AQCA008","y": -16.3860005,"x": -71.5448125021498},
  {"name": "LMAN012-F","y": -11.775204,"x": -77.1763031524636},
  {"name": "PISH008-F","y": -5.560176,"x": -80.8219495659568},
  {"name": "AQCA021","y": -16.341087,"x": -71.5428177129016},
  {"name": "AQCC017-S // AQCC017","y": -16.391103,"x": -71.5609348374252},
  {"name": "AQCA022","y": -16.337573,"x": -71.5413396252715},
  {"name": "PISH009-F","y": -5.561364,"x": -80.8184937325942},
  {"name": "AQCC036","y": -16.379538,"x": -71.55236487366},
  {"name": "CZES010-F","y": -14.7914405,"x": -71.4167744731043},
  {"name": "AQCC001-S // AQCC001","y": -16.3779895,"x": -71.571160717227},
  {"name": "LMSA014","y": -12.050441,"x": -76.9703894405801},
  {"name": "AQCC002-S // AQCC002","y": -16.381558,"x": -71.5706876789179},
  {"name": "AQCC004","y": -16.378233,"x": -71.5610085516938},
  {"name": "CZWQ011","y": -13.5369145,"x": -71.9513919077666},
  {"name": "PISH010-F","y": -5.564265,"x": -80.8194446675616},
  {"name": "AQCC006-S // AQCC006","y": -16.3883445,"x": -71.5532549919479},
  {"name": "AQCC012","y": -16.3727695,"x": -71.5674549406108},
  {"name": "AQCC007","y": -16.3865775,"x": -71.567885890327},
  {"name": "AQCC015","y": -16.40097,"x": -71.5701686498162},
  {"name": "AQCC014-S // AQCC014","y": -16.3963375,"x": -71.5691559615529},
  {"name": "AQCC009","y": -16.38001,"x": -71.5558774682428},
  {"name": "PIUS024-F","y": -4.913483,"x": -80.699054502738},
  {"name": "AQCC027","y": -16.352517,"x": -71.5667880256127},
  {"name": "AQCC013","y": -16.3889335,"x": -71.5698564111818},
  {"name": "AQCC018-S // AQCC018","y": -16.387542,"x": -71.561473010514},
  {"name": "AQCC054","y": -16.345285,"x": -71.5583506474031},
  {"name": "AQCC021","y": -16.3909815,"x": -71.5622625534759},
  {"name": "AQCC022","y": -16.390254,"x": -71.564540209589},
  {"name": "AQCC023","y": -16.388212,"x": -71.5639719118523},
  {"name": "AQCC024","y": -16.390617,"x": -71.5633634347525},
  {"name": "AQCC028","y": -16.3531615,"x": -71.5619340787843},
  {"name": "AQCC035","y": -16.3728835,"x": -71.5530715670606},
  {"name": "AQCC040","y": -16.3831345,"x": -71.5586792472001},
  {"name": "AQCC044","y": -16.3756625,"x": -71.5549370725668},
  {"name": "PIUS025-F","y": -4.913766,"x": -80.6961674657143},
  {"name": "AQCC055","y": -16.34883,"x": -71.5587474649768},
  {"name": "AQCC056-S // AQCC056","y": -16.351728,"x": -71.5585665743298},
  {"name": "AQHU001","y": -16.451622,"x": -71.5510413306858},
  {"name": "CZSS010","y": -13.535933,"x": -71.9095144093814},
  {"name": "AQHU002-S // AQHU002","y": -16.4459825,"x": -71.5492270438614},
  {"name": "AQMF001-S // AQMF001","y": -16.4001345,"x": -71.5141117634828},
  {"name": "CZST019","y": -13.5416,"x": -71.9838358217593},
  {"name": "AQHU003","y": -16.444436,"x": -71.5522873362951},
  {"name": "PIUS026-F","y": -4.9149345,"x": -80.6940753743551},
  {"name": "AQHU004","y": -16.443867,"x": -71.556494431694},
  {"name": "AQHU016","y": -16.4555225,"x": -71.5534019996861},
  {"name": "AQHU005-S // AQHU005","y": -16.4494175,"x": -71.5544955209716},
  {"name": "CHI099-S // CHI099","y": -6.7996415,"x": -79.8374211551333},
  {"name": "AQHU006-S // AQHU006","y": -16.44151,"x": -71.5600059262948},
  {"name": "AQMM001","y": -16.4087305,"x": -71.5089803905823},
  {"name": "AQMM003","y": -16.406324,"x": -71.5013376783},
  {"name": "AQHU017","y": -16.4589215,"x": -71.5551780703855},
  {"name": "AQHU007-S // AQHU007","y": -16.439365,"x": -71.5551528439572},
  {"name": "AQHU008","y": -16.451708,"x": -71.557663465035},
  {"name": "AQHU009","y": -16.449042,"x": -71.5584185020858},
  {"name": "AQHU010","y": -16.4440625,"x": -71.5598270009006},
  {"name": "AQHU014","y": -16.438858,"x": -71.5579288943005},
  {"name": "AQHU015","y": -16.454171,"x": -71.5549380024393},
  {"name": "AQMM004","y": -16.403725,"x": -71.5057699745155},
  {"name": "PIUS027-F","y": -4.908477,"x": -80.6931498568079},
  {"name": "AQMM005-S // AQMM005","y": -16.402138,"x": -71.5044981287879},
  {"name": "AQMM006","y": -16.4038975,"x": -71.5100681560847},
  {"name": "AQMM007","y": -16.4064505,"x": -71.5127918288362},
  {"name": "AQMF014-S // AQMF014","y": -16.3851605,"x": -71.5126116156412},
  {"name": "AQMM008","y": -16.402141,"x": -71.511115380616},
  {"name": "AQMM009","y": -16.3978125,"x": -71.5075516756739},
  {"name": "PUMC001-F","y": -14.0661175,"x": -70.4286453901923},
  {"name": "AQMM010","y": -16.4056705,"x": -71.4971911111439},
  {"name": "AQMM011","y": -16.4031895,"x": -71.4970406617647},
  {"name": "CZSS011","y": -13.5408465,"x": -71.9247690697506},
  {"name": "AQMM012","y": -16.4025425,"x": -71.4997840248131},
  {"name": "AQMF002-S // AQMF002","y": -16.400242,"x": -71.5179535320552},
  {"name": "AQMF003-S // AQMF003","y": -16.3979685,"x": -71.5182488883442},
  {"name": "AQMF010-S // AQMF010","y": -16.3947645,"x": -71.5168705141025},
  {"name": "AQMF005-S // AQMF005","y": -16.3957215,"x": -71.5244132546457},
  {"name": "AQMF007","y": -16.391498,"x": -71.5245975777486},
  {"name": "CZSS017","y": -13.53098,"x": -71.9206651545479},
  {"name": "AQMF008","y": -16.390712,"x": -71.5216892794872},
  {"name": "AQMF009-S // AQMF009","y": -16.392952,"x": -71.5203782187175},
  {"name": "AQMF022","y": -16.3720295,"x": -71.5017025398054},
  {"name": "AQMF023","y": -16.3759215,"x": -71.5045394468834},
  {"name": "CZSS002","y": -13.526487,"x": -71.9390228443218},
  {"name": "AQMF011-S // AQMF011","y": -16.391075,"x": -71.5164170078194},
  {"name": "PIUS028-F","y": -4.9015985,"x": -80.6914604188568},
  {"name": "TRLE012","y": -8.059582,"x": -79.0554269760495},
  {"name": "CZCZ009","y": -13.516516,"x": -71.9676623772392},
  {"name": "AQMF012-S // AQMF012","y": -16.388033,"x": -71.520009426711},
  {"name": "AQMF013-S // AQMF013","y": -16.3856255,"x": -71.5159018515519},
  {"name": "AQMF015-S // AQMF015","y": -16.381589,"x": -71.5111049479473},
  {"name": "AQMF024","y": -16.3758545,"x": -71.5078891694776},
  {"name": "AQSC014-S // AQSC014","y": -16.435113,"x": -71.5714787833333},
  {"name": "AQSC007","y": -16.4157935,"x": -71.5819931958525},
  {"name": "CZSS016","y": -13.528624,"x": -71.9357687032215},
  {"name": "AQSC008","y": -16.4130685,"x": -71.5775835269052},
  {"name": "AQSC010","y": -16.4060575,"x": -71.5540272797682},
  {"name": "AQSC011","y": -16.408892,"x": -71.559847956476},
  {"name": "CZSS033","y": -13.5402975,"x": -71.9154152923449},
  {"name": "CZCZ010","y": -13.5161585,"x": -71.9705881679389},
  {"name": "CZSS001","y": -13.5261575,"x": -71.9413844000508},
  {"name": "PIUS029-F","y": -4.903683,"x": -80.6888038027747},
  {"name": "CZSS013","y": -13.522274,"x": -71.9425446810058},
  {"name": "CZSS003","y": -13.529757,"x": -71.9391058295548},
  {"name": "LMSA016","y": -12.0471525,"x": -76.9671577799296},
  {"name": "CZSS015","y": -13.526678,"x": -71.9337915190058},
  {"name": "CZSS004","y": -13.5308215,"x": -71.9343887083481},
  {"name": "LMSA017","y": -12.0453855,"x": -76.9650560229779},
  {"name": "CZSS005","y": -13.53287,"x": -71.9361903851924},
  {"name": "CZSS006","y": -13.533277,"x": -71.9343365819109},
  {"name": "CZSS007","y": -13.5328195,"x": -71.9312782076938},
  {"name": "CZSS008","y": -13.533975,"x": -71.9276785329698},
  {"name": "CZSS009","y": -13.5331835,"x": -71.9241715199455},
  {"name": "CZSS014","y": -13.5252935,"x": -71.9362398122137},
  {"name": "TCNA095-S // TCNA095","y": -18.03845,"x": -70.2458544129703},
  {"name": "CZSS018-S // CZSS018","y": -13.53429,"x": -71.908256906843},
  {"name": "CZES018-F","y": -14.7978735,"x": -71.4068101956376},
  {"name": "CZSS019","y": -13.539186,"x": -71.9094104782542},
  {"name": "CZSS020","y": -13.5407105,"x": -71.9331069868938},
  {"name": "CZSS021","y": -13.5403705,"x": -71.9356704221456},
  {"name": "CZSS022","y": -13.5403705,"x": -71.9380584999003},
  {"name": "CZSS025","y": -13.530298,"x": -71.9160247494383},
  {"name": "PIUR163-F","y": -5.173205,"x": -80.6477536149781},
  {"name": "CZSS026","y": -13.5299185,"x": -71.9289772465024},
  {"name": "CZSS027","y": -13.5297805,"x": -71.9263312449543},
  {"name": "CZSS034","y": -13.5434515,"x": -71.9144093879838},
  {"name": "CZSS028","y": -13.543951,"x": -71.9276591802214},
  {"name": "PIUS030-F","y": -4.9005345,"x": -80.6886544107198},
  {"name": "CZSS029","y": -13.543918,"x": -71.9243442169422},
  {"name": "CZSS030","y": -13.543665,"x": -71.9221718836917},
  {"name": "CZSS031","y": -13.540482,"x": -71.9200535844418},
  {"name": "TCNA014-S // TCNA014","y": -17.9988733,"x": -70.2414706988048},
  {"name": "CZSS032","y": -13.543806,"x": -71.9179056844741},
  {"name": "CZSS035","y": -13.544191,"x": -71.9115317611258},
  {"name": "PIUS031-F","y": -4.9022995,"x": -80.6862212731742},
  {"name": "AQYA001-S // AQYA001","y": -16.382106,"x": -71.5363920897688},
  {"name": "AQYA005","y": -16.39456,"x": -71.5464645075962},
  {"name": "AQYA006-S // AQYA006","y": -16.3963825,"x": -71.5503620583631},
  {"name": "CZCZ011","y": -13.5176235,"x": -71.9809168423205},
  {"name": "CZCZ016-S // CZCZ016","y": -13.522674,"x": -71.9497735624597},
  {"name": "AQYA002-S // AQYA002","y": -16.3863495,"x": -71.5421841065313},
  {"name": "AQYA003-S // AQYA003","y": -16.389623,"x": -71.5402158560277},
  {"name": "CZCZ012","y": -13.5256025,"x": -71.9445237465517},
  {"name": "CZCZ013","y": -13.5262055,"x": -71.9468556463158},
  {"name": "CZSJ009","y": -13.541095,"x": -71.8972893592197},
  {"name": "PIUS033-F","y": -4.901125,"x": -80.6825871345486},
  {"name": "AQYA004-S // AQYA004","y": -16.3923245,"x": -71.5438122966072},
  {"name": "CZCZ014","y": -13.5239125,"x": -71.9463949649915},
  {"name": "CZCZ037","y": -13.514612,"x": -71.971542565178},
  {"name": "AQYA007","y": -16.4006515,"x": -71.5518497914087},
  {"name": "PIUS032-F","y": -4.899694,"x": -80.6851215540331},
  {"name": "AQYA010","y": -16.39673,"x": -71.556498698823},
  {"name": "AQYA011-S // AQYA011","y": -16.3954325,"x": -71.5561000449635},
  {"name": "AQYA013","y": -16.401127,"x": -71.5538933549158},
  {"name": "CZCZ023","y": -13.518347,"x": -71.9622727101911},
  {"name": "PIUS034-F","y": -4.89672,"x": -80.6850191785714},
  {"name": "CZCZ024","y": -13.5165385,"x": -71.9606270988906},
  {"name": "CZCZ025","y": -13.518795,"x": -71.9593612375355},
  {"name": "CZCZ026","y": -13.517385,"x": -71.9580661151836},
  {"name": "CZSJ011","y": -13.5427545,"x": -71.8853335183896},
  {"name": "CZCZ027","y": -13.519149,"x": -71.9559984591978},
  {"name": "CZCZ028","y": -13.5163765,"x": -71.953201817124},
  {"name": "LMSC047-S // LMSC047","y": -12.1299555,"x": -76.9866265776274},
  {"name": "CZCZ029","y": -13.5171065,"x": -71.9512318873172},
  {"name": "CZCZ030","y": -13.520052,"x": -71.9536057593402},
  {"name": "TRLE016","y": -8.0635,"x": -79.0594617648731},
  {"name": "CZCZ031","y": -13.519208,"x": -71.9499647383572},
  {"name": "CZCZ032-S // CZCZ032","y": -13.520589,"x": -71.9472276507162},
  {"name": "CZCZ035","y": -13.5230465,"x": -71.9628004686722},
  {"name": "CZCZ036","y": -13.525137,"x": -71.9559461874455},
  {"name": "CZST018","y": -13.539696,"x": -71.9857373358102},
  {"name": "CZCZ038","y": -13.5138715,"x": -71.9687100167911},
  {"name": "PIUS035-F","y": -4.897265,"x": -80.6827623710692},
  {"name": "CZSJ010","y": -13.5430575,"x": -71.8901970675423},
  {"name": "CZSJ001","y": -13.527631,"x": -71.8997826604033},
  {"name": "CZSJ002","y": -13.533258,"x": -71.901565508785},
  {"name": "PIUS036-F","y": -4.894355,"x": -80.6835428187914},
  {"name": "CZSJ003","y": -13.536321,"x": -71.9022610430103},
  {"name": "CZSJ004","y": -13.540221,"x": -71.9034697279611},
  {"name": "CZSJ006","y": -13.542634,"x": -71.8957235818355},
  {"name": "CZSJ008","y": -13.540103,"x": -71.899899070771},
  {"name": "CZWQ008","y": -13.534857,"x": -71.9572183923902},
  {"name": "CZSJ012","y": -13.543687,"x": -71.8827652219559},
  {"name": "CZSJ013","y": -13.545461,"x": -71.8875672494457},
  {"name": "CZSJ014","y": -13.5477195,"x": -71.8834411173051},
  {"name": "CZSJ015","y": -13.547772,"x": -71.8873239255563},
  {"name": "CZST003","y": -13.5303495,"x": -71.9706166945142},
  {"name": "CZST009","y": -13.5385675,"x": -71.9638381065271},
  {"name": "LMSA018","y": -12.0484165,"x": -76.9636234209808},
  {"name": "CZST010","y": -13.5391265,"x": -71.962117372142},
  {"name": "CZST011","y": -13.53926,"x": -71.9576447322779},
  {"name": "CZST012","y": -13.54292,"x": -71.9607808415033},
  {"name": "CZST013","y": -13.541798,"x": -71.9540549678812},
  {"name": "CZST014","y": -13.544243,"x": -71.9540736756103},
  {"name": "CZST016","y": -13.5350825,"x": -71.9825186093668},
  {"name": "CZWQ010","y": -13.528772,"x": -71.9475124291262},
  {"name": "CZWQ018","y": -13.5286015,"x": -71.9683442068965},
  {"name": "CZST017","y": -13.5386865,"x": -71.9833982007874},
  {"name": "CZWQ007","y": -13.5345645,"x": -71.9602946267158},
  {"name": "LMLV114-F","y": -12.066514,"x": -77.0166270921458},
  {"name": "CZWQ006","y": -13.531697,"x": -71.9565960216949},
  {"name": "CZWQ003","y": -13.5328495,"x": -71.96556616686},
  {"name": "CZWQ001-S // CZWQ001","y": -13.529768,"x": -71.9604424792685},
  {"name": "CZWQ020","y": -13.5258835,"x": -71.9635759876062},
  {"name": "CZWQ021","y": -13.527365,"x": -71.9592642146175},
  {"name": "CZWQ016","y": -13.5241705,"x": -71.967083460784},
  {"name": "CZES017-F","y": -14.797944,"x": -71.4103174052615},
  {"name": "CZWQ019","y": -13.5286015,"x": -71.9650717310606},
  {"name": "CZWQ025-S // CZWQ025","y": -13.528307,"x": -71.9519025178458},
  {"name": "PIUS037-F","y": -4.9096975,"x": -80.6777442624388},
  {"name": "CZWQ026","y": -13.5290755,"x": -71.9434716913526},
  {"name": "CZWQ027-S // CZWQ027","y": -13.530724,"x": -71.943456535545},
  {"name": "LMSA019","y": -12.049581,"x": -76.9655036374126},
  {"name": "CZWQ022","y": -13.528452,"x": -71.9610451861472},
  {"name": "CZWQ023","y": -13.529399,"x": -71.9548447243162},
  {"name": "TCNA097-S // TCNA097","y": -18.0429735,"x": -70.2444435993455},
  {"name": "CZWQ024","y": -13.531719,"x": -71.9532792115294},
  {"name": "CZWQ002","y": -13.5316535,"x": -71.9651877302056},
  {"name": "CZWQ005","y": -13.5315985,"x": -71.9597509978666},
  {"name": "CZWQ015","y": -13.5233005,"x": -71.9704839187396},
  {"name": "CZWQ004","y": -13.5336655,"x": -71.962917714598},
  {"name": "CZWQ009","y": -13.529086,"x": -71.9500201729922},
  {"name": "TCNA004-S // TCNA004","y": -18.003301,"x": -70.2473155959477},
  {"name": "TCNA005-S // TCNA005","y": -18.0036955,"x": -70.2507023136029},
  {"name": "TCNA018-S // TCNA018","y": -17.9957965,"x": -70.2310780325895},
  {"name": "LAMO056-S","y": -12.087627,"x": -76.9566629808824},
  {"name": "CZWQ017","y": -13.5265425,"x": -71.9671016332817},
  {"name": "TCNA001-S // TCNA001","y": -18.0086075,"x": -70.257950880204},
  {"name": "TCNA002-S // TCNA002","y": -18.0061125,"x": -70.24891539463},
  {"name": "TCNA058-S // TCNA058","y": -17.9725365,"x": -70.2324333607933},
  {"name": "TCNA003-S // TCNA003","y": -18.00354,"x": -70.2447065516387},
  {"name": "PIUS038-F","y": -4.909124,"x": -80.6750377881212},
  {"name": "LAMO056","y": -12.085878,"x": -76.9578118678881},
  {"name": "TCNA006-S // TCNA006","y": -18.0012345,"x": -70.2503583421685},
  {"name": "LMSA067-F","y": -12.0322815,"x": -76.9432749899865},
  {"name": "TCNA007-S // TCNA007","y": -18.000852,"x": -70.247810758707},
  {"name": "5520A04-B","y": -12.1259,"x": -77.0040374141574},
  {"name": "TCNA016-S // TCNA016","y": -17.998584,"x": -70.235827584507},
  {"name": "TCNA008-S // TCNA008","y": -17.9996095,"x": -70.2466316988203},
  {"name": "LLLE024-F","y": -8.07309,"x": -79.039723781799},
  {"name": "TCNA009-S // TCNA009","y": -17.9968603,"x": -70.2514606704534},
  {"name": "TCNA010-S // TCNA010","y": -17.996209,"x": -70.2497393513285},
  {"name": "TCNA011","y": -17.9958975,"x": -70.2468614543229},
  {"name": "TCNA012-S // TCNA012","y": -17.9997655,"x": -70.2440942735369},
  {"name": "TCNA013-S // TCNA013","y": -18.001171,"x": -70.2411436772823},
  {"name": "TCNA015-S // TCNA015","y": -17.99829765,"x": -70.2381682722621},
  {"name": "TCNA059","y": -17.9737135,"x": -70.2317497261029},
  {"name": "TCNA061","y": -17.9757965,"x": -70.2279463880933},
  {"name": "TCNA017-S // TCNA017","y": -17.9976045,"x": -70.2337883403016},
  {"name": "PIHN002-F","y": -5.2365755,"x": -79.4493452208848},
  {"name": "LMSC045-S // LMSC045","y": -12.1287005,"x": -76.9864405960823},
  {"name": "TCNA019-S // TCNA019","y": -17.996751,"x": -70.2245690595781},
  {"name": "TCNA020-S // TCNA020","y": -17.99730575,"x": -70.2215338289304},
  {"name": "TCNA021-S // TCNA021","y": -18.0186005,"x": -70.2582319342995},
  {"name": "TCNA022-S // TCNA022","y": -18.0176355,"x": -70.2538737722856},
  {"name": "TCNA034-S // TCNA034","y": -18.0390635,"x": -70.2547270006526},
  {"name": "TCNA040-S // TCNA040","y": -18.034421,"x": -70.2780551749444},
  {"name": "TCNA023-S // TCNA023","y": -18.022685,"x": -70.2521835850181},
  {"name": "TCNA024","y": -18.0187185,"x": -70.2504571194945},
  {"name": "TCNA025-S // TCNA025","y": -18.0198595,"x": -70.2471348354779},
  {"name": "TCNA026-S // TCNA026","y": -18.020973,"x": -70.2456805833892},
  {"name": "TCNA027-S // TCNA027","y": -18.0099655,"x": -70.230159566634},
  {"name": "TCNA035-S // TCNA035","y": -18.0391895,"x": -70.2491727261583},
  {"name": "TCNA036-S // TCNA036","y": -18.0424355,"x": -70.249141365116},
  {"name": "TCNA028-S // TCNA028","y": -18.0129847,"x": -70.2333299246253},
  {"name": "PIHN003-F","y": -5.240257,"x": -79.4497689396436},
  {"name": "TCNA029-S // TCNA029","y": -18.0167614,"x": -70.2332726659942},
  {"name": "LAMO057","y": -12.091518,"x": -76.9484851256757},
  {"name": "TCNA030-S // TCNA030","y": -18.0185194,"x": -70.2385703644338},
  {"name": "LMJL116-S // LMJL116","y": -11.967945,"x": -77.0094239617641},
  {"name": "TCNA099-S // TCNA099","y": -18.0470636,"x": -70.2452369755603},
  {"name": "TCNA031-S // TCNA031","y": -18.0337115,"x": -70.2489310048534},
  {"name": "TCNA032-S // TCNA032","y": -18.0366145,"x": -70.2491123054734},
  {"name": "PIOR001-F","y": -4.1762015,"x": -81.1274799649654},
  {"name": "TCNA041-S // TCNA041","y": -18.036746,"x": -70.2773035332154},
  {"name": "TCNA033-S // TCNA033","y": -18.036021,"x": -70.2528404525978},
  {"name": "TCNA050-S // TCNA050","y": -18.0419865,"x": -70.259609125325},
  {"name": "TCNA038-S // TCNA038","y": -18.0421978,"x": -70.2553402788352},
  {"name": "TCNA093-S // TCNA093","y": -18.0334308,"x": -70.2457752107477},
  {"name": "PIOR002-F","y": -4.179504,"x": -81.1272938724478},
  {"name": "LAMO056","y": -12.090251,"x": -76.9539184999537},
  {"name": "TCNA039","y": -18.0082165,"x": -70.2320689265562},
  {"name": "TCNA042-S // TCNA042","y": -18.0387,"x": -70.2751136783491},
  {"name": "TCNA094-S // TCNA094","y": -18.0342961,"x": -70.2439037148428},
  {"name": "TCNA043-S // TCNA043","y": -18.03542645,"x": -70.2736615188249},
  {"name": "LMVS098-F","y": -12.221514,"x": -76.9365118458262},
  {"name": "TCNA044-S // TCNA044","y": -18.030018,"x": -70.2733410011555},
  {"name": "TCNA045-S // TCNA045","y": -18.02908145,"x": -70.2675523760081},
  {"name": "PUPU003","y": -15.832601,"x": -70.0196894530509},
  {"name": "TCNA046-S // TCNA046","y": -18.02698165,"x": -70.2655690951016},
  {"name": "TCNA047-S // TCNA047","y": -18.0236925,"x": -70.2632940525283},
  {"name": "TCNA048-S // TCNA048","y": -18.029572,"x": -70.2633119051466},
  {"name": "TCNA049","y": -18.044588,"x": -70.2611116616972},
  {"name": "PIOR003-F","y": -4.178052,"x": -81.1251120877551},
  {"name": "TCNA098","y": -18.047009,"x": -70.2482223370387},
  {"name": "TCNA087-S // TCNA087","y": -18.0122495,"x": -70.2448652827896},
  {"name": "TCNA051-S // TCNA051","y": -18.039872,"x": -70.2575390464464},
  {"name": "TCNA052-S // TCNA052","y": -18.0434771,"x": -70.2577899219926},
  {"name": "LMLM176-F","y": -12.0356725,"x": -77.0701962471657},
  {"name": "TCNA068-S // TCNA068","y": -17.9780263,"x": -70.2388152854637},
  {"name": "TCNA055-S // TCNA055","y": -18.047212,"x": -70.2537281738457},
  {"name": "TCNA056-S // TCNA056","y": -18.049382,"x": -70.2538438536073},
  {"name": "TCNA086-S // TCNA086","y": -17.9933985,"x": -70.2488780728159},
  {"name": "TCNA088","y": -18.0329595,"x": -70.2605015897227},
  {"name": "TCNA062-S // TCNA062","y": -17.9781725,"x": -70.2275377781955},
  {"name": "TCNA063","y": -17.9818535,"x": -70.2302591583587},
  {"name": "PIOR004-F","y": -4.179713,"x": -81.1236474446261},
  {"name": "TCNA064-S // TCNA064","y": -17.9800419,"x": -70.2313883811245},
  {"name": "TCNA065","y": -17.97689455,"x": -70.2326791499151},
  {"name": "PIOR005-F","y": -4.173947,"x": -81.1211983109049},
  {"name": "TCNA066-S // TCNA066","y": -17.9757625,"x": -70.2360423989986},
  {"name": "LMLO076","y": -11.964243,"x": -77.0732465040926},
  {"name": "TCNA067-S // TCNA067","y": -17.980583,"x": -70.2346803765291},
  {"name": "LMLO072-S // LMLO072","y": -11.9647825,"x": -77.0792950169253},
  {"name": "TCNA069-S // TCNA069","y": -17.9793005,"x": -70.2366334086553},
  {"name": "LAMO058-S // LAMO058","y": -12.0834945,"x": -76.9063518637301},
  {"name": "PIOR006-F","y": -4.171225,"x": -81.1244469275269},
  {"name": "LMSC036-S // LMSC036","y": -12.12769,"x": -76.9995117930264},
  {"name": "TCNA072","y": -18.007305,"x": -70.2444539221887},
  {"name": "TCNA073-S // TCNA073","y": -18.0021955,"x": -70.2359340247312},
  {"name": "TCNA077-S // TCNA077","y": -17.984492,"x": -70.2462671592018},
  {"name": "TCNA078-S // TCNA078","y": -17.984688,"x": -70.2438899622792},
  {"name": "JNPG007-F","y": -11.4397524,"x": -74.484285874608},
  {"name": "TCNA079-S // TCNA079","y": -17.9873593,"x": -70.2454547739219},
  {"name": "PIVI001-F","y": -4.113119,"x": -81.0772572831644},
  {"name": "TCNA080-S // TCNA080","y": -17.9875785,"x": -70.2408629794719},
  {"name": "TCNA102-S // TCNA102","y": -18.0552575,"x": -70.2460617196136},
  {"name": "PUMC006-F","y": -14.0719865,"x": -70.4254601706485},
  {"name": "TCNA081-S // TCNA081","y": -17.9917184,"x": -70.2430290543514},
  {"name": "LMSC046-S // LMSC046","y": -12.1302845,"x": -76.9878301167763},
  {"name": "TCNA082","y": -17.989112,"x": -70.2439494645292},
  {"name": "TCNA083-S // TCNA083","y": -17.9916827,"x": -70.2473129402559},
  {"name": "TCNA084-S // TCNA084","y": -17.99069265,"x": -70.2500500937168},
  {"name": "LMCO151","y": -11.929147,"x": -77.0411404787752},
  {"name": "TCNA085-S // TCNA085","y": -17.9896719,"x": -70.2521619387257},
  {"name": "TCNA090-S // TCNA090","y": -18.037148,"x": -70.258147451201},
  {"name": "LMAN005-F","y": -11.780374,"x": -77.1621078551502},
  {"name": "TCNA091-S // TCNA091","y": -18.0339615,"x": -70.2539995479018},
  {"name": "TCNA092","y": -18.033088,"x": -70.2475206458904},
  {"name": "LMAG025-F","y": -12.0464355,"x": -77.0003965039223},
  {"name": "TCNA100","y": -18.049233,"x": -70.249352292636},
  {"name": "TCNA101","y": -18.0526419,"x": -70.2442504885784},
  {"name": "TCNA103-S // TCNA103","y": -18.05528165,"x": -70.2501023691021},
  {"name": "LAMO059-S // LAMO059","y": -12.0754245,"x": -76.8936495682732},
  {"name": "TCNA104-S // TCNA104","y": -18.052365,"x": -70.2490528969208},
  {"name": "TCNA105-S // TCNA105","y": -18.051682,"x": -70.2549476212825},
  {"name": "LAMO061-S","y": -12.068703,"x": -76.9120228872806},
  {"name": "TCNA106-S // TCNA106","y": -18.0548543,"x": -70.2532283134799},
  {"name": "TCNA107","y": -18.0550307,"x": -70.255913561994},
  {"name": "TCNA108-S // TCNA108","y": -18.052338,"x": -70.2593165687976},
  {"name": "JNPG006-F","y": -11.43150545,"x": -74.4724793179826},
  {"name": "TCNA111-S // TCNA111","y": -18.038598,"x": -70.2825666611671},
  {"name": "TCNA114-S // TCNA114","y": -18.048625,"x": -70.2622606229488},
  {"name": "PUPU005","y": -15.838585,"x": -70.0258282869565},
  {"name": "TCNA139","y": -18.01006,"x": -70.2419488162395},
  {"name": "TCNA140-S // TCNA140","y": -17.998309,"x": -70.2533687248979},
  {"name": "TCNA135-S // TCNA135","y": -18.009568,"x": -70.2478149845755},
  {"name": "TCNA132-S // TCNA132","y": -18.0128285,"x": -70.2505390577664},
  {"name": "LMCA001-S // LMCA001","y": -12.005985,"x": -77.1061823022809},
  {"name": "TCNA054-S // TCNA054","y": -18.04530225,"x": -70.2536328424459},
  {"name": "TCNA133-S // TCNA133","y": -18.01348595,"x": -70.2495529506177},
  {"name": "JNPG007-F","y": -11.43693135,"x": -74.4817095280337},
  {"name": "TCNA134-S // TCNA134","y": -18.009847,"x": -70.2519084140266},
  {"name": "PUPU002","y": -15.8338775,"x": -70.0210319862961},
  {"name": "TCNA136-S // TCNA136","y": -18.0098885,"x": -70.2450759538916},
  {"name": "TCNA137","y": -18.007345,"x": -70.252518689206},
  {"name": "TCNA138","y": -18.004596,"x": -70.2361539179449},
  {"name": "TCNA141-S // TCNA141","y": -18.004297,"x": -70.2623955063639},
  {"name": "TCNA060","y": -17.9741989,"x": -70.2291840336716},
  {"name": "TCNA053-S // TCNA053","y": -18.0472875,"x": -70.2581175244755},
  {"name": "PUBS002","y": -15.871718,"x": -69.9974356955607},
  {"name": "JNPG008-F","y": -11.426191,"x": -74.4817190263985},
  {"name": "TCNA057","y": -18.0131852,"x": -70.2472294685621},
  {"name": "PUPU001","y": -15.8337655,"x": -70.0230049821489},
  {"name": "PUPU004","y": -15.836299,"x": -70.0204080473507},
  {"name": "PUPU007","y": -15.840004,"x": -70.0191427610366},
  {"name": "PUPU008","y": -15.841184,"x": -70.0205594379095},
  {"name": "PUPU009","y": -15.8412665,"x": -70.0231767539784},
  {"name": "PUPU010","y": -15.84379,"x": -70.025424877686},
  {"name": "PUPU011","y": -15.8435065,"x": -70.0289304360409},
  {"name": "MDPM005","y": -12.5918135,"x": -69.1848993789199},
  {"name": "MQMN024-S // MQMN024","y": -17.200799,"x": -70.9221987596472},
  {"name": "PUPU012","y": -15.845989,"x": -70.02737496709},
  {"name": "PUBS004","y": -15.87230035,"x": -69.9939931894699},
  {"name": "AQBR073-F","y": -16.428289,"x": -71.5178120478801},
  {"name": "PUPU013","y": -15.8441765,"x": -70.0224015312874},
  {"name": "PUPU014","y": -15.844486,"x": -70.0194720793282},
  {"name": "PUPU015","y": -15.847523,"x": -70.0202397238392},
  {"name": "AQCA056-F","y": -16.367536,"x": -71.538213179229},
  {"name": "PUPU016","y": -15.846506,"x": -70.0231788035051},
  {"name": "PUBS003","y": -15.8696512,"x": -69.9949308427349},
  {"name": "PUBS006","y": -15.87130225,"x": -69.9993603646834},
  {"name": "PUPU017","y": -15.848325,"x": -70.0266360353752},
  {"name": "PUPU018","y": -15.8521405,"x": -70.0265543399068},
  {"name": "PUPU045","y": -15.857048,"x": -70.012802195152},
  {"name": "PUPU046","y": -15.8605985,"x": -70.0173466407395},
  {"name": "PUPU019","y": -15.850124,"x": -70.0225335638298},
  {"name": "PUPU020","y": -15.848316,"x": -70.0181562009259},
  {"name": "AQBR074-F","y": -16.4279755,"x": -71.5168922545089},
  {"name": "PUPU021","y": -15.846956,"x": -70.0167962814178},
  {"name": "TCGA022-F","y": -18.079726,"x": -70.2565244325222},
  {"name": "PUPU022","y": -15.8495995,"x": -70.0206590797866},
  {"name": "PUPU023","y": -15.8539445,"x": -70.0204444987407},
  {"name": "LMSC130","y": -12.102493,"x": -76.963962786},
  {"name": "PUPU024","y": -15.8520495,"x": -70.0192900319304},
  {"name": "PUBS001","y": -15.867039,"x": -69.996201375008},
  {"name": "PUPU026","y": -15.8539805,"x": -70.0153070256293},
  {"name": "CZES019-F","y": -14.7993305,"x": -71.4046005029915},
  {"name": "PUPU027","y": -15.857048,"x": -70.0165842001217},
  {"name": "PUPU037","y": -15.8219665,"x": -70.0215397765638},
  {"name": "PUBS007","y": -15.880232,"x": -70.000211688168},
  {"name": "JNPG012-F","y": -11.42302505,"x": -74.4872988824783},
  {"name": "PUPU038","y": -15.8297275,"x": -70.0221551104167},
  {"name": "PUPU044","y": -15.8609925,"x": -70.0026021875145},
  {"name": "PUPU047","y": -15.8650165,"x": -70.0168948632542},
  {"name": "PUPU049","y": -15.861219,"x": -70.0115058571969},
  {"name": "PUPU050","y": -15.8637995,"x": -70.0123331093962},
  {"name": "PUBS005","y": -15.874933,"x": -69.9932483459043},
  {"name": "MQMN002-S // MQMN002","y": -17.209857,"x": -70.9474605981262},
  {"name": "MQMN003","y": -17.2065695,"x": -70.9476773096271},
  {"name": "MDPM004","y": -12.601082,"x": -69.1869014594972},
  {"name": "PIUR202-F","y": -5.1885855,"x": -80.6259772262494},
  {"name": "ZONA SATURADA","y": -12.1346015,"x": -76.9579702653577},
  {"name": "MQMN004-S // MQMN004","y": -17.2068515,"x": -70.9417275565879},
  {"name": "MQMN005-S // MQMN005","y": -17.191231,"x": -70.9503268617318},
  {"name": "MQMN006-S // MQMN006","y": -17.193624,"x": -70.9515749733542},
  {"name": "MQMN007-S // MQMN007","y": -17.1941985,"x": -70.9471763413048},
  {"name": "JNPG010-F","y": -11.44677105,"x": -74.4932387177968},
  {"name": "MQMN008","y": -17.1925885,"x": -70.9445856428501},
  {"name": "JNPG013-F","y": -11.4234937,"x": -74.4924351372828},
  {"name": "MQMN009-S // MQMN009","y": -17.189694,"x": -70.9399210147771},
  {"name": "LMCA002-S // LMCA002","y": -12.0079395,"x": -77.1049088727256},
  {"name": "MQMN010-S // MQMN010","y": -17.187154,"x": -70.932942522349},
  {"name": "MQMN011-S // MQMN011","y": -17.1885025,"x": -70.9304132135042},
  {"name": "MDPM015","y": -12.601305,"x": -69.1934865529353},
  {"name": "MQMN012-S // MQMN012","y": -17.187392,"x": -70.9272956501075},
  {"name": "LAMO061","y": -12.0660465,"x": -76.9110133829497},
  {"name": "MQMN013","y": -17.1905815,"x": -70.9292276927817},
  {"name": "MQMN014-S // MQMN014","y": -17.195773,"x": -70.93106576293},
  {"name": "MDPM009","y": -12.5962825,"x": -69.1931861853327},
  {"name": "MQMN015-S // MQMN015","y": -17.198068,"x": -70.934558792714},
  {"name": "MQMN016-S // MQMN016","y": -17.182075,"x": -70.9000461424915},
  {"name": "PIUC131","y": -5.187159,"x": -80.6069936787975},
  {"name": "MQMN021-S // MQMN021","y": -17.1984125,"x": -70.9187655821048},
  {"name": "MQMN027","y": -17.170929,"x": -70.9071914601954},
  {"name": "MDPM003","y": -12.5970475,"x": -69.1828698143224},
  {"name": "MQMN028","y": -17.1665675,"x": -70.9056440946727},
  {"name": "MDPM012","y": -12.5906675,"x": -69.1912713663336},
  {"name": "MDPM027","y": -12.580434,"x": -69.2002601199718},
  {"name": "MQMN022-S // MQMN022","y": -17.193621,"x": -70.9378669286805},
  {"name": "PIUC132","y": -5.1895085,"x": -80.6062331926348},
  {"name": "MQMN025-S // MQMN025","y": -17.206293,"x": -70.9531009934307},
  {"name": "MQMN026-S // MQMN026","y": -17.192427,"x": -70.9342093082902},
  {"name": "MQMN029","y": -17.171573,"x": -70.8961757464626},
  {"name": "MDPM002","y": -12.592623,"x": -69.1822834530227},
  {"name": "MDPM016","y": -12.5982765,"x": -69.1981050394993},
  {"name": "MDPM006","y": -12.595081,"x": -69.1868482686925},
  {"name": "MDPM021","y": -12.588172,"x": -69.2047817352178},
  {"name": "LMSA020-S // LMSA020","y": -12.051365,"x": -76.9651412925685},
  {"name": "MDPM007","y": -12.599303,"x": -69.188948403649},
  {"name": "MDPM008","y": -12.5979,"x": -69.1914554622708},
  {"name": "MDPM010","y": -12.594074,"x": -69.1943057159242},
  {"name": "MDPM013","y": -12.5889795,"x": -69.1875881592627},
  {"name": "CHI100-S // CHI100","y": -6.795379,"x": -79.842247651986},
  {"name": "MDPM014","y": -12.5987785,"x": -69.1822473784014},
  {"name": "LMCA003-S // LMCA003","y": -12.010522,"x": -77.1036176690044},
  {"name": "MDPM022","y": -12.5874585,"x": -69.19949348905},
  {"name": "MDPM023","y": -12.587397,"x": -69.1921062040967},
  {"name": "MDPM024","y": -12.585553,"x": -69.1947725286316},
  {"name": "TCGA019-F","y": -18.072203,"x": -70.2640761637379},
  {"name": "TCGA020-F","y": -18.0743145,"x": -70.2621477173028},
  {"name": "TCGA021-F","y": -18.0749425,"x": -70.2567211061475},
  {"name": "LMCO186","y": -11.9242005,"x": -77.0432497761993},
  {"name": "MDPM025","y": -12.5833715,"x": -69.204570301381},
  {"name": "MDPM026","y": -12.583719,"x": -69.2009840972786},
  {"name": "MDPM028","y": -12.5776825,"x": -69.1962642968807},
  {"name": "TCGA004-F","y": -18.0613975,"x": -70.2540693162394},
  {"name": "TCGA005-F","y": -18.061909,"x": -70.2491325401158},
  {"name": "TCGA006-F","y": -18.065818,"x": -70.2491387698497},
  {"name": "MDPM033","y": -12.595971,"x": -69.1737133655397},
  {"name": "TCGA023-F","y": -18.077796,"x": -70.2525051970679},
  {"name": "TCGA024-F","y": -18.07226,"x": -70.2456962274329},
  {"name": "TCGA025-F","y": -18.0300855,"x": -70.2431072825721},
  {"name": "MDPM034","y": -12.6005585,"x": -69.1788828984893},
  {"name": "PIUS041-F","y": -4.904042,"x": -80.6787555323354},
  {"name": "MDPM038","y": -12.6080565,"x": -69.1969969507543},
  {"name": "MDPM039-S // MDPM039","y": -12.57647,"x": -69.2031760282275},
  {"name": "MDPM030","y": -12.580915,"x": -69.1954593336128},
  {"name": "MDPM031","y": -12.5833485,"x": -69.1890185566104},
  {"name": "MDPM029","y": -12.5958107,"x": -69.1773323068064},
  {"name": "AQME003-F","y": -17.097946,"x": -71.9121635338698},
  {"name": "TCGA007-F","y": -18.0617825,"x": -70.2446311967067},
  {"name": "CZST033-F","y": -13.523781,"x": -71.9904849815984},
  {"name": "LMSC089-S // LMSC089","y": -12.112565,"x": -76.9923124265038},
  {"name": "TCGA026-F","y": -18.0352445,"x": -70.2430313824013},
  {"name": "TCGA008-F","y": -18.065605,"x": -70.245335719894},
  {"name": "LMSA021","y": -12.0531085,"x": -76.9626001920966},
  {"name": "TCGA001-F","y": -18.067303,"x": -70.2622891209269},
  {"name": "TCGA002-F","y": -18.062495,"x": -70.2610854981552},
  {"name": "TCGA010-F","y": -18.067316,"x": -70.2415354795969},
  {"name": "TCGA011-F","y": -18.070645,"x": -70.2422474093355},
  {"name": "TCGA012-F","y": -18.0695115,"x": -70.2498135480462},
  {"name": "TCGA013-F","y": -18.070449,"x": -70.2525521246033},
  {"name": "TCGA014-F","y": -18.070652,"x": -70.2544349588031},
  {"name": "TCGA015-F","y": -18.0739005,"x": -70.2494253432101},
  {"name": "TCGA016-F","y": -18.074233,"x": -70.2531755218075},
  {"name": "TCGA017-F","y": -18.05502,"x": -70.2589520578556},
  {"name": "CZUC001-F","y": -13.678822,"x": -71.6285599740972},
  {"name": "CZUC002-F","y": -13.688482,"x": -71.6255399019507},
  {"name": "PIUS042-F","y": -4.900717,"x": -80.678929746904},
  {"name": "CZUC003-F","y": -13.68513335,"x": -71.6236686898424},
  {"name": "CZUC004-F","y": -13.6865272,"x": -71.6205169733507},
  {"name": "CZST021-F","y": -13.5251255,"x": -71.9842046062236},
  {"name": "JNPG004-F","y": -11.4314912,"x": -74.4825855900372},
  {"name": "CZST023-F","y": -13.526457,"x": -71.9789504340133},
  {"name": "CZST024-F","y": -13.527183,"x": -71.9756637906551},
  {"name": "LMSA026","y": -12.053824,"x": -76.9796239495339},
  {"name": "CZST025-F","y": -13.529111,"x": -71.9749862826562},
  {"name": "CZST026-F","y": -13.529674,"x": -71.9817473237889},
  {"name": "CZST027-F","y": -13.5281215,"x": -71.9846341148825},
  {"name": "CZST028-F","y": -13.5310245,"x": -71.9857228655136},
  {"name": "CZST029-F","y": -13.5315515,"x": -71.9875890671653},
  {"name": "AQBR078-F","y": -16.4448955,"x": -71.5132663708068},
  {"name": "CZSC001-F","y": -14.2587545,"x": -71.2251083129394},
  {"name": "CZST030-F","y": -13.532738,"x": -71.9836777778721},
  {"name": "JNPG005-F","y": -11.43579545,"x": -74.4843731011729},
  {"name": "CZST031-F","y": -13.535544,"x": -71.9853102784424},
  {"name": "CZST032-F","y": -13.526453,"x": -71.9902014288181},
  {"name": "CZST034-F","y": -13.535568,"x": -71.9664913134746},
  {"name": "CZST035-F","y": -13.5377375,"x": -71.9705508687307},
  {"name": "CZSJ016-F","y": -13.549124,"x": -71.9056754524021},
  {"name": "CZSJ017-F","y": -13.546001,"x": -71.898841905193},
  {"name": "ILIL006-F","y": -17.6412015,"x": -71.3393631472825},
  {"name": "CZSC002-F","y": -14.26241,"x": -71.2242260370281},
  {"name": "CZSC003-F","y": -14.262826,"x": -71.2267649670862},
  {"name": "CZSC004-F","y": -14.2626555,"x": -71.2290976799318},
  {"name": "CZSC009-F","y": -14.2759795,"x": -71.2268664978491},
  {"name": "CZSC005-F","y": -14.267055,"x": -71.227501550418},
  {"name": "CZSC006-F","y": -14.2696115,"x": -71.2276017828832},
  {"name": "CZSC007-F","y": -14.2708985,"x": -71.226515085986},
  {"name": "CZSC008-F","y": -14.274795,"x": -71.2255949849215},
  {"name": "ZONA SATURADA","y": -17.6534495,"x": -71.3293687341342},
  {"name": "AQME004-F","y": -17.0568515,"x": -71.9617840031739},
  {"name": "AQME005-F","y": -17.0503925,"x": -71.9725024832536},
  {"name": "CZSC010-F","y": -14.2784715,"x": -71.2239200999977},
  {"name": "CZSC011-F","y": -14.281921,"x": -71.2216147897745},
  {"name": "CZSC012-F","y": -14.267713,"x": -71.2317985764925},
  {"name": "CZSC013-F","y": -14.270261,"x": -71.2308038123283},
  {"name": "CZSC014-F","y": -14.2690855,"x": -71.2347384547535},
  {"name": "CZSC015-F","y": -14.272302,"x": -71.2321874128066},
  {"name": "CZSJ018-F","y": -13.5458335,"x": -71.8958085710482},
  {"name": "CZSJ019-F","y": -13.5489525,"x": -71.8963669151034},
  {"name": "CZSC016-F","y": -14.273,"x": -71.2356006080902},
  {"name": "CZSC017-F","y": -14.274216,"x": -71.230177821842},
  {"name": "CZSC018-F","y": -14.2757425,"x": -71.2323815679172},
  {"name": "LMSC306-F","y": -12.135184,"x": -77.0028211676663},
  {"name": "CZSC019-F","y": -14.2782075,"x": -71.2282874184688},
  {"name": "CZSJ031-F","y": -13.546867,"x": -71.9071643977059},
  {"name": "CZSC020-F","y": -14.27855,"x": -71.2300285476622},
  {"name": "CZSC021-F","y": -14.2781245,"x": -71.2329906185837},
  {"name": "CZSC022-F","y": -14.281357,"x": -71.2276952486247},
  {"name": "CZSC023-F","y": -14.285568,"x": -71.2247218962527},
  {"name": "CZSC024-F","y": -14.288568,"x": -71.2237411515152},
  {"name": "CZSJ020-F","y": -13.5506965,"x": -71.8853454169603},
  {"name": "CZSJ021-F","y": -13.5532655,"x": -71.8789809297899},
  {"name": "PIUS048-F","y": -4.9053025,"x": -80.6866484963952},
  {"name": "CZSJ022-F","y": -13.546098,"x": -71.8789394876881},
  {"name": "ZONA SATURADA","y": -11.500986,"x": -77.209365258156},
  {"name": "CZSJ023-F","y": -13.5485415,"x": -71.8761163771538},
  {"name": "CZSJ024-F","y": -13.5506715,"x": -71.8778061164136},
  {"name": "CZSJ025-F","y": -13.5265805,"x": -71.8962288309529},
  {"name": "CZSJ026-F","y": -13.5317795,"x": -71.8980551961845},
  {"name": "CZCA006-F","y": -13.3264528,"x": -71.951407828121},
  {"name": "CZSJ027-F","y": -13.5375315,"x": -71.9000108014844},
  {"name": "LMLM177-F","y": -12.0356815,"x": -77.0675500644599},
  {"name": "CZSJ028-F","y": -13.540908,"x": -71.8917638812188},
  {"name": "CZSJ029-F","y": -13.5390865,"x": -71.8886556682796},
  {"name": "CZSJ030-F","y": -13.544205,"x": -71.9049626972858},
  {"name": "CZPS001-F","y": -13.4218765,"x": -71.8542863709449},
  {"name": "MQSG003-F","y": -17.1877465,"x": -70.9079744277666},
  {"name": "CZCA004-F","y": -13.32291865,"x": -71.9566936678184},
  {"name": "CZPS002-F","y": -13.422181,"x": -71.8499091134501},
  {"name": "TCPC002-F","y": -18.004527,"x": -70.2272554362105},
  {"name": "ZONA SATURADA","y": -12.1349405,"x": -76.957793139744},
  {"name": "CZCA001-F","y": -13.3167472,"x": -71.953955301403},
  {"name": "CZCA002-F","y": -13.3190091,"x": -71.9519894392481},
  {"name": "AQBR089-F","y": -16.4279955,"x": -71.5149181291846},
  {"name": "CZCA003-F","y": -13.3224564,"x": -71.9528593194108},
  {"name": "LMLM178-F","y": -12.0371585,"x": -77.0703624508589},
  {"name": "CZCA005-F","y": -13.31942665,"x": -71.9569703245074},
  {"name": "AQMM027-F","y": -16.393505,"x": -71.4850616115269},
  {"name": "PIUC135","y": -5.185783,"x": -80.5933281262771},
  {"name": "AQPP064-F","y": -16.4162155,"x": -71.4848236060754},
  {"name": "AQMM028-F","y": -16.389779,"x": -71.4920649092472},
  {"name": "AQMM029-F","y": -16.393402,"x": -71.4815644661017},
  {"name": "AQMM030-F","y": -16.397869,"x": -71.4794098525158},
  {"name": "AQMM031-F","y": -16.4002385,"x": -71.4859168264897},
  {"name": "LMSA024","y": -12.051467,"x": -76.9723605694494},
  {"name": "AQMM032-F","y": -16.4018945,"x": -71.4831898003857},
  {"name": "CZCZ053-F","y": -13.5180465,"x": -71.9674937714708},
  {"name": "TCPC003-F","y": -18.0006688,"x": -70.224139905453},
  {"name": "AQNP004-F","y": -16.5687965,"x": -72.7156462563795},
  {"name": "PIUS043-F","y": -4.9000755,"x": -80.6760575716832},
  {"name": "AQMM021-F","y": -16.392306,"x": -71.4977325191932},
  {"name": "LMSA023","y": -12.050163,"x": -76.9732912741888},
  {"name": "AQMM022-F","y": -16.3953555,"x": -71.4996564902239},
  {"name": "MQPC001-F","y": -17.6078875,"x": -71.3416352627201},
  {"name": "AQPP068-F","y": -16.420454,"x": -71.4922167382261},
  {"name": "AQBR082-F","y": -16.4310135,"x": -71.5215777464747},
  {"name": "AQBR083-F","y": -16.433045,"x": -71.5203433884956},
  {"name": "MQPC002-F","y": -17.603351,"x": -71.3452423763495},
  {"name": "TCNA165-F","y": -18.0655651836377,"x": -70.2991767566804},
  {"name": "AQBR084-F","y": -16.4347015,"x": -71.521345209657},
  {"name": "PIUS044-F","y": -4.89893,"x": -80.6792263825364},
  {"name": "AQBR085-F","y": -16.4364185,"x": -71.5184037902945},
  {"name": "AQBR086-F","y": -16.433772,"x": -71.5149663133511},
  {"name": "AQBR087-F","y": -16.432272,"x": -71.5152583989468},
  {"name": "AQBR088-F","y": -16.4307275,"x": -71.5150874005587},
  {"name": "LMSA025","y": -12.052821,"x": -76.9777670199926},
  {"name": "ILIL001-F","y": -17.631193,"x": -71.3405394963479},
  {"name": "AQPP075-F","y": -16.4270145,"x": -71.5083650170405},
  {"name": "MQSG001-F","y": -17.179343,"x": -70.8979772339032},
  {"name": "MDTB004-F","y": -12.605284,"x": -69.201042809434},
  {"name": "MDTB001-F","y": -12.585712,"x": -69.2106907421716},
  {"name": "MQSG002-F","y": -17.183361,"x": -70.8964054727249},
  {"name": "PIUS045-F","y": -4.896784,"x": -80.6802877492113},
  {"name": "MQSG004-F","y": -17.1911605,"x": -70.9122476101102},
  {"name": "CZCZ041-F","y": -13.5063325,"x": -71.9974873371524},
  {"name": "CZCZ042-F","y": -13.507269,"x": -71.9943762883955},
  {"name": "CZCZ043-F","y": -13.5096573,"x": -71.9888892542858},
  {"name": "PIUC136","y": -5.2175955,"x": -80.6295437079736},
  {"name": "CZCZ044-F","y": -13.512893,"x": -71.9914870702128},
  {"name": "CZCZ046-F","y": -13.513572,"x": -71.9882275563223},
  {"name": "CZCZ047-F","y": -13.51669255,"x": -71.9894689706333},
  {"name": "CZCZ048-F","y": -13.5200215,"x": -71.9886874737965},
  {"name": "MDTB002-F","y": -12.5763945,"x": -69.2007702151759},
  {"name": "LLEP024-F","y": -8.0765135,"x": -79.013871306083},
  {"name": "CZCZ059-F","y": -13.5058475,"x": -72.0148197657085},
  {"name": "PIUS047-F","y": -4.9040405,"x": -80.6832397199915},
  {"name": "CZCZ049-F","y": -13.5200011,"x": -71.9911701240942},
  {"name": "PIUS046-F","y": -4.8965175,"x": -80.6771370324324},
  {"name": "LMSA027","y": -12.0511505,"x": -76.9799387267534},
  {"name": "CZCZ050-F","y": -13.5209825,"x": -71.9924663698218},
  {"name": "CZCZ051-F","y": -13.5239076,"x": -71.991414956862},
  {"name": "CZCZ052-F","y": -13.5256339,"x": -71.9942564318493},
  {"name": "ILIL007-F","y": -17.644147,"x": -71.3419146748262},
  {"name": "CZCZ054-F","y": -13.5142202,"x": -71.9608817742936},
  {"name": "PIUR001","y": -5.184625,"x": -80.6700190493747},
  {"name": "CZCZ055-F","y": -13.5140327,"x": -71.9567919981267},
  {"name": "CZCZ056-F","y": -13.5203694,"x": -71.9644115099649},
  {"name": "CZCZ057-F","y": -13.502062,"x": -72.0180815301032},
  {"name": "CZCZ058-F","y": -13.50482245,"x": -72.01244976773},
  {"name": "JNPG002-F","y": -11.42874725,"x": -74.4869614685989},
  {"name": "CZCZ060-F","y": -13.5093938,"x": -72.0110004883202},
  {"name": "JNPG001-F","y": -11.43686385,"x": -74.4897736961975},
  {"name": "CZCZ061-F","y": -13.5055177,"x": -72.008384579684},
  {"name": "CZCZ062-F","y": -13.5087228,"x": -72.0060750851141},
  {"name": "CZCZ063-F","y": -13.5061377,"x": -72.0030339612269},
  {"name": "MDTB003-F","y": -12.5934685,"x": -69.1789211177586},
  {"name": "PIUS054-F","y": -4.9029765,"x": -80.7106260698539},
  {"name": "MQMN030-F","y": -17.209364,"x": -70.9521033076114},
  {"name": "CZCZ070-F","y": -13.5138581,"x": -71.9668012900579},
  {"name": "CZCZ064-F","y": -13.5094312,"x": -72.0012499770429},
  {"name": "CZCZ065-F","y": -13.50939655,"x": -71.9974736717072},
  {"name": "CZCZ066-F","y": -13.5129179,"x": -71.9951218514303},
  {"name": "CZCZ067-F","y": -13.50450135,"x": -71.9941595064471},
  {"name": "CZCZ068-F","y": -13.511878,"x": -71.9756533395522},
  {"name": "CZCZ069-F","y": -13.51287435,"x": -71.9726017691258},
  {"name": "MQMN047-F","y": -17.2063395,"x": -70.9202638702799},
  {"name": "ILIL002-F","y": -17.633394,"x": -71.33721667761},
  {"name": "LMSC037-S // LMSC037","y": -12.127493,"x": -76.9975324579208},
  {"name": "CZCZ071-F","y": -13.5115695,"x": -71.9637264550174},
  {"name": "CZCZ072-F","y": -13.5097584,"x": -71.9602123280922},
  {"name": "MQMN034-F","y": -17.1952505,"x": -70.9442246945747},
  {"name": "CZCZ073-F","y": -13.5147975,"x": -71.9541889071259},
  {"name": "CZCZ074-F","y": -13.52019505,"x": -71.9624033928001},
  {"name": "JNPG003-F","y": -11.4249103,"x": -74.4883147163438},
  {"name": "MQMN031-F","y": -17.207486,"x": -70.9569961716343},
  {"name": "MQMN032-F","y": -17.202759,"x": -70.9590743425227},
  {"name": "MQMN039-F","y": -17.1939365,"x": -70.9242801912349},
  {"name": "TCNA146-F","y": -18.0054955,"x": -70.2410029083557},
  {"name": "TCNA143-F","y": -18.01931,"x": -70.2656650833333},
  {"name": "MQMN040-F","y": -17.1907915,"x": -70.921048477775},
  {"name": "TCNA167-F","y": -18.0620855224273,"x": -70.2976213749502},
  {"name": "MQMN033-F","y": -17.201611,"x": -70.9487691837487},
  {"name": "MQMN035-F","y": -17.19379,"x": -70.9416073501289},
  {"name": "PIUR002","y": -5.1847005,"x": -80.6665011677852},
  {"name": "MQMN048-F","y": -17.1903495,"x": -70.9465526606759},
  {"name": "MQMN036-F","y": -17.1936755,"x": -70.9387998024114},
  {"name": "MQMN037-F","y": -17.1968635,"x": -70.9385007528003},
  {"name": "MQMN038-F","y": -17.1926315,"x": -70.9263367174645},
  {"name": "MQMN041-F","y": -17.2011295,"x": -70.9527845267341},
  {"name": "PIUR032","y": -5.20056,"x": -80.6332669381387},
  {"name": "MQMN043-F","y": -17.205285,"x": -70.9502618339177},
  {"name": "MQMN044-F","y": -17.2020125,"x": -70.9455356875804},
  {"name": "MQMN045-F","y": -17.2018475,"x": -70.9428905462581},
  {"name": "MQMN046-F","y": -17.198155,"x": -70.9260831633166},
  {"name": "TCNA147-F","y": -18.0207905,"x": -70.2717434126741},
  {"name": "TCNA144-F","y": -18.0030815,"x": -70.2404612478009},
  {"name": "MQMN049-F","y": -17.18618,"x": -70.9280764713405},
  {"name": "MQMN050-F","y": -17.159628,"x": -70.9218560370297},
  {"name": "MQMN051-F","y": -17.2026225,"x": -70.9399557745069},
  {"name": "MQMN053-F","y": -17.208186,"x": -70.9384858936893},
  {"name": "TCNA145-F","y": -18.0005915,"x": -70.2366463783436},
  {"name": "ILIL028-F","y": -17.6528505,"x": -71.3425874626787},
  {"name": "PIUC152-F","y": -5.1895785,"x": -80.595716842354},
  {"name": "MQMN057-F","y": -17.2014795,"x": -70.9270329496403},
  {"name": "MQMN061-F","y": -17.207286,"x": -70.9280325038932},
  {"name": "MQMN063-F","y": -17.2051285,"x": -70.9132677635844},
  {"name": "MQMN064-F","y": -17.199577,"x": -70.9127222674932},
  {"name": "ILIL029-F","y": -17.655669,"x": -71.3435826071428},
  {"name": "TCNA148-F","y": -18.0181805,"x": -70.2726828780193},
  {"name": "TCNA149-F","y": -18.0189965,"x": -70.2688459563567},
  {"name": "TCNA150-F","y": -18.023932,"x": -70.2657675342324},
  {"name": "TCNA151-F","y": -18.0200085,"x": -70.2620833214286},
  {"name": "PIUC153-F","y": -5.188551,"x": -80.5916182822686},
  {"name": "TCNA152-F","y": -18.0150435,"x": -70.2618017028192},
  {"name": "MQIL005-F","y": -17.659001,"x": -71.349041640625},
  {"name": "TCNA153-F","y": -18.0125315,"x": -70.2570912575758},
  {"name": "LMSA031","y": -12.0466865,"x": -76.9756088879961},
  {"name": "TCNA154-F","y": -18.0157515,"x": -70.2434856622738},
  {"name": "PIUS055-F","y": -4.905474,"x": -80.7109545198201},
  {"name": "TCNA155-F","y": -18.01256,"x": -70.2375476286681},
  {"name": "TCNA156-F","y": -18.018554,"x": -70.2414242305194},
  {"name": "TCNA157-F","y": -18.024805,"x": -70.2402880810724},
  {"name": "TCNA158-F","y": -18.0259495,"x": -70.2438168345238},
  {"name": "ILIL004-F","y": -17.636914,"x": -71.3373625490438},
  {"name": "ILIL005-F","y": -17.6400325,"x": -71.3413609551516},
  {"name": "TCNA159-F","y": -18.028449,"x": -70.2480974839675},
  {"name": "ILIL003-F","y": -17.636028,"x": -71.340158677963},
  {"name": "MQIL014-F","y": -17.653715,"x": -71.3092942601339},
  {"name": "TCNA160-F","y": -18.026722,"x": -70.2529255444535},
  {"name": "ILIL031-F","y": -17.647202,"x": -71.3234463429137},
  {"name": "TCNA161-F","y": -18.0321925,"x": -70.2623177505682},
  {"name": "TCNA162-F","y": -17.9950715,"x": -70.2414290358436},
  {"name": "PICH027-F","y": -5.105923,"x": -80.1643680056571},
  {"name": "TCNA168-F","y": -18.0645448960813,"x": -70.2935425964211},
  {"name": "TCNA166-F","y": -18.0674154165542,"x": -70.2945274007036},
  {"name": "MQIL031-F","y": -17.6584225,"x": -71.3259073580719},
  {"name": "ILIL008-F","y": -17.646273,"x": -71.345804878866},
  {"name": "ILIL009-F","y": -17.646033,"x": -71.3437042194641},
  {"name": "ILIL010-F","y": -17.6548465,"x": -71.3386177838983},
  {"name": "ILIL011-F","y": -17.657075,"x": -71.3362680974519},
  {"name": "ILIL012-F","y": -17.6585785,"x": -71.3383489304447},
  {"name": "ILIL018-F","y": -17.653263,"x": -71.3307905632517},
  {"name": "LMSC058-S // LMSC058","y": -12.138743,"x": -76.989669457196},
  {"name": "ILIL013-F","y": -17.6589255,"x": -71.3343655556641},
  {"name": "ILIL014-F","y": -17.6493345,"x": -71.3369701666419},
  {"name": "ILIL015-F","y": -17.650602,"x": -71.3354034517668},
  {"name": "ILIL032-F","y": -17.647037,"x": -71.3265435444995},
  {"name": "PUIL008-F","y": -16.0854945,"x": -69.6370348346366},
  {"name": "ILIL016-F","y": -17.65126,"x": -71.3335035566332},
  {"name": "ILIL017-F","y": -17.6522385,"x": -71.3321656357276},
  {"name": "PIUR014","y": -5.1926415,"x": -80.6518243137938},
  {"name": "ILIL019-F","y": -17.6495345,"x": -71.3454004836563},
  {"name": "ILIL020-F","y": -17.630567,"x": -71.3369888750798},
  {"name": "ILIL021-F","y": -17.6291365,"x": -71.3345031781168},
  {"name": "ILIL022-F","y": -17.633546,"x": -71.3325442556067},
  {"name": "ILIL023-F","y": -17.6352455,"x": -71.3346063247664},
  {"name": "ILIL024-F","y": -17.6384135,"x": -71.3344197041284},
  {"name": "ILIL025-F","y": -17.643086,"x": -71.3378735204136},
  {"name": "ILIL027-F","y": -17.6497825,"x": -71.3418417186143},
  {"name": "PIUS056-F","y": -4.9087185,"x": -80.6913300822216},
  {"name": "ILIL033-F","y": -17.610687,"x": -71.3401050164194},
  {"name": "ILIL034-F","y": -17.612881,"x": -71.3397679001987},
  {"name": "ILIL035-F","y": -17.6160325,"x": -71.3367669138903},
  {"name": "MQIL002-F","y": -17.6541425,"x": -71.3215318455667},
  {"name": "MQIL004-F","y": -17.6563895,"x": -71.3162454112868},
  {"name": "MQIL006-F","y": -17.658037,"x": -71.3465548087219},
  {"name": "MQIL007-F","y": -17.645857,"x": -71.3331288449264},
  {"name": "MQIL008-F","y": -17.646593,"x": -71.3299679625807},
  {"name": "MQIL009-F","y": -17.6435215,"x": -71.3299639753552},
  {"name": "MQIL010-F","y": -17.641795,"x": -71.326872588571},
  {"name": "MQIL011-F","y": -17.6397015,"x": -71.3266915474653},
  {"name": "MQIL012-F","y": -17.637448,"x": -71.3256752013856},
  {"name": "MQIL013-F","y": -17.639187,"x": -71.3230593254333},
  {"name": "CZES016-F","y": -14.7991325,"x": -71.4153437838261},
  {"name": "MQIL015-F","y": -17.650506,"x": -71.3096380168377},
  {"name": "MQIL016-F","y": -17.653427,"x": -71.3061742119793},
  {"name": "PIUC155-F","y": -5.222296,"x": -80.6261716400998},
  {"name": "MQIL017-F","y": -17.626339,"x": -71.3342801645862},
  {"name": "MQIL018-F","y": -17.6290165,"x": -71.3256578475829},
  {"name": "MQIL019-F","y": -17.6319735,"x": -71.3282605897211},
  {"name": "MQIL020-F","y": -17.632611,"x": -71.3254946934093},
  {"name": "MQIL021-F","y": -17.6338715,"x": -71.310108982642},
  {"name": "MQIL022-F","y": -17.637591,"x": -71.3098312267996},
  {"name": "MQIL023-F","y": -17.641645,"x": -71.3138441931432},
  {"name": "PIUC154-F","y": -5.221174,"x": -80.6282648770228},
  {"name": "LMSA030","y": -12.0494295,"x": -76.9758912605812},
  {"name": "MQIL024-F","y": -17.6419165,"x": -71.3179261505205},
  {"name": "MQIL025-F","y": -17.6447285,"x": -71.3181400171427},
  {"name": "MQIL026-F","y": -17.645021,"x": -71.3207205025409},
  {"name": "MQIL027-F","y": -17.650406,"x": -71.3145211464126},
  {"name": "MQIL028-F","y": -17.652059,"x": -71.3146085225857},
  {"name": "MQIL029-F","y": -17.6540465,"x": -71.314708429721},
  {"name": "MQIL032-F","y": -17.6522245,"x": -71.3450770548321},
  {"name": "PIUR162-F","y": -5.171007,"x": -80.6489800185925},
  {"name": "CZSS037-F","y": -13.5437985,"x": -71.9343077481053},
  {"name": "CZSS038-F","y": -13.5404225,"x": -71.9523710568536},
  {"name": "CZSS039-F","y": -13.540208,"x": -71.9483994280189},
  {"name": "CZSS040-F","y": -13.541436,"x": -71.94591842766},
  {"name": "CZSS041-F","y": -13.5275035,"x": -71.9309520781712},
  {"name": "LMAG041-F","y": -12.0378565,"x": -76.9900202333248},
  {"name": "CZSS042-F","y": -13.5275315,"x": -71.9219489234317},
  {"name": "CZSS043-F","y": -13.543472,"x": -71.907343856723},
  {"name": "CZSS044-F","y": -13.544403,"x": -71.9100315888113},
  {"name": "CZSS045-F","y": -13.524572,"x": -71.9286009763697},
  {"name": "CHI102-S // CHI102","y": -6.797092,"x": -79.8454686343852},
  {"name": "CZSS046-F","y": -13.527346,"x": -71.9274941060747},
  {"name": "CZSS047-F","y": -13.5278155,"x": -71.9245315748292},
  {"name": "CZSS048-F","y": -13.5301185,"x": -71.9195811273585},
  {"name": "CZSS049-F","y": -13.527601,"x": -71.9171476230199},
  {"name": "CZSS050-F","y": -13.527601,"x": -71.9149811935548},
  {"name": "CZSS051-F","y": -13.531075,"x": -71.91290881},
  {"name": "CZSS052-F","y": -13.5273235,"x": -71.9194514539637},
  {"name": "PIUC157-F","y": -5.2257755,"x": -80.6290683173299},
  {"name": "CZSS053-F","y": -13.53858,"x": -71.9543408824403},
  {"name": "CZSA001-F","y": -12.8552645,"x": -72.6977047783402},
  {"name": "PIUC158-F","y": -5.22698,"x": -80.6268529662596},
  {"name": "CZSA002-F","y": -12.8579555,"x": -72.6935092998647},
  {"name": "CZSA003-F","y": -12.859553,"x": -72.6968289413646},
  {"name": "CZSA004-F","y": -12.8602825,"x": -72.6933828923797},
  {"name": "CZSA005-F","y": -12.863537,"x": -72.692425930406},
  {"name": "CZSA006-F","y": -12.8648175,"x": -72.6924157916265},
  {"name": "PUIL017-F","y": -16.080042,"x": -69.6462082589789},
  {"name": "CZSA006-F","y": -12.865093,"x": -72.6964286901669},
  {"name": "CZSA007-F","y": -12.8669865,"x": -72.6908736390201},
  {"name": "PUSM001-F","y": -15.479374,"x": -70.1337632166933},
  {"name": "CZSA008-F","y": -12.867491,"x": -72.6966082380856},
  {"name": "AQCL001-F","y": -15.8404365,"x": -74.2687702185392},
  {"name": "CZSA009-F","y": -12.8690775,"x": -72.6907976229433},
  {"name": "CHI103","y": -6.7985285,"x": -79.8529370182196},
  {"name": "PUSM004-F","y": -15.479917,"x": -70.1216088783693},
  {"name": "CZSA010-F","y": -12.869462,"x": -72.6952341307885},
  {"name": "CZSA011-F","y": -12.8720065,"x": -72.6906972428423},
  {"name": "CZSA012-F","y": -12.871454,"x": -72.69435028978},
  {"name": "PUSM007-F","y": -15.4738815,"x": -70.1163721905583},
  {"name": "CZSA013-F","y": -12.873972,"x": -72.6969555868167},
  {"name": "PUJL002-F","y": -15.4817805,"x": -70.1295073098504},
  {"name": "PUIL002-F","y": -16.077545,"x": -69.6391816663882},
  {"name": "CZSA014-F","y": -12.876164,"x": -72.695556820375},
  {"name": "CZUR001-F","y": -13.3032125,"x": -72.1205054005653},
  {"name": "CZUR002-F","y": -13.3027155,"x": -72.1180038088915},
  {"name": "CZUR003-F","y": -13.303942,"x": -72.115289775283},
  {"name": "PUJL003-F","y": -15.481964,"x": -70.1271314763158},
  {"name": "CZUR004-F","y": -13.307133,"x": -72.1172767185039},
  {"name": "PUSM008-F","y": -15.468204,"x": -70.1361921337589},
  {"name": "CZUR005-F","y": -13.305949,"x": -72.1135574629279},
  {"name": "CZUR006-F","y": -13.3090825,"x": -72.1100084948754},
  {"name": "CZUR007-F","y": -13.3037535,"x": -72.1328445097775},
  {"name": "PUPU067-F","y": -15.855096,"x": -70.0112021824818},
  {"name": "CZUR008-F","y": -13.3064175,"x": -72.1319902527666},
  {"name": "CZWQ039-F","y": -13.537422,"x": -71.9526390503597},
  {"name": "CZWQ040-F","y": -13.5393375,"x": -71.9440192142598},
  {"name": "AQPP074-F","y": -16.4280513823322,"x": -71.5126033031226},
  {"name": "PIUR188-F","y": -5.2030355,"x": -80.6439082956024},
  {"name": "PUIL001-F","y": -16.075588,"x": -69.6374338024688},
  {"name": "PIUP001-F","y": -5.0968035,"x": -81.1086736013979},
  {"name": "PUPU077-F","y": -15.8279355,"x": -70.0329145820433},
  {"name": "PUIL003-F","y": -16.0800575,"x": -69.6409062166106},
  {"name": "CHI094","y": -6.789823,"x": -79.8470435019569},
  {"name": "PUIL004-F","y": -16.0828365,"x": -69.6428259617424},
  {"name": "PUIL005-F","y": -16.085706,"x": -69.6433826054448},
  {"name": "PUIL006-F","y": -16.088146,"x": -69.641361945087},
  {"name": "PUIL007-F","y": -16.0846865,"x": -69.6392000918479},
  {"name": "PUIL009-F","y": -16.0769735,"x": -69.6325588775748},
  {"name": "PIUT030-F","y": -4.5903925,"x": -81.2852783951109},
  {"name": "PUSM005-F","y": -15.4782395,"x": -70.1205225546396},
  {"name": "PUIL010-F","y": -16.0815805,"x": -69.6371920133173},
  {"name": "PUIL011-F","y": -16.0855855,"x": -69.633736644682},
  {"name": "PUIL012-F","y": -16.089174,"x": -69.6352915489418},
  {"name": "PUIL013-F","y": -16.0898925,"x": -69.6397319227949},
  {"name": "PUJL006-F","y": -15.48489,"x": -70.1348102259218},
  {"name": "PUIL014-F","y": -16.076157,"x": -69.6295216076377},
  {"name": "PUSM003-F","y": -15.481779,"x": -70.1240288168303},
  {"name": "PUSM006-F","y": -15.47653,"x": -70.1189131122995},
  {"name": "LMSC050-S // LMSC050","y": -12.131977,"x": -76.9883171457751},
  {"name": "PUIL015-F","y": -16.0743335,"x": -69.6409306131948},
  {"name": "PUIL016-F","y": -16.076975,"x": -69.6465242065191},
  {"name": "PUIL018-F","y": -16.085939,"x": -69.6481267277355},
  {"name": "PUIL019-F","y": -16.092215,"x": -69.6447979970805},
  {"name": "PUIL020-F","y": -16.0930955,"x": -69.6427090353648},
  {"name": "PUSM002-F","y": -15.47894,"x": -70.1302999259437},
  {"name": "LMSA032","y": -12.048017,"x": -76.9755345079116},
  {"name": "PUSM009-F","y": -15.472371,"x": -70.1355555884907},
  {"name": "PUSM010-F","y": -15.476064,"x": -70.1345464111075},
  {"name": "PUSM011-F","y": -15.467728,"x": -70.1332230118033},
  {"name": "PUSM012-F","y": -15.4716735,"x": -70.1318038392687},
  {"name": "PUSM013-F","y": -15.4675245,"x": -70.1285881922419},
  {"name": "PUSM014-F","y": -15.472836,"x": -70.1292107062193},
  {"name": "PUSM015-F","y": -15.477014,"x": -70.1300784483302},
  {"name": "TRLE039","y": -8.071882,"x": -79.0608433029626},
  {"name": "PUSM016-F","y": -15.467595,"x": -70.1254926690647},
  {"name": "PUPU059-F","y": -15.8367855,"x": -70.0319443476563},
  {"name": "PUSM017-F","y": -15.4707685,"x": -70.1254174674917},
  {"name": "PUSM019-F","y": -15.47881,"x": -70.1257814901763},
  {"name": "PUJL016-F","y": -15.483741,"x": -70.1498463965417},
  {"name": "PUSM021-F","y": -15.4704135,"x": -70.1203379856581},
  {"name": "PUSM022-F","y": -15.473046,"x": -70.119204315877},
  {"name": "PUSM024-F","y": -15.4754055,"x": -70.122256475},
  {"name": "PUSM025-F","y": -15.476729,"x": -70.124306500625},
  {"name": "PUPU057-F","y": -15.8420425,"x": -70.0316977592981},
  {"name": "PUPU062-F","y": -15.8304995,"x": -70.0281690941781},
  {"name": "PUPU058-F","y": -15.8397995,"x": -70.0324595014033},
  {"name": "PUPU060-F","y": -15.83467,"x": -70.027770000743},
  {"name": "PUJL017-F","y": -15.4806685,"x": -70.1466372838476},
  {"name": "PUJL018-F","y": -15.483419,"x": -70.147667336544},
  {"name": "PUPU061-F","y": -15.8311765,"x": -70.0295545282307},
  {"name": "PIUP002-F","y": -5.094381,"x": -81.1051985592772},
  {"name": "LLLR007-F","y": -8.0852035,"x": -78.9634446123651},
  {"name": "PUPU063-F","y": -15.831881,"x": -70.0242584787456},
  {"name": "PUPU064-F","y": -15.828016,"x": -70.0310736413609},
  {"name": "PUPU065-F","y": -15.851397,"x": -70.0137982458615},
  {"name": "PUPU066-F","y": -15.8534325,"x": -70.0106823711538},
  {"name": "PUPU068-F","y": -15.8550055,"x": -70.0060606307753},
  {"name": "PUPU069-F","y": -15.8602305,"x": -70.0146389553921},
  {"name": "PUPU070-F","y": -15.86312,"x": -70.0137949901639},
  {"name": "PUPU071-F","y": -15.829622,"x": -70.0271133947773},
  {"name": "LLCP009-F","y": -7.2295175,"x": -79.428109150167},
  {"name": "PUPU072-F","y": -15.8289745,"x": -70.0207735713405},
  {"name": "HZHU014-F","y": -9.53591575,"x": -77.5225038461755},
  {"name": "PUPU073-F","y": -15.8283725,"x": -70.018110368421},
  {"name": "PUPU074-F","y": -15.825078,"x": -70.0188449904144},
  {"name": "PUPU075-F","y": -15.8234175,"x": -70.0118960239941},
  {"name": "PUPU076-F","y": -15.823591,"x": -70.0083031856436},
  {"name": "PUJL001-F","y": -15.482242,"x": -70.1329239066227},
  {"name": "PUJL004-F","y": -15.484431,"x": -70.1292933942459},
  {"name": "PUJL005-F","y": -15.484694,"x": -70.1325406552028},
  {"name": "LLLR008-F","y": -8.0863765,"x": -78.9531444305657},
  {"name": "PUJL007-F","y": -15.4839575,"x": -70.1262502952057},
  {"name": "PUJL023-F","y": -15.480902,"x": -70.1373536056354},
  {"name": "LLLR009-F","y": -8.088542,"x": -78.9563167950413},
  {"name": "PUJL008-F","y": -15.485899,"x": -70.1261656112756},
  {"name": "LMSA033","y": -12.0473735,"x": -76.9714369751725},
  {"name": "LLCP010-F","y": -7.2313855,"x": -79.4256011670752},
  {"name": "PUJL024-F","y": -15.4830075,"x": -70.1390004576017},
  {"name": "PUJL025-F","y": -15.4848085,"x": -70.1392124072794},
  {"name": "PUDE005-F","y": -16.5809995,"x": -69.0576758069259},
  {"name": "PUJL009-F","y": -15.486627,"x": -70.1286779905882},
  {"name": "PUDE001-F","y": -16.561704,"x": -69.0450609437899},
  {"name": "PUJL010-F","y": -15.487648,"x": -70.1327180217514},
  {"name": "PUJL011-F","y": -15.487927,"x": -70.1342113755799},
  {"name": "PUJL012-F","y": -15.486957,"x": -70.1247955813725},
  {"name": "PUJL013-F","y": -15.487918,"x": -70.1288575762341},
  {"name": "PUJL014-F","y": -15.490172,"x": -70.1331004970459},
  {"name": "LLCP008-F","y": -7.2274765,"x": -79.4296428129549},
  {"name": "LMSC052-S // LMSC052","y": -12.133289,"x": -76.9871793829352},
  {"name": "PUJL022-F","y": -15.480452,"x": -70.1398292980691},
  {"name": "LMSC039-S // LMSC039","y": -12.129967,"x": -76.9982880288099},
  {"name": "PUJL026-F","y": -15.486127,"x": -70.1374849551234},
  {"name": "PUJL027-F","y": -15.487138,"x": -70.1403234473684},
  {"name": "PIUS057-F","y": -4.91268,"x": -80.6912710037453},
  {"name": "PIUS058-F","y": -4.908187,"x": -80.6851770728615},
  {"name": "LLLR005-F","y": -8.08504,"x": -78.9581820995711},
  {"name": "PITG004-F","y": -4.931104,"x": -80.3456979482334},
  {"name": "PILU008-F","y": -5.4047875,"x": -80.7415086363636},
  {"name": "PITG005-F","y": -4.9309545,"x": -80.3408090103806},
  {"name": "PITG006-F","y": -4.933055,"x": -80.3435876274592},
  {"name": "PITG007-F","y": -4.934309,"x": -80.3413586539708},
  {"name": "PITG008-F","y": -4.919196,"x": -80.343402359375},
  {"name": "PITG009-F","y": -4.9232005,"x": -80.3429954250903},
  {"name": "PITG010-F","y": -4.9253945,"x": -80.3484076479739},
  {"name": "PITG011-F","y": -4.9274455,"x": -80.3508839500406},
  {"name": "PUDE006-F","y": -16.5655835,"x": -69.0424193066408},
  {"name": "LLLR010-F","y": -8.0878975,"x": -78.958608836815},
  {"name": "PITG012-F","y": -4.9301755,"x": -80.3495568373725},
  {"name": "PITG013-F","y": -4.933101,"x": -80.3487890445344},
  {"name": "PITG015-F","y": -4.9204835,"x": -80.3382485328063},
  {"name": "LMSC048-S // LMSC048","y": -12.1306315,"x": -76.9848018985802},
  {"name": "LLLR006-F","y": -8.0839675,"x": -78.9603585187427},
  {"name": "PUDE003-F","y": -16.5685975,"x": -69.0466859750357},
  {"name": "LMSC049-S // LMSC049","y": -12.1321395,"x": -76.9835350288575},
  {"name": "PUDE004-F","y": -16.5740825,"x": -69.0522287127},
  {"name": "PUDE007-F","y": -16.567284,"x": -69.0401303837838},
  {"name": "LMSC054-S // LMSC054","y": -12.135454,"x": -76.984799009479},
  {"name": "LMSA068-F","y": -12.0450465,"x": -76.9773340895954},
  {"name": "ZONA SATURADA","y": -16.431597,"x": -71.5118112403579},
  {"name": "ZONA SATURADA","y": -16.432438,"x": -71.511299706422},
  {"name": "PUDE008-F","y": -16.569235,"x": -69.0418108778272},
  {"name": "AQSC019-F","y": -16.406932,"x": -71.5690364002329},
  {"name": "PIUR015","y": -5.187791,"x": -80.6470515836849},
  {"name": "PIUR011","y": -5.1887075,"x": -80.6533557776347},
  {"name": "AQBR053-F","y": -16.423262,"x": -71.526248311574},
  {"name": "ZONA SATURADA","y": -16.4243615,"x": -71.5271820989979},
  {"name": "ZONA SATURADA","y": -16.423777,"x": -71.5266300519305},
  {"name": "MQIL003-F","y": -17.6560335,"x": -71.324639571633},
  {"name": "ZONA SATURADA","y": -17.655551,"x": -71.3290386930829},
  {"name": "PILU001-F","y": -5.391473,"x": -80.7391858292683},
  {"name": "LLCP005-F","y": -7.229991,"x": -79.42437043},
  {"name": "PILU002-F","y": -5.397091,"x": -80.7416544330067},
  {"name": "PILU005-F","y": -5.400609,"x": -80.7401123262206},
  {"name": "PILU006-F","y": -5.4052835,"x": -80.74765620714},
  {"name": "PILU007-F","y": -5.4062105,"x": -80.744839769816},
  {"name": "PIMA001-F","y": -4.106189,"x": -81.0517309471892},
  {"name": "LLPC012-F","y": -7.4064875,"x": -79.5615327178893},
  {"name": "PIMA002-F","y": -4.104736,"x": -81.0504418705674},
  {"name": "PIMA003-F","y": -4.105382,"x": -81.0463357122447},
  {"name": "PIMA004-F","y": -4.107886,"x": -81.0496156666667},
  {"name": "PIMA006-F","y": -4.1026175,"x": -81.0479571561366},
  {"name": "LMPC009-F","y": -12.1008405,"x": -76.875513160518},
  {"name": "PIVI002-F","y": -4.132027,"x": -81.1014445642857},
  {"name": "LMSC057-S // LMSC057","y": -12.138081,"x": -76.9888857513534},
  {"name": "PIMO001-F","y": -5.1825565,"x": -79.9721118558489},
  {"name": "PIMO002-F","y": -5.1869085,"x": -79.9726044864107},
  {"name": "PIMO003-F","y": -5.1879265,"x": -79.9655106807882},
  {"name": "PIMO004-F","y": -5.187995,"x": -79.9629033760504},
  {"name": "LLLR012-F","y": -8.090219,"x": -78.9610753228929},
  {"name": "LMCA156-F","y": -12.052117,"x": -77.113673939973},
  {"name": "CBCB013","y": -9.067075,"x": -78.5830804231465},
  {"name": "LBFE010-F","y": -6.641492,"x": -79.7951885115385},
  {"name": "TRLE036","y": -8.0709165,"x": -79.0655972315892},
  {"name": "LAMO069","y": -12.0671785,"x": -76.9014845496357},
  {"name": "LLPC013-F","y": -7.409757,"x": -79.5616696916968},
  {"name": "LLPC014-F","y": -7.411093,"x": -79.5635434588055},
  {"name": "LLPC001-F","y": -7.406833,"x": -79.572600751498},
  {"name": "LLPC002-F","y": -7.4039825,"x": -79.5737677965347},
  {"name": "LLPC003-F","y": -7.405151,"x": -79.5693983618598},
  {"name": "LLPC004-F","y": -7.40142,"x": -79.5718204726981},
  {"name": "LLPC005-F","y": -7.402884,"x": -79.5688563396068},
  {"name": "LLPC006-F","y": -7.404458,"x": -79.5663762268033},
  {"name": "LLPC007-F","y": -7.3999995,"x": -79.5700141439769},
  {"name": "LLPC008-F","y": -7.402249,"x": -79.5643459010903},
  {"name": "LLPC009-F","y": -7.3990895,"x": -79.5664999593407},
  {"name": "LLPC010-F","y": -7.397826,"x": -79.56280025},
  {"name": "LLPC011-F","y": -7.408087,"x": -79.5687544643784},
  {"name": "LMJL044-S","y": -12.0144005,"x": -77.0036948606736},
  {"name": "TBZR002-F","y": -3.6806365,"x": -80.6794193159782},
  {"name": "TBZR003-F","y": -3.673526,"x": -80.6621977333995},
  {"name": "LLHM001-F","y": -7.8087985,"x": -78.0477307455486},
  {"name": "LLLE026-F","y": -8.0792065,"x": -79.0343730390886},
  {"name": "LLHM002-F","y": -7.8118725,"x": -78.0481845262128},
  {"name": "LLLE011-F","y": -8.070815,"x": -79.0462934255175},
  {"name": "LLHM003-F","y": -7.81514,"x": -78.0489324682596},
  {"name": "LLHM005-F","y": -7.8137635,"x": -78.0449853361303},
  {"name": "LLLE007-F","y": -8.0578445,"x": -79.0520580738731},
  {"name": "LLLE005-F","y": -8.054767,"x": -79.0507855733945},
  {"name": "LLHM007-F","y": -7.818301,"x": -78.0458158108108},
  {"name": "LLHM008-F","y": -7.8159895,"x": -78.0410145517041},
  {"name": "LLLE012-F","y": -8.070539,"x": -79.0442482131859},
  {"name": "LLHM009-F","y": -7.8182835,"x": -78.0385888269231},
  {"name": "LLHM010-F","y": -7.820298,"x": -78.0406585157783},
  {"name": "LLLE001-F","y": -8.078929,"x": -79.0457668630984},
  {"name": "LLLE008-F","y": -8.058814,"x": -79.0489151197546},
  {"name": "LLLE009-F","y": -8.0605525,"x": -79.0511446358045},
  {"name": "LLLE010-F","y": -8.0608775,"x": -79.0466801895884},
  {"name": "LLLE025-F","y": -8.076091,"x": -79.0360406675069},
  {"name": "LLLE027-F","y": -8.0845955,"x": -79.0323870495931},
  {"name": "LLLR001-F","y": -8.0801155,"x": -78.9533224689034},
  {"name": "LLLR002-F","y": -8.0820805,"x": -78.9591938646232},
  {"name": "LLLR003-F","y": -8.0827565,"x": -78.9535234},
  {"name": "LLLR004-F","y": -8.084347,"x": -78.9546521293644},
  {"name": "LMCA023","y": -12.022589,"x": -77.09889950775},
  {"name": "LLCP004-F","y": -7.228019,"x": -79.4250927220448},
  {"name": "LMSA039","y": -12.041631,"x": -76.9656873130898},
  {"name": "LMSA036","y": -12.040119,"x": -76.9739443406544},
  {"name": "LLLR013-F","y": -8.0909925,"x": -78.957285712118},
  {"name": "LLLR014-F","y": -8.0908525,"x": -78.9593073209799},
  {"name": "LLLR015-F","y": -8.09112,"x": -78.9630633181818},
  {"name": "LLLR016-F","y": -8.065912,"x": -78.9786453596087},
  {"name": "LLLR017-F","y": -8.064097,"x": -78.9781116642943},
  {"name": "LLLR018-F","y": -8.0626015,"x": -78.9783734457547},
  {"name": "LLLR019-F","y": -8.0622135,"x": -78.976200798734},
  {"name": "LMCA024","y": -12.019309,"x": -77.0989943649909},
  {"name": "LMCA033-S // LMCA033","y": -12.0380015,"x": -77.0963795199447},
  {"name": "LMSA038","y": -12.041082,"x": -76.9691622689014},
  {"name": "LMJL003-S // LMJL003","y": -11.988726,"x": -77.0137610022753},
  {"name": "LLHC009-F","y": -8.0276795,"x": -79.0668317879133},
  {"name": "LLCP001-F","y": -7.222339,"x": -79.4313428093729},
  {"name": "LLCP003-F","y": -7.2264605,"x": -79.4275132388416},
  {"name": "LMCA050-S // LMCA050","y": -11.9961655,"x": -77.1210762651584},
  {"name": "LMCA186-F","y": -12.0557795,"x": -77.1351048274522},
  {"name": "LMCA004-S // LMCA004","y": -12.00623,"x": -77.1027243039568},
  {"name": "LMLV068-F","y": -12.0718665,"x": -77.0258506446069},
  {"name": "LLCH001-F","y": -8.5423185,"x": -78.6807562207909},
  {"name": "LLCH002-F","y": -8.5408585,"x": -78.6774085760336},
  {"name": "LMLM195-F","y": -12.0634595,"x": -77.0435128180118},
  {"name": "PIUR033","y": -5.201105,"x": -80.6299192204865},
  {"name": "LLCH003-F","y": -8.539398,"x": -78.6740777560976},
  {"name": "LMSC127-S // LMSC127","y": -12.101027,"x": -76.9726422149757},
  {"name": "LMLV073-F","y": -12.072049,"x": -77.0206919808706},
  {"name": "LMCA005","y": -12.0062505,"x": -77.1004554163822},
  {"name": "LMSA042","y": -12.0362285,"x": -76.9654271650059},
  {"name": "LMSC059","y": -12.124414,"x": -77.0002091838235},
  {"name": "CZES007-F","y": -14.788186,"x": -71.4047575521453},
  {"name": "LMSA043","y": -12.039266,"x": -76.9630204019324},
  {"name": "LMCA006-S // LMCA006","y": -12.0095245,"x": -77.1006896499648},
  {"name": "LMLM196-F","y": -12.063706,"x": -77.0415484016337},
  {"name": "LMLM203-F","y": -12.0387965,"x": -77.0569297258536},
  {"name": "LMLM204-F","y": -12.037461,"x": -77.0562060231377},
  {"name": "LMSA044","y": -12.032848,"x": -76.9641151341085},
  {"name": "TRLE035","y": -8.066276,"x": -79.0625506729925},
  {"name": "LMCO006-S","y": -11.9435735,"x": -77.0626777486213},
  {"name": "LMSA044","y": -12.0336005,"x": -76.9625587527963},
  {"name": "PIUR034","y": -5.201791,"x": -80.6280294078982},
  {"name": "LMCA007","y": -12.0088215,"x": -77.0987705258987},
  {"name": "LMCO001-S","y": -11.9579615,"x": -77.0618827489826},
  {"name": "LMCO001","y": -11.9555655,"x": -77.0623417479167},
  {"name": "LMVS008-S // LMVS008","y": -12.196485,"x": -76.9513483067512},
  {"name": "LMCO001","y": -11.9555405,"x": -77.0608819842718},
  {"name": "LMCO001","y": -11.960245,"x": -77.0620550587121},
  {"name": "LMCO001","y": -11.959999,"x": -77.0622729985865},
  {"name": "CZES001-F","y": -14.7806165,"x": -71.4130134141171},
  {"name": "LMSA045","y": -12.0321415,"x": -76.9622810584263},
  {"name": "LMSA047","y": -12.034639,"x": -76.9600553643478},
  {"name": "PIUR006","y": -5.183397,"x": -80.6586452916331},
  {"name": "PIUR007","y": -5.1842865,"x": -80.6570983684219},
  {"name": "PIUR008","y": -5.1845965,"x": -80.6555565183461},
  {"name": "CZES011-F","y": -14.7922165,"x": -71.4189397242991},
  {"name": "LMJL118","y": -11.973313,"x": -77.0049637560154},
  {"name": "LMSA047","y": -12.0340345,"x": -76.960065267768},
  {"name": "PIUR010","y": -5.186872,"x": -80.6505570363658},
  {"name": "5518D04","y": -12.126689,"x": -77.0248752706287},
  {"name": "LMCA008-S // LMCA008","y": -12.007356,"x": -77.0968019004782},
  {"name": "SRJL014-F","y": -15.50981235,"x": -70.1273152861448},
  {"name": "PUJL121-F","y": -15.4681115,"x": -70.1463813189825},
  {"name": "AQBR077-F","y": -16.4134615,"x": -71.5164408013333},
  {"name": "AQBR090-F","y": -16.41329,"x": -71.5181068333333},
  {"name": "PIUR016","y": -5.1890555,"x": -80.6444912954218},
  {"name": "AQBR072-F","y": -16.4235455,"x": -71.529867727025},
  {"name": "PIUR004","y": -5.1861505,"x": -80.6616836322086},
  {"name": "LMLV113-F","y": -12.0676925,"x": -77.0151267138173},
  {"name": "LMLV123-F","y": -12.06631,"x": -77.0155920873618},
  {"name": "LMCA029-S // LMCA029","y": -12.0282165,"x": -77.0957059733167},
  {"name": "PIUC056-S // PIUC056","y": -5.186089,"x": -80.6166724614907},
  {"name": "PIUC057-S // PIUC057","y": -5.1901295,"x": -80.6163638862552},
  {"name": "PIUR005","y": -5.1888915,"x": -80.662623418558},
  {"name": "PIUC118","y": -5.1762075,"x": -80.6113394367768},
  {"name": "PIUC059-S // PIUC059","y": -5.1893715,"x": -80.6220624669777},
  {"name": "PIUC060-S // PIUC060","y": -5.1918155,"x": -80.6205393853955},
  {"name": "PIUC061-S // PIUC061","y": -5.1956685,"x": -80.6218913973394},
  {"name": "PIUC105","y": -5.2034225,"x": -80.6239772323883},
  {"name": "PIUC106","y": -5.2034485,"x": -80.6213915167117},
  {"name": "PIUC107","y": -5.1991905,"x": -80.622781400513},
  {"name": "PIUC108","y": -5.199904,"x": -80.6200123959269},
  {"name": "PIUC109","y": -5.187688,"x": -80.6129648386571},
  {"name": "PIUC119","y": -5.17865,"x": -80.6094714804563},
  {"name": "PIUR012","y": -5.190896,"x": -80.6499767457649},
  {"name": "LMCA044-S // LMCA044","y": -12.002452,"x": -77.1046416472639},
  {"name": "PIUR013","y": -5.1912835,"x": -80.6547652620702},
  {"name": "PIUR017-S // PIUR017","y": -5.1898635,"x": -80.6409476005434},
  {"name": "PIUR018-S // PIUR018","y": -5.19119,"x": -80.6387038226795},
  {"name": "PIUR019","y": -5.192578,"x": -80.6470083025944},
  {"name": "PIUR020","y": -5.193702,"x": -80.6445666429288},
  {"name": "PIUR024","y": -5.191907,"x": -80.6359305143595},
  {"name": "PIUR051-S // PIUR051","y": -5.176221,"x": -80.6430982672465},
  {"name": "PIUR027-S // PIUR027","y": -5.1951805,"x": -80.6259197289392},
  {"name": "PIUR037","y": -5.190439,"x": -80.6286507683263},
  {"name": "PIUR038","y": -5.188491,"x": -80.6303811354148},
  {"name": "PIUR041","y": -5.18369,"x": -80.6375466514568},
  {"name": "PIUR042-S // PIUR042","y": -5.1772055,"x": -80.6267548223307},
  {"name": "PIUR043-S // PIUR043","y": -5.174506,"x": -80.6322298715011},
  {"name": "PIUR044","y": -5.173018,"x": -80.6346661575761},
  {"name": "PIUR065","y": -5.2031695,"x": -80.6344404973466},
  {"name": "PIUR045-S // PIUR045","y": -5.172568,"x": -80.6300827570915},
  {"name": "PIUR046","y": -5.170454,"x": -80.6307748418942},
  {"name": "PIUR052","y": -5.177963,"x": -80.6454194571388},
  {"name": "PIUR053-S // PIUR053","y": -5.1769325,"x": -80.6531617419486},
  {"name": "PIUR054","y": -5.1781955,"x": -80.6301955088843},
  {"name": "PIUR055","y": -5.171195,"x": -80.6342194626768},
  {"name": "LMCA045-S // LMCA045","y": -12.0032105,"x": -77.1123636993222},
  {"name": "PIUR062","y": -5.1841095,"x": -80.6327631512005},
  {"name": "PIUR066","y": -5.2032585,"x": -80.6366546587312},
  {"name": "PIUR073","y": -5.195006,"x": -80.6531231144741},
  {"name": "LMSA047","y": -12.034757,"x": -76.9592803017464},
  {"name": "PIUR110","y": -5.1769325,"x": -80.6486097558239},
  {"name": "PIUR112-S // PIUR112","y": -5.179544,"x": -80.6406446425252},
  {"name": "LMSC060-S","y": -12.127778,"x": -76.9838308705093},
  {"name": "PIUR113","y": -5.1799015,"x": -80.6427867507772},
  {"name": "PIUR117","y": -5.182541,"x": -80.6456887071112},
  {"name": "PIUR124","y": -5.168247,"x": -80.6594904771442},
  {"name": "PIUR125","y": -5.166979,"x": -80.6631546425826},
  {"name": "PIUR151-S // PIUR151","y": -5.1593365,"x": -80.6197481343621},
  {"name": "PIUR153","y": -5.177158,"x": -80.6746672445157},
  {"name": "PIUR154","y": -5.17862,"x": -80.6685787427372},
  {"name": "LMSA048","y": -12.035559,"x": -76.9623546700107},
  {"name": "PIUR155","y": -5.178143,"x": -80.6791282329356},
  {"name": "PIUR156-S // PIUR156","y": -5.1797915,"x": -80.6742303152049},
  {"name": "LMSA049","y": -12.036254,"x": -76.9599080850424},
  {"name": "PIUR157","y": -5.169123,"x": -80.6605992134113},
  {"name": "ANNC012-F","y": -9.1243555,"x": -78.5430323348767},
  {"name": "TRLE001","y": -8.0857235,"x": -79.0358581366687},
  {"name": "TRLE002-S // TRLE002","y": -8.0837145,"x": -79.0367539442867},
  {"name": "TRLE003","y": -8.085157,"x": -79.0394525777536},
  {"name": "TRLE004","y": -8.0822715,"x": -79.04275280977},
  {"name": "TRLE005","y": -8.0767205,"x": -79.0458158930204},
  {"name": "PIUS022","y": -4.906215,"x": -80.7024436601589},
  {"name": "TRLE043","y": -8.0752665,"x": -79.0492814090376},
  {"name": "TRLE006","y": -8.0825865,"x": -79.0393921748903},
  {"name": "TRLE007","y": -8.0794155,"x": -79.0384108590379},
  {"name": "TRLE008","y": -8.0804665,"x": -79.0412146637173},
  {"name": "TRLE009","y": -8.077882,"x": -79.0430123379537},
  {"name": "TRLE010","y": -8.0746145,"x": -79.0447959659091},
  {"name": "TRLE017","y": -8.0625155,"x": -79.0570439190408},
  {"name": "TRLE018","y": -8.0614,"x": -79.0542060820282},
  {"name": "TRLE021","y": -8.0661995,"x": -79.0599245202726},
  {"name": "PIUS012","y": -4.889666,"x": -80.6867760599022},
  {"name": "TRLE022","y": -8.0666985,"x": -79.0567710040302},
  {"name": "PIUS014","y": -4.8932645,"x": -80.6848051552068},
  {"name": "TRLE023","y": -8.064009,"x": -79.0539539589957},
  {"name": "TRLE024","y": -8.0663845,"x": -79.0531281122697},
  {"name": "TRLE027","y": -8.070768,"x": -79.0574297205686},
  {"name": "TRLE028","y": -8.069184,"x": -79.053047028345},
  {"name": "ANNC020-F","y": -9.12579135,"x": -78.49799392195},
  {"name": "TRLE030","y": -8.072527,"x": -79.0561762227785},
  {"name": "TRLE031","y": -8.071397,"x": -79.0518146747652},
  {"name": "TRLE032","y": -8.074621,"x": -79.0555992619971},
  {"name": "TRLE041","y": -8.078718,"x": -79.0553482255812},
  {"name": "TRLE042","y": -8.075594,"x": -79.0522460773164},
  {"name": "TRLE044","y": -8.079629,"x": -79.0528484745289},
  {"name": "TRLE045","y": -8.0788675,"x": -79.0491201909912},
  {"name": "PIUS011","y": -4.892276,"x": -80.6861834965436},
  {"name": "TRLE046","y": -8.0819475,"x": -79.0531931192835},
  {"name": "TRLE047","y": -8.080757,"x": -79.0479340769398},
  {"name": "TRLE048","y": -8.083453,"x": -79.0463459163286},
  {"name": "TRLE049","y": -8.0735725,"x": -79.0654211922389},
  {"name": "LMCO027","y": -11.916744,"x": -77.0530128417856},
  {"name": "TRFM001-S // TRFM001","y": -8.0849845,"x": -79.0197698827799},
  {"name": "ANNC018-F","y": -9.12544455,"x": -78.4962202718891},
  {"name": "TRFM002","y": -8.0863465,"x": -79.0231680886275},
  {"name": "TRFM003","y": -8.0844765,"x": -79.0234062368565},
  {"name": "TRFM004","y": -8.0817665,"x": -79.0205711528926},
  {"name": "TRFM005","y": -8.0818505,"x": -79.0251707852972},
  {"name": "TRFM006-S // TRFM006","y": -8.0820735,"x": -79.0230444515159},
  {"name": "PIUS001","y": -4.901528,"x": -80.6993747556555},
  {"name": "PIUS003","y": -4.900347,"x": -80.701566714148},
  {"name": "PIUS005","y": -4.897996,"x": -80.6943861277206},
  {"name": "PIUS013","y": -4.890067,"x": -80.6841427018634},
  {"name": "LMLV115-F","y": -12.066946,"x": -77.0150137051515},
  {"name": "LMSA051","y": -12.0383745,"x": -76.955808484432},
  {"name": "LMSA050","y": -12.038856,"x": -76.9590834705497},
  {"name": "PIUS006","y": -4.8950945,"x": -80.6919474537655},
  {"name": "PIUS021","y": -4.909191,"x": -80.6992836810405},
  {"name": "PIUS007-S // PIUS007","y": -4.8980915,"x": -80.6917724832128},
  {"name": "LMSA053","y": -12.0410595,"x": -76.9591286713401},
  {"name": "PIUS008","y": -4.8961575,"x": -80.6898378914803},
  {"name": "PIUS009","y": -4.8925665,"x": -80.6890177987945},
  {"name": "PIUS010","y": -4.8947585,"x": -80.6882931949619},
  {"name": "PIUS015-S // PIUS015","y": -4.8967335,"x": -80.6875119730501},
  {"name": "PUMC007-F","y": -14.071617,"x": -70.4295242813029},
  {"name": "LMJL193-F","y": -11.9972095,"x": -77.0166629675174},
  {"name": "PIUS016","y": -4.8991505,"x": -80.6900273314764},
  {"name": "PIUS017","y": -4.902092,"x": -80.6950703060151},
  {"name": "PIUS018","y": -4.9046965,"x": -80.6964484282651},
  {"name": "PIUS019","y": -4.909045,"x": -80.6954332366522},
  {"name": "PIUS020","y": -4.905135,"x": -80.6989059080597},
  {"name": "PIUS023","y": -4.9093575,"x": -80.7028749364343},
  {"name": "LMSA052-S // LMSA052","y": -12.0400475,"x": -76.9565662043668},
  {"name": "ANNC002-F","y": -9.1316041,"x": -78.5084450360241},
  {"name": "LMSA054","y": -12.04394,"x": -76.9586979381825},
  {"name": "LMSA055","y": -12.046403,"x": -76.9578200264324},
  {"name": "TRHC001","y": -8.083202,"x": -79.119898810316},
  {"name": "TRHC002","y": -8.0815995,"x": -79.1196733661142},
  {"name": "PUMC004-F","y": -14.0631755,"x": -70.4306879410632},
  {"name": "ZONA SATURADA","y": -12.0388325,"x": -76.9534180653724},
  {"name": "ANNC004-F","y": -9.14073565,"x": -78.5094042518568},
  {"name": "TRHC003","y": -8.07972,"x": -79.1195439846939},
  {"name": "TRHC004","y": -8.073819,"x": -79.1186238789111},
  {"name": "LMSA057-F","y": -12.0357965,"x": -76.9533096664799},
  {"name": "TRHC005","y": -8.0961775,"x": -79.1008248054988},
  {"name": "TRHC006","y": -8.0855215,"x": -79.0821224310437},
  {"name": "TRLE038","y": -8.073836,"x": -79.0628013463046},
  {"name": "ANNC001-F","y": -9.12973545,"x": -78.5075616514095},
  {"name": "ANNC003-F","y": -9.1375943,"x": -78.5016881482943},
  {"name": "LMJR116-F","y": -12.1396905,"x": -76.9700019509701},
  {"name": "ANNC005-F","y": -9.14453735,"x": -78.5089858249495},
  {"name": "ANNC006-F","y": -9.14412915,"x": -78.5063396054775},
  {"name": "ANNC007-F","y": -9.14551975,"x": -78.5058140821654},
  {"name": "ANNC007-F","y": -9.14724025,"x": -78.506043354113},
  {"name": "LMLV121-F","y": -12.0665565,"x": -77.01405798911},
  {"name": "ANNC008-F","y": -9.1433122,"x": -78.5028469038836},
  {"name": "ANNC009-F","y": -9.14714595,"x": -78.5044449994689},
  {"name": "ANNC010-F","y": -9.14635785,"x": -78.5013296774699},
  {"name": "ANNC010-F","y": -9.1476409,"x": -78.5016099732298},
  {"name": "ANNC010-F","y": -9.1494685,"x": -78.5015160950719},
  {"name": "LAMO072-S // LAMO072","y": -12.0805165,"x": -76.9194857664926},
  {"name": "ANNC011-F","y": -9.12357435,"x": -78.5469300677687},
  {"name": "ANNC013-F","y": -9.10747165,"x": -78.5360828378743},
  {"name": "ANCB002-F","y": -9.0492473,"x": -78.5758886954127},
  {"name": "ANCB004-F","y": -9.05332925,"x": -78.5756145180945},
  {"name": "ANNC014-F","y": -9.105682,"x": -78.5296426591868},
  {"name": "ANNC015-F","y": -9.1025388,"x": -78.5230159833147},
  {"name": "ANNC018-F","y": -9.12417215,"x": -78.4983501199563},
  {"name": "ANNC020-F","y": -9.1267761,"x": -78.4970510857516},
  {"name": "ANCB003-F","y": -9.0508271,"x": -78.5789622235822},
  {"name": "ANCB005-F","y": -9.0529509,"x": -78.5822431617078},
  {"name": "ANCB006-F","y": -9.05574085,"x": -78.5781373888483},
  {"name": "ANCB006-F","y": -9.05440915,"x": -78.5799621052702},
  {"name": "ANCB007-F","y": -9.07695355,"x": -78.5688325915657},
  {"name": "LMJL196-F","y": -11.963336,"x": -77.0023307480004},
  {"name": "ANCB008-F","y": -9.0781379,"x": -78.5712915934939},
  {"name": "ANCB009-F","y": -9.08085935,"x": -78.5715658161083},
  {"name": "ANCB010-F","y": -9.0839483,"x": -78.5693556457958},
  {"name": "ANCB010-F","y": -9.0817292,"x": -78.5726215992334},
  {"name": "ANCB011-F","y": -9.09005945,"x": -78.5657572436014},
  {"name": "ANCB012-F","y": -9.0879817,"x": -78.5764089612443},
  {"name": "ANCB013-F","y": -9.0814193,"x": -78.5839177775326},
  {"name": "ANCB013-F","y": -9.0793639,"x": -78.5820696875478},
  {"name": "ANCB014-F","y": -9.0752975,"x": -78.5870745487137},
  {"name": "ANCB014-F","y": -9.0759234,"x": -78.5856583859556},
  {"name": "ANCB015-F","y": -9.0705445,"x": -78.5877988308842},
  {"name": "ANCB016-F","y": -9.07146795,"x": -78.5918521537157},
  {"name": "ANCB017-F","y": -9.07052995,"x": -78.5940828881834},
  {"name": "ANCB024-F","y": -9.0708035,"x": -78.5796477176079},
  {"name": "ANCB017-F","y": -9.0725214,"x": -78.5950344517584},
  {"name": "ANCB018-F","y": -9.0961907,"x": -78.5692738076988},
  {"name": "ANCB019-F","y": -9.0627845,"x": -78.5770075766884},
  {"name": "ANCB020-F","y": -9.06536745,"x": -78.577953473514},
  {"name": "ANCB021-F","y": -9.0674115,"x": -78.5770405205224},
  {"name": "ANCB022-F","y": -9.0687355,"x": -78.5797750634406},
  {"name": "HZHU018-F","y": -9.5246425,"x": -77.5247459161702},
  {"name": "ANCM006-F","y": -9.473583,"x": -78.3001865308349},
  {"name": "ANCB028-F","y": -9.07591455,"x": -78.5807334739027},
  {"name": "ANCB023-F","y": -9.0702433,"x": -78.5770942270707},
  {"name": "ANCB025-F","y": -9.072182,"x": -78.5810667544656},
  {"name": "ANCB041-F","y": -9.0846603,"x": -78.5793145304892},
  {"name": "ANCB026-F","y": -9.073536,"x": -78.5819157940026},
  {"name": "ANCB027-F","y": -9.07285875,"x": -78.5754506758245},
  {"name": "ANCB027-F","y": -9.07289805,"x": -78.5791287576232},
  {"name": "ANCM008-F","y": -9.472171,"x": -78.2967597018388},
  {"name": "HZHU003-F","y": -9.5273287,"x": -77.5293868384143},
  {"name": "ANCB029-F","y": -9.0756558,"x": -78.5764184203231},
  {"name": "ANCB030-F","y": -9.076747,"x": -78.58313688178},
  {"name": "ANCB031-F","y": -9.077803,"x": -78.5776702664984},
  {"name": "ANCB032-F","y": -9.060469,"x": -78.5773196302291},
  {"name": "ANCB033-F","y": -9.05608495,"x": -78.5752012633007},
  {"name": "ANCB034-F","y": -9.0504138,"x": -78.5848121307433},
  {"name": "ANCB035-F","y": -9.0616875,"x": -78.5810961283367},
  {"name": "ANCB036-F","y": -9.05271485,"x": -78.5878839703065},
  {"name": "HZHU012-F","y": -9.5326145,"x": -77.5222041250638},
  {"name": "ANCB038-F","y": -9.0732574,"x": -78.5938176652231},
  {"name": "LMSA058-F","y": -12.0364065,"x": -76.9501541219981},
  {"name": "ANCB039-F","y": -9.0741632,"x": -78.5918278361274},
  {"name": "ANCB040-F","y": -9.0829016,"x": -78.5804157971443},
  {"name": "ANCB046-F","y": -9.09230945,"x": -78.5623254808001},
  {"name": "ANCB041-F","y": -9.0851649,"x": -78.576057520513},
  {"name": "ANCB042-F","y": -9.0906919,"x": -78.5696517957424},
  {"name": "ANCB043-F","y": -9.0879947,"x": -78.561305061604},
  {"name": "ANCB044-F","y": -9.09015305,"x": -78.5594523470274},
  {"name": "ANCB045-F","y": -9.09217435,"x": -78.5611015591434},
  {"name": "ANCB046-F","y": -9.09468495,"x": -78.5601306199674},
  {"name": "ANCB046-F","y": -9.0955036,"x": -78.561577312902},
  {"name": "ANCB046-F","y": -9.09413075,"x": -78.5630680673446},
  {"name": "ANCB047-F","y": -9.07867605,"x": -78.5858612078356},
  {"name": "ANCB048-F","y": -9.0757877,"x": -78.589794775048},
  {"name": "ANCB048-F","y": -9.0751416,"x": -78.5879473300848},
  {"name": "ANCB048-F","y": -9.0772664,"x": -78.5932799459753},
  {"name": "ANCB048-F","y": -9.07729055,"x": -78.5896007183653},
  {"name": "ANCB048-F","y": -9.0763571,"x": -78.5924476595741},
  {"name": "HZIN002-F","y": -9.4973375,"x": -77.538876302932},
  {"name": "ANCB049-F","y": -9.07502045,"x": -78.5963606582729},
  {"name": "HZIN011-F","y": -9.519105,"x": -77.5257745079787},
  {"name": "ANCB050-F","y": -9.06134015,"x": -78.5826800196385},
  {"name": "ANCB051-F","y": -9.05983795,"x": -78.5822054946423},
  {"name": "ANCM001-F","y": -9.4744175,"x": -78.307980827821},
  {"name": "HZIN002-F","y": -9.4959935,"x": -77.5403455676692},
  {"name": "ANCM002-F","y": -9.477788,"x": -78.3066209569717},
  {"name": "ANCM004-F","y": -9.4730075,"x": -78.3050307475889},
  {"name": "ANCM005-F","y": -9.471303,"x": -78.3017927935746},
  {"name": "HZIN006-F","y": -9.5120515,"x": -77.5326966377551},
  {"name": "HZIN017-F","y": -9.51726355,"x": -77.5336695801385},
  {"name": "HZIN001-F","y": -9.4923312,"x": -77.5383516872149},
  {"name": "LMSA059-F","y": -12.0329715,"x": -76.9560730366798},
  {"name": "HZIN002-F","y": -9.495713,"x": -77.5383962948718},
  {"name": "HZIN010-F","y": -9.5199695,"x": -77.5280989366955},
  {"name": "CBCB013","y": -9.0679025,"x": -78.5817883752706},
  {"name": "LMCA145-F","y": -12.012347,"x": -77.1010710913601},
  {"name": "HZIN012-F","y": -9.52190765,"x": -77.5234512839531},
  {"name": "HZIN018-F","y": -9.5215034,"x": -77.5337957378719},
  {"name": "HZIN008-F","y": -9.519857,"x": -77.5311905898699},
  {"name": "HZIN003-F","y": -9.4992548,"x": -77.5367989425251},
  {"name": "HZIN004-F","y": -9.5041045,"x": -77.5344749090909},
  {"name": "HZIN005-F","y": -9.508898,"x": -77.5329507951675},
  {"name": "HZHU017-F","y": -9.538719,"x": -77.5282956985911},
  {"name": "HZIN006-F","y": -9.515296,"x": -77.5318873681883},
  {"name": "HZIN007-F","y": -9.5183355,"x": -77.5314128577211},
  {"name": "HZIN009-F","y": -9.522065,"x": -77.5309833732394},
  {"name": "HZHU015-F","y": -9.53659955,"x": -77.5278882163484},
  {"name": "HZHU012-F","y": -9.5326155,"x": -77.5241878658211},
  {"name": "LMAT010-S","y": -12.0800075,"x": -76.9808757741238},
  {"name": "HZIN013-F","y": -9.5238174,"x": -77.5224606255073},
  {"name": "LMSA060-F","y": -12.0326985,"x": -76.9499490449438},
  {"name": "HZIN014-F","y": -9.5223815,"x": -77.5280304023874},
  {"name": "HZIN015-F","y": -9.5006945,"x": -77.5339631754386},
  {"name": "LMCA049","y": -11.9961585,"x": -77.1175982954469},
  {"name": "HZIN016-F","y": -9.512475,"x": -77.5338369576271},
  {"name": "HZIN019-F","y": -9.51709175,"x": -77.5287419443397},
  {"name": "HZIN027-F","y": -9.52528775,"x": -77.5380712635651},
  {"name": "HZIN032-F","y": -9.51617115,"x": -77.5268293623615},
  {"name": "HZIN029-F","y": -9.5115242,"x": -77.5258358948256},
  {"name": "HZHU019-F","y": -9.5256445,"x": -77.5230115328477},
  {"name": "HZIN030-F","y": -9.51358905,"x": -77.5246885430453},
  {"name": "LMLM179-F","y": -12.0374255,"x": -77.0675360530754},
  {"name": "HZHU004-F","y": -9.5289091,"x": -77.5254173957656},
  {"name": "HZIN031-F","y": -9.5147953,"x": -77.5226615034483},
  {"name": "HZIN033-F","y": -9.51691595,"x": -77.5215178610367},
  {"name": "HZHU006-F","y": -9.5308225,"x": -77.5335961743839},
  {"name": "HZHU001-F","y": -9.5264905,"x": -77.5351359627895},
  {"name": "HZIN034-F","y": -9.5187876,"x": -77.5215810406953},
  {"name": "HZIN035-F","y": -9.5208298,"x": -77.5207323155063},
  {"name": "CBNV017-S // CBNV017","y": -9.13212615,"x": -78.5265327027448},
  {"name": "HZHU004-F","y": -9.5294672,"x": -77.5271598324979},
  {"name": "HZIN036-F","y": -9.52414745,"x": -77.520270925405},
  {"name": "LMCA051-S // LMCA051","y": -11.9955015,"x": -77.1251396855249},
  {"name": "LMSA085-F","y": -12.0470635,"x": -76.9833181262678},
  {"name": "HZIN037-F","y": -9.52621985,"x": -77.516552052744},
  {"name": "HZIN042-F","y": -9.4943669,"x": -77.5323378338496},
  {"name": "HZHU013-F","y": -9.53436115,"x": -77.5254376479633},
  {"name": "CBNV059-S //CBNV059","y": -9.1305332,"x": -78.5371319252535},
  {"name": "HZHU002-F","y": -9.5271835,"x": -77.5320222837578},
  {"name": "HZHU007-F","y": -9.5302427,"x": -77.5309418616146},
  {"name": "HZIN043-F","y": -9.50353705,"x": -77.5292191332471},
  {"name": "5119A03-S // 5119A03","y": -12.099889,"x": -77.0209202713381},
  {"name": "LMSA061-F","y": -12.030853,"x": -76.9517095019979},
  {"name": "HZHU001-F","y": -9.5297545,"x": -77.5326009982269},
  {"name": "HZIN044-F","y": -9.50688865,"x": -77.5315198028912},
  {"name": "HZIN045-F","y": -9.5102387,"x": -77.5301450230786},
  {"name": "HZHU005-F","y": -9.5281077,"x": -77.5223931934254},
  {"name": "HZHU024-F","y": -9.5247675,"x": -77.5344006447368},
  {"name": "HZIN046-F","y": -9.5214416,"x": -77.5117464177312},
  {"name": "HZHU001-F","y": -9.528584,"x": -77.533731814251},
  {"name": "HZHU023-F","y": -9.523874,"x": -77.5307747068966},
  {"name": "HZHU025-F","y": -9.5405728,"x": -77.5318241891065},
  {"name": "HZHU008-F","y": -9.5303589,"x": -77.5223028039933},
  {"name": "HZHU008-F","y": -9.530537,"x": -77.5244715681627},
  {"name": "HZHU009-F","y": -9.533157,"x": -77.5206639392765},
  {"name": "LMSM003","y": -12.065128,"x": -77.1040631457956},
  {"name": "HZHU010-F","y": -9.5335205,"x": -77.5308033246678},
  {"name": "HZHU011-F","y": -9.5331983,"x": -77.5282888564014},
  {"name": "HZHU016-F","y": -9.5381945,"x": -77.5242381398025},
  {"name": "HZHU020-F","y": -9.524699,"x": -77.5276479615194},
  {"name": "CZES014-F","y": -14.793422,"x": -71.4051149753509},
  {"name": "LMCA158-F","y": -12.054797,"x": -77.1115239396747},
  {"name": "HZHU021-F","y": -9.5249885,"x": -77.5296503671105},
  {"name": "HZHU022-F","y": -9.5248565,"x": -77.5319055393662},
  {"name": "HZHU025-F","y": -9.5391493,"x": -77.5325196157559},
  {"name": "HZHU026-F","y": -9.54017425,"x": -77.5309447883246},
  {"name": "HZHU026-F","y": -9.53770635,"x": -77.5310727731181},
  {"name": "HZHU027-F","y": -9.5349627,"x": -77.5320720285926},
  {"name": "LMLM010","y": -12.0603755,"x": -77.0642674796789},
  {"name": "HZHU028-F","y": -9.54034605,"x": -77.529681800739},
  {"name": "PUDE009-F","y": -16.5741265,"x": -69.045819249376},
  {"name": "HZHU030-F","y": -9.54211045,"x": -77.5294676650962},
  {"name": "LMSA062-F","y": -12.0334615,"x": -76.9480106600439},
  {"name": "LMCA179-F","y": -12.049643,"x": -77.1316569182283},
  {"name": "HZHU031-F","y": -9.5281045,"x": -77.5188905862252},
  {"name": "LMCO122","y": -11.9671025,"x": -77.0578687271368},
  {"name": "HZHU032-F","y": -9.5322745,"x": -77.5191717792793},
  {"name": "HZHU032-F","y": -9.5304885,"x": -77.5159570627303},
  {"name": "ANHM008-F","y": -10.0577058,"x": -78.1621318204058},
  {"name": "ANCO002-F","y": -9.025819,"x": -78.6151763980868},
  {"name": "ANHM011-F","y": -10.0526044,"x": -78.1607884131821},
  {"name": "HZHU033-F","y": -9.5399035,"x": -77.5199939559083},
  {"name": "HZHU034-F","y": -9.549382,"x": -77.5390770382577},
  {"name": "PUDE010-F","y": -16.5614315,"x": -69.0408317456862},
  {"name": "ANCO001-F","y": -9.02024325,"x": -78.6151359801919},
  {"name": "ANCO002-F","y": -9.0239534,"x": -78.6163903930063},
  {"name": "ANCO002-F","y": -9.02125175,"x": -78.6151982111931},
  {"name": "LMSA063-F","y": -12.031636,"x": -76.9479504770139},
  {"name": "ANCO003-F","y": -9.02229985,"x": -78.611560935548},
  {"name": "LMLM109","y": -12.062198,"x": -77.0783892110656},
  {"name": "CBNV009","y": -9.1186195,"x": -78.5431998036078},
  {"name": "ANCO004-F","y": -9.01766085,"x": -78.6171169786568},
  {"name": "ANCO004-F","y": -9.01959335,"x": -78.616165653217},
  {"name": "ANHM004-F","y": -10.0625912,"x": -78.1473879126817},
  {"name": "ANCO004-F","y": -9.02205215,"x": -78.6168150979931},
  {"name": "LMLM011-S","y": -12.0580465,"x": -77.0625184816141},
  {"name": "ANCO005-F","y": -9.02769955,"x": -78.6170674155512},
  {"name": "ANHM001-F","y": -10.0700117,"x": -78.1563111406164},
  {"name": "ANHM001-F","y": -10.0688714,"x": -78.154205462071},
  {"name": "ANHM001-F","y": -10.070424,"x": -78.1537093775284},
  {"name": "ANHM002-F","y": -10.06619015,"x": -78.156053492406},
  {"name": "ANHM003-F","y": -10.06298245,"x": -78.1536790300412},
  {"name": "LMSA069-F","y": -12.0444125,"x": -76.9751369701751},
  {"name": "ANHM004-F","y": -10.06385655,"x": -78.1497352014933},
  {"name": "LMJL198-F","y": -11.959778,"x": -77.0005958144496},
  {"name": "ANHM005-F","y": -10.0672194,"x": -78.1515461712426},
  {"name": "ANHM005-F","y": -10.06658175,"x": -78.1477762176094},
  {"name": "ANHM006-F","y": -10.069896,"x": -78.1478314996776},
  {"name": "ANHM007-F","y": -10.07017055,"x": -78.1505779105751},
  {"name": "ANCR004-F","y": -9.044927,"x": -77.8065035612634},
  {"name": "LMCO246-F","y": -11.9039685,"x": -77.0511036984419},
  {"name": "ANYU004-F","y": -9.1420733,"x": -77.7390945540714},
  {"name": "ANHM009-F","y": -10.05775155,"x": -78.1584640365098},
  {"name": "ANHM010-F","y": -10.0580668,"x": -78.1563946164185},
  {"name": "LMCA113","y": -12.003429,"x": -77.1071652702137},
  {"name": "ANHM012-F","y": -10.05166845,"x": -78.1546489666883},
  {"name": "ANHM013-F","y": -10.0500999,"x": -78.1589824407901},
  {"name": "ANHM013-F","y": -10.04877095,"x": -78.1623521056632},
  {"name": "LMCA046-S // LMCA046","y": -11.999662,"x": -77.1133286681937},
  {"name": "CBNV005","y": -9.1169894,"x": -78.5380417519629},
  {"name": "CBNV058","y": -9.1290625,"x": -78.5404380080013},
  {"name": "ANYU004-F","y": -9.13873085,"x": -77.7399517791925},
  {"name": "ANHM014-F","y": -10.04788675,"x": -78.1582487657603},
  {"name": "HZIN041-F","y": -9.52668805,"x": -77.5130719452335},
  {"name": "LMJL199-F","y": -11.957781,"x": -76.9999466324192},
  {"name": "ANCR002-F","y": -9.0420213,"x": -77.8104855208392},
  {"name": "ANCR003-F","y": -9.0447772,"x": -77.8134592082613},
  {"name": "ANCR006-F","y": -9.0477547,"x": -77.8133894934819},
  {"name": "CBNV015","y": -9.12524405,"x": -78.5288928907982},
  {"name": "CBNV057","y": -9.12839265,"x": -78.5429784882826},
  {"name": "ANCR008-F","y": -9.04793685,"x": -77.8035279270739},
  {"name": "LMCA047","y": -11.9991655,"x": -77.1168055305643},
  {"name": "ANCR009-F","y": -9.0500851,"x": -77.8088219599229},
  {"name": "ANCR010-F","y": -9.0518625,"x": -77.8135928130493},
  {"name": "ANCR011-F","y": -9.0506626,"x": -77.8030043324318},
  {"name": "CBNV010-S // CBNV010","y": -9.120765,"x": -78.5461321981601},
  {"name": "ANYU001-F","y": -9.1372159,"x": -77.7459838155308},
  {"name": "CBNV008-S // CBNV008","y": -9.11787555,"x": -78.5472552418797},
  {"name": "LMCO248-F","y": -11.8978445,"x": -77.0513707274292},
  {"name": "CBNV006-S // CBNV006","y": -9.11743305,"x": -78.5413378998138},
  {"name": "CBNV007","y": -9.117826,"x": -78.5495368081596},
  {"name": "ANYU001-F","y": -9.1375412,"x": -77.749055473882},
  {"name": "CBNV011","y": -9.1222575,"x": -78.5456003325893},
  {"name": "ANYU002-F","y": -9.14221445,"x": -77.7444528853155},
  {"name": "CBNV040-S // CBNV040","y": -9.1208593,"x": -78.510733620195},
  {"name": "ANYU003-F","y": -9.14232835,"x": -77.7453761428021},
  {"name": "CBNV012-S // CBNV012","y": -9.1219205,"x": -78.5408305782443},
  {"name": "CBNV013-S // CBNV013","y": -9.123346,"x": -78.5387632749835},
  {"name": "LMCA162-F","y": -12.0530925,"x": -77.1011565128957},
  {"name": "LMLM183-F","y": -12.045049,"x": -77.0447112855729},
  {"name": "ANYU004-F","y": -9.13894665,"x": -77.742087505875},
  {"name": "LMJR077","y": -12.185815,"x": -76.9631351944225},
  {"name": "ANYU005-F","y": -9.14841645,"x": -77.7433146607206},
  {"name": "ANYU006-F","y": -9.14433435,"x": -77.7414750008338},
  {"name": "LMCA127","y": -12.00048,"x": -77.1086822533192},
  {"name": "CBNV039-S // CBNV039","y": -9.117679,"x": -78.5099284997834},
  {"name": "ANYU007-F","y": -9.15823895,"x": -77.7353833701324},
  {"name": "CBNV001-S // CBNV001","y": -9.11258175,"x": -78.5389018800977},
  {"name": "CBNV002-S // CBNV002","y": -9.1142853,"x": -78.5407419680949},
  {"name": "CBNV003","y": -9.11135145,"x": -78.5365184202456},
  {"name": "LMCA130","y": -12.0519235,"x": -77.1096820289625},
  {"name": "CBNV004","y": -9.11509755,"x": -78.5369342277332},
  {"name": "CBNV015","y": -9.1275397,"x": -78.530846020223},
  {"name": "CBNV017-S // CBNV017","y": -9.1299489,"x": -78.5237971394444},
  {"name": "CBNV019-S // CBNV019","y": -9.1362927,"x": -78.5206979267662},
  {"name": "CBNV020-S // CBNV020","y": -9.13365955,"x": -78.5185028974009},
  {"name": "LMCA163-F","y": -12.051885,"x": -77.0997413871732},
  {"name": "LMCA134","y": -12.045023,"x": -77.0645559281931},
  {"name": "CBNV021-S // CBNV021","y": -9.13013405,"x": -78.5205801764516},
  {"name": "LMSA074-F","y": -12.0395765,"x": -76.9544897957406},
  {"name": "CBNV022-S // CBNV022","y": -9.1306768,"x": -78.5157611526259},
  {"name": "CBNV023-S // CBNV023","y": -9.1236906,"x": -78.5271385730605},
  {"name": "CBNV030","y": -9.12461935,"x": -78.5174209076965},
  {"name": "LMCA025-S // LMCA025","y": -12.022192,"x": -77.0960906564436},
  {"name": "CBNV024-S // CBNV024","y": -9.12060085,"x": -78.5288856299298},
  {"name": "CBNV059-S //CBNV059","y": -9.129141,"x": -78.5386690318646},
  {"name": "LMCA020-S // LMCA020","y": -12.0170765,"x": -77.0903091614107},
  {"name": "CZES015-F","y": -14.7975705,"x": -71.4193670652197},
  {"name": "CZES006-F","y": -14.784837,"x": -71.3997221762638},
  {"name": "LMCA026-S // LMCA026","y": -12.023726,"x": -77.0939133295001},
  {"name": "CZES003-F","y": -14.786746,"x": -71.4168098094556},
  {"name": "LMSA070-F","y": -12.0432025,"x": -76.9725359790718},
  {"name": "LMCA019-S // LMCA019","y": -12.0158695,"x": -77.0902014037611},
  {"name": "LMCA021","y": -12.018926,"x": -77.0933570305198},
  {"name": "LMCA022","y": -12.020884,"x": -77.0930975373754},
  {"name": "LMCA115-S // LMCA115","y": -12.035687,"x": -77.0962654325513},
  {"name": "LMCA030-S // LMCA030","y": -12.0303135,"x": -77.0972534583479},
  {"name": "LMCA031-S // LMCA031","y": -12.0337425,"x": -77.0976852396373},
  {"name": "LMCA146-F","y": -12.054285,"x": -77.1245527377831},
  {"name": "LMCA147-F","y": -12.056425,"x": -77.1285729828754},
  {"name": "LMCA167-F","y": -12.041143,"x": -77.1201972194969},
  {"name": "LMCA034-S // LMCA034","y": -12.0259065,"x": -77.1006193123419},
  {"name": "LMSA076-F","y": -12.0364555,"x": -76.9574070921492},
  {"name": "LMCA035-S // LMCA035","y": -12.0235425,"x": -77.1013907530839},
  {"name": "LMCA036","y": -12.021503,"x": -77.1014047475402},
  {"name": "LMSA077-F","y": -12.0335875,"x": -76.9568262221631},
  {"name": "LMCA063","y": -12.0462405,"x": -77.106297962138},
  {"name": "LMCA064-S // LMCA064","y": -12.0435825,"x": -77.1059528596076},
  {"name": "LMCA075-S // LMCA075","y": -12.0451315,"x": -77.1141047202913},
  {"name": "LMCA122","y": -12.048667,"x": -77.0924370905795},
  {"name": "LMCA139-F","y": -12.01663,"x": -77.1021084305054},
  {"name": "LMCA076-S // LMCA076","y": -12.044179,"x": -77.1116562114286},
  {"name": "LMCA077-S // LMCA077","y": -12.043568,"x": -77.1094935629078},
  {"name": "LMCA078-S // LMCA078","y": -12.0420755,"x": -77.1136510340647},
  {"name": "LMMP111-S // LMMP111","y": -11.9954705,"x": -77.110201637931},
  {"name": "LMCA141-F","y": -12.013272,"x": -77.103816662278},
  {"name": "LMMP112","y": -11.997718,"x": -77.1090134978097},
  {"name": "LMCA178-F","y": -12.049046,"x": -77.1334099303094},
  {"name": "LMCA114-S // LMCA114","y": -12.0272275,"x": -77.0992301161442},
  {"name": "LMCA147-F","y": -12.0569835,"x": -77.1257308242187},
  {"name": "LMJR079-S // LMJR079","y": -12.187432,"x": -76.9602880368358},
  {"name": "LMCA148-F","y": -12.056466,"x": -77.1304756900383},
  {"name": "LMCA150-F","y": -12.0576685,"x": -77.1314943054356},
  {"name": "LMCA151-F","y": -12.050526,"x": -77.0972330392007},
  {"name": "LMCA152-F","y": -12.0511095,"x": -77.0940464746126},
  {"name": "LMCA157-F","y": -12.054887,"x": -77.1127873474198},
  {"name": "LMCA153-F","y": -12.051884,"x": -77.0965734337808},
  {"name": "LMCA168-F","y": -12.0413155,"x": -77.1185112160857},
  {"name": "LMCA169-F","y": -12.0415105,"x": -77.1168066420792},
  {"name": "LMCA170-F","y": -12.0440635,"x": -77.1169758245631},
  {"name": "LMCA171-F","y": -12.044004,"x": -77.1190342824123},
  {"name": "LMCA154-F","y": -12.0542605,"x": -77.1197421134833},
  {"name": "LMCA155-F","y": -12.0557645,"x": -77.1175340717822},
  {"name": "LMSA078-F","y": -12.032183,"x": -76.9575910369967},
  {"name": "LMCA159-F","y": -12.054553,"x": -77.1089842080052},
  {"name": "LMSA080-F","y": -12.0414465,"x": -76.9845049803719},
  {"name": "LMCA160-F","y": -12.0539215,"x": -77.1069296352153},
  {"name": "LMCA161-F","y": -12.052996,"x": -77.1034063789697},
  {"name": "LMCA180-F","y": -12.0502625,"x": -77.1361900414807},
  {"name": "LMCA194-F","y": -12.051353,"x": -77.1114990287734},
  {"name": "LMCA195-F","y": -12.05455,"x": -77.1140993446722},
  {"name": "LMCA181-F","y": -12.053661,"x": -77.1355910899705},
  {"name": "LMCA183-F","y": -11.9828655,"x": -77.1139893055431},
  {"name": "LMCA184-F","y": -12.0622805,"x": -77.1425798744535},
  {"name": "LMCA185-F","y": -12.06099,"x": -77.1357198560344},
  {"name": "LMCA187-F","y": -12.0537525,"x": -77.1310355405061},
  {"name": "LMCA188-F","y": -12.0525155,"x": -77.1274670979072},
  {"name": "LMLM017","y": -12.0502845,"x": -77.0612267346638},
  {"name": "LMCA191-F","y": -12.053679,"x": -77.1230042340997},
  {"name": "LMCA189-F","y": -12.0541325,"x": -77.1255889575387},
  {"name": "LMSA080-F","y": -12.040439,"x": -76.985383370007},
  {"name": "LMLM016-S // LMLM016","y": -12.056618,"x": -77.0712732476548},
  {"name": "LMLM002-S // LMLM002","y": -12.062198,"x": -77.076580673322},
  {"name": "LMLM111","y": -12.050068,"x": -77.0570820439917},
  {"name": "LMCA190-F","y": -12.056588,"x": -77.1229640708436},
  {"name": "LMLM181-F","y": -12.0470135,"x": -77.05154345198},
  {"name": "LMCA192-F","y": -12.053048,"x": -77.1212880509387},
  {"name": "LMCA193-F","y": -12.052617,"x": -77.1190608653715},
  {"name": "LMLM001","y": -12.066469,"x": -77.075778814184},
  {"name": "LMLM003-S // LMLM003","y": -12.062991,"x": -77.0725164842023},
  {"name": "LMLM182-F","y": -12.0454705,"x": -77.0483752635403},
  {"name": "LMLM004-S // LMLM004","y": -12.059924,"x": -77.0675601895419},
  {"name": "LMLM005-S // LMLM005","y": -12.0638635,"x": -77.06892290065},
  {"name": "LMLM007-S // LMLM007","y": -12.064983,"x": -77.0621020116661},
  {"name": "LMLM008-S","y": -12.064983,"x": -77.0654726393035},
  {"name": "LMLM009-S","y": -12.059757,"x": -77.0665478948063},
  {"name": "LMLM015-S // LMLM015","y": -12.055906,"x": -77.0744873682938},
  {"name": "LMLM018","y": -12.050332,"x": -77.0647796660396},
  {"name": "LMSA081-F","y": -12.0420755,"x": -76.9853262574897},
  {"name": "LMLM019-S","y": -12.0524715,"x": -77.06389427691},
  {"name": "LMLM019","y": -12.0531,"x": -77.06135456},
  {"name": "LMLM019","y": -12.052223,"x": -77.0614306117143},
  {"name": "LMLM019","y": -12.0514745,"x": -77.0667407866508},
  {"name": "LMLM020-S // LMLM020","y": -12.0550065,"x": -77.0672164644383},
  {"name": "LMLM021-S // LMLM021","y": -12.0524085,"x": -77.0754333510061},
  {"name": "LMLM022-S // LMLM022","y": -12.0572885,"x": -77.0770061903143},
  {"name": "LMSR003-F","y": -11.7876795,"x": -77.1556711575533},
  {"name": "LMLM054","y": -12.051239,"x": -77.0593558337578},
  {"name": "LMLM064-S // LMLM064","y": -12.0744995,"x": -77.033178154465},
  {"name": "LMLM065-S // LMLM065","y": -12.0769255,"x": -77.0327854368976},
  {"name": "LMLM161-S // LMLM161","y": -12.077777,"x": -77.0354578676651},
  {"name": "LMCO002","y": -11.9539325,"x": -77.0641484938295},
  {"name": "LMCO037","y": -11.903761,"x": -77.0446589795105},
  {"name": "LMLM162-S // LMLM162","y": -12.0789655,"x": -77.03485222322},
  {"name": "LMSA082-F","y": -12.041833,"x": -76.9809255335763},
  {"name": "LMLM163","y": -12.078317,"x": -77.0325031059627},
  {"name": "LMLM164","y": -12.077555,"x": -77.0302770326779},
  {"name": "LMJR082","y": -12.1641225,"x": -76.9799390506635},
  {"name": "LMCO115-S // LMCO115","y": -11.9585825,"x": -77.0597916722408},
  {"name": "LMLM165-S // LMLM165","y": -12.07589,"x": -77.030636085019},
  {"name": "LMLM166-S // LMLM166","y": -12.073925,"x": -77.0310571587505},
  {"name": "LMLM172-F","y": -12.036637,"x": -77.0760982966433},
  {"name": "LMLM173-F","y": -12.0375105,"x": -77.0755303772871},
  {"name": "LMLM174-F","y": -12.0365955,"x": -77.0740495033521},
  {"name": "LMLM175-F","y": -12.0362065,"x": -77.072290151227},
  {"name": "LMSA083-F","y": -12.0433435,"x": -76.9844579186982},
  {"name": "LMLM180-F","y": -12.0471065,"x": -77.0592595134096},
  {"name": "LMCO002","y": -11.954877,"x": -77.0637640352232},
  {"name": "LMLM223-F","y": -12.050329,"x": -77.0687485939731},
  {"name": "LMLM185-F","y": -12.0370055,"x": -77.0653651364087},
  {"name": "LMLM192-F","y": -12.041739,"x": -77.061970951556},
  {"name": "LMLM186-F","y": -12.036849,"x": -77.0636543680851},
  {"name": "LMLM187-F","y": -12.037193,"x": -77.0602858613342},
  {"name": "LMCO002","y": -11.9522855,"x": -77.0642466191555},
  {"name": "LMLM188-F","y": -12.0381735,"x": -77.0630006246967},
  {"name": "LMLM189-F","y": -12.037964,"x": -77.0591561149807},
  {"name": "LMLM190-F","y": -12.040091,"x": -77.0621030942029},
  {"name": "LMLM191-F","y": -12.041114,"x": -77.0600365686776},
  {"name": "LMLM224-F","y": -12.0526355,"x": -77.0672913842592},
  {"name": "LMMP034-S // LMMP034","y": -12.035087,"x": -77.082650711123},
  {"name": "LMLM205-F","y": -12.039145,"x": -77.0544697880682},
  {"name": "LMLM226-F","y": -12.060795,"x": -77.0732139230769},
  {"name": "LMCO002","y": -11.952422,"x": -77.0638479743154},
  {"name": "LMCO002","y": -11.952164,"x": -77.0636440820513},
  {"name": "LMLM227-F","y": -12.059762,"x": -77.071742229071},
  {"name": "LMCO009-S // LMCO009","y": -11.940879,"x": -77.0620136590879},
  {"name": "LMCO005","y": -11.947797,"x": -77.0646607505959},
  {"name": "LMCO082","y": -11.93579,"x": -77.0519800911343},
  {"name": "LMLM208-F","y": -12.0372025,"x": -77.0508016112739},
  {"name": "LMLM209-F","y": -12.033277,"x": -77.0103205667096},
  {"name": "LMCO003-S // LMCO003","y": -11.9507735,"x": -77.0630030218559},
  {"name": "LMCO014","y": -11.9317895,"x": -77.0584465648976},
  {"name": "LMLM211-F","y": -12.070125,"x": -77.0371925906219},
  {"name": "LMLM212-F","y": -12.037566,"x": -77.0785995760497},
  {"name": "LMLM213-F","y": -12.037781,"x": -77.0811726393315},
  {"name": "LMLM228-F","y": -12.0600435,"x": -77.0693273281462},
  {"name": "LAMO062-S","y": -12.083343,"x": -76.8949657366667},
  {"name": "LMCO002-S","y": -11.9536625,"x": -77.0623050142408},
  {"name": "LMCO004","y": -11.947712,"x": -77.0621134886976},
  {"name": "LMSA084-F","y": -12.0457755,"x": -76.9839784599596},
  {"name": "LAMO062","y": -12.082667,"x": -76.8993391313944},
  {"name": "LMCO011","y": -11.9372305,"x": -77.0626287493976},
  {"name": "LMCO012","y": -11.937478,"x": -77.0597303638554},
  {"name": "LMCO013","y": -11.9318655,"x": -77.0562241455793},
  {"name": "LMMP227-F","y": -12.00325,"x": -77.0917564049148},
  {"name": "LMCO015-S // LMCO015","y": -11.9278625,"x": -77.0540359559576},
  {"name": "LMCO015","y": -11.929071,"x": -77.0548508721751},
  {"name": "LMCO024-S","y": -11.918876,"x": -77.0596085072586},
  {"name": "LMCO016","y": -11.925898,"x": -77.0558234212884},
  {"name": "LMCO017","y": -11.924774,"x": -77.0535354774855},
  {"name": "LMCO018","y": -11.9207095,"x": -77.0545951167185},
  {"name": "LMCO019-S // LMCO019","y": -11.920824,"x": -77.0525378991158},
  {"name": "LMCO020","y": -11.9346605,"x": -77.0700948358713},
  {"name": "LMCO021","y": -11.9341715,"x": -77.066879160629},
  {"name": "LMCO022","y": -11.929901,"x": -77.0665617888311},
  {"name": "LMSM008-S // LMSM008","y": -12.0712245,"x": -77.0885194919974},
  {"name": "LMCO024","y": -11.916256,"x": -77.0579578354839},
  {"name": "LMCO029","y": -11.9132475,"x": -77.0564572781004},
  {"name": "LMCO030","y": -11.9146265,"x": -77.0510555537797},
  {"name": "LMCO031","y": -11.9156035,"x": -77.049622603022},
  {"name": "LMMP027-S // LMMP027","y": -12.033406,"x": -77.0733536400568},
  {"name": "LMCO032-S","y": -11.9126555,"x": -77.0489322834017},
  {"name": "LMCO032","y": -11.9132375,"x": -77.0471794508368},
  {"name": "LMCO033","y": -11.910613,"x": -77.0477062032095},
  {"name": "LMCO034-S // LMCO034","y": -11.910777,"x": -77.0514156773874},
  {"name": "LMCO035-S","y": -11.9086755,"x": -77.0530399677241},
  {"name": "LMCO083","y": -11.937423,"x": -77.0509331228336},
  {"name": "LMCO038","y": -11.901233,"x": -77.0425686152101},
  {"name": "LMCO041","y": -11.8994755,"x": -77.0473850184873},
  {"name": "LMCO076","y": -11.9310415,"x": -77.0498568953632},
  {"name": "LMCO043-S // LMCO043","y": -11.8970195,"x": -77.0450485384146},
  {"name": "LMCO044","y": -11.897396,"x": -77.0421432512755},
  {"name": "LMCO045","y": -11.899188,"x": -77.0412638147339},
  {"name": "LMCO046","y": -11.904298,"x": -77.0365925641485},
  {"name": "LMCO047","y": -11.9029295,"x": -77.0395927962995},
  {"name": "LMBY047-S // LMBY047","y": -11.896471,"x": -77.0403017536303},
  {"name": "LMCO048-S // LMCO048","y": -11.903998,"x": -77.0383739702381},
  {"name": "LMCO049-S // LMCO049","y": -11.9065585,"x": -77.0406825897861},
  {"name": "LMCO050","y": -11.906752,"x": -77.0370020861775},
  {"name": "LMCO186","y": -11.9233365,"x": -77.0429615807719},
  {"name": "LMCO051","y": -11.908443,"x": -77.0381199305056},
  {"name": "LMCO052","y": -11.9094545,"x": -77.0397359583045},
  {"name": "LMCO053-S // LMCO053","y": -11.9088905,"x": -77.0426753803444},
  {"name": "LMCO054","y": -11.912558,"x": -77.0447594801459},
  {"name": "LMCO055","y": -11.911181,"x": -77.04098328},
  {"name": "LMCO056","y": -11.9133885,"x": -77.0417711812492},
  {"name": "LAMO062","y": -12.085153,"x": -76.893540197056},
  {"name": "LMJR117-F","y": -12.1420215,"x": -76.9629663622449},
  {"name": "LMCO058-S // LMCO058","y": -11.9148605,"x": -77.0460836178848},
  {"name": "LMCO060","y": -11.91482,"x": -77.035155061379},
  {"name": "LMCO061","y": -11.915807,"x": -77.0328680371214},
  {"name": "LMCO062","y": -11.9142935,"x": -77.0300631524548},
  {"name": "LMCO185","y": -11.9262205,"x": -77.0440112970738},
  {"name": "LMCO073","y": -11.9275775,"x": -77.0502657440903},
  {"name": "LMSA086-F","y": -12.047208,"x": -76.98218137751},
  {"name": "LMCO088","y": -11.939854,"x": -77.0466854729604},
  {"name": "LMCO088","y": -11.9382085,"x": -77.0465079914773},
  {"name": "LMCO074-S // LMCO074","y": -11.929258,"x": -77.0477944477131},
  {"name": "LMCO075","y": -11.929734,"x": -77.0519672238786},
  {"name": "LMCO077-S","y": -11.9316435,"x": -77.0465127034091},
  {"name": "LMCO078","y": -11.931775,"x": -77.0519193992442},
  {"name": "LMCO185","y": -11.9251865,"x": -77.0431088486172},
  {"name": "LMCO079","y": -11.933716,"x": -77.0509902},
  {"name": "LMCO080","y": -11.934399,"x": -77.0488309422528},
  {"name": "LMCO081","y": -11.933917,"x": -77.0537844333333},
  {"name": "LMCO088","y": -11.9376335,"x": -77.0459344638212},
  {"name": "LMCO186","y": -11.923805,"x": -77.0436000221402},
  {"name": "LMCO103","y": -11.945902,"x": -77.0523637528271},
  {"name": "LMCO086","y": -11.939936,"x": -77.052213405473},
  {"name": "LMCO088-S // LMCO088","y": -11.938709,"x": -77.0460545421008},
  {"name": "LMCO088","y": -11.938038,"x": -77.0464432072307},
  {"name": "LMCO088","y": -11.940039,"x": -77.0459681853493},
  {"name": "LMCO088","y": -11.9378115,"x": -77.0460297662447},
  {"name": "LMCO088","y": -11.9399175,"x": -77.0471237834067},
  {"name": "LMJR118-F","y": -12.141499,"x": -76.9650180299862},
  {"name": "LMCO105","y": -11.948408,"x": -77.0533426868939},
  {"name": "LMCO247-F","y": -11.8996725,"x": -77.0490803905479},
  {"name": "LMCO087","y": -11.939082,"x": -77.048170422261},
  {"name": "LMAT106-F","y": -12.018908,"x": -76.8872744678362},
  {"name": "LMCO089","y": -11.9429795,"x": -77.0418220311077},
  {"name": "LMCO091-S // LMCO091","y": -11.938654,"x": -77.0435936276614},
  {"name": "LMCO092","y": -11.93491,"x": -77.0450942849462},
  {"name": "LMCO093","y": -11.935088,"x": -77.0411385776119},
  {"name": "LMCO102","y": -11.943469,"x": -77.0524032140231},
  {"name": "LMCO095-S // LMCO095","y": -11.940133,"x": -77.0412715641422},
  {"name": "LMCO096","y": -11.942381,"x": -77.0356033776291},
  {"name": "LMCO097-S","y": -11.94502,"x": -77.0338520117838},
  {"name": "LMCO098","y": -11.940631,"x": -77.0555634932716},
  {"name": "LMCO098","y": -11.939389,"x": -77.0577240742956},
  {"name": "LMCO120","y": -11.9627525,"x": -77.0613286832151},
  {"name": "LMCO099","y": -11.9419825,"x": -77.0581190048544},
  {"name": "LMCO100","y": -11.9419265,"x": -77.0546807797755},
  {"name": "LMCO101","y": -11.9444485,"x": -77.055707233463},
  {"name": "LMCO106","y": -11.950661,"x": -77.0535560647737},
  {"name": "LMCO109-S","y": -11.9495085,"x": -77.0588967802067},
  {"name": "LMCO110-S // LMCO110","y": -11.9541155,"x": -77.0585042314904},
  {"name": "LMCO111-S // LMCO111","y": -11.9535205,"x": -77.0553912196298},
  {"name": "LMCO112","y": -11.9543695,"x": -77.0538873144411},
  {"name": "LAMO062","y": -12.081746,"x": -76.8933127420823},
  {"name": "LMCO114-S // LMCO114","y": -11.957644,"x": -77.0567164292989},
  {"name": "LMCO116-S // LMCO116","y": -11.96049,"x": -77.0578270572103},
  {"name": "LAMO063-S","y": -12.0877415,"x": -76.9253443838298},
  {"name": "LMCO123-S // LMCO123","y": -11.96902,"x": -77.0590153063352},
  {"name": "LMCO185","y": -11.925865,"x": -77.0431758946886},
  {"name": "LMCO124","y": -11.972483,"x": -77.059014877898},
  {"name": "LMCO225-F","y": -11.9116055,"x": -77.0239903026377},
  {"name": "LMCO126-S","y": -11.952441,"x": -77.049720972438},
  {"name": "LMCO126","y": -11.951211,"x": -77.0477803212512},
  {"name": "LMCO126","y": -11.951023,"x": -77.0476727381416},
  {"name": "LMCO127","y": -11.944043,"x": -77.0369468931156},
  {"name": "LMAT025","y": -12.0396345,"x": -76.9353190212766},
  {"name": "LMCO185","y": -11.925353,"x": -77.043772783881},
  {"name": "LMCO128-S // LMCO128","y": -11.954902,"x": -77.0468559014575},
  {"name": "LMCO129-S // LMCO129","y": -11.9557995,"x": -77.0446198246769},
  {"name": "LAMO063","y": -12.0877545,"x": -76.9232659308511},
  {"name": "LMCO189","y": -11.9361675,"x": -77.0469777941622},
  {"name": "LMCO130-S // LMCO130","y": -11.956374,"x": -77.0416166680794},
  {"name": "LMCO185","y": -11.9262615,"x": -77.0468685},
  {"name": "LMCO131-S // LMCO131","y": -11.959956,"x": -77.0421246325215},
  {"name": "LMSA087-F","y": -12.0496715,"x": -76.9802096845623},
  {"name": "LMCO132-S // LMCO132","y": -11.9600955,"x": -77.0455376370608},
  {"name": "LMSA088-F","y": -12.0538,"x": -76.9830545407515},
  {"name": "LMCO135-S // LMCO135","y": -11.957035,"x": -77.0514637050446},
  {"name": "LMLO024-S // LMLO024","y": -11.995944,"x": -77.0743833312629},
  {"name": "LMLO051","y": -11.979283,"x": -77.0700450715935},
  {"name": "LMCO190","y": -11.937968,"x": -77.0409080072142},
  {"name": "LMCO191-F","y": -11.900264,"x": -77.044441404908},
  {"name": "LMCO136-S // LMCO136","y": -11.9604665,"x": -77.0525401919367},
  {"name": "LMCO137-S // LMCO137","y": -11.96534,"x": -77.0545788856239},
  {"name": "LMCO138-S // LMCO138","y": -11.95386,"x": -77.0485072981952},
  {"name": "LMCO139-S // LMCO139","y": -11.9433425,"x": -77.039196522},
  {"name": "LMCO140-S // LMCO140","y": -11.956636,"x": -77.0382497693989},
  {"name": "LMCO142-S // LMCO142","y": -11.96005,"x": -77.0405716657762},
  {"name": "LMCO192-F","y": -11.935444,"x": -77.0616206846742},
  {"name": "LMCO143-S // LMCO143","y": -11.9429735,"x": -77.0488027775813},
  {"name": "LMCO188","y": -11.919069,"x": -77.0397135813953},
  {"name": "LMCO244-F","y": -11.899592,"x": -77.0558959166105},
  {"name": "LMCO195-F","y": -11.946247,"x": -77.0677979322012},
  {"name": "LMCO154","y": -11.9267505,"x": -77.0409896262626},
  {"name": "LMCO157","y": -11.9228065,"x": -77.0409593300258},
  {"name": "LMCO160","y": -11.9212695,"x": -77.0357649978179},
  {"name": "LMCO186-S","y": -11.922039,"x": -77.0442296338698},
  {"name": "LMCO186","y": -11.9246105,"x": -77.0431752522989},
  {"name": "LMCO193-F","y": -11.942097,"x": -77.0693161134635},
  {"name": "LMCO161","y": -11.9173345,"x": -77.0360673658189},
  {"name": "LMCO184","y": -11.928095,"x": -77.0453497307692},
  {"name": "LMCO185-S","y": -11.9251475,"x": -77.0454020632147},
  {"name": "LMJR120-F","y": -12.1375735,"x": -76.9668679044779},
  {"name": "LMCO185","y": -11.924751,"x": -77.0427558309927},
  {"name": "LMCO185","y": -11.92577,"x": -77.0440108425076},
  {"name": "LMCO196-F","y": -11.9485885,"x": -77.0687988978591},
  {"name": "LMCO197-F","y": -11.9505785,"x": -77.0676756245626},
  {"name": "LMCO206-F","y": -11.9052835,"x": -77.045604605214},
  {"name": "LMCO216-F","y": -11.911619,"x": -77.0055233052342},
  {"name": "LMCO217-F","y": -11.9119855,"x": -77.0090058702119},
  {"name": "LMCO218-F","y": -11.9151055,"x": -77.0118230855429},
  {"name": "LMCO245-F","y": -11.9009535,"x": -77.0535119253012},
  {"name": "LMCO219-F","y": -11.9103325,"x": -77.0138654405364},
  {"name": "LMCO220-F","y": -11.912529,"x": -77.016251930359},
  {"name": "LMCO221-F","y": -11.9147125,"x": -77.0160736832604},
  {"name": "LMAT113-F","y": -12.025287,"x": -76.9155879873922},
  {"name": "LMCO222-F","y": -11.9097955,"x": -77.0199905956829},
  {"name": "LMCO223-F","y": -11.912037,"x": -77.0202578111287},
  {"name": "LMIN042-F","y": -12.0075059,"x": -77.051860226874},
  {"name": "LMCO224-F","y": -11.9141325,"x": -77.0222376194774},
  {"name": "LMIN034-S // LMIN034","y": -11.974008,"x": -77.0506854763776},
  {"name": "LMCO226-F","y": -11.9148735,"x": -77.0261394499274},
  {"name": "LMCO227-F","y": -11.92258,"x": -77.0221398198563},
  {"name": "LMCO228-F","y": -11.919748,"x": -77.027724273711},
  {"name": "LMCO243-F","y": -11.901347,"x": -77.0576877715354},
  {"name": "LMCO229-F","y": -11.9176755,"x": -77.0264897452663},
  {"name": "LMCO230-F","y": -11.9126935,"x": -77.0292652661494},
  {"name": "LMCO249-F","y": -11.894316,"x": -77.0485950413067},
  {"name": "LMCO250-F","y": -11.9709135,"x": -77.0564022525713},
  {"name": "LMCO231-F","y": -11.910188,"x": -77.0332551873503},
  {"name": "LMCO232-F","y": -11.9180725,"x": -77.0305753802763},
  {"name": "LMCO241-F","y": -11.904182,"x": -77.0592236521976},
  {"name": "LMCO242-F","y": -11.904298,"x": -77.0552706025641},
  {"name": "LMIN001","y": -11.984696,"x": -77.0599194430838},
  {"name": "LMIN002","y": -11.9826115,"x": -77.0613673869822},
  {"name": "LMIN004-S // LMIN004","y": -11.992879,"x": -77.0530436133361},
  {"name": "LMIN005-S // LMIN005","y": -11.995037,"x": -77.053546911215},
  {"name": "LMIN006","y": -12.003041,"x": -77.0597140363057},
  {"name": "LMIN019-S // LMIN019","y": -11.9819405,"x": -77.0570917253268},
  {"name": "LMIN007-S // LMIN007","y": -12.0018895,"x": -77.0563650796095},
  {"name": "LMIN008","y": -12.005075,"x": -77.053137967775},
  {"name": "LMMP074","y": -11.997602,"x": -77.0862344982337},
  {"name": "LMIN010-S // LMIN010","y": -12.004734,"x": -77.0517928686377},
  {"name": "LMSA089-F","y": -12.0419305,"x": -76.972374802564},
  {"name": "LMIN011-S // LMIN011","y": -12.000135,"x": -77.0535094209115},
  {"name": "LMMP039-S // LMMP039","y": -12.029591,"x": -77.0870142781351},
  {"name": "LMIN020-S // LMIN020","y": -11.981015,"x": -77.0531081699258},
  {"name": "LMLO081","y": -11.95976,"x": -77.0780523328792},
  {"name": "LMLO014","y": -12.002191,"x": -77.0655511044776},
  {"name": "LMIN012-S // LMIN012","y": -11.9989935,"x": -77.0509317092679},
  {"name": "LMIN013-S // LMIN013","y": -11.999752,"x": -77.0489500415163},
  {"name": "LMIN029","y": -11.9760955,"x": -77.0491798399129},
  {"name": "LMIN016-S // LMIN016","y": -11.9917739,"x": -77.0505195380058},
  {"name": "LMLO082","y": -11.9610955,"x": -77.0745011691593},
  {"name": "LMIN017-S // LMIN017","y": -11.9828065,"x": -77.0471719764922},
  {"name": "LMIN018-S // LMIN018","y": -11.98495495,"x": -77.0560965227069},
  {"name": "LMIN021-S // LMIN021","y": -11.979324,"x": -77.048115111492},
  {"name": "LMIN022","y": -11.980375,"x": -77.0406381074499},
  {"name": "LMIN027-S // LMIN027","y": -11.9784605,"x": -77.0567620049458},
  {"name": "LAMO063","y": -12.0882135,"x": -76.9279049346028},
  {"name": "LMIN033","y": -11.967263,"x": -77.0384106674464},
  {"name": "LMIN024-S // LMIN024","y": -11.977439,"x": -77.0380658004714},
  {"name": "LMIN025","y": -11.9924525,"x": -77.0555719562247},
  {"name": "LMIN026-S // LMIN026","y": -11.9806295,"x": -77.0460514610444},
  {"name": "LMIN028-S // LMIN028","y": -11.9758275,"x": -77.0524985650206},
  {"name": "LMSC118","y": -12.081261,"x": -76.959824200565},
  {"name": "LMIN030-S // LMIN030","y": -11.973359,"x": -77.0482570717773},
  {"name": "LMIN032-S // LMIN032","y": -11.9708045,"x": -77.0435551092544},
  {"name": "LMIN035","y": -11.9867405,"x": -77.0529555553592},
  {"name": "LMLO044","y": -11.982823,"x": -77.0739178583411},
  {"name": "LMIN036-S // LMIN036","y": -11.9876085,"x": -77.0624483386076},
  {"name": "LMLO018-S // LMLO018","y": -11.995853,"x": -77.0704319998052},
  {"name": "ZONA SATURADA","y": -11.9927275,"x": -77.0708575857843},
  {"name": "LAMO064-S // LAMO064","y": -12.0773325,"x": -76.9070127153385},
  {"name": "LMIN043-F","y": -12.00993,"x": -77.0516320191973},
  {"name": "LMIN044-F","y": -11.9766065,"x": -77.0547695283957},
  {"name": "LMIN045-F","y": -11.982912,"x": -77.0640113115016},
  {"name": "LMLO023-S // LMLO023","y": -11.996694,"x": -77.0782585179967},
  {"name": "LMCO251-F","y": -11.9753315,"x": -77.0578725049478},
  {"name": "LMLO001-S // LMLO001","y": -12.0068025,"x": -77.0637627221735},
  {"name": "LMLO021","y": -12.000459,"x": -77.0816980055848},
  {"name": "LMLO002-S // LMLO002","y": -12.0077025,"x": -77.0660242461954},
  {"name": "LMLO003-S // LMLO003","y": -12.0082565,"x": -77.070186492959},
  {"name": "LMLO019-S // LMLO019","y": -11.999366,"x": -77.0744063528431},
  {"name": "LMLO083","y": -11.9614395,"x": -77.0706525035422},
  {"name": "LMLO004-S // LMLO004","y": -12.007851,"x": -77.0734726320634},
  {"name": "LMLO005-S // LMLO005","y": -12.010253,"x": -77.0721372468914},
  {"name": "LMLO006-S // LMLO006","y": -12.0080585,"x": -77.0770961005156},
  {"name": "LMLO007","y": -12.010437,"x": -77.0754790184158},
  {"name": "LMLO008","y": -12.01109,"x": -77.0792710385005},
  {"name": "LMLO009-S // LMLO009","y": -12.008659,"x": -77.0803350917655},
  {"name": "LMLO074-S // LMLO074","y": -11.966806,"x": -77.0725785680836},
  {"name": "LMLO010-S // LMLO010","y": -12.004264,"x": -77.0811931066199},
  {"name": "LMLO022-S // LMLO022","y": -11.996733,"x": -77.082229337865},
  {"name": "LMLO011-S // LMLO011","y": -12.0048155,"x": -77.0772615302006},
  {"name": "LMLO012","y": -12.002985,"x": -77.0724963260255},
  {"name": "LMLO013","y": -12.001691,"x": -77.0686816405694},
  {"name": "LMLV089-F","y": -12.0648225,"x": -77.027034069407},
  {"name": "LMLO015-S // LMLO015","y": -12.0027035,"x": -77.0632888709677},
  {"name": "LMLO016","y": -11.9987415,"x": -77.0640338152968},
  {"name": "LMLO017-S // LMLO017","y": -11.995317,"x": -77.065759456213},
  {"name": "LMLO025-S // LMLO025","y": -11.9938895,"x": -77.0818754539275},
  {"name": "LMLO026-S","y": -11.9936005,"x": -77.0788080779084},
  {"name": "LMLO027-S // LMLO027","y": -11.99319,"x": -77.0760881054322},
  {"name": "LMLO080","y": -11.958079,"x": -77.0808364347291},
  {"name": "LMLO037","y": -11.984743,"x": -77.0773774511212},
  {"name": "LMLO028-S // LMLO028","y": -11.9929005,"x": -77.0728461922761},
  {"name": "LAMO066-S // LAMO066","y": -12.076832,"x": -76.916359696818},
  {"name": "LMLO029","y": -11.992735,"x": -77.06854154549},
  {"name": "LMJM043-F","y": -12.073585,"x": -77.0439215379254},
  {"name": "LMLO030","y": -11.9917895,"x": -77.0656420002488},
  {"name": "LMLO064","y": -11.9729445,"x": -77.0684657662214},
  {"name": "LMLO031-S // LMLO031","y": -11.988482,"x": -77.0665863581081},
  {"name": "LMLO032-S // LMLO032","y": -11.98957,"x": -77.070001034135},
  {"name": "LMLO033-S // LMLO033","y": -11.990549,"x": -77.0741122200945},
  {"name": "LMLO038-S // LMLO038","y": -11.986696,"x": -77.074515827532},
  {"name": "LMLO039","y": -11.9849355,"x": -77.0727144461482},
  {"name": "LMLO065","y": -11.9698815,"x": -77.0689644284979},
  {"name": "LMLO040","y": -11.986098,"x": -77.0711690291559},
  {"name": "LMLO041-S // LMLO041","y": -11.9857895,"x": -77.0672871957682},
  {"name": "LMLO034-S // LMLO034","y": -11.988648,"x": -77.0748438224122},
  {"name": "LMLO035","y": -11.99024,"x": -77.078100509806},
  {"name": "LMLO036","y": -11.987693,"x": -77.0787855137931},
  {"name": "LMLO094-S // LMLO094","y": -11.9503195,"x": -77.0784860954199},
  {"name": "LMLO045-S // LMLO045","y": -11.9822265,"x": -77.0767731133965},
  {"name": "LMLO046","y": -11.9818,"x": -77.079900478036},
  {"name": "LMLO047-S // LMLO047","y": -11.9806875,"x": -77.0833750681818},
  {"name": "LMLO048-A","y": -11.9784165,"x": -77.0820501404282},
  {"name": "LMLO048-B","y": -11.9788775,"x": -77.0787125276287},
  {"name": "LMLO054-S // LMLO054","y": -11.975253,"x": -77.074499303286},
  {"name": "LMLO070","y": -11.9672375,"x": -77.0768573300453},
  {"name": "LMLO071","y": -11.9638955,"x": -77.0819942895022},
  {"name": "LMLO057","y": -11.974558,"x": -77.0848654538087},
  {"name": "LMLO058","y": -11.9728455,"x": -77.0837698170624},
  {"name": "LMLO060-S // LMLO060","y": -11.971835,"x": -77.0800979635941},
  {"name": "LMLO061-S // LMLO061","y": -11.9727575,"x": -77.0777720472904},
  {"name": "LMLO062","y": -11.9729535,"x": -77.0744629650373},
  {"name": "LMLO063-S // LMLO063","y": -11.972968,"x": -77.0712870465515},
  {"name": "LMJM003","y": -12.0843685,"x": -77.0585444632702},
  {"name": "LMLO066","y": -11.969422,"x": -77.0712831412429},
  {"name": "LMLO067-S // LMLO067","y": -11.97008,"x": -77.0738670267629},
  {"name": "LMLO068-S // LMLO068","y": -11.9700475,"x": -77.0776678407833},
  {"name": "LMLO069","y": -11.967728,"x": -77.0813524643607},
  {"name": "LMLO075","y": -11.9647105,"x": -77.0703161133292},
  {"name": "LMLO077","y": -11.961931,"x": -77.0788867880278},
  {"name": "LMLO078","y": -11.96061,"x": -77.0822449487028},
  {"name": "LMLO079","y": -11.956818,"x": -77.083141138078},
  {"name": "ICNZ014-F","y": -14.829458,"x": -74.9452266070437},
  {"name": "LMLO095-S // LMLO095","y": -11.950805,"x": -77.0819201021449},
  {"name": "LMLO096-S // LMLO096","y": -11.9524565,"x": -77.0841933468333},
  {"name": "LMLO097-S // LMLO097","y": -11.948116,"x": -77.0845003465633},
  {"name": "LMLO098-S // LMLO098","y": -11.947844,"x": -77.0819863886699},
  {"name": "LMLO092-S // LMLO092","y": -11.948133,"x": -77.0722794751639},
  {"name": "LMMP038","y": -12.031542,"x": -77.0878295227887},
  {"name": "LMLO093-S // LMLO093","y": -11.948231,"x": -77.075386916171},
  {"name": "LMLO085","y": -11.957339,"x": -77.0745359067333},
  {"name": "LMLO099-S // LMLO099","y": -11.945303,"x": -77.0792760571672},
  {"name": "LMLO100-S // LMLO100","y": -11.945054,"x": -77.075680274988},
  {"name": "LMLO101","y": -11.945053,"x": -77.0725296224924},
  {"name": "LMLO102","y": -11.940019,"x": -77.0731597895262},
  {"name": "LMLO122-F","y": -11.9504595,"x": -77.0749965240016},
  {"name": "LMLO103-S // LMLO103","y": -11.9408225,"x": -77.0762774634061},
  {"name": "LMLO084-S // LMLO084","y": -11.956832,"x": -77.0713402528757},
  {"name": "LMLO086","y": -11.957079,"x": -77.0775212884791},
  {"name": "LMLO088-S // LMLO088","y": -11.9542455,"x": -77.0820345621019},
  {"name": "LMLO089-S // LMLO089","y": -11.9535855,"x": -77.0779803529021},
  {"name": "LMLO123-F","y": -11.9246045,"x": -77.0748734927952},
  {"name": "LMLO091-S // LMLO091","y": -11.95271,"x": -77.071956737892},
  {"name": "LMLO104","y": -11.943138,"x": -77.0826023616735},
  {"name": "LMLO105-S // LMLO105","y": -11.939744,"x": -77.0808311556604},
  {"name": "LMLO106-S // LMLO106","y": -11.937463,"x": -77.0765254633547},
  {"name": "LMSC064-S // LMSC064","y": -12.128001,"x": -76.9781439348958},
  {"name": "LMLO107-S // LMLO107","y": -11.9352655,"x": -77.078962902089},
  {"name": "LMLO108-S // LMLO108","y": -11.935122,"x": -77.073869948919},
  {"name": "LMLO109-S // LMLO109","y": -11.9326515,"x": -77.076324963568},
  {"name": "LMPP029-F","y": -11.935197,"x": -77.0851353027983},
  {"name": "LMLO110-S // LMLO110","y": -11.9308215,"x": -77.0778002768041},
  {"name": "LMLO111","y": -11.9263675,"x": -77.0748220252712},
  {"name": "LMLO114-S // LMLO114","y": -11.965939,"x": -77.0664456074576},
  {"name": "LMLO115","y": -11.951729,"x": -77.0727009879121},
  {"name": "LMLO119-F","y": -11.979188,"x": -77.0761405954811},
  {"name": "LMLO120-F","y": -11.9655005,"x": -77.0756961351068},
  {"name": "LMLO121-F","y": -11.952941,"x": -77.0750717404678},
  {"name": "LMLO124-F","y": -11.921181,"x": -77.07436880145},
  {"name": "LMPP030-F","y": -11.89122,"x": -77.0725622192429},
  {"name": "LMLO125-F","y": -11.9803895,"x": -77.0744252315463},
  {"name": "LMPP033-F","y": -11.87363975,"x": -77.063828551588},
  {"name": "LMSA090-F","y": -12.049625,"x": -76.9674088465958},
  {"name": "LMLO127-F","y": -11.978281,"x": -77.0853759822623},
  {"name": "LMLO128-F","y": -11.9706205,"x": -77.0840677882543},
  {"name": "LMPP004-S // LMPP004","y": -11.8680503,"x": -77.0785070664685},
  {"name": "LMPP001-S // LMPP001","y": -11.8568339,"x": -77.0860381307923},
  {"name": "LMPP006-S // LMPP006","y": -11.8709777,"x": -77.0748111677316},
  {"name": "LMPP002-S // LMPP002","y": -11.862448,"x": -77.0824688547518},
  {"name": "LMPP003-S // LMPP003","y": -11.8627,"x": -77.0787632401707},
  {"name": "LMPP031-F","y": -11.87765185,"x": -77.0757755788012},
  {"name": "LMMP072","y": -12.005203,"x": -77.0840308689506},
  {"name": "LMMP215-F","y": -12.0270775,"x": -77.0482630531915},
  {"name": "LMPP005-S // LMPP005","y": -11.86673815,"x": -77.0745887200107},
  {"name": "LMSA091-F","y": -12.0420985,"x": -76.9645099843226},
  {"name": "LMPP007-S // LMPP007","y": -11.8704537,"x": -77.0894795847358},
  {"name": "LMPP008-S // LMPP008","y": -11.8749395,"x": -77.0890118394124},
  {"name": "LMPP032-F","y": -11.8823855,"x": -77.0751552995556},
  {"name": "LMMP126-S // LMMP126","y": -11.98388,"x": -77.090121602477},
  {"name": "LMPP042-F","y": -11.846816,"x": -77.1036615433769},
  {"name": "LMPP009-S // LMPP009","y": -11.873642,"x": -77.0843031857387},
  {"name": "LMPP010-S // LMPP010","y": -11.88011105,"x": -77.0717787550167},
  {"name": "LMPP011-S // LMPP011","y": -11.883768,"x": -77.0731461103347},
  {"name": "LMPP021-F","y": -11.917165,"x": -77.0752294447791},
  {"name": "LMPP022-F","y": -11.920488,"x": -77.0770887062669},
  {"name": "LMMP141-S // LMMP141","y": -11.9922265,"x": -77.0908709143494},
  {"name": "LMMP145","y": -11.995032,"x": -77.0915790533635},
  {"name": "LMLV108-F","y": -12.0681445,"x": -77.0129330965625},
  {"name": "LMMP166","y": -11.991332,"x": -77.0994533740699},
  {"name": "LMJM003","y": -12.0825825,"x": -77.0559736829772},
  {"name": "LMPP012","y": -11.8842002,"x": -77.0705242200702},
  {"name": "LMPP013-S // LMPP013","y": -11.92423,"x": -77.0797196618568},
  {"name": "LMPP014-S // LMPP014","y": -11.927657,"x": -77.0790548517359},
  {"name": "LMSA092-F","y": -12.041423,"x": -76.9618843181818},
  {"name": "LMPP015","y": -11.864737,"x": -77.0795079602593},
  {"name": "LMJM003","y": -12.084477,"x": -77.0578067977717},
  {"name": "LMPP023-F","y": -11.9238335,"x": -77.0816830901992},
  {"name": "LMPP024-F","y": -11.923585,"x": -77.0845851028047},
  {"name": "LMPP024-F","y": -11.921863,"x": -77.0828382670079},
  {"name": "LMPP025-F","y": -11.925218,"x": -77.0854610896086},
  {"name": "LMPP026-F","y": -11.9315075,"x": -77.0828812453557},
  {"name": "LMPP027-F","y": -11.931893,"x": -77.0819841972375},
  {"name": "LMPP028-F","y": -11.9318315,"x": -77.0849930513299},
  {"name": "LMPP034-F","y": -11.8758939,"x": -77.0643429263011},
  {"name": "LMJM003","y": -12.083597,"x": -77.0570354838257},
  {"name": "LMJM003","y": -12.083324,"x": -77.0559425271544},
  {"name": "LAMO067-S // LAMO067","y": -12.0789445,"x": -76.9147683907888},
  {"name": "LMPP036-F","y": -11.883261,"x": -77.064915972624},
  {"name": "LMPP056-F","y": -11.8579715,"x": -77.0736484150323},
  {"name": "LMPP037-F","y": -11.886432,"x": -77.0650075768418},
  {"name": "LMPP038-F","y": -11.8895624,"x": -77.0651646276091},
  {"name": "LMPP063-F","y": -11.8310635,"x": -77.1077018483886},
  {"name": "LMPP039-F","y": -11.89176745,"x": -77.0666863564524},
  {"name": "LMPP040-F","y": -11.8405405,"x": -77.1102566734717},
  {"name": "LMPP048-F","y": -11.8508535,"x": -77.0837306748081},
  {"name": "LMMP154","y": -11.959407,"x": -77.0869302510351},
  {"name": "LMMP157-S // LMMP157","y": -11.9991415,"x": -77.1042256661009},
  {"name": "LMPP041-F","y": -11.8432395,"x": -77.1056120180677},
  {"name": "LMMP158","y": -11.99829,"x": -77.1023885763397},
  {"name": "LMPP043-F","y": -11.846966,"x": -77.1070239905696},
  {"name": "LMPP044-F","y": -11.8472335,"x": -77.0996538180336},
  {"name": "LMPP045-F","y": -11.848841,"x": -77.0956440019078},
  {"name": "LMSA093-F","y": -12.044286,"x": -76.9595180810352},
  {"name": "LMPP057-F","y": -11.85877,"x": -77.0762092330979},
  {"name": "LMPP046-F","y": -11.8500125,"x": -77.0985521527788},
  {"name": "LMPP047-F","y": -11.85294,"x": -77.0856660322426},
  {"name": "LMPP049-F","y": -11.848569,"x": -77.0816734934593},
  {"name": "LMMP224-F","y": -12.000412,"x": -77.0899299927925},
  {"name": "LMLC062-F","y": -12.087316,"x": -77.0281936550513},
  {"name": "LMPP050-F","y": -11.849442,"x": -77.0789542612374},
  {"name": "LMSR002-F","y": -11.7847565,"x": -77.157215647554},
  {"name": "LMPP055-F","y": -11.858132,"x": -77.0788829745098},
  {"name": "LMSA094-F","y": -12.0472085,"x": -76.9618886301294},
  {"name": "LMPP051-F","y": -11.853481,"x": -77.0821202076412},
  {"name": "LMPP052-F","y": -11.856192,"x": -77.0810573214286},
  {"name": "LMPP066-F","y": -11.88782595,"x": -77.074080778492},
  {"name": "LMPP054-F","y": -11.85464,"x": -77.0755571801567},
  {"name": "LMPP058-F","y": -11.82332315,"x": -77.1217699286448},
  {"name": "LMPP059-F","y": -11.827888,"x": -77.1181627350951},
  {"name": "LMSA095-F","y": -12.0478735,"x": -76.9589952298701},
  {"name": "LMPP060-F","y": -11.8305976,"x": -77.1137660478495},
  {"name": "LMPP061-F","y": -11.83364,"x": -77.1102787708212},
  {"name": "LMMP039-S // LMMP039","y": -12.030176,"x": -77.0845040502849},
  {"name": "LMPP062-F","y": -11.834246,"x": -77.1065459977935},
  {"name": "LMPP064-F","y": -11.829485,"x": -77.1050531229297},
  {"name": "LMPP065-F","y": -11.887593,"x": -77.0711981082271},
  {"name": "LMMP025-S // LMMP025","y": -12.032957,"x": -77.0700276445993},
  {"name": "LMPP067-F","y": -11.878051,"x": -77.0616591223776},
  {"name": "LMSA097-F","y": -12.0419695,"x": -76.9512222818539},
  {"name": "LMPP068-F","y": -11.880333,"x": -77.0635314897226},
  {"name": "LMMP024-S // LMMP024","y": -12.030825,"x": -77.0682115897438},
  {"name": "LMPP069-F","y": -11.87860195,"x": -77.0667601969146},
  {"name": "LMPP070-F","y": -11.8724411,"x": -77.0718390142797},
  {"name": "LMPP071-F","y": -11.8753499,"x": -77.075230903343},
  {"name": "LMSR004-F","y": -11.798034,"x": -77.1757540686977},
  {"name": "LMSC119-S // LMSC119","y": -12.0882015,"x": -76.9635983407578},
  {"name": "LMMP005-S // LMMP005","y": -12.0134095,"x": -77.055108800156},
  {"name": "LMMP026-S // LMMP026","y": -12.0302665,"x": -77.0708955564759},
  {"name": "LMSR005-F","y": -11.801311,"x": -77.17586123081},
  {"name": "LMMP028-S // LMMP028","y": -12.0334865,"x": -77.0764700637155},
  {"name": "LMAN006-F","y": -11.781922,"x": -77.1602944770642},
  {"name": "LMMP001-S // LMMP001","y": -12.008733,"x": -77.0556182575472},
  {"name": "LMMP002-S // LMMP002","y": -12.010576,"x": -77.055039557019},
  {"name": "LMMP003-S","y": -12.0103295,"x": -77.0588638212078},
  {"name": "LMMP004-S // LMMP004","y": -12.0133955,"x": -77.0584805438999},
  {"name": "LMMP159-S // LMMP159","y": -11.9927395,"x": -77.1072757741891},
  {"name": "LMMP006-S // LMMP006","y": -12.0162435,"x": -77.0584006480673},
  {"name": "LMMP007-S // LMMP007","y": -12.0152335,"x": -77.0537378695896},
  {"name": "LMMP008-S // LMMP008","y": -12.0182645,"x": -77.0571199114455},
  {"name": "LMMP010-S // LMMP010","y": -12.0171425,"x": -77.0531483415936},
  {"name": "LMMP011","y": -12.0211485,"x": -77.0523442602292},
  {"name": "LMMP012-S // LMMP012","y": -12.023125,"x": -77.0532189567039},
  {"name": "LMMP013-S // LMMP013","y": -12.0248555,"x": -77.0550113692755},
  {"name": "LMMP021-S // LMMP021","y": -12.0334955,"x": -77.0635196973581},
  {"name": "LMMP030-S // LMMP030","y": -12.030179,"x": -77.07912275},
  {"name": "LMMP022-S // LMMP022","y": -12.0309145,"x": -77.0650114945608},
  {"name": "LMMP023","y": -12.033316,"x": -77.0657264339329},
  {"name": "LMMP014-S // LMMP014","y": -12.026282,"x": -77.050265705325},
  {"name": "LMMP030-S // LMMP030","y": -12.0303825,"x": -77.0782458455036},
  {"name": "LMMP015-S // LMMP015","y": -12.026849,"x": -77.0528100962644},
  {"name": "LMMP017-S // LMMP017","y": -12.029546,"x": -77.05577334235},
  {"name": "LMMP018-S // LMMP018","y": -12.031716,"x": -77.0592464253196},
  {"name": "LMMP019","y": -12.0340595,"x": -77.060477673509},
  {"name": "LMMP020-S // LMMP020","y": -12.031387,"x": -77.0618032646171},
  {"name": "LMMP031-S // LMMP031","y": -12.0337845,"x": -77.0797952513162},
  {"name": "LMMP032-S // LMMP032","y": -12.029837,"x": -77.0812931143045},
  {"name": "LMMP121-S // LMMP121","y": -11.976218,"x": -77.086602111332},
  {"name": "LMCA032-S // LMCA032","y": -12.036222,"x": -77.0930653914122},
  {"name": "LMMP033-S // LMMP033","y": -12.032489,"x": -77.08236835734},
  {"name": "LMMP036","y": -12.035835,"x": -77.0888744769126},
  {"name": "LMMP059-S // LMMP059","y": -12.0208575,"x": -77.0775202868699},
  {"name": "LMMP037","y": -12.0335735,"x": -77.0886501592919},
  {"name": "LMMP040-S // LMMP040","y": -12.0337425,"x": -77.0912158125374},
  {"name": "LMMP041-S // LMMP041","y": -12.0330525,"x": -77.0942666636467},
  {"name": "LMMP042-S // LMMP042","y": -12.0313855,"x": -77.090719378928},
  {"name": "LMMP116-S // LMMP116","y": -11.9454495,"x": -77.0895548955098},
  {"name": "LMSA098-F","y": -12.045092,"x": -76.9480094331812},
  {"name": "LMMP044-S // LMMP044","y": -12.0266145,"x": -77.0911957118531},
  {"name": "LMMP057-S // LMMP057","y": -12.022998,"x": -77.0800674041386},
  {"name": "LMMP045-S // LMMP045","y": -12.026878,"x": -77.0883157539614},
  {"name": "LMMP046-S // LMMP046","y": -12.02628,"x": -77.0851103525361},
  {"name": "LMMP047-S // LMMP047","y": -12.027536,"x": -77.08300476201},
  {"name": "LMMP048-S // LMMP048","y": -12.027032,"x": -77.0773685333333},
  {"name": "LMAT107-F","y": -12.045321,"x": -76.9542606287139},
  {"name": "LMMP050-S // LMMP050","y": -12.023487,"x": -77.0839002161972},
  {"name": "LMMP185","y": -11.9925505,"x": -77.1110142528507},
  {"name": "LMLC003","y": -12.090976,"x": -77.0462239147287},
  {"name": "LMJR121-F","y": -12.1387635,"x": -76.9575499422139},
  {"name": "LMMP060-S // LMMP060","y": -12.017521,"x": -77.0784541396445},
  {"name": "LMMP051-S // LMMP051","y": -12.023741,"x": -77.087814763786},
  {"name": "LMMP054-S // LMMP054","y": -12.020346,"x": -77.0843259436872},
  {"name": "LMMP056-S // LMMP056","y": -12.0201675,"x": -77.0807431271864},
  {"name": "LMSC065-S // LMSC065","y": -12.125557,"x": -76.9787250883927},
  {"name": "LMSC066-S // LMSC066","y": -12.1250875,"x": -76.9817326815562},
  {"name": "LMMP058-S // LMMP058","y": -12.023711,"x": -77.0762198773101},
  {"name": "LMMP061-S // LMMP061","y": -12.016832,"x": -77.0812274489796},
  {"name": "LMMP064-S // LMMP064","y": -12.014214,"x": -77.0805937709205},
  {"name": "LMJL037-S // LMJL037","y": -12.00897,"x": -77.0094325841073},
  {"name": "LMMP129-S // LMMP129","y": -11.9848035,"x": -77.0809932241248},
  {"name": "LMMP065-S // LMMP065","y": -12.0168135,"x": -77.073967592877},
  {"name": "LMMP117-S // LMMP117","y": -11.9472005,"x": -77.0877604232181},
  {"name": "LMMP118-S // LMMP118","y": -11.9470905,"x": -77.0920056437788},
  {"name": "LMSM003-S","y": -12.0665895,"x": -77.1026429330913},
  {"name": "LMMP066","y": -12.015545,"x": -77.0753846781801},
  {"name": "LMMP067-S // LMMP067","y": -12.013988,"x": -77.0773191951624},
  {"name": "LMMP069","y": -12.0245135,"x": -77.0574681723461},
  {"name": "LMMP070-S // LMMP070","y": -12.009614,"x": -77.0826831812747},
  {"name": "LMMP071-S // LMMP071","y": -12.010874,"x": -77.0852066900692},
  {"name": "LMMP073-S // LMMP073","y": -12.001118,"x": -77.0850850831613},
  {"name": "LMMP119","y": -11.9496185,"x": -77.0881605215909},
  {"name": "LMMP120-S // LMMP120","y": -11.949885,"x": -77.0912460844775},
  {"name": "LMMP122-S // LMMP122","y": -11.9770655,"x": -77.0893997857094},
  {"name": "LMMP123-S // LMMP123","y": -11.9801725,"x": -77.0910564},
  {"name": "LMMP124","y": -11.9811025,"x": -77.0874390831551},
  {"name": "LMMP127-S // LMMP127","y": -11.9844195,"x": -77.088366115535},
  {"name": "LMLV088-F","y": -12.0617005,"x": -77.028435201905},
  {"name": "LMMP130-S // LMMP130","y": -11.987231,"x": -77.0833517767199},
  {"name": "LMMP131-S // LMMP131","y": -11.985359,"x": -77.0973797614042},
  {"name": "LMMP132-S // LMMP132","y": -11.9876735,"x": -77.1020097605776},
  {"name": "LMMP133-S // LMMP133","y": -11.987807,"x": -77.0972960764683},
  {"name": "LMMP134-S // LMMP134","y": -11.9868365,"x": -77.0913085865677},
  {"name": "LMCH128-F","y": -12.195215,"x": -76.9823136058752},
  {"name": "LMLV069-F","y": -12.073388,"x": -77.0271432125407},
  {"name": "LMMP135","y": -11.9877135,"x": -77.0891601954546},
  {"name": "LMMP136-S // LMMP136","y": -11.9884175,"x": -77.086972423693},
  {"name": "LMMP173","y": -11.957878,"x": -77.0958332226161},
  {"name": "LMMP205","y": -12.020035,"x": -77.0609762013918},
  {"name": "LMMP137-S // LMMP137","y": -11.9893175,"x": -77.0829354474093},
  {"name": "LMSI003-S // LMSI003","y": -12.0997495,"x": -77.0583099785328},
  {"name": "LMMP138-S // LMMP138","y": -11.988829,"x": -77.0949116392327},
  {"name": "LMMP139-S // LMMP139","y": -11.989179,"x": -77.091463427563},
  {"name": "LMMP140-S // LMMP140","y": -11.9897655,"x": -77.0872573058943},
  {"name": "LMMP146-S // LMMP146","y": -11.993842,"x": -77.0947275699169},
  {"name": "LMMP147-S // LMMP147","y": -11.992504,"x": -77.0971364450998},
  {"name": "LMB�010-S // LMB�010","y": -12.06043515,"x": -77.0415301925729},
  {"name": "LMLC003","y": -12.0900565,"x": -77.0451582995731},
  {"name": "LMMP174","y": -11.96097,"x": -77.0940653521291},
  {"name": "LMMP148-S // LMMP148","y": -11.9965145,"x": -77.0965548526042},
  {"name": "LMMP151-S // LMMP151","y": -12.001096,"x": -77.0928909810606},
  {"name": "LMMP152-S // LMMP152","y": -11.999229,"x": -77.0981065826401},
  {"name": "LMMP218-F","y": -12.031037,"x": -77.0464039387737},
  {"name": "LMMP153-S // LMMP153","y": -11.9986325,"x": -77.1004658874162},
  {"name": "LMMP160-S  // LMMP160","y": -11.9957065,"x": -77.1072634715956},
  {"name": "LMJR122-F","y": -12.137651,"x": -76.9594589176347},
  {"name": "LMMP161-S // LMMP161","y": -11.9972205,"x": -77.1046937045379},
  {"name": "LMMP162-S // LMMP162","y": -11.9945855,"x": -77.1028458814581},
  {"name": "LMMP163","y": -11.992868,"x": -77.1033869611132},
  {"name": "LMMP219-F","y": -12.032136,"x": -77.0536747046896},
  {"name": "LMMP164","y": -11.991096,"x": -77.1043057388653},
  {"name": "LMMP165","y": -11.993117,"x": -77.1003287434908},
  {"name": "LMMP186","y": -11.989617,"x": -77.111775530617},
  {"name": "LMMP167","y": -11.970162,"x": -77.0885149554357},
  {"name": "LMMP175-S // LMMP175","y": -11.963464,"x": -77.0912791996529},
  {"name": "LMMG018-S // LMMG018","y": -12.0888855,"x": -77.0628269619399},
  {"name": "LMSC061-S","y": -12.1274185,"x": -76.982018960677},
  {"name": "LMMP168","y": -11.9689295,"x": -77.0903375340646},
  {"name": "LMMP169","y": -11.966459,"x": -77.092067688898},
  {"name": "LMMP170�","y": -11.9634005,"x": -77.0940898267702},
  {"name": "LMMP170�","y": -11.963795,"x": -77.0950958277027},
  {"name": "LMMP170-S","y": -11.964697,"x": -77.0943242326632},
  {"name": "LMLV093-F","y": -12.061483,"x": -77.0328785245837},
  {"name": "LMMP171","y": -11.962462,"x": -77.0960656455068},
  {"name": "LMMP225-F","y": -11.9521905,"x": -77.0869877569286},
  {"name": "LMMP172-S // LMMP172","y": -11.960298,"x": -77.0979837629088},
  {"name": "LMMP176","y": -11.966462,"x": -77.0882729795918},
  {"name": "LMMP177","y": -11.9643225,"x": -77.0893771821334},
  {"name": "LMMP178-S // LMMP178","y": -11.9619195,"x": -77.0893338016429},
  {"name": "LMMP179","y": -11.960017,"x": -77.0911965031408},
  {"name": "LMLC003","y": -12.0880115,"x": -77.0450139948792},
  {"name": "LMMP187-S // LMMP187","y": -11.9903165,"x": -77.1087282873454},
  {"name": "LMMP180","y": -11.957575,"x": -77.0931723449914},
  {"name": "LMLV070-F","y": -12.0739475,"x": -77.0255181902709},
  {"name": "LMLV071-F","y": -12.0695335,"x": -77.0203003648228},
  {"name": "LMLV092-F","y": -12.0648285,"x": -77.0295995610674},
  {"name": "LMMP181","y": -11.9573025,"x": -77.091096561022},
  {"name": "LMVT061-F","y": -11.8415295,"x": -77.1271590759672},
  {"name": "LMAT108-F","y": -12.043629,"x": -76.9548338004171},
  {"name": "LMMP182","y": -11.959375,"x": -77.0887026076337},
  {"name": "LMMP183","y": -11.994799,"x": -77.1146315197023},
  {"name": "LMMP184","y": -11.994519,"x": -77.1125710575545},
  {"name": "LMMP195-S // LMMP195","y": -11.9786605,"x": -77.098761748494},
  {"name": "LMMP188","y": -11.987641,"x": -77.1069973944392},
  {"name": "LMMP189","y": -11.9860975,"x": -77.1060378782421},
  {"name": "LMMP190","y": -11.9853975,"x": -77.1040358030646},
  {"name": "LMMP191","y": -11.982905,"x": -77.101274402234},
  {"name": "LMMP192-S // LMMP192","y": -11.98401,"x": -77.1067223656635},
  {"name": "LMMP193","y": -11.9827125,"x": -77.1032424699601},
  {"name": "LMMP194-S // LMMP194","y": -11.9795445,"x": -77.0968792685185},
  {"name": "LMMP196-S // LMMP196","y": -11.977645,"x": -77.0942856808536},
  {"name": "LMMP197","y": -11.976522,"x": -77.0971960756878},
  {"name": "LMMP198-S // LMMP198","y": -11.97491,"x": -77.0912941595598},
  {"name": "LMMP199","y": -11.9742585,"x": -77.0945917388331},
  {"name": "LMJR123-F","y": -12.1379235,"x": -76.9622264822827},
  {"name": "LMMP200","y": -11.971921,"x": -77.0916591075768},
  {"name": "LMMP201","y": -11.9721345,"x": -77.09640030502},
  {"name": "LMMP202","y": -11.9750735,"x": -77.0999976998942},
  {"name": "LMMP203","y": -11.97352,"x": -77.1023263224988},
  {"name": "LMSC001-S // LMSC001","y": -12.1319045,"x": -77.0155445815066},
  {"name": "LMMP204","y": -11.970643,"x": -77.0982309334025},
  {"name": "LMMP206","y": -12.022865,"x": -77.0605129644128},
  {"name": "LMMP226-F","y": -11.953833,"x": -77.0892986919486},
  {"name": "LMMP207","y": -12.0255515,"x": -77.0630048434565},
  {"name": "LMMP208","y": -12.024807,"x": -77.0651672109705},
  {"name": "LMMP209","y": -12.0264025,"x": -77.067027757365},
  {"name": "LMSM002-S // LMSM002","y": -12.06558,"x": -77.0999852705844},
  {"name": "LMMP210","y": -12.028035,"x": -77.0644864527368},
  {"name": "LMMP211-S // LMMP211","y": -12.0284125,"x": -77.0595905763039},
  {"name": "LMMP212-S // LMMP212","y": -12.025782,"x": -77.0602583704234},
  {"name": "LMMP213","y": -12.021921,"x": -77.0574184784483},
  {"name": "LMMP216-F","y": -12.0285825,"x": -77.0464493761962},
  {"name": "LMMP217-F","y": -12.0291905,"x": -77.0500069054901},
  {"name": "LMMP220-F","y": -12.0322785,"x": -77.0517220925926},
  {"name": "LMMP221-F","y": -12.030486,"x": -77.0481412411982},
  {"name": "LMMP222-F","y": -11.9396065,"x": -77.0850154910504},
  {"name": "LMMP223-F","y": -11.9421925,"x": -77.0863614904465},
  {"name": "LMMP229-F","y": -12.0062535,"x": -77.0902928357319},
  {"name": "LMMP230-F","y": -12.00914,"x": -77.0919044977231},
  {"name": "LMLV087-F","y": -12.061712,"x": -77.030310717868},
  {"name": "LMMP231-F","y": -12.0095695,"x": -77.0895188313636},
  {"name": "LMMP232-F","y": -12.013632,"x": -77.0692543817967},
  {"name": "LMMP233-F","y": -12.0151085,"x": -77.0710437224123},
  {"name": "LMMP234-F","y": -12.018317,"x": -77.0725133311086},
  {"name": "LMMP235-F","y": -12.0196455,"x": -77.0745859006262},
  {"name": "LMMP236-F","y": -12.0213905,"x": -77.0748960524399},
  {"name": "LMMP237-F","y": -12.024435,"x": -77.0730987894737},
  {"name": "LMMP238-F","y": -12.025735,"x": -77.0733580218326},
  {"name": "LMSI002-S // LMSI002","y": -12.095658,"x": -77.0566839292169},
  {"name": "LMMP239-F","y": -12.0273735,"x": -77.0721018765061},
  {"name": "LMMP240-F","y": -12.028446,"x": -77.0735141772837},
  {"name": "LMMP241-F","y": -12.0285695,"x": -77.069276695767},
  {"name": "LMMP242-F","y": -12.0331245,"x": -77.0576522138795},
  {"name": "LMMP243-F","y": -12.0341085,"x": -77.0564280025907},
  {"name": "HVLI001-F","y": -12.987422,"x": -74.7210524823083},
  {"name": "LMMP245-F","y": -12.0343675,"x": -77.0531293602041},
  {"name": "LMLC063-F","y": -12.0897375,"x": -77.0284917493846},
  {"name": "LMMP246-F","y": -12.035796,"x": -77.0532749348045},
  {"name": "LMMP247-F","y": -12.0354355,"x": -77.0504516348684},
  {"name": "LMMP248-F","y": -12.018452,"x": -77.0616259250292},
  {"name": "LMMP249-F","y": -11.994984,"x": -77.1165852579235},
  {"name": "LMMP250-F","y": -11.993316,"x": -77.1166368276956},
  {"name": "LMMP251-F","y": -11.95331,"x": -77.0941220659717},
  {"name": "LMMP253-F","y": -11.999093,"x": -77.0872227984345},
  {"name": "LMMP254-F","y": -12.006905,"x": -77.0870846512108},
  {"name": "LMVT001-S // LMVT001","y": -11.88681855,"x": -77.1314963798491},
  {"name": "LMVT007-S // LMVT007","y": -11.8723355,"x": -77.1281732872013},
  {"name": "LMVT002-S // LMVT002","y": -11.885165,"x": -77.1279321968326},
  {"name": "LMVT009-S // LMVT009","y": -11.872303,"x": -77.1202385716332},
  {"name": "LMVT005","y": -11.8800335,"x": -77.1311353758833},
  {"name": "LMVT006-S // LMVT006","y": -11.879646,"x": -77.1281595803952},
  {"name": "LMVT008","y": -11.874186,"x": -77.1240076942586},
  {"name": "LMVT010","y": -11.87763,"x": -77.1161805990909},
  {"name": "LMVT011","y": -11.874289,"x": -77.1135222849312},
  {"name": "LMVT012","y": -11.8696105,"x": -77.1175480344329},
  {"name": "LMVT015","y": -11.871415,"x": -77.1090568473096},
  {"name": "LMLC064-F","y": -12.0897305,"x": -77.0244280399375},
  {"name": "LMVT016-S // LMVT016","y": -11.8727275,"x": -77.1114844641506},
  {"name": "LMVT018","y": -11.8746635,"x": -77.1059842056151},
  {"name": "LMVT019","y": -11.8775785,"x": -77.1064591702479},
  {"name": "LMVT020-S // LMVT020","y": -11.888074,"x": -77.1218087555767},
  {"name": "LMJR124-F","y": -12.1356965,"x": -76.9623012573498},
  {"name": "LMVT054-F","y": -11.829758,"x": -77.1301515526574},
  {"name": "LMVT021-S // LMVT021","y": -11.8887745,"x": -77.1190841839172},
  {"name": "LMVT022-S // LMVT022","y": -11.890652,"x": -77.1161002096774},
  {"name": "LMVT023-S // LMVT023","y": -11.8909095,"x": -77.109813766316},
  {"name": "LMVT024-S // LMVT024","y": -11.8936805,"x": -77.1129495016027},
  {"name": "LMBV006","y": -12.060773,"x": -77.1233889350962},
  {"name": "LMVT053-F","y": -11.8259865,"x": -77.1259853153846},
  {"name": "LMVT025","y": -11.8924415,"x": -77.127668635536},
  {"name": "LMVT026","y": -11.8970885,"x": -77.1287140906226},
  {"name": "LMVT032-S // LMVT032","y": -11.879763,"x": -77.1248618510554},
  {"name": "LMVT050-F","y": -11.8233585,"x": -77.1315508839925},
  {"name": "LMVT051-F","y": -11.8248555,"x": -77.1288723288461},
  {"name": "LMVT052-F","y": -11.8270645,"x": -77.1331142552044},
  {"name": "LMVT055-F","y": -11.8282495,"x": -77.1245655650063},
  {"name": "LMVT056-F","y": -11.8335145,"x": -77.1290955381258},
  {"name": "LMVT057-F","y": -11.828937,"x": -77.1217083197201},
  {"name": "LMVT058-F","y": -11.832529,"x": -77.1258816215313},
  {"name": "LMVT059-F","y": -11.831963,"x": -77.1189226493997},
  {"name": "LMVT060-F","y": -11.836816,"x": -77.1271434665323},
  {"name": "LMLV106-F","y": -12.068592,"x": -77.0137810372144},
  {"name": "LMBN028","y": -12.0514487,"x": -77.0482821183057},
  {"name": "LMPL010-S // LMPL010","y": -12.0746725,"x": -77.0674058571429},
  {"name": "LMVT062-F","y": -11.866635,"x": -77.1305528144588},
  {"name": "LMVT063-F","y": -11.866098,"x": -77.1342159134228},
  {"name": "LMBV004-S // LMBV004","y": -12.0628585,"x": -77.1265199404483},
  {"name": "LMBV007-S // LMBV007","y": -12.063289,"x": -77.1150730033632},
  {"name": "LMBV008-S // LMBV008","y": -12.05893,"x": -77.1163466273748},
  {"name": "LMBV009-S // LMBV009","y": -12.060862,"x": -77.1136861348993},
  {"name": "LMBV010-S // LMBV010","y": -12.0579165,"x": -77.1127127419545},
  {"name": "LMLV107-F","y": -12.0688575,"x": -77.0143752115023},
  {"name": "LMBV011-S // LMBV011","y": -12.058102,"x": -77.1084368381672},
  {"name": "LMBV012-S // LMBV012","y": -12.0620895,"x": -77.1104665531933},
  {"name": "LMBV013-S // LMBV013","y": -12.0616105,"x": -77.1067855824661},
  {"name": "LMBV014-S // LMBV014","y": -12.0576335,"x": -77.1058137853261},
  {"name": "LMBV015-S // LMBV015","y": -12.058294,"x": -77.1038112890789},
  {"name": "LMBN031","y": -12.054725,"x": -77.0547278264723},
  {"name": "LMJM002-S","y": -12.083205,"x": -77.0589559694377},
  {"name": "LMBN032","y": -12.05267365,"x": -77.0541703905731},
  {"name": "LMBV016-S // LMBV016","y": -12.06162,"x": -77.1031504241379},
  {"name": "LMBV017-S","y": -12.0598125,"x": -77.1013377034209},
  {"name": "LMBV017","y": -12.0592595,"x": -77.1024362813268},
  {"name": "LMBV018-S // LMBV018","y": -12.057453,"x": -77.0995562199631},
  {"name": "LMBV020-S // LMBV020","y": -12.060376,"x": -77.095605815302},
  {"name": "LMBN033","y": -12.05804665,"x": -77.0569395512003},
  {"name": "LMJM041-F","y": -12.071337,"x": -77.0382135721618},
  {"name": "LMBV021-S // LMBV021","y": -12.0570675,"x": -77.0954870947494},
  {"name": "LMSC002-S // LMSC002","y": -12.13194,"x": -77.0118566857939},
  {"name": "LMBV023-S // LMBV023","y": -12.055058,"x": -77.09430782361},
  {"name": "LMMG019-S // LMMG019","y": -12.0907815,"x": -77.0625523727385},
  {"name": "LMBV024-S // LMBV024","y": -12.0570685,"x": -77.0909228441404},
  {"name": "LMBV026-S // LMBV026","y": -12.0538785,"x": -77.0900345568648},
  {"name": "LMPL011-S // LMPL011","y": -12.077238,"x": -77.0674081811434},
  {"name": "LMB�008","y": -12.0602885,"x": -77.0541109181675},
  {"name": "LMJR125-F","y": -12.134822,"x": -76.9640257357383},
  {"name": "ZONA SATURADA","y": -12.0675185,"x": -77.1313923428821},
  {"name": "LMBV035-F","y": -12.06608,"x": -77.1272616612557},
  {"name": "LMSQ171-F","y": -12.1170905,"x": -77.0144286122966},
  {"name": "5017B03","y": -12.092854,"x": -77.0384367965495},
  {"name": "LMB�001-S // LMB�001","y": -12.056168,"x": -77.0512763287321},
  {"name": "LMJM003","y": -12.084053,"x": -77.0582192751323},
  {"name": "LMB�009-S // LMB�009","y": -12.061859,"x": -77.0495813117647},
  {"name": "LMB�002-S // LMB�002","y": -12.0610241,"x": -77.0567366221655},
  {"name": "LMB�003-S // LMB�003","y": -12.0557975,"x": -77.0473769877495},
  {"name": "LMPL012-S // LMPL012","y": -12.0806705,"x": -77.0676662151959},
  {"name": "LMB�004","y": -12.05557865,"x": -77.0439775220748},
  {"name": "LMB�005-S // LMB�005","y": -12.05757,"x": -77.04716699631},
  {"name": "LMB�006","y": -12.06000655,"x": -77.0413862282809},
  {"name": "LMJM003","y": -12.0851115,"x": -77.0571882754872},
  {"name": "LMB�006","y": -12.057999,"x": -77.0438693031915},
  {"name": "LMB�007-S // LMB�007","y": -12.0597765,"x": -77.0506308807978},
  {"name": "LMLV079-F","y": -12.074794,"x": -77.0284907489729},
  {"name": "LMB�010-S // LMB�010","y": -12.061171,"x": -77.0464368867145},
  {"name": "LMB�011-S // LMB�011","y": -12.063043,"x": -77.0471563190819},
  {"name": "LMB�012-S // LMB�012","y": -12.0632995,"x": -77.0514195286561},
  {"name": "LMB�013-S // LMB�013","y": -12.065798,"x": -77.048584017367},
  {"name": "LMVS006","y": -12.19866,"x": -76.9557751932223},
  {"name": "LMB�014-S // LMB�014","y": -12.06778075,"x": -77.0503747332211},
  {"name": "LMJM005-S // LMJM005","y": -12.080126,"x": -77.0562659977117},
  {"name": "LMB�015-S // LMB�015","y": -12.06624035,"x": -77.0522613377084},
  {"name": "LMSC007-S // LMSC007","y": -12.132178,"x": -77.0046831617647},
  {"name": "LMB�016-S // LMB�016","y": -12.064731,"x": -77.0547421336978},
  {"name": "LMLV139-F","y": -12.0629055,"x": -77.0146387832447},
  {"name": "LMB�017","y": -12.0651675,"x": -77.0583214310992},
  {"name": "LMBN029","y": -12.0513746,"x": -77.0511908189655},
  {"name": "LMJM006-S","y": -12.081429,"x": -77.0542610510132},
  {"name": "LMJM025-S // LMJM025","y": -12.0666065,"x": -77.0459110126962},
  {"name": "LMB�030-S // LMBN030","y": -12.05375,"x": -77.0518203316812},
  {"name": "LMBN034","y": -12.05818,"x": -77.0527014917291},
  {"name": "LMB�045-S // LMBN045","y": -12.0518348,"x": -77.0445226522342},
  {"name": "LMBN046","y": -12.0540545,"x": -77.0495209169355},
  {"name": "LMBN047","y": -12.0537275,"x": -77.0470036509434},
  {"name": "LMBN048","y": -12.0532839,"x": -77.0441174299744},
  {"name": "LMJM015-S // LMJM015","y": -12.0729705,"x": -77.0500615018707},
  {"name": "LMB�054-F","y": -12.0552763,"x": -77.0501704899142},
  {"name": "LMB�055-F","y": -12.057977,"x": -77.042136648788},
  {"name": "LMJM014-S // LMJM014","y": -12.075089,"x": -77.051895408801},
  {"name": "LMLV110-F","y": -12.067715,"x": -77.0133222833333},
  {"name": "LMJM003-S","y": -12.083937,"x": -77.0563026266667},
  {"name": "LMSC008","y": -12.133849,"x": -77.0081435433365},
  {"name": "LMJM007-S","y": -12.079357,"x": -77.0530297265807},
  {"name": "LMJM007","y": -12.0784775,"x": -77.0542138602941},
  {"name": "LMJM008-S","y": -12.078957,"x": -77.0507158489573},
  {"name": "LMJM009","y": -12.081869,"x": -77.0511804916526},
  {"name": "LMPL016","y": -12.0740665,"x": -77.0636478107202},
  {"name": "LMJM013-S","y": -12.0766945,"x": -77.0531424639063},
  {"name": "LMJM016-S // LMJM016","y": -12.075677,"x": -77.049089681189},
  {"name": "LMJM019-S // LMJM019","y": -12.07378,"x": -77.0476831205711},
  {"name": "LMMG017-S // LMMG017","y": -12.091867,"x": -77.0660296199095},
  {"name": "LMJM020-S // LMJM020","y": -12.07015,"x": -77.0440375714823},
  {"name": "LMJM022-S // LMJM022","y": -12.070628,"x": -77.0485334311752},
  {"name": "LMJM026","y": -12.066351,"x": -77.043173278125},
  {"name": "LMLP008-S // LMLP008","y": -12.0729205,"x": -77.1215346936831},
  {"name": "LMLC077-F","y": -12.0823375,"x": -77.0416453265797},
  {"name": "LMMG016","y": -12.0942325,"x": -77.0679895662267},
  {"name": "LMLP009-S // LMLP009","y": -12.070365,"x": -77.1204218725908},
  {"name": "LMLP010-S // LMLP010","y": -12.0681155,"x": -77.1193060734154},
  {"name": "LMPL017","y": -12.069515,"x": -77.0603285424028},
  {"name": "LMLP011-S","y": -12.073028,"x": -77.117967406037},
  {"name": "LMLP011","y": -12.07423,"x": -77.1180883997586},
  {"name": "LMLP011","y": -12.073613,"x": -77.1194382835498},
  {"name": "LMLP011","y": -12.072679,"x": -77.1175535720367},
  {"name": "LMLP011","y": -12.0736275,"x": -77.1178665055861},
  {"name": "LMLP011","y": -12.0744485,"x": -77.1173499535494},
  {"name": "LMLV055-F","y": -12.071315,"x": -77.0098191807404},
  {"name": "LMLP012","y": -12.070908,"x": -77.1164804099242},
  {"name": "LMLP013-S // LMLP013","y": -12.0686925,"x": -77.1162341366831},
  {"name": "LMLP014-S // LMLP014","y": -12.0706585,"x": -77.1120424221576},
  {"name": "LMLP015-S // LMLP015","y": -12.073294,"x": -77.1157872224192},
  {"name": "LMLP016","y": -12.0744145,"x": -77.1139349552366},
  {"name": "LMLP019-S","y": -12.071759,"x": -77.1098588145011},
  {"name": "LMLV057-F","y": -12.0738105,"x": -77.0098470122683},
  {"name": "LMLV058-F","y": -12.0867755,"x": -77.011752505069},
  {"name": "LMLC042-S // LMLC042","y": -12.0898125,"x": -77.0317442280908},
  {"name": "LMLP020-S // LMLP020","y": -12.074944,"x": -77.1114249555006},
  {"name": "LMLP023","y": -12.0752225,"x": -77.1077302748679},
  {"name": "LMLP024-S // LMLP024","y": -12.0725955,"x": -77.106592170278},
  {"name": "LMAG043-F","y": -12.0432765,"x": -76.9882740281044},
  {"name": "LMLP025-S // LMLP025","y": -12.0667685,"x": -77.1152991980932},
  {"name": "LMLP026-S","y": -12.06731,"x": -77.1122884675242},
  {"name": "LBCH060-F","y": -6.758607,"x": -79.8212579952872},
  {"name": "LMLP027-S","y": -12.064768,"x": -77.1102632365137},
  {"name": "LMLP027","y": -12.065653,"x": -77.1090100838067},
  {"name": "LMLP028-S // LMLP028","y": -12.0679815,"x": -77.1098601437144},
  {"name": "LMLP029-S","y": -12.0676185,"x": -77.107437637791},
  {"name": "LMLP029","y": -12.068462,"x": -77.107864649732},
  {"name": "5017B03","y": -12.0920025,"x": -77.0385770545489},
  {"name": "LMLP030-S","y": -12.065248,"x": -77.1063664545159},
  {"name": "LMLP030","y": -12.0643535,"x": -77.1067640401998},
  {"name": "LMLP031-S","y": -12.067568,"x": -77.105068665072},
  {"name": "LMLP033-F","y": -12.0771285,"x": -77.1141537425847},
  {"name": "LMLC018-S // LMLC018","y": -12.081618,"x": -77.0293500330211},
  {"name": "LMLP034-F","y": -12.0760265,"x": -77.1114980347944},
  {"name": "LMLP035-F","y": -12.0731265,"x": -77.1094826635071},
  {"name": "LMLV002-S // LMLV002","y": -12.082611,"x": -77.0194396849838},
  {"name": "LMLV060-F","y": -12.085121,"x": -77.0226591635989},
  {"name": "LMLV061-F","y": -12.0841545,"x": -77.0250517734054},
  {"name": "LMLV062-F","y": -12.0828385,"x": -77.0248711133646},
  {"name": "LMSM044","y": -12.086328,"x": -77.0789879460326},
  {"name": "LMLC005-S // LMLC005","y": -12.0859365,"x": -77.0431408125},
  {"name": "LMLC041-S // LMLC041","y": -12.0896905,"x": -77.0300732291453},
  {"name": "LMLV005-S // LMLV005","y": -12.087434,"x": -77.0225546706827},
  {"name": "LMLV006-S // LMLV006","y": -12.086996,"x": -77.0182891435743},
  {"name": "LMLV010-S // LMLV010","y": -12.077909,"x": -77.0127902407182},
  {"name": "LMLV090-F","y": -12.068891,"x": -77.0267273975075},
  {"name": "LMLV011-S // LMLV011","y": -12.0796775,"x": -77.0248334464205},
  {"name": "LMLV008-S // LMLV008","y": -12.0771025,"x": -77.0188740831181},
  {"name": "LMLV063-F","y": -12.0827515,"x": -77.0220319366027},
  {"name": "LMLV009-S","y": -12.0782155,"x": -77.0166932800231},
  {"name": "LMLV091-F","y": -12.0706155,"x": -77.0305708307347},
  {"name": "LAMO083-S","y": -12.1057095,"x": -76.9481907352188},
  {"name": "LMLV009","y": -12.077706,"x": -77.0173232023507},
  {"name": "LMLV009","y": -12.0797595,"x": -77.0152515470779},
  {"name": "LMLV009","y": -12.0786285,"x": -77.01602},
  {"name": "LMLV009","y": -12.0796585,"x": -77.0158016245336},
  {"name": "LMLV013-S // LMLV013","y": -12.079682,"x": -77.020954782957},
  {"name": "LMLV014-S // LMLV014","y": -12.0803975,"x": -77.017751599359},
  {"name": "LMLV015-S // LMLV015","y": -12.081133,"x": -77.0149175414075},
  {"name": "LMLC021","y": -12.082603,"x": -77.0320174196891},
  {"name": "LMLV016-S // LMLV016","y": -12.0820995,"x": -77.0111499534352},
  {"name": "LMLV018","y": -12.0830175,"x": -77.0064713858879},
  {"name": "LMLV020-S // LMLV020","y": -12.0775775,"x": -77.0268955166667},
  {"name": "LMLV021-S // LMLV021","y": -12.0765235,"x": -77.023424313052},
  {"name": "LMLV102-F","y": -12.069834,"x": -77.012158672169},
  {"name": "LMMG014","y": -12.098769,"x": -77.0697362212242},
  {"name": "LMLV024-S // LMLV024","y": -12.0752155,"x": -77.0195665034837},
  {"name": "LMSC010","y": -12.135209,"x": -77.0060741369136},
  {"name": "LMLV064-F","y": -12.083747,"x": -77.0130313093433},
  {"name": "LMLV074-F","y": -12.07016,"x": -77.017422360687},
  {"name": "LMLV075-F","y": -12.0730165,"x": -77.0182574728288},
  {"name": "LMLV076-F","y": -12.0720585,"x": -77.0153611241476},
  {"name": "LMLV077-F","y": -12.070534,"x": -77.0291147748372},
  {"name": "LMLV078-F","y": -12.0729285,"x": -77.0287618914224},
  {"name": "LMLC004","y": -12.083794,"x": -77.043217735972},
  {"name": "LMLV095-F","y": -12.0708535,"x": -77.0044009848237},
  {"name": "LMLV096-F","y": -12.0739255,"x": -77.0246422634766},
  {"name": "LMLV097-F","y": -12.071563,"x": -77.0233505073074},
  {"name": "LMLV098-F","y": -12.0713835,"x": -77.0129108978347},
  {"name": "LMLV099-F","y": -12.0700515,"x": -77.0126861042337},
  {"name": "LMLV100-F","y": -12.069936,"x": -77.0138286957801},
  {"name": "LMLV101-F","y": -12.0692345,"x": -77.0133378899721},
  {"name": "LMLV103-F","y": -12.0699635,"x": -77.0094831827718},
  {"name": "LMLV105-F","y": -12.06835,"x": -77.0123964099036},
  {"name": "LMLV131-F","y": -12.064659,"x": -77.0159033116961},
  {"name": "LMLV132-F","y": -12.065448,"x": -77.0172872570706},
  {"name": "LMLV134-F","y": -12.064564,"x": -77.0154303118196},
  {"name": "LMLV135-F","y": -12.0640095,"x": -77.013532375},
  {"name": "LMLV137-F","y": -12.063303,"x": -77.0133938710273},
  {"name": "LMLV138-F","y": -12.0633955,"x": -77.0144711249577},
  {"name": "LMLV142-F","y": -12.0638595,"x": -77.0167971685464},
  {"name": "LMLV143-F","y": -12.062149,"x": -77.0165432766176},
  {"name": "5018C03-A","y": -12.094378,"x": -77.019927454089},
  {"name": "LMLV144-F","y": -12.0619445,"x": -77.0151265057553},
  {"name": "LMLV145-F","y": -12.0617795,"x": -77.0133771986926},
  {"name": "LMLV146-F","y": -12.061708,"x": -77.0114978728386},
  {"name": "LMLC001-S // LMLC001","y": -12.084345,"x": -77.0464576222072},
  {"name": "LMLC014-S // LMLC014","y": -12.0822155,"x": -77.0359504247201},
  {"name": "LMLC002-S // LMLC002","y": -12.086822,"x": -77.0442205753318},
  {"name": "LMLC023-S // LMLC023","y": -12.0840645,"x": -77.0328345340302},
  {"name": "LMLC025","y": -12.0862,"x": -77.0330331533505},
  {"name": "5017B03","y": -12.089656,"x": -77.0349428950829},
  {"name": "LMLC003-S","y": -12.089606,"x": -77.0447329739064},
  {"name": "LMLC003","y": -12.0913495,"x": -77.0464025160061},
  {"name": "LMLC007-S // LMLC007","y": -12.0851985,"x": -77.0416869604226},
  {"name": "LMLC009-S // LMLC009","y": -12.085844,"x": -77.0397251287034},
  {"name": "LMLC010-S // LMLC010","y": -12.082655,"x": -77.0385794499735},
  {"name": "LMLC011-S // LMLC011","y": -12.0850915,"x": -77.0376927480788},
  {"name": "LMLC012-S // LMLC012","y": -12.087533,"x": -77.0385073812332},
  {"name": "LMLC013-S // LMLC013","y": -12.086108,"x": -77.0348569710596},
  {"name": "LMPL026-S // LMPL026","y": -12.0732225,"x": -77.0539408303544},
  {"name": "LMLC015-S // LMLC015","y": -12.080695,"x": -77.0381424094615},
  {"name": "LMLC016-S // LMLC016","y": -12.080137,"x": -77.0327336425352},
  {"name": "LMLC017","y": -12.0797895,"x": -77.0297132831911},
  {"name": "LMLC027-S // LMLC027","y": -12.0881265,"x": -77.0327919499452},
  {"name": "LMLC037-S // LMLC037","y": -12.0828735,"x": -77.0284027332474},
  {"name": "LMLC038","y": -12.0842895,"x": -77.0295872769649},
  {"name": "LMLC039","y": -12.0855225,"x": -77.0301977776608},
  {"name": "LBCH061-F","y": -6.7577065,"x": -79.8191659959868},
  {"name": "LMPL004-S // LMPL004","y": -12.078215,"x": -77.0743164777568},
  {"name": "LMLC040","y": -12.087616,"x": -77.0306229465463},
  {"name": "LMMG028-S // LMMG028","y": -12.103167,"x": -77.0625051886581},
  {"name": "LMMG001-S // LMMG001","y": -12.09389,"x": -77.0757033843811},
  {"name": "LMMG002-S // LMMG002","y": -12.095062,"x": -77.0733529821783},
  {"name": "LMPL006","y": -12.0744525,"x": -77.0711719976272},
  {"name": "LMMG003","y": -12.090225,"x": -77.0741723209781},
  {"name": "ICNZ015-F","y": -14.827536,"x": -74.927324119944},
  {"name": "LMMG004-S // LMMG004","y": -12.090938,"x": -77.0713485864074},
  {"name": "LMMG005-S // LMMG005","y": -12.087673,"x": -77.0730294807692},
  {"name": "LMMG006-S // LMMG006","y": -12.087249,"x": -77.0697144133811},
  {"name": "LMSM004-S // LMSM004","y": -12.067701,"x": -77.099566054311},
  {"name": "LMMG007-S // LMMG007","y": -12.0858504,"x": -77.0715142595356},
  {"name": "LMMG008-S // LMMG008","y": -12.0863975,"x": -77.0663952283159},
  {"name": "LMMG009-S // LMMG009","y": -12.087522,"x": -77.0652571616721},
  {"name": "LMMG010-S // LMMG010","y": -12.088202,"x": -77.0679930845308},
  {"name": "LMMG011","y": -12.08979,"x": -77.0684646796748},
  {"name": "LMMG012-S // LMMG012","y": -12.091707,"x": -77.0689192608359},
  {"name": "LMMG015-S // LMMG015","y": -12.0965595,"x": -77.0696575944518},
  {"name": "LMMG020-S // LMMG020","y": -12.089546,"x": -77.0600679038659},
  {"name": "LMMG021-S // LMMG021","y": -12.091353,"x": -77.0592621666667},
  {"name": "LMMG022-S // LMMG022","y": -12.091926,"x": -77.0581293503644},
  {"name": "LMMG023-S // LMMG023","y": -12.091705,"x": -77.0610063995902},
  {"name": "LMMG024-S // LMMG024","y": -12.094513,"x": -77.0605137751317},
  {"name": "5118C03-S // 5118C03","y": -12.0997835,"x": -77.0243898797235},
  {"name": "LMMG025-S // LMMG025","y": -12.096786,"x": -77.0614517455232},
  {"name": "LMMG026-S // LMMG026","y": -12.096759,"x": -77.0591466270434},
  {"name": "LMMG027","y": -12.0996305,"x": -77.0619806702635},
  {"name": "LMMG029-S // LMMG029","y": -12.095651,"x": -77.0653380885558},
  {"name": "LMMG030-S // LMMG030","y": -12.093328,"x": -77.0627841223663},
  {"name": "LMPL001-S // LMPL001","y": -12.069557,"x": -77.0753222124497},
  {"name": "LMPL002-S // LMPL002","y": -12.0737865,"x": -77.0754351648217},
  {"name": "LMPL003-S // LMPL003","y": -12.0774855,"x": -77.0768436995701},
  {"name": "LMPL005-S // LMPL005","y": -12.0792825,"x": -77.0709516784713},
  {"name": "LMPL007","y": -12.0698425,"x": -77.0710746837603},
  {"name": "LMPL008-S // LMPL008","y": -12.0700455,"x": -77.0676186535514},
  {"name": "LMPL019","y": -12.077247,"x": -77.0603359863202},
  {"name": "5016D03-S // 5016D03","y": -12.0920285,"x": -77.0511001662218},
  {"name": "LMPL020","y": -12.079426,"x": -77.0622286616692},
  {"name": "5119C03","y": -12.101887,"x": -77.0129420457138},
  {"name": "LMPL027-S // LMPL027","y": -12.074408,"x": -77.056194673277},
  {"name": "LMPL013-S // LMPL013","y": -12.083353,"x": -77.0695714515846},
  {"name": "LMPL014-S // LMPL014","y": -12.068961,"x": -77.064032158618},
  {"name": "LMPL015-S // LMPL015","y": -12.0712735,"x": -77.0631585610561},
  {"name": "5016F03-S // 5016F03","y": -12.0963105,"x": -77.0480734361016},
  {"name": "5216A03-S // 5216A03","y": -12.1065475,"x": -77.0438687691083},
  {"name": "5216B03-S // 5216B03","y": -12.104622,"x": -77.0465153796204},
  {"name": "LMPL018-S // LMPL018","y": -12.0742585,"x": -77.0620989516697},
  {"name": "LMPL021-S // LMPL021","y": -12.0812205,"x": -77.06545945269},
  {"name": "5117B03-S // 5117B03","y": -12.101453,"x": -77.0370091481217},
  {"name": "5117D03-S // 5117D03","y": -12.102732,"x": -77.0336951170213},
  {"name": "LMPL022-S // LMPL022","y": -12.084996,"x": -77.066214281768},
  {"name": "LMPL024-S","y": -12.071244,"x": -77.0569840362242},
  {"name": "LMPL024","y": -12.0717465,"x": -77.0583363333473},
  {"name": "LMPL028","y": -12.0744745,"x": -77.0582252083168},
  {"name": "LMPL023-S // LMPL023","y": -12.0683865,"x": -77.0573668403238},
  {"name": "LMSM005-S // LMSM005","y": -12.063903,"x": -77.0950101217729},
  {"name": "LMPL025-S // LMPL025","y": -12.0692585,"x": -77.0523400053436},
  {"name": "LMPL034","y": -12.0742825,"x": -77.0788199990637},
  {"name": "5118A03-S // 5118A03","y": -12.0991695,"x": -77.0292868899007},
  {"name": "LMPL028-S","y": -12.0767065,"x": -77.0568238133333},
  {"name": "LMPL029","y": -12.0800575,"x": -77.0595107951487},
  {"name": "LMPL030","y": -12.082378,"x": -77.0641934917414},
  {"name": "LMPL031","y": -12.083719,"x": -77.062119905644},
  {"name": "LMPL032","y": -12.070321,"x": -77.0762902511148},
  {"name": "LMPL033-S // LMPL033","y": -12.0730605,"x": -77.0626700367873},
  {"name": "LMSI007-S // LMSI007","y": -12.0980225,"x": -77.0522681170172},
  {"name": "LMSI008-S // LMSI008","y": -12.1054895,"x": -77.0557670912829},
  {"name": "LMSI009-S // LMSI009","y": -12.1055475,"x": -77.0487911774103},
  {"name": "5217E03-S // 5217E03","y": -12.1095915,"x": -77.0390592276459},
  {"name": "LMSM006","y": -12.06721,"x": -77.0959574918621},
  {"name": "LMSM023-S // LMSM023","y": -12.0753235,"x": -77.0861484492337},
  {"name": "5016A03","y": -12.088708,"x": -77.0491057502579},
  {"name": "5016B03","y": -12.0921985,"x": -77.0444798216157},
  {"name": "5016C03-S","y": -12.0926935,"x": -77.0480161885181},
  {"name": "5016C03","y": -12.091315,"x": -77.0471478498559},
  {"name": "5216C03-S // 5216C03","y": -12.1088775,"x": -77.0469248786473},
  {"name": "LMSM007-S // LMSM007","y": -12.0684265,"x": -77.0929274493019},
  {"name": "5018C03-B","y": -12.094993,"x": -77.0226223871986},
  {"name": "5018A03","y": -12.093214,"x": -77.0310433351186},
  {"name": "LMSQ164-F","y": -12.1079475,"x": -77.0137732703125},
  {"name": "5018D03-S // 5018D03","y": -12.096275,"x": -77.0306214412916},
  {"name": "5017C03-S // 5017C03","y": -12.0955635,"x": -77.037744518018},
  {"name": "5017D03","y": -12.0955055,"x": -77.0407562227776},
  {"name": "5017A03-S // 5017A03","y": -12.091514,"x": -77.0407881109155},
  {"name": "5018B03-A","y": -12.094911,"x": -77.0269648312878},
  {"name": "5018B03BS // 5018B03-B","y": -12.0936775,"x": -77.0251648114723},
  {"name": "5119B03-B","y": -12.102489,"x": -77.0154164444796},
  {"name": "5217A03","y": -12.103589,"x": -77.0418879633431},
  {"name": "5217B03-S // 5217B03","y": -12.1076695,"x": -77.0411645586326},
  {"name": "LAMO074","y": -12.087936,"x": -76.8977982323213},
  {"name": "5217D03-S // 5217D03","y": -12.104484,"x": -77.0373924020343},
  {"name": "5219A03-S // 5219A03","y": -12.1050365,"x": -77.0134170242056},
  {"name": "5117A03","y": -12.0989525,"x": -77.039623129326},
  {"name": "5016E03-S // 5016E03","y": -12.0949385,"x": -77.0439871085547},
  {"name": "5017000","y": -12.094753,"x": -77.034046615856},
  {"name": "5119B03AS // 5119B03-A","y": -12.099874,"x": -77.017315923913},
  {"name": "LMSI050-S // LMSI050","y": -12.1030925,"x": -77.05957885859},
  {"name": "LMSI051-S // LMSI051","y": -12.0929435,"x": -77.0555945655841},
  {"name": "LMSM009-S // LMSM009","y": -12.0709245,"x": -77.1023851737335},
  {"name": "LMSM010-S // LMSM010","y": -12.0717995,"x": -77.1005397093252},
  {"name": "LMSM011-S // LMSM011","y": -12.074117,"x": -77.1024227862351},
  {"name": "LMSM012","y": -12.0753275,"x": -77.1044914126637},
  {"name": "LMSM013-S // LMSM013","y": -12.0768065,"x": -77.1020271774113},
  {"name": "LMSM014-S","y": -12.0790685,"x": -77.1073742254803},
  {"name": "LMSM014","y": -12.079943,"x": -77.1075710229784},
  {"name": "LMSM014","y": -12.076996,"x": -77.1061317081184},
  {"name": "LMSM015-S // LMSM015","y": -12.080551,"x": -77.1036086145038},
  {"name": "LMSM024-S // LMSM024","y": -12.0763395,"x": -77.0826656227178},
  {"name": "LMSM016-S // LMSM016","y": -12.082764,"x": -77.100591503096},
  {"name": "LMSM017-S // LMSM017","y": -12.0782135,"x": -77.0983605057659},
  {"name": "LMSM018-S // LMSM018","y": -12.077101,"x": -77.0961298725929},
  {"name": "LMSM019-S // LMSM019","y": -12.070625,"x": -77.0958258264467},
  {"name": "LMSM034-S // LMSM034","y": -12.085041,"x": -77.0844816148649},
  {"name": "LMSM020-S // LMSM020","y": -12.0736545,"x": -77.0932144187183},
  {"name": "LMSM021-S // LMSM021","y": -12.0745935,"x": -77.096152158105},
  {"name": "LMSM022-S // LMSM022","y": -12.074478,"x": -77.0897842925746},
  {"name": "LMSM026","y": -12.0635635,"x": -77.0803425693862},
  {"name": "LMAG015-F","y": -12.031635,"x": -76.9984374725554},
  {"name": "LMSM027-S // LMSM027","y": -12.081123,"x": -77.0960287168106},
  {"name": "LMSM035","y": -12.0826165,"x": -77.0853312818728},
  {"name": "LMSM028-S // LMSM028","y": -12.0795915,"x": -77.0918314219265},
  {"name": "LMSM029-S // LMSM029","y": -12.084768,"x": -77.0950512387218},
  {"name": "LMSM030BS // LMSM030","y": -12.086902,"x": -77.0901544115034},
  {"name": "LMSM031-S // LMSM031","y": -12.0885165,"x": -77.0864610188895},
  {"name": "LMSM032","y": -12.084344,"x": -77.0885589414184},
  {"name": "LMSM033-S // LMSM033","y": -12.086167,"x": -77.0853302307895},
  {"name": "LMSM036-S // LMSM036","y": -12.080379,"x": -77.0835626765733},
  {"name": "LAMO081-S // LAMO081","y": -12.094138,"x": -76.9534869068047},
  {"name": "LMSM037-S // LMSM037","y": -12.079795,"x": -77.0863621455786},
  {"name": "LMSM038","y": -12.080089,"x": -77.0771740765723},
  {"name": "LMSM039","y": -12.0829685,"x": -77.0806912608696},
  {"name": "LMSM040","y": -12.0834945,"x": -77.0769835735294},
  {"name": "LMSM047-S // LMSM047","y": -12.0890475,"x": -77.0809532240325},
  {"name": "LMSM041-S // LMSM041","y": -12.0831645,"x": -77.0733067289916},
  {"name": "LMSM042-S // LMSM042","y": -12.0869615,"x": -77.0762815670277},
  {"name": "LMSM043","y": -12.085219,"x": -77.0778820023585},
  {"name": "LMSM045-S // LMSM045","y": -12.0857085,"x": -77.0817405036982},
  {"name": "LMSM046","y": -12.0893575,"x": -77.0840750779632},
  {"name": "LMAG016-F","y": -12.036673,"x": -77.0044003306461},
  {"name": "LMSM078-S // LMSM078","y": -12.0631525,"x": -77.0833409213836},
  {"name": "LMSM048","y": -12.089609,"x": -77.0776922873949},
  {"name": "LMSM049-S // LMSM049","y": -12.0914205,"x": -77.0818639592364},
  {"name": "LMSM050-S // LMSM050","y": -12.0927875,"x": -77.0786789397519},
  {"name": "LMSC077-S // LMSC077","y": -12.1199955,"x": -76.987714109336},
  {"name": "LMSM051-S // LMSM051","y": -12.0804015,"x": -77.1000803582386},
  {"name": "LMSM052","y": -12.082081,"x": -77.0896610818439},
  {"name": "LMSM079-S // LMSM079","y": -12.063825,"x": -77.0853899725988},
  {"name": "LMAT001-S // LMAT001","y": -12.0734035,"x": -76.9853672892257},
  {"name": "LMAT002-S // LMAT002","y": -12.0732685,"x": -76.9803735771597},
  {"name": "LMAT018","y": -12.061752,"x": -76.9397867028649},
  {"name": "LMAT005","y": -12.075023,"x": -76.9899133633296},
  {"name": "LMSC116-S // LMSC116","y": -12.082966,"x": -76.9751969693449},
  {"name": "LMAT016-S // LMAT016","y": -12.054946,"x": -76.9407432923837},
  {"name": "LMAT006","y": -12.076288,"x": -76.9851565983979},
  {"name": "LMSC091-S // LMSC091","y": -12.1278955,"x": -76.9741982469446},
  {"name": "LMAT020","y": -12.052381,"x": -76.9465147015366},
  {"name": "LMAT079-F","y": -12.051477,"x": -76.9512389877436},
  {"name": "LMSC284-F","y": -12.1411975,"x": -76.9899589097439},
  {"name": "LMAT033-S // LMAT033","y": -12.045541,"x": -76.9320934987585},
  {"name": "LMAT061","y": -12.0768595,"x": -76.9768879609398},
  {"name": "LMAT013","y": -12.0439695,"x": -76.9355707221302},
  {"name": "LMAT014-S // LMAT014","y": -12.049844,"x": -76.9383069536892},
  {"name": "LMAT015-S // LMAT015","y": -12.056707,"x": -76.9390909865552},
  {"name": "LMAT080-F","y": -12.0506645,"x": -76.9532628801248},
  {"name": "LMAT017","y": -12.0579645,"x": -76.9419369242242},
  {"name": "LMAT022-S","y": -12.0343485,"x": -76.9336079215694},
  {"name": "LMAT022","y": -12.034035,"x": -76.9354579843122},
  {"name": "LMAT022","y": -12.03649,"x": -76.9339964071821},
  {"name": "LMAT022","y": -12.0333765,"x": -76.9315274587683},
  {"name": "LMAT022","y": -12.0338925,"x": -76.931357379375},
  {"name": "LMAT022","y": -12.032215,"x": -76.9319270710449},
  {"name": "LMAT022","y": -12.035916,"x": -76.9345947777778},
  {"name": "LMAT030-S // LMAT030","y": -12.03986,"x": -76.9253972722109},
  {"name": "LMAT023-S // LMAT023","y": -12.032548,"x": -76.9300128195075},
  {"name": "LMAT026-S // LMAT026","y": -12.036316,"x": -76.9318064408602},
  {"name": "LMAT027-S // LMAT027","y": -12.0348825,"x": -76.9264836047512},
  {"name": "LMAT028","y": -12.0374665,"x": -76.9292834410496},
  {"name": "LMAT029","y": -12.041288,"x": -76.9286936614327},
  {"name": "LMAT196-F","y": -11.9979505,"x": -76.8330848030303},
  {"name": "ZONA SATURADA","y": -12.0299055,"x": -76.9431174789929},
  {"name": "LMAT082-F","y": -12.027574,"x": -76.9381050055834},
  {"name": "LMAT194-F","y": -12.0162335,"x": -76.8382081336132},
  {"name": "LMAT062-S // LMAT062","y": -12.074289,"x": -76.9769058602794},
  {"name": "LMAT063","y": -12.073481,"x": -76.9743113696736},
  {"name": "LMAT064","y": -12.072827,"x": -76.9769800172826},
  {"name": "LMAT089-F","y": -12.03117,"x": -76.9370778103448},
  {"name": "LMAT066-S // LMAT066","y": -12.070059,"x": -76.9759494388371},
  {"name": "LMAT069","y": -12.031395,"x": -76.9406170451724},
  {"name": "LMAT073-F","y": -12.0551055,"x": -76.9590939395316},
  {"name": "ZONA SATURADA","y": -12.0502805,"x": -76.9513857672563},
  {"name": "LMAT080-F","y": -12.049751,"x": -76.9464819790576},
  {"name": "LMAT104-F","y": -12.062806,"x": -76.935337932701},
  {"name": "LMAG042-F","y": -12.0409935,"x": -76.9891484655131},
  {"name": "LMAT074-F","y": -12.057124,"x": -76.9595949758225},
  {"name": "ZONA SATURADA","y": -12.057012,"x": -76.9582903024971},
  {"name": "LMAT075-F","y": -12.0546205,"x": -76.957736528761},
  {"name": "LMAT076-F","y": -12.0565555,"x": -76.9558824813095},
  {"name": "ZONA SATURADA","y": -12.052069,"x": -76.9577406666193},
  {"name": "LMBR016-F","y": -10.75337685,"x": -77.7540690818959},
  {"name": "LMAT078-F","y": -12.056786,"x": -76.9475959639525},
  {"name": "LMAT084-F","y": -12.0269145,"x": -76.931970095136},
  {"name": "LMAT090-F","y": -12.0305075,"x": -76.9338377588698},
  {"name": "LMAT091-F","y": -12.029382,"x": -76.929997613615},
  {"name": "LMAT098-F","y": -12.026745,"x": -76.9089370419213},
  {"name": "LMAT092-F","y": -12.0277055,"x": -76.9257701557263},
  {"name": "LMAT093-F","y": -12.027627,"x": -76.9169913388186},
  {"name": "LMAT094-F","y": -12.028063,"x": -76.9155372878714},
  {"name": "LMAT095-F","y": -12.0279585,"x": -76.9143987419932},
  {"name": "LMAT103-F","y": -12.060954,"x": -76.9348787925087},
  {"name": "LMAT096-F","y": -12.0277495,"x": -76.9135703887262},
  {"name": "LMAT097-F","y": -12.0276175,"x": -76.9119751324768},
  {"name": "TRUJ174","y": -8.114812,"x": -79.0470790822263},
  {"name": "LMAT099-F","y": -12.0537755,"x": -76.9534361593079},
  {"name": "LMAT115-F","y": -12.024739,"x": -76.9054098804318},
  {"name": "LMAT100-F","y": -12.0528395,"x": -76.9508930731265},
  {"name": "LMAT114-F","y": -12.024589,"x": -76.9128268333333},
  {"name": "LMAT191-F","y": -12.0108385,"x": -76.8417936734229},
  {"name": "LMAT116-F","y": -12.0247615,"x": -76.9031776501775},
  {"name": "LMAT117-F","y": -12.023412,"x": -76.9010240074802},
  {"name": "LMAT118-F","y": -12.026031,"x": -76.9013380429802},
  {"name": "LMAT119-F","y": -12.0286455,"x": -76.9015989039406},
  {"name": "LMAT120-F","y": -12.03021,"x": -76.9035358444376},
  {"name": "LMSC088-S // LMSC088","y": -12.1123825,"x": -76.9896456262636},
  {"name": "LMAT122-F","y": -12.030063,"x": -76.9097952396194},
  {"name": "LMAT123-F","y": -12.0294025,"x": -76.9223536429591},
  {"name": "LMAT124-F","y": -12.0313055,"x": -76.9238681266003},
  {"name": "LMAT125-F","y": -12.035519,"x": -76.9224768021182},
  {"name": "LAMO082-S // LAMO082","y": -12.098857,"x": -76.9434495532008},
  {"name": "LMAT140-F","y": -12.0026345,"x": -76.8364862173173},
  {"name": "LMAT126-F","y": -12.0365855,"x": -76.9214199180099},
  {"name": "LMAT137-F","y": -12.0241985,"x": -76.8886961879587},
  {"name": "LMAT127-F","y": -12.0384965,"x": -76.9177255572179},
  {"name": "LMAT130-F","y": -12.040574,"x": -76.9171693716356},
  {"name": "LMAT132-F","y": -12.042773,"x": -76.9157633262527},
  {"name": "LMAT134-F","y": -12.02459,"x": -76.9177138329146},
  {"name": "LMAT142-F","y": -12.004347,"x": -76.840400547171},
  {"name": "LMAT135-F","y": -12.023165,"x": -76.897882545852},
  {"name": "LMAT154-F","y": -12.060865,"x": -76.9929522617989},
  {"name": "LMAT138-F","y": -12.0179945,"x": -76.8824923724694},
  {"name": "LMAT139-F","y": -12.00161,"x": -76.8343569668468},
  {"name": "LMAT143-F","y": -12.008364,"x": -76.8318204185165},
  {"name": "LMAT151-F","y": -12.059876,"x": -76.9953899585926},
  {"name": "LMAT152-F","y": -12.061392,"x": -76.9964657101612},
  {"name": "LMAT153-F","y": -12.0595355,"x": -76.9916257668906},
  {"name": "LMAT155-F","y": -12.061577,"x": -76.9899377308944},
  {"name": "LMAT159-F","y": -12.0322995,"x": -76.9042356092896},
  {"name": "LMAT160-F","y": -12.035758,"x": -76.9038489435484},
  {"name": "LMAT161-F","y": -12.039267,"x": -76.905103980187},
  {"name": "LMVS121-F","y": -12.1974995,"x": -76.9437916596154},
  {"name": "LMAT162-F","y": -12.0397605,"x": -76.9021665809979},
  {"name": "LMAT163-F","y": -12.0431825,"x": -76.898537291411},
  {"name": "LMAT190-F","y": -12.0097675,"x": -76.8456173140704},
  {"name": "LMAT192-F","y": -12.0100275,"x": -76.8398941847371},
  {"name": "LMAT164-F","y": -12.0299255,"x": -76.8919569711538},
  {"name": "LMAT229-F","y": -12.0631925,"x": -76.9825947395426},
  {"name": "LMAT165-F","y": -12.028793,"x": -76.8882225877427},
  {"name": "LMAT166-F","y": -12.0298035,"x": -76.8840384580446},
  {"name": "LMAT167-F","y": -12.026971,"x": -76.890579253304},
  {"name": "LMAT168-F","y": -12.02443,"x": -76.8839607299703},
  {"name": "LMAT193-F","y": -12.0162485,"x": -76.8400390703727},
  {"name": "LMAT183-F","y": -12.0099895,"x": -76.8632790502672},
  {"name": "LMAT169-F","y": -12.021414,"x": -76.882822980433},
  {"name": "LMAT170-F","y": -12.020265,"x": -76.8797713579092},
  {"name": "LMAT171-F","y": -12.0220725,"x": -76.8784222874145},
  {"name": "LMAT172-F","y": -12.0227225,"x": -76.8751665138761},
  {"name": "LMAT173-F","y": -12.0217035,"x": -76.8715725294409},
  {"name": "LMAT182-F","y": -12.0131095,"x": -76.8694181997786},
  {"name": "LMAT174-F","y": -12.022716,"x": -76.86935002},
  {"name": "LMAT175-F","y": -12.0206875,"x": -76.8747391919856},
  {"name": "LMAT176-F","y": -12.0175895,"x": -76.876365375},
  {"name": "LMSC063-S // LMSC063","y": -12.1296425,"x": -76.9800041316756},
  {"name": "LMAT245-F","y": -12.026766,"x": -76.8983683692336},
  {"name": "LMAT178-F","y": -12.0146705,"x": -76.8782315941132},
  {"name": "LMAT179-F","y": -12.0125955,"x": -76.8744157988861},
  {"name": "LMAT181-F","y": -12.0120415,"x": -76.8694028347222},
  {"name": "LMAT195-F","y": -12.0194735,"x": -76.838754051298},
  {"name": "LAMO089-F","y": -12.087081,"x": -76.8918381086072},
  {"name": "LMAT184-F","y": -12.009581,"x": -76.857395454023},
  {"name": "LMAT185-F","y": -12.0120205,"x": -76.853917167484},
  {"name": "LMAT186-F","y": -12.012365,"x": -76.8510108869269},
  {"name": "LMAT187-F","y": -12.0103475,"x": -76.8509312584695},
  {"name": "LMAT188-F","y": -12.0091285,"x": -76.8537736438356},
  {"name": "LMAT189-F","y": -12.00758,"x": -76.8464712407081},
  {"name": "LMAT197-F","y": -12.0000125,"x": -76.8315183838652},
  {"name": "LMBA029-F","y": -12.145442,"x": -77.0162404147597},
  {"name": "LMAT224-F","y": -12.067953,"x": -76.9764859046246},
  {"name": "LMAT200-F","y": -12.022014,"x": -76.8250766258278},
  {"name": "LMAT201-F","y": -12.0246375,"x": -76.8236769868458},
  {"name": "LMAT202-F","y": -12.027705,"x": -76.8265803647581},
  {"name": "LMAT203-F","y": -12.027795,"x": -76.8230032581121},
  {"name": "LMAT225-F","y": -12.069056,"x": -76.9779189024448},
  {"name": "LMAT204-F","y": -12.0307435,"x": -76.8234048309609},
  {"name": "LMAT205-F","y": -12.0297055,"x": -76.8210456441035},
  {"name": "LMAT220-F","y": -12.0558335,"x": -76.9620076021506},
  {"name": "LMAT222-F","y": -12.06638,"x": -76.9734752427746},
  {"name": "LMAT223-F","y": -12.0673955,"x": -76.975434108871},
  {"name": "LMAT226-F","y": -12.0685615,"x": -76.9794016635631},
  {"name": "LMCY007-F","y": -11.9939105,"x": -76.8251727},
  {"name": "LMAT227-F","y": -12.0692805,"x": -76.9819530969454},
  {"name": "LMSC118","y": -12.0766445,"x": -76.957446933965},
  {"name": "LMAT228-F","y": -12.06872,"x": -76.9839054907963},
  {"name": "LMAT230-F","y": -12.06251,"x": -76.9856432865507},
  {"name": "LMAT231-F","y": -12.0526195,"x": -76.9436743083624},
  {"name": "LMAG039-F","y": -12.035033,"x": -76.9905747026069},
  {"name": "LMAT234-F","y": -12.0450615,"x": -76.9302051777701},
  {"name": "LMAT235-F","y": -12.044808,"x": -76.9288351421663},
  {"name": "LMAT236-F","y": -12.044054,"x": -76.9268170916667},
  {"name": "LMAT237-F","y": -12.039681,"x": -76.921611335133},
  {"name": "LMAT238-F","y": -12.0417435,"x": -76.9191885557096},
  {"name": "LMAT239-F","y": -12.043115,"x": -76.9176467887953},
  {"name": "LMAT240-F","y": -12.045372,"x": -76.9166236401677},
  {"name": "LMAT241-F","y": -12.0445255,"x": -76.9143578617585},
  {"name": "LMAT242-F","y": -12.0270615,"x": -76.9066024078757},
  {"name": "LMAT244-F","y": -12.022928,"x": -76.8991764921913},
  {"name": "LMAT247-F","y": -12.0210445,"x": -76.8859072631968},
  {"name": "LMCY004-F","y": -11.985907,"x": -76.8149198641181},
  {"name": "LMAT248-F","y": -12.0143265,"x": -76.875342465979},
  {"name": "LMAT260-F","y": -12.0285255,"x": -76.9526587813187},
  {"name": "LMBA009","y": -12.142111,"x": -77.0248522907572},
  {"name": "LMBA011","y": -12.135732,"x": -77.0205396742424},
  {"name": "LMAG040-F","y": -12.036457,"x": -76.992988838408},
  {"name": "LMBA012","y": -12.137921,"x": -77.0214174266101},
  {"name": "LMBA013-S // LMBA013","y": -12.137621,"x": -77.019279240714},
  {"name": "LMAG019-F","y": -12.033084,"x": -76.9937890557275},
  {"name": "ZONA SATURADA","y": -12.0330765,"x": -76.9950025294466},
  {"name": "LMBA014-S // LMBA014","y": -12.1334445,"x": -77.0198362704327},
  {"name": "LMBA028-F","y": -12.142882,"x": -77.0168147711029},
  {"name": "LMBA030-F","y": -12.1450795,"x": -77.0188751454857},
  {"name": "LMBA031-F","y": -12.143489,"x": -77.0194196047342},
  {"name": "LMAG018-F","y": -12.0335315,"x": -76.9960080444079},
  {"name": "LMBA032-F","y": -12.14115,"x": -77.0200794037901},
  {"name": "LMCY005-F","y": -11.9854955,"x": -76.8123688457317},
  {"name": "LMCY006-F","y": -11.994125,"x": -76.8284789893773},
  {"name": "LMBA048-F","y": -12.152494,"x": -77.0222672451869},
  {"name": "LMAG021-F","y": -12.042171,"x": -77.000233101207},
  {"name": "LMBA049-F","y": -12.150886,"x": -77.0193684008076},
  {"name": "LMBA051-F","y": -12.139116,"x": -77.0161113615843},
  {"name": "LMBA052-F","y": -12.146524,"x": -77.0204790523885},
  {"name": "LMAG022-F","y": -12.045101,"x": -77.0024798809274},
  {"name": "LMAG052-F","y": -12.0548775,"x": -77.005786625},
  {"name": "LMBA053-F","y": -12.148327,"x": -77.0176307948696},
  {"name": "LMBA054-F","y": -12.1468765,"x": -77.0221340279333},
  {"name": "LMCY008-F","y": -11.9922835,"x": -76.8224307353404},
  {"name": "LMCY009-F","y": -11.9937435,"x": -76.8200819485842},
  {"name": "LMAG024-F","y": -12.04315,"x": -76.9982196321484},
  {"name": "LMCY010-F","y": -11.9856605,"x": -76.8082000027076},
  {"name": "LMCY011-F","y": -11.9803845,"x": -76.7932103008615},
  {"name": "LMCY013-F","y": -11.986379,"x": -76.8167144927839},
  {"name": "LMCY014-F","y": -11.9777145,"x": -76.7819020364892},
  {"name": "LMCY015-F","y": -11.982755,"x": -76.77989622},
  {"name": "LMAG013-F","y": -12.0329935,"x": -77.0015226719537},
  {"name": "LMAG023-F","y": -12.0442975,"x": -77.0006346608155},
  {"name": "LMCY016-F","y": -11.9784455,"x": -76.7754263337239},
  {"name": "LMCY017-F","y": -11.977133,"x": -76.7688883663785},
  {"name": "LMCY019-F","y": -11.984813,"x": -76.808979455814},
  {"name": "LMCY020-F","y": -11.9822015,"x": -76.7998234454991},
  {"name": "LMAG011-F","y": -12.0341755,"x": -77.0066359661017},
  {"name": "LMAG012-F","y": -12.033687,"x": -77.0039178176505},
  {"name": "LMAG026-F","y": -12.0474705,"x": -77.0019854898265},
  {"name": "LMAG027-F","y": -12.037303,"x": -76.9981999234184},
  {"name": "LMAG028-F","y": -12.0366305,"x": -76.9964755400875},
  {"name": "LMAG029-F","y": -12.035921,"x": -76.9948698543388},
  {"name": "LMAG030-F","y": -12.0384135,"x": -76.9920813835051},
  {"name": "LMAG031-F","y": -12.038379,"x": -76.9940328337898},
  {"name": "LMAG032-F","y": -12.0387825,"x": -76.9961092651784},
  {"name": "LMAG035-F","y": -12.031668,"x": -77.0072638863636},
  {"name": "LMAG036-F","y": -12.029996,"x": -77.0026253211509},
  {"name": "LMAG037-F","y": -12.028558,"x": -76.9971890735484},
  {"name": "LMAG038-F","y": -12.029032,"x": -76.9935659976848},
  {"name": "LMAG044-F","y": -12.0491895,"x": -77.0055911955806},
  {"name": "LMAG045-F","y": -12.0492235,"x": -77.0027090745921},
  {"name": "LMAG046-F","y": -12.0502385,"x": -77.0036979947496},
  {"name": "LMAG047-F","y": -12.0509255,"x": -77.0044319243987},
  {"name": "LMAG048-F","y": -12.0520535,"x": -77.0046537812003},
  {"name": "LMAG049-F","y": -12.0520105,"x": -77.0076771993671},
  {"name": "LMAG050-F","y": -12.050226,"x": -77.0079887456223},
  {"name": "LMAG051-F","y": -12.0537385,"x": -77.0051485088838},
  {"name": "LAMO029","y": -12.0668315,"x": -76.9347314956145},
  {"name": "LAMO040-S // LAMO040","y": -12.1159895,"x": -76.9407182118353},
  {"name": "LAMO026-S // LAMO026","y": -12.072972,"x": -76.9384227220125},
  {"name": "LAMO028","y": -12.071302,"x": -76.9523572608865},
  {"name": "LAMO039-S // LAMO039","y": -12.101882,"x": -76.9354407750016},
  {"name": "TRUJ131-S // TRUJ131","y": -8.0922805,"x": -79.0461262748291},
  {"name": "LMJR136-F","y": -12.180314,"x": -76.9805688710711},
  {"name": "LAMO035-S // LAMO035","y": -12.0783645,"x": -76.9372483286695},
  {"name": "LAMO036-S // LAMO036","y": -12.1086245,"x": -76.9421938542296},
  {"name": "LAMO037-S // LAMO037","y": -12.1117285,"x": -76.9364117169811},
  {"name": "LAMO038-S // LAMO038","y": -12.111544,"x": -76.9437729596651},
  {"name": "LMSC062-S // LMSC062","y": -12.127513,"x": -76.98027333366},
  {"name": "LAMO053-S","y": -12.0873045,"x": -76.9521801680232},
  {"name": "LAMO053","y": -12.0877455,"x": -76.9443291222103},
  {"name": "LAMO053","y": -12.084777,"x": -76.9523829089577},
  {"name": "LAMO053","y": -12.0872685,"x": -76.9556640133577},
  {"name": "LAMO054-S","y": -12.101128,"x": -76.9502002618503},
  {"name": "LAMO075-S // LAMO075","y": -12.0908625,"x": -76.9306619762219},
  {"name": "LAMO076-S // LAMO076","y": -12.0833635,"x": -76.9240309911266},
  {"name": "LAMO077-S // LAMO077","y": -12.0843885,"x": -76.913777377264},
  {"name": "LAMO079-S // LAMO079","y": -12.0645075,"x": -76.94263516995},
  {"name": "LAMO080-S // LAMO080","y": -12.071892,"x": -76.9627059199785},
  {"name": "LAMO090-F","y": -12.0884085,"x": -76.8878525261667},
  {"name": "LMSC094-S","y": -12.1236025,"x": -76.9757536120998},
  {"name": "LMSC067-S // LMSC067","y": -12.12471,"x": -76.9850839146586},
  {"name": "LMSC068-S","y": -12.1225575,"x": -76.9815768809686},
  {"name": "LMSC069-S // LMSC069","y": -12.1216715,"x": -76.9836914095212},
  {"name": "LMSC070-S // LMSC070","y": -12.1197515,"x": -76.9798096436825},
  {"name": "LMSC099-S","y": -12.118355,"x": -76.9756423057732},
  {"name": "LMSC071-S // LMSC071","y": -12.1184975,"x": -76.9826265398495},
  {"name": "LMSC072-S // LMSC072","y": -12.11657,"x": -76.980005327296},
  {"name": "LMSC073-S // LMSC073","y": -12.1162575,"x": -76.9816034478394},
  {"name": "LMSC074-S // LMSC074","y": -12.120928,"x": -76.9856078714799},
  {"name": "LMSC075-S // LMSC075","y": -12.116592,"x": -76.9847479602556},
  {"name": "LMSC076-S // LMSC076","y": -12.119334,"x": -76.9866157594538},
  {"name": "LMSC078-S // LMSC078","y": -12.11735,"x": -76.9861065833333},
  {"name": "LMSC079-S // LMSC079","y": -12.1157555,"x": -76.989090635912},
  {"name": "LMSC080-S","y": -12.1140955,"x": -76.9858732237583},
  {"name": "LMSC081-S // LMSC081","y": -12.1154815,"x": -76.9833177196055},
  {"name": "LMSC082-S","y": -12.1135235,"x": -76.9819697392354},
  {"name": "LMSC083-S","y": -12.1142835,"x": -76.9804144383537},
  {"name": "LMSC084-S // LMSC084","y": -12.113044,"x": -76.9785745380782},
  {"name": "LMSC085-S // LMSC085","y": -12.1117435,"x": -76.9802580886176},
  {"name": "LMSC086-S","y": -12.112271,"x": -76.9823043792709},
  {"name": "LMSC087-S // LMSC087","y": -12.1118265,"x": -76.9860124754181},
  {"name": "LMSC090-S","y": -12.1264035,"x": -76.9759237127007},
  {"name": "LMSC092","y": -12.12774,"x": -76.9708470656845},
  {"name": "LMSC093-S // LMSC093","y": -12.125761,"x": -76.9738090579399},
  {"name": "LMSC096-S // LMSC096","y": -12.1210975,"x": -76.9761568533517},
  {"name": "LMSC097-S","y": -12.120329,"x": -76.9741870361964},
  {"name": "LMSC098-S","y": -12.116911,"x": -76.9738942394984},
  {"name": "LMSC098","y": -12.115661,"x": -76.9739665550697},
  {"name": "LMSC098","y": -12.1187485,"x": -76.9726013858556},
  {"name": "LMSC100-S","y": -12.114547,"x": -76.9747726929596},
  {"name": "LMSC100","y": -12.116063,"x": -76.9761024249476},
  {"name": "LMSC100","y": -12.1121815,"x": -76.9743806605048},
  {"name": "LMSC101-S // LMSC101","y": -12.116198,"x": -76.971784898863},
  {"name": "LMSC102-S // LMSC102","y": -12.1149545,"x": -76.9691021074702},
  {"name": "LMSC104-S","y": -12.112049,"x": -76.9724832626332},
  {"name": "LMSC105-S // LMSC105","y": -12.1136665,"x": -76.9731353723526},
  {"name": "LMSC106-S // LMSC106","y": -12.1112315,"x": -76.9707721672392},
  {"name": "LMSC107-S","y": -12.1098915,"x": -76.9698462567454},
  {"name": "LMSC115-S // LMSC115","y": -12.083333,"x": -76.9785714673632},
  {"name": "LMRC006-S // LMRC006","y": -12.0244865,"x": -77.0288251929987},
  {"name": "LMSC108-S","y": -12.109544,"x": -76.9678193674127},
  {"name": "LMSC108","y": -12.1113585,"x": -76.9680958580714},
  {"name": "LMSC109-S // LMSC109","y": -12.108398,"x": -76.9646336402851},
  {"name": "LMSC112","y": -12.136673,"x": -76.9793897183236},
  {"name": "LMSC112","y": -12.131776,"x": -76.9780964641},
  {"name": "LMSC112","y": -12.1313745,"x": -76.9770138768718},
  {"name": "LMSC113-S // LMSC113","y": -12.127014,"x": -76.9860816708145},
  {"name": "LMSC114-S // LMSC114","y": -12.08113,"x": -76.9764679981463},
  {"name": "LMSC117-S // LMSC117","y": -12.087294,"x": -76.9713420307829},
  {"name": "LMSC124-S // LMSC124","y": -12.0978095,"x": -76.9672980354364},
  {"name": "LMSC319-F","y": -12.165297,"x": -76.9984002556111},
  {"name": "LMSC118-S","y": -12.081064,"x": -76.9582172576564},
  {"name": "LMSC118","y": -12.08101,"x": -76.9614793507742},
  {"name": "LMSC120-S // LMSC120","y": -12.0929345,"x": -76.9689568414066},
  {"name": "LMSC286-F","y": -12.1425725,"x": -76.9835164643581},
  {"name": "LMSC121-S // LMSC121","y": -12.0914485,"x": -76.9663481969574},
  {"name": "LMSC122-S // LMSC122","y": -12.0953945,"x": -76.9724749496661},
  {"name": "LMSC135-S // LMSC135","y": -12.106564,"x": -76.9724665941868},
  {"name": "5222B06BS // 5222B06-B","y": -12.10862145,"x": -76.9816342132489},
  {"name": "LMSC123","y": -12.095162,"x": -76.9653762830663},
  {"name": "LMSC126-S // LMSC126","y": -12.0995825,"x": -76.9747285140279},
  {"name": "LMSC193-S // LMSC193","y": -12.10676,"x": -76.9615684924718},
  {"name": "LMSC131-S // LMSC131","y": -12.103742,"x": -76.9762302516621},
  {"name": "LMSC132-S // LMSC132","y": -12.1033085,"x": -76.9717441918771},
  {"name": "LMSC134-S","y": -12.1067145,"x": -76.9767491025837},
  {"name": "LMSC134","y": -12.1051025,"x": -76.9765935386376},
  {"name": "LMSC283-F","y": -12.141063,"x": -76.9866462144814},
  {"name": "LMSC279-F","y": -12.1347325,"x": -76.9816639997357},
  {"name": "LMSC280-F","y": -12.137083,"x": -76.9818592321267},
  {"name": "LMJR178-F","y": -12.163631,"x": -76.9848573712467},
  {"name": "LMJR179-F","y": -12.1650955,"x": -76.9849311270611},
  {"name": "LMSC293-F","y": -12.1369655,"x": -76.9981947035749},
  {"name": "LMJR180-F","y": -12.159244,"x": -76.986826486182},
  {"name": "LMSC184-S","y": -12.125308,"x": -76.9952143235344},
  {"name": "LMSC185-S // LMSC185","y": -12.0832235,"x": -76.9673159724322},
  {"name": "LMSC194-S // LMSC194","y": -12.1067955,"x": -76.9634056923945},
  {"name": "LMSC285-F","y": -12.141343,"x": -76.9851960139212},
  {"name": "LMSC292-F","y": -12.148157,"x": -76.987672780453},
  {"name": "LMSC195-S // LMSC195","y": -12.1106015,"x": -76.9620740093672},
  {"name": "LMSC252-S","y": -12.085123,"x": -76.9604191222123},
  {"name": "LMSC278-F","y": -12.118887,"x": -76.9677827097458},
  {"name": "LMSC281-F","y": -12.139258,"x": -76.9825606113116},
  {"name": "LMSC289-F","y": -12.1443555,"x": -76.983664831671},
  {"name": "LMSC290-F","y": -12.1457805,"x": -76.9837993933594},
  {"name": "LMSC274-S // LMSC274","y": -12.136988,"x": -76.9937722675732},
  {"name": "LMSC287-F","y": -12.1445805,"x": -76.9878857115962},
  {"name": "LMSC288-F","y": -12.145596,"x": -76.986629546875},
  {"name": "LMHL016-F","y": -11.50077515,"x": -77.2079781774491},
  {"name": "LMSC275-S // LMSC275","y": -12.133562,"x": -76.9909314440372},
  {"name": "LMSC276-S // LMSC276","y": -12.138362,"x": -76.9922893945703},
  {"name": "LMSC294-F","y": -12.1409985,"x": -76.9975285837595},
  {"name": "LMSC295-F","y": -12.13983,"x": -76.9957261247057},
  {"name": "LMSC296-F","y": -12.141883,"x": -76.9986788106826},
  {"name": "LMSC297-F","y": -12.1414005,"x": -76.9931306697366},
  {"name": "LMSC317-F","y": -12.1665735,"x": -76.9946090471672},
  {"name": "LMSC305-F","y": -12.1320475,"x": -77.0012667054984},
  {"name": "LMSC298-F","y": -12.143793,"x": -76.9962319756944},
  {"name": "LMSC326-F","y": -12.1636565,"x": -76.9876966796875},
  {"name": "LMSC299-F","y": -12.1446325,"x": -76.9932408581933},
  {"name": "LMSC309-F","y": -12.1345255,"x": -76.9989352032411},
  {"name": "LMSC301-F","y": -12.1466365,"x": -76.9924722677648},
  {"name": "LMSC302-F","y": -12.1452325,"x": -76.9900833717155},
  {"name": "ZONA SATURADA","y": -12.130874,"x": -77.0005506802086},
  {"name": "ZONA SATURADA","y": -12.132879,"x": -77.0018431793478},
  {"name": "LMSC307-F","y": -12.139398,"x": -77.004103034066},
  {"name": "LMSC308-F","y": -12.138446,"x": -77.0009354304348},
  {"name": "LMSC310-F","y": -12.135646,"x": -77.0129867444444},
  {"name": "LMSC310-F","y": -12.1376575,"x": -77.0110673024193},
  {"name": "LMSC316-F","y": -12.1626045,"x": -76.9965057974374},
  {"name": "LMSC324-F","y": -12.1616755,"x": -76.987968991623},
  {"name": "LMSC325-F","y": -12.1628305,"x": -76.9902214294141},
  {"name": "LMSC326-F","y": -12.161835,"x": -76.9870479780138},
  {"name": "LMLR017-F","y": -12.250797,"x": -76.8986938030303},
  {"name": "LMSC367-F","y": -12.1568615,"x": -76.9872666964819},
  {"name": "LMSC331-F","y": -12.1131165,"x": -76.9762610292041},
  {"name": "LMHL013-F","y": -11.498206,"x": -77.2086930232112},
  {"name": "LMSC332-F","y": -12.1076375,"x": -76.9703842306188},
  {"name": "LMSC350-F","y": -12.1414125,"x": -77.0056487890475},
  {"name": "LMSC133-S","y": -12.105599,"x": -76.9681316589513},
  {"name": "LMSC336-F","y": -12.145069,"x": -77.0117026659051},
  {"name": "TRUJ099","y": -8.1124685,"x": -79.016203997887},
  {"name": "LMSC337-F","y": -12.148304,"x": -77.0118376054048},
  {"name": "LMSC338-F","y": -12.150282,"x": -77.016256572473},
  {"name": "LMHL014-F","y": -11.4986665,"x": -77.2123230936427},
  {"name": "LMSC339-F","y": -12.149873,"x": -77.0136940876019},
  {"name": "LMSC339-F","y": -12.1499405,"x": -77.0114953543205},
  {"name": "LMSC340-F","y": -12.15146,"x": -77.0103641374457},
  {"name": "LMSC341-F","y": -12.1528315,"x": -77.0035704960579},
  {"name": "LMSC341-F","y": -12.15232,"x": -77.005522723127},
  {"name": "LMSC349-F","y": -12.143409,"x": -77.0082212834878},
  {"name": "5221C06","y": -12.103655,"x": -76.9922985644258},
  {"name": "LMSC348-F","y": -12.144732,"x": -77.0064044261252},
  {"name": "LMSC366-F","y": -12.1548335,"x": -76.989462596644},
  {"name": "LMSC342-F","y": -12.149345,"x": -77.0063155065494},
  {"name": "LMSC343-F","y": -12.147363,"x": -77.0071633548168},
  {"name": "LMSC345-F","y": -12.14674,"x": -77.0009177667882},
  {"name": "LMSC346-F","y": -12.144679,"x": -77.0023553315697},
  {"name": "LMSC347-F","y": -12.143669,"x": -77.0039987028424},
  {"name": "LMHL027-F","y": -11.50201,"x": -77.2186935561024},
  {"name": "LMSC351-F","y": -12.159414,"x": -76.9904032736325},
  {"name": "LMSC352-F","y": -12.16063,"x": -76.9904199990342},
  {"name": "LMSC361-F","y": -12.1349675,"x": -77.0152826200998},
  {"name": "LMSC362-F","y": -12.135525,"x": -77.0073365878765},
  {"name": "LMSL007","y": -12.077521,"x": -77.0019063406214},
  {"name": "LMSC363-F","y": -12.1604195,"x": -76.9862434008325},
  {"name": "LMSC365-F","y": -12.158677,"x": -76.9880172446236},
  {"name": "LMSC368-F","y": -12.104967,"x": -76.9574638713449},
  {"name": "LMSC369-F","y": -12.10497,"x": -76.9544045203681},
  {"name": "LMSC371-F","y": -12.159565,"x": -76.9957580721244},
  {"name": "ZONA SATURADA","y": -12.1601145,"x": -76.9960794378778},
  {"name": "LMSL008","y": -12.0780465,"x": -76.9964575942762},
  {"name": "LMHL026-F","y": -11.5028895,"x": -77.2147859738071},
  {"name": "5120F02","y": -12.099554,"x": -77.0041168396226},
  {"name": "LMSC373-F","y": -12.1509085,"x": -76.9903459165296},
  {"name": "LMSC375-F","y": -12.151921,"x": -77.0169159263566},
  {"name": "LMSC425-F","y": -12.1527575,"x": -77.0135089440994},
  {"name": "LMSC426-F","y": -12.1531645,"x": -77.0154254954862},
  {"name": "LMSC427-F","y": -12.1545885,"x": -77.0153429267723},
  {"name": "LMVS174-F","y": -12.239526,"x": -76.9187563746951},
  {"name": "LMSC428-F","y": -12.155039,"x": -77.0142970698756},
  {"name": "LMSC432-F","y": -12.095126,"x": -76.9632853751176},
  {"name": "LMSQ150-F","y": -12.11205,"x": -77.0208433161224},
  {"name": "LMSC439-F","y": -12.151331,"x": -76.9854224875072},
  {"name": "LMSC440-F","y": -12.1537545,"x": -76.9850243401941},
  {"name": "LMSC455-F","y": -12.1486825,"x": -77.0130328272353},
  {"name": "5120A02-S // 5120A02","y": -12.1023675,"x": -77.0086292201715},
  {"name": "5220A02","y": -12.1056595,"x": -77.0099646837765},
  {"name": "5120B02","y": -12.1023575,"x": -77.0040421947646},
  {"name": "LMSB046-S // LMSB046","y": -12.090333,"x": -76.9825409440543},
  {"name": "LMSB029-S // LMSB029","y": -12.0902043,"x": -76.9969602163548},
  {"name": "LMSQ189-F","y": -12.115704,"x": -77.0181557403846},
  {"name": "5122B02","y": -12.099383,"x": -76.9927062345522},
  {"name": "5220B02-S // 5220B02","y": -12.106803,"x": -77.0063588388451},
  {"name": "5220C02","y": -12.1048085,"x": -77.0038789408706},
  {"name": "5120D02","y": -12.0986855,"x": -77.0079611735541},
  {"name": "LMSB113-F","y": -12.110846,"x": -77.0084809605863},
  {"name": "512000","y": -12.096223,"x": -77.0056738536736},
  {"name": "5121A06","y": -12.1022765,"x": -76.9998624810081},
  {"name": "LMSB010","y": -12.1057365,"x": -76.9973029784676},
  {"name": "5222A06AS // 5222A06-A","y": -12.1071975,"x": -76.9902294967296},
  {"name": "5222A06-B","y": -12.109117,"x": -76.9866419138273},
  {"name": "5221D06","y": -12.109038,"x": -76.9946581591376},
  {"name": "5222B06AS // 5222B06-A","y": -12.1052384,"x": -76.9819789413184},
  {"name": "LMSB045-S // LMSB045","y": -12.0920625,"x": -76.9847239848084},
  {"name": "LMLR018-F","y": -12.276132,"x": -76.8414383002226},
  {"name": "LMSB012-S // LMSB012","y": -12.1040295,"x": -76.99539086459},
  {"name": "LMSB044-S // LMSB044","y": -12.093988,"x": -76.986848219105},
  {"name": "LMSB018","y": -12.098208,"x": -76.9975875415129},
  {"name": "LMSB020-S // LMSB020","y": -12.098228,"x": -76.9909166784188},
  {"name": "LMRC017-S // LMRC017","y": -12.026654,"x": -77.0353501673973},
  {"name": "LMSB021","y": -12.094688,"x": -76.9936096749497},
  {"name": "LMSB022","y": -12.09753,"x": -77.0015021109467},
  {"name": "LMSL010-S // LMSL010","y": -12.078789,"x": -76.9919144656295},
  {"name": "LMSQ091-S","y": -12.1175875,"x": -77.0039727632112},
  {"name": "LMSL009","y": -12.076717,"x": -76.9927689789157},
  {"name": "LMSQ095-S // LMSQ095","y": -12.117785,"x": -76.9977115881391},
  {"name": "LMSB112-F","y": -12.1093335,"x": -77.0087801665504},
  {"name": "LMSB030","y": -12.0903575,"x": -76.9946497962922},
  {"name": "LMSL022-F","y": -12.0723305,"x": -77.000454787842},
  {"name": "LMSB031","y": -12.089482,"x": -76.9909613471616},
  {"name": "LMSB032","y": -12.093044,"x": -76.9900933372158},
  {"name": "LMSL005","y": -12.0739,"x": -76.9945151420598},
  {"name": "LMSL030-F","y": -12.062191,"x": -77.0001624979675},
  {"name": "LMSL006","y": -12.0757065,"x": -76.9968453933853},
  {"name": "LMSB033-S // LMSB033","y": -12.088563,"x": -76.9865520910807},
  {"name": "LMSB042-S // LMSB042","y": -12.0946625,"x": -76.9983868441234},
  {"name": "LMSQ038","y": -12.1245795,"x": -77.0025642787586},
  {"name": "LMSB082-F","y": -12.085308,"x": -76.9920202674253},
  {"name": "LMSL011","y": -12.0804225,"x": -76.9950007458698},
  {"name": "LMSL012","y": -12.079651,"x": -76.9889514669796},
  {"name": "LMSL018-S // LMSL018","y": -12.080631,"x": -76.9912712777778},
  {"name": "LMSL019-S // LMSL019","y": -12.0753975,"x": -77.0067742424863},
  {"name": "LMSL021-F","y": -12.0753545,"x": -76.9982411145833},
  {"name": "LMSL023-F","y": -12.070661,"x": -76.996916211557},
  {"name": "LMCH041-S // LMCH041","y": -12.1986085,"x": -77.0102503743149},
  {"name": "LMSL024-F","y": -12.0730825,"x": -76.9976593873452},
  {"name": "LMSL026-F","y": -12.078702,"x": -77.0085390175045},
  {"name": "LMSL027-F","y": -12.0770215,"x": -77.0052584505393},
  {"name": "LMSL028-F","y": -12.0799395,"x": -77.0066407654198},
  {"name": "LMSL029-F","y": -12.0612655,"x": -76.9989524226286},
  {"name": "LMSL031-F","y": -12.065943,"x": -76.9969585559887},
  {"name": "LMSL032-F","y": -12.078375,"x": -77.0027257338326},
  {"name": "LMSL034-F","y": -12.0741505,"x": -77.0032589114078},
  {"name": "LMSQ033-R","y": -12.115508,"x": -77.0005551953681},
  {"name": "LMSQ033-R","y": -12.1157785,"x": -77.0039881002341},
  {"name": "LMSQ033-S","y": -12.1151495,"x": -77.0023905938513},
  {"name": "LMSQ035-S // LMSQ035","y": -12.118417,"x": -77.0002580072816},
  {"name": "LMSQ168-F","y": -12.1157565,"x": -77.0170007719355},
  {"name": "LMSQ036","y": -12.122634,"x": -77.0034597797619},
  {"name": "LMSQ037","y": -12.121656,"x": -77.0007021062718},
  {"name": "LMVS012","y": -12.2024055,"x": -76.9510419400685},
  {"name": "LMSQ076-S // LMSQ076","y": -12.114763,"x": -77.0055990326699},
  {"name": "LMSQ077-S // LMSQ077","y": -12.1134095,"x": -77.0024603828512},
  {"name": "LMSQ078-S // LMSQ078","y": -12.119381,"x": -77.0060073808626},
  {"name": "LMSQ079","y": -12.116401,"x": -77.0042249384302},
  {"name": "LMSQ079","y": -12.1183545,"x": -77.0050959281915},
  {"name": "LMSQ089-S","y": -12.119585,"x": -77.0031222088113},
  {"name": "LMSQ094-S // LMSQ094","y": -12.1134995,"x": -76.9981572622461},
  {"name": "LMCH093-F","y": -12.193048,"x": -77.0214876419348},
  {"name": "LMSQ153-F","y": -12.1130725,"x": -77.0238905002864},
  {"name": "LMSQ155-F","y": -12.1164625,"x": -77.0234087630301},
  {"name": "LMCH001","y": -12.1715795,"x": -77.0068377918299},
  {"name": "LMJL036-S","y": -12.0098225,"x": -77.0121199963197},
  {"name": "LMSQ157-F","y": -12.1186155,"x": -77.0230484936953},
  {"name": "TRUJ060-S // TRUJ060","y": -8.1026825,"x": -79.0437593987251},
  {"name": "LMSQ158-F","y": -12.104342,"x": -77.0251870986687},
  {"name": "LMSQ159-F","y": -12.105019,"x": -77.0210730712095},
  {"name": "LMSQ160-F","y": -12.1081705,"x": -77.0229738368623},
  {"name": "LMSQ169-F","y": -12.110154,"x": -77.0112830814675},
  {"name": "LMSQ161-F","y": -12.1104435,"x": -77.0237517686625},
  {"name": "LMSQ162-F","y": -12.107368,"x": -77.0177255868263},
  {"name": "LMSQ162-F","y": -12.107628,"x": -77.020290878655},
  {"name": "LMSQ163-F","y": -12.110124,"x": -77.0198309562792},
  {"name": "LMSQ165-F","y": -12.110753,"x": -77.0159680467033},
  {"name": "LMSQ167-F","y": -12.1140595,"x": -77.0168234999846},
  {"name": "LMCH002-S // LMCH002","y": -12.1736265,"x": -77.0078420823668},
  {"name": "LMCH003-S // LMCH003","y": -12.1758895,"x": -77.0051061221591},
  {"name": "LMCH004-S // LMCH004","y": -12.175459,"x": -77.009297216354},
  {"name": "LMCH005-S // LMCH005","y": -12.176932,"x": -77.010113862473},
  {"name": "LMCH006-S // LMCH006","y": -12.178861,"x": -77.0082455613183},
  {"name": "LMCH007-S // LMCH007","y": -12.1815505,"x": -77.0099003603249},
  {"name": "LMCH008","y": -12.178515,"x": -77.0123339858725},
  {"name": "LMCH029","y": -12.1897765,"x": -77.0073327954545},
  {"name": "LMCH009","y": -12.1756015,"x": -77.0156808326772},
  {"name": "LLTR028-F","y": -8.10331,"x": -78.9827197631867},
  {"name": "LMCH011-S // LMCH011","y": -12.1727275,"x": -77.0177216951271},
  {"name": "LMCH013","y": -12.1750555,"x": -77.0212630892046},
  {"name": "LMCH029","y": -12.192231,"x": -77.0109633142379},
  {"name": "LMCH029-S","y": -12.1897955,"x": -77.0093062257951},
  {"name": "LMCH016-S // LMCH016","y": -12.1719465,"x": -77.0247089963381},
  {"name": "LMCH020-S // LMCH020","y": -12.168295,"x": -77.0228654800212},
  {"name": "LMCH021","y": -12.168641,"x": -77.0308081690608},
  {"name": "LMCH025","y": -12.1599975,"x": -77.0234580021228},
  {"name": "LMVS076-F","y": -12.2247725,"x": -76.9486230363873},
  {"name": "LMCH026-S // LMCH026","y": -12.157663,"x": -77.0209930332859},
  {"name": "LMCH029","y": -12.1895435,"x": -77.0124875129865},
  {"name": "LMCH030-S // LMCH030","y": -12.210251,"x": -77.0160709937105},
  {"name": "LMCH031-S // LMCH031","y": -12.2090015,"x": -77.0181887342026},
  {"name": "LMCH035","y": -12.168283,"x": -77.0275203134621},
  {"name": "LMVS128-F","y": -12.216441,"x": -76.9523748879056},
  {"name": "LMCH036","y": -12.2036645,"x": -77.0046668164492},
  {"name": "LMCH038","y": -12.203729,"x": -77.0114297474977},
  {"name": "LMCH039","y": -12.199634,"x": -77.0123702914882},
  {"name": "LMCH039","y": -12.203377,"x": -77.008635643217},
  {"name": "LMCH039","y": -12.2007825,"x": -77.0136487794756},
  {"name": "LMCH090-F","y": -12.195757,"x": -77.0265312143744},
  {"name": "LMCH039-S","y": -12.201524,"x": -77.0112773181467},
  {"name": "LMCH040-S // LMCH040","y": -12.1951755,"x": -77.0117034555632},
  {"name": "LMMP263-F","y": -11.9686825,"x": -77.0951809587532},
  {"name": "LMCH042-S // LMCH042","y": -12.2011055,"x": -77.007725110147},
  {"name": "LMCH068","y": -12.1947215,"x": -77.0069443911734},
  {"name": "LMCH091-F","y": -12.1943475,"x": -77.024170832037},
  {"name": "LMCH160-F","y": -12.196315,"x": -77.0186266401639},
  {"name": "LMCH069-S // LMCH069","y": -12.1979975,"x": -77.0033047106192},
  {"name": "LMCH070","y": -12.203824,"x": -77.0168820421304},
  {"name": "LMVT049-F","y": -11.858675,"x": -77.1270678116206},
  {"name": "LMCH071-S // LMCH071","y": -12.204914,"x": -77.0198531531423},
  {"name": "LMCH080","y": -12.1703795,"x": -77.0266053782895},
  {"name": "LMCH081-S // LMCH081","y": -12.165563,"x": -77.0235885418012},
  {"name": "LMCH092-F","y": -12.1969635,"x": -77.0241283934446},
  {"name": "LMCH094-F","y": -12.1952705,"x": -77.0208692790634},
  {"name": "LMCH082-S // LMCH082","y": -12.172843,"x": -77.0239822545165},
  {"name": "LMCH083","y": -12.170509,"x": -77.0207423825146},
  {"name": "LMCH122-F","y": -12.194648,"x": -76.9883866454691},
  {"name": "LMCH084","y": -12.175507,"x": -77.0237850455254},
  {"name": "LMCH087-F","y": -12.1697665,"x": -76.9982040047073},
  {"name": "LMJL013-S // LMJL013","y": -11.991622,"x": -77.0097199749733},
  {"name": "LMCH095-F","y": -12.1975125,"x": -77.0221887958589},
  {"name": "LMRC003-S // LMRC003","y": -12.019463,"x": -77.0297172191377},
  {"name": "LMCH123-F","y": -12.1982615,"x": -76.9895513481121},
  {"name": "LMCH097-F","y": -12.1920965,"x": -77.0192853249064},
  {"name": "LMCH098-F","y": -12.188475,"x": -77.0182802553247},
  {"name": "LMCH100-F","y": -12.185916,"x": -77.0156339133964},
  {"name": "LMCH101-F","y": -12.1866455,"x": -77.0145993621495},
  {"name": "LMCH102-F","y": -12.187844,"x": -77.0130499203368},
  {"name": "LMCH124-F","y": -12.1897525,"x": -76.9829845121951},
  {"name": "LMCH125-F","y": -12.1930465,"x": -76.9832748141897},
  {"name": "LMCS010-F","y": -11.9310425,"x": -76.6924600513747},
  {"name": "LMCH103-F","y": -12.1858345,"x": -77.0112226377389},
  {"name": "LMCH104-F","y": -12.1853465,"x": -77.0079096852094},
  {"name": "LMCH134-F","y": -12.190382,"x": -76.9943529619658},
  {"name": "LMCH105-F","y": -12.188217,"x": -77.0057682658319},
  {"name": "LMVS015-S // LMVS015","y": -12.191382,"x": -76.9489583904227},
  {"name": "LMJL043-S","y": -12.011207,"x": -77.0100469531171},
  {"name": "LMCH106-F","y": -12.185363,"x": -77.0058258959075},
  {"name": "LMCH107-F","y": -12.187925,"x": -77.0033411320225},
  {"name": "LMCH108-F","y": -12.190141,"x": -77.0046120447667},
  {"name": "LMCH109-F","y": -12.1855685,"x": -77.0009967330163},
  {"name": "LMCH110-F","y": -12.188812,"x": -76.9992071918089},
  {"name": "LMCH117-F","y": -12.1908665,"x": -77.0170400781361},
  {"name": "LMCH111-F","y": -12.1848365,"x": -76.9982471882924},
  {"name": "LMCH112-F","y": -12.1814805,"x": -76.9962016563756},
  {"name": "LMCH113-F","y": -12.1959315,"x": -76.9979038887197},
  {"name": "LMHL009-F","y": -11.4962035,"x": -77.2054477290939},
  {"name": "LMCH114-F","y": -12.198105,"x": -76.9978820515797},
  {"name": "LMCH131-F","y": -12.197141,"x": -76.9797465181913},
  {"name": "LMCH121-F","y": -12.191059,"x": -76.9854160791911},
  {"name": "LMCH126-F","y": -12.196906,"x": -76.9861999375},
  {"name": "LMCH127-F","y": -12.192613,"x": -76.9813586155389},
  {"name": "LMCH129-F","y": -12.1920945,"x": -76.9916780228959},
  {"name": "LMCH130-F","y": -12.195384,"x": -76.977585765625},
  {"name": "LMCH132-F","y": -12.1999905,"x": -76.9807096871103},
  {"name": "LMCH133-F","y": -12.1970745,"x": -76.9742366958992},
  {"name": "LMHL028-F","y": -11.5009075,"x": -77.2200262141053},
  {"name": "LMCH135-F","y": -12.1862105,"x": -76.9906056268858},
  {"name": "LMCH136-F","y": -12.1984505,"x": -76.983698327665},
  {"name": "LMCH137-F","y": -12.199865,"x": -76.977135986599},
  {"name": "LMCH138-F","y": -12.1918585,"x": -76.9893971902461},
  {"name": "LMCH139-F","y": -12.188621,"x": -76.989266281451},
  {"name": "LMCH152-F","y": -12.184196,"x": -77.0197858002901},
  {"name": "LMCH140-F","y": -12.1862725,"x": -76.9934050915239},
  {"name": "LMCH141-F","y": -12.186962,"x": -76.9965922023121},
  {"name": "LMCH142-F","y": -12.203666,"x": -76.977522907392},
  {"name": "LMCH150-F","y": -12.1778105,"x": -77.0222249607487},
  {"name": "LMLR019-F","y": -12.2750895,"x": -76.8380177381399},
  {"name": "LMCH143-F","y": -12.185482,"x": -76.9936865106383},
  {"name": "LMCH144-F","y": -12.182984,"x": -76.9929230733754},
  {"name": "LMCH145-F","y": -12.189452,"x": -76.9980725885965},
  {"name": "LMCH146-F","y": -12.1927715,"x": -76.9994066068577},
  {"name": "LMCH154-F","y": -12.1988315,"x": -77.0163350084171},
  {"name": "LMCH147-F","y": -12.1939235,"x": -76.9965796548462},
  {"name": "LMCH156-F","y": -12.2017975,"x": -77.0184109049179},
  {"name": "LMCH148-F","y": -12.1961295,"x": -76.9934266672208},
  {"name": "LMCH151-F","y": -12.180858,"x": -77.0210755258995},
  {"name": "LMLR021-F","y": -12.2789615,"x": -76.8346335810529},
  {"name": "LMCH153-F","y": -12.1936745,"x": -77.0141421160546},
  {"name": "CHI095-S // CHI095","y": -6.7934335,"x": -79.835137494025},
  {"name": "LMCH155-F","y": -12.2007185,"x": -77.0152794845952},
  {"name": "LMCH157-F","y": -12.194926,"x": -77.0023427931197},
  {"name": "LMCH158-F","y": -12.199012,"x": -77.0075674205261},
  {"name": "LMCH159-F","y": -12.2042825,"x": -77.0180406168408},
  {"name": "LMRC001","y": -12.017572,"x": -77.0346342621978},
  {"name": "LMCH161-F","y": -12.1934045,"x": -77.0166234087127},
  {"name": "LMCH169-F","y": -12.2106715,"x": -77.0065354967713},
  {"name": "LMCH170-F","y": -12.213782,"x": -77.0095355152818},
  {"name": "LMCH171-F","y": -12.2195095,"x": -76.9958787292271},
  {"name": "LMJR182-F","y": -12.173457,"x": -76.9904183055068},
  {"name": "LMLR020-F","y": -12.2767575,"x": -76.8384706619002},
  {"name": "LMLR004-F","y": -12.277404,"x": -76.8677299590873},
  {"name": "LMCG002-F","y": -12.108333,"x": -76.8264638010866},
  {"name": "LMHL001-F","y": -11.4910855,"x": -77.209373204764},
  {"name": "LMHL002-F","y": -11.49255155,"x": -77.2055080725301},
  {"name": "LMHL003-F","y": -11.4923905,"x": -77.2034855981775},
  {"name": "LMLR003-F","y": -12.274214,"x": -76.8716849354648},
  {"name": "LMVS129-F","y": -12.204439,"x": -76.9482500667506},
  {"name": "LMVS105-F","y": -12.220776,"x": -76.9277769478478},
  {"name": "LMHL004-F","y": -11.49245,"x": -77.2109373413525},
  {"name": "LMHL005-F","y": -11.4938675,"x": -77.2124342039521},
  {"name": "LMHL006-F","y": -11.49569495,"x": -77.215563118329},
  {"name": "LMHL007-F","y": -11.4947405,"x": -77.2084438314851},
  {"name": "LMHL008-F","y": -11.494987,"x": -77.2063604491525},
  {"name": "LMHL008-F","y": -11.4962465,"x": -77.2067013070095},
  {"name": "LMHL010-F","y": -11.495677,"x": -77.2013608837868},
  {"name": "LMHL011-F","y": -11.4985502,"x": -77.2036610744873},
  {"name": "LMHL012-F","y": -11.49874185,"x": -77.2065554665572},
  {"name": "ZONA SATURADA","y": -11.497988,"x": -77.2054770444965},
  {"name": "LMHL017-F","y": -11.5003935,"x": -77.1979560189189},
  {"name": "LMHL018-F","y": -11.49797235,"x": -77.2005609402313},
  {"name": "LMJR154-F","y": -12.1788625,"x": -76.9618365199797},
  {"name": "LMHL019-F","y": -11.4969115,"x": -77.1968430800992},
  {"name": "LMPC013-F","y": -12.0933855,"x": -76.882516505622},
  {"name": "LMHL020-F","y": -11.4918855,"x": -77.194625457931},
  {"name": "LMHL021-F","y": -11.4920535,"x": -77.1996473019242},
  {"name": "LMHL022-F","y": -11.489681,"x": -77.2043797388534},
  {"name": "LMHL023-F","y": -11.486191,"x": -77.2071908651373},
  {"name": "LMHL030-F","y": -11.4948485,"x": -77.2173589234747},
  {"name": "LMPC015-F","y": -12.090256,"x": -76.8785578617571},
  {"name": "LMHL024-F","y": -11.482683,"x": -77.2067852478567},
  {"name": "LMHL025-F","y": -11.48865,"x": -77.2203945202381},
  {"name": "LMHL032-F","y": -11.4923745,"x": -77.2222300897624},
  {"name": "LMHL029-F","y": -11.4986059,"x": -77.2181237993333},
  {"name": "LMPC016-F","y": -12.089995,"x": -76.8754157024874},
  {"name": "LMHL031-F","y": -11.491055,"x": -77.2162482314815},
  {"name": "LMJL147-S","y": -11.9608345,"x": -76.9910734831302},
  {"name": "LMLR022-F","y": -12.306878,"x": -76.8439583939879},
  {"name": "LMLR005-F","y": -12.274863,"x": -76.8673327931818},
  {"name": "LMPC003-F","y": -12.2294625,"x": -76.8587297901536},
  {"name": "LMLR012-F","y": -12.246317,"x": -76.8942316873435},
  {"name": "LMLR013-F","y": -12.245961,"x": -76.8979537972378},
  {"name": "LMLR014-F","y": -12.248662,"x": -76.8966199763975},
  {"name": "LMLR015-F","y": -12.247916,"x": -76.8995687893793},
  {"name": "LMPC006-F","y": -12.112771,"x": -76.8729042774354},
  {"name": "LMLR016-F","y": -12.249242,"x": -76.8946402877639},
  {"name": "LMVS087-F","y": -12.2130055,"x": -76.9348880655054},
  {"name": "LMLR023-F","y": -12.309049,"x": -76.8415089839556},
  {"name": "LMLR037-F","y": -12.2362755,"x": -76.9096047821652},
  {"name": "LMLR038-F","y": -12.239269,"x": -76.9108221005655},
  {"name": "LMPC004-F","y": -12.1117015,"x": -76.8655036315871},
  {"name": "LMPC005-F","y": -12.113323,"x": -76.8701248671879},
  {"name": "LMPC007-F","y": -12.109148,"x": -76.8747365107548},
  {"name": "LMPC008-F","y": -12.1057155,"x": -76.8759236713215},
  {"name": "LMPC010-F","y": -12.1004625,"x": -76.8782370281759},
  {"name": "LMPC011-F","y": -12.099029,"x": -76.8808961408007},
  {"name": "LMPC012-F","y": -12.096596,"x": -76.8830653409091},
  {"name": "LMPC017-F","y": -12.084287,"x": -76.875941626087},
  {"name": "LMRC002-S // LMRC002","y": -12.0176745,"x": -77.0326758636201},
  {"name": "LMRC004-S","y": -12.021631,"x": -77.0282019567644},
  {"name": "LMRC005","y": -12.025198,"x": -77.0247105593385},
  {"name": "LMRC005","y": -12.02306,"x": -77.0262899690266},
  {"name": "LMRC005","y": -12.026539,"x": -77.0259183145695},
  {"name": "LMRC005","y": -12.025198,"x": -77.0263042799003},
  {"name": "LMCS003-F","y": -11.9361385,"x": -76.7147761170846},
  {"name": "LMRC007-S // LMRC007","y": -12.0236985,"x": -77.03455544326},
  {"name": "LMRC008-S // LMRC008","y": -12.0256945,"x": -77.0318162999786},
  {"name": "LMRC009","y": -12.0269025,"x": -77.0291678469507},
  {"name": "LMRC010-S // LMRC010","y": -12.0284005,"x": -77.0302389754826},
  {"name": "LMRC012-S // LMRC012","y": -12.0341155,"x": -77.0239598495951},
  {"name": "LMCS004-F","y": -11.937812,"x": -76.7129988045171},
  {"name": "LMJL004-S // LMJL004","y": -11.9855015,"x": -77.0087233459079},
  {"name": "LMRC018-S // LMRC018","y": -12.0294175,"x": -77.0383352637338},
  {"name": "LMRC019-S // LMRC019","y": -12.026123,"x": -77.0379421526957},
  {"name": "LMRC021-S // LMRC021","y": -12.0317995,"x": -77.034776772749},
  {"name": "LMRC022-S // LMRC022","y": -12.0330465,"x": -77.0356532156398},
  {"name": "LMRC043-F","y": -12.015877,"x": -77.0264905196413},
  {"name": "LMRC023","y": -12.03576,"x": -77.0343298738023},
  {"name": "LMRC025-S // LMRC025","y": -12.0340965,"x": -77.0328717966067},
  {"name": "LMRC044-F","y": -12.0310085,"x": -77.0403571820578},
  {"name": "LMRC048-F","y": -12.031368,"x": -77.0295263812129},
  {"name": "LMRC033-F","y": -12.0083755,"x": -77.0352618144468},
  {"name": "LMRC034-F","y": -12.015576,"x": -77.0343348716353},
  {"name": "LMRC042-F","y": -12.0385025,"x": -77.0166294340365},
  {"name": "LMJL001-S // LMJL001","y": -11.9844155,"x": -77.0132883935811},
  {"name": "LMJL002-S // LMJL002","y": -11.986777,"x": -77.0137026383959},
  {"name": "LMCS008-F","y": -11.9351275,"x": -76.703441801089},
  {"name": "LMJL009-S // LMJL009","y": -11.988341,"x": -77.0028378929725},
  {"name": "LMCS005-F","y": -11.940287,"x": -76.7103038009869},
  {"name": "LMJL005","y": -11.98627,"x": -77.0107145266362},
  {"name": "LMJL006-S // LMJL006","y": -11.9863455,"x": -77.0051000034128},
  {"name": "LMJL011-S","y": -11.994187,"x": -77.0140197529617},
  {"name": "LMJL011","y": -11.9943405,"x": -77.0129530118684},
  {"name": "LMCS011-F","y": -12.001339,"x": -76.8790011571759},
  {"name": "5317B03-S","y": -12.1117995,"x": -77.0406875918681},
  {"name": "LMCS006-F","y": -11.942561,"x": -76.7102926649123},
  {"name": "LMJL007-S","y": -11.988987,"x": -77.0051679434572},
  {"name": "LMCS007-F","y": -11.929964,"x": -76.7026337465813},
  {"name": "LMJL008-S // LMJL008","y": -11.9882515,"x": -77.0071363328094},
  {"name": "LMVS007","y": -12.197714,"x": -76.9537751674918},
  {"name": "LMCS009-F","y": -11.9386535,"x": -76.7024670361988},
  {"name": "LMJL010-S // LMJL010","y": -11.9915335,"x": -77.0139775276169},
  {"name": "LMJL012-S // LMJL012","y": -11.991788,"x": -77.0122202582363},
  {"name": "LMCS012-F","y": -12.002526,"x": -76.8748427981497},
  {"name": "LMCS013-F","y": -12.0034605,"x": -76.8803159551835},
  {"name": "LMJL014-S // LMJL014","y": -11.990934,"x": -77.0072136222222},
  {"name": "LMCS014-F","y": -12.004677,"x": -76.8770946138952},
  {"name": "LMJL015-S // LMJL015","y": -11.9946455,"x": -77.0089532487325},
  {"name": "LMCS015-F","y": -11.99949,"x": -76.8792949399563},
  {"name": "LMJL027-S // LMJL027","y": -12.0000075,"x": -77.0128021376488},
  {"name": "LMJL051-S // LMJL051","y": -12.019249,"x": -77.0103781219348},
  {"name": "LMJL016-S // LMJL016","y": -11.9929975,"x": -77.0067481290942},
  {"name": "LMJL025-S","y": -12.0046355,"x": -77.0011391083467},
  {"name": "LMVS092-F","y": -12.229025,"x": -76.9461201256339},
  {"name": "LMCS016-F","y": -12.005844,"x": -76.8827157435992},
  {"name": "LMJL017-S // LMJL017","y": -11.995533,"x": -77.0065867439006},
  {"name": "LMCS017-F","y": -12.0014285,"x": -76.873121363321},
  {"name": "LMCS018-F","y": -12.0061745,"x": -76.8762327296523},
  {"name": "LMJL018-S","y": -11.99222,"x": -77.0041946578716},
  {"name": "LMJL018","y": -11.994028,"x": -77.0051126967816},
  {"name": "LMJL052-S // LMJL052","y": -12.021152,"x": -77.0080864601305},
  {"name": "LMJL053-S // LMJL053","y": -12.02311,"x": -77.0103337738905},
  {"name": "LMJL019-S // LMJL019","y": -11.99919,"x": -77.007915424803},
  {"name": "LMJL020-S","y": -11.9989425,"x": -77.0062201112069},
  {"name": "LMJL020","y": -12.0011985,"x": -77.0065307298807},
  {"name": "LMJL020","y": -11.9968065,"x": -77.005446980689},
  {"name": "LMJL020","y": -11.9971325,"x": -77.0054319503501},
  {"name": "LMJL020","y": -12.000865,"x": -77.0065522774123},
  {"name": "LMJL021","y": -12.0036785,"x": -77.005981930235},
  {"name": "LMJL022","y": -12.0029235,"x": -77.0042972248403},
  {"name": "CHI096-S // CHI096","y": -6.795748,"x": -79.8327315590089},
  {"name": "LMJL023","y": -12.002397,"x": -77.0023400878076},
  {"name": "LMCS023-F","y": -11.941632,"x": -76.7001578338578},
  {"name": "LMJL024-S","y": -12.0018545,"x": -77.0004219094251},
  {"name": "LMCS024-F","y": -11.9391775,"x": -76.6950171082488},
  {"name": "LMCS025-F","y": -11.931886,"x": -76.6913218854732},
  {"name": "LMJL025","y": -12.004773,"x": -76.9984816885135},
  {"name": "LMJL026-S // LMJL026","y": -11.999043,"x": -77.0108254902724},
  {"name": "LMJL158-S // LMJL158","y": -11.960511,"x": -76.9806867447195},
  {"name": "LMCS026-F","y": -11.9288255,"x": -76.6867780560102},
  {"name": "LMVS093-F","y": -12.232067,"x": -76.9443006866892},
  {"name": "LMCS027-F","y": -11.932968,"x": -76.6895178367347},
  {"name": "LMJL028","y": -12.0025955,"x": -77.0097326883527},
  {"name": "LMJL029","y": -12.003543,"x": -77.0114040846711},
  {"name": "LMJL030","y": -12.0061935,"x": -77.0103038804572},
  {"name": "LMJL031-S // LMJL031","y": -12.005817,"x": -77.007727503041},
  {"name": "LMJL032-S // LMJL032","y": -12.003139,"x": -77.0147322446639},
  {"name": "LMJL041-S","y": -12.012423,"x": -77.0037531225364},
  {"name": "LMJL033-S","y": -12.0069795,"x": -77.0146679908428},
  {"name": "LMJL033","y": -12.007254,"x": -77.0164429447717},
  {"name": "LMJL033","y": -12.007196,"x": -77.0132273023314},
  {"name": "LMJL033","y": -12.0074605,"x": -77.0131952601355},
  {"name": "LMJL034-S // LMJL034","y": -12.0060085,"x": -77.0128187787581},
  {"name": "LMJL035-S","y": -12.0100835,"x": -77.0139305714963},
  {"name": "LMJL035","y": -12.0099945,"x": -77.0155542969805},
  {"name": "LMJL035","y": -12.0094045,"x": -77.0161676329431},
  {"name": "LMJL035","y": -12.011063,"x": -77.0140390316401},
  {"name": "LMJL038-S // LMJL038","y": -12.0076055,"x": -77.0066945398085},
  {"name": "LMJL039-S // LMJL039","y": -12.0099265,"x": -77.0061558533368},
  {"name": "LMJL040-S // LMJL040","y": -12.0109405,"x": -77.0040200762712},
  {"name": "LMJL042-S","y": -12.011799,"x": -77.0071177326898},
  {"name": "LMJL045-S // LMJL045","y": -12.014153,"x": -77.0070610134409},
  {"name": "LMJL046-S","y": -12.013634,"x": -77.0102450625291},
  {"name": "LMJL047-S","y": -12.0162945,"x": -77.0103671176338},
  {"name": "LMJL071-S // LMJL071","y": -12.0253445,"x": -76.9902213756956},
  {"name": "LMJL048-S","y": -12.016866,"x": -77.0071274586707},
  {"name": "LMJL049-S","y": -12.016923,"x": -77.0035431411299},
  {"name": "LMJL050-S // LMJL050","y": -12.01946,"x": -77.0059296146051},
  {"name": "LMJL054-S","y": -12.029209,"x": -77.010534802},
  {"name": "LMJL055-S","y": -12.026381,"x": -77.0082496233397},
  {"name": "LMJL055","y": -12.0276295,"x": -77.0108464752002},
  {"name": "LMJL055","y": -12.02551,"x": -77.0086649705323},
  {"name": "LMJL055","y": -12.0265015,"x": -77.0090902675425},
  {"name": "LMJL056-S // LMJL056","y": -12.0250115,"x": -77.0075311181193},
  {"name": "LMJL057","y": -12.0288125,"x": -77.0081110499738},
  {"name": "LMJL073-S // LMJL073","y": -12.025175,"x": -76.9875010999786},
  {"name": "LMJL058","y": -12.02823,"x": -77.0063110733071},
  {"name": "LMJL059","y": -12.0276555,"x": -77.0045655015969},
  {"name": "LMJL076-S // LMJL076","y": -12.0065845,"x": -76.9993132368523},
  {"name": "LMJL060","y": -12.025298,"x": -77.0041198279923},
  {"name": "LMJL062","y": -12.0267515,"x": -77.0021028242728},
  {"name": "LMJL063","y": -12.0261695,"x": -76.9994149317895},
  {"name": "LMJL064-S // LMJL064","y": -12.023917,"x": -77.0011447807243},
  {"name": "LMJL065-S","y": -12.0201305,"x": -77.0014214495463},
  {"name": "LMJL066-S","y": -12.01984,"x": -76.9989017555786},
  {"name": "LMJL075-S // LMJL075","y": -11.996491,"x": -77.0125389543189},
  {"name": "LMJL077-S // LMJL077","y": -12.0240725,"x": -76.9839135748701},
  {"name": "LMJL074-S // LMJL074","y": -12.0008765,"x": -77.0149612786264},
  {"name": "LMJL067-S // LMJL067","y": -12.0245905,"x": -76.9978593381295},
  {"name": "LMJL113-S // LMJL113","y": -11.974192,"x": -77.0122698377518},
  {"name": "LMJL068-S // LMJL068","y": -12.0234635,"x": -76.995668432458},
  {"name": "LMJL069-S // LMJL069","y": -12.0235445,"x": -76.9927366722859},
  {"name": "LMJL070-S // LMJL070","y": -12.0258275,"x": -76.9938340469786},
  {"name": "LMJL072-S // LMJL072","y": -12.0234115,"x": -76.9885993676742},
  {"name": "LMJL079-S // LMJL079","y": -12.0215945,"x": -77.0133295547927},
  {"name": "LMJL080-S // LMJL080","y": -11.9416075,"x": -76.9775557283758},
  {"name": "LMJL081-S // LMJL081","y": -11.943126,"x": -76.9787065714286},
  {"name": "LMJL082-S // LMJL082","y": -11.944235,"x": -76.9796951867949},
  {"name": "LMJL083-S","y": -11.9456145,"x": -76.9806122813844},
  {"name": "LMJL084-S // LMJL084","y": -11.9952095,"x": -77.0030936911542},
  {"name": "LMJL085-S // LMJL085","y": -11.9974005,"x": -77.0032541788113},
  {"name": "LMJL100-S","y": -12.023852,"x": -76.9728158959834},
  {"name": "LMJL127-S // LMJL127","y": -11.9676615,"x": -77.0019067272328},
  {"name": "LMJL088-S","y": -12.0137475,"x": -76.9955183361131},
  {"name": "LMJL089-S // LMJL089","y": -11.9470935,"x": -76.9818414247253},
  {"name": "LMJL090-S","y": -11.949063,"x": -76.9826589881568},
  {"name": "LMJL091-S","y": -11.9503205,"x": -76.9843374522287},
  {"name": "LMJL092-S // LMJL092","y": -11.9522375,"x": -76.9849264243428},
  {"name": "LMVS133-F","y": -12.206578,"x": -76.9446557109766},
  {"name": "LMJL094-S // LMJL094","y": -12.015829,"x": -76.9879819971401},
  {"name": "LMJL136-S // LMJL136","y": -11.9721485,"x": -76.9910155753296},
  {"name": "LMJL107-S","y": -12.020402,"x": -76.9564461339709},
  {"name": "LMJL107","y": -12.0195685,"x": -76.9534181099386},
  {"name": "LMJL107","y": -12.0204935,"x": -76.959778069679},
  {"name": "LMJL107","y": -12.019533,"x": -76.9589627825013},
  {"name": "LMJL095-S // LMJL095","y": -12.0144945,"x": -76.9832449115946},
  {"name": "LMJL096-S // LMJL096","y": -12.010527,"x": -76.9834263076272},
  {"name": "LMJL137-S // LMJL137","y": -11.9701465,"x": -76.9902769993377},
  {"name": "LMJL097-S // LMJL097","y": -12.011925,"x": -76.9810699659997},
  {"name": "LMJL093-S // LMJL093","y": -12.0187085,"x": -76.9858898231409},
  {"name": "LMJL107","y": -12.0203085,"x": -76.9593451219136},
  {"name": "LMJL107","y": -12.021869,"x": -76.9612726435077},
  {"name": "LMJL107","y": -12.0212785,"x": -76.9598084050536},
  {"name": "LMJL107","y": -12.0201565,"x": -76.9613535380215},
  {"name": "LMJL108-S","y": -11.982579,"x": -77.0155753576212},
  {"name": "LMJL164-S // LMJL164","y": -11.9485575,"x": -76.9887354172762},
  {"name": "LMJL102-S // LMJL102","y": -12.019054,"x": -76.973120545715},
  {"name": "LMJL103-S","y": -12.0225135,"x": -76.9654399388088},
  {"name": "LMJL101-S // LMJL101","y": -12.0222305,"x": -76.9723246026978},
  {"name": "LMJL104-S // LMJL104","y": -12.0195675,"x": -76.9682537327904},
  {"name": "LMJL112-S","y": -11.97544,"x": -77.0054557899909},
  {"name": "LMJL112","y": -11.976732,"x": -77.005620595293},
  {"name": "LMJL111-S","y": -11.9793115,"x": -77.0010396854836},
  {"name": "LMJL098-S // LMJL098","y": -12.009155,"x": -76.9772362531252},
  {"name": "LMJL099-S","y": -12.0229515,"x": -76.9771642408664},
  {"name": "LMJL159-S // LMJL159","y": -11.957554,"x": -76.9799383560885},
  {"name": "LMJL109-S","y": -11.989406,"x": -77.000176092958},
  {"name": "LMJL111","y": -11.9786825,"x": -77.0001040801718},
  {"name": "LMJL111","y": -11.978214,"x": -77.0011594769231},
  {"name": "LMJL105-S","y": -12.019304,"x": -76.9639834713584},
  {"name": "LMJL106-S","y": -12.0159245,"x": -76.9633717652303},
  {"name": "LMJL106","y": -12.0169545,"x": -76.9652651374459},
  {"name": "LMJL120-S // LMJL120","y": -11.970282,"x": -77.0007168842489},
  {"name": "LMJL106","y": -12.015454,"x": -76.9673073397683},
  {"name": "LMJL106","y": -12.0178715,"x": -76.9604435998499},
  {"name": "LMJL110-S","y": -11.980492,"x": -77.0013816407577},
  {"name": "LMJL111","y": -11.9793075,"x": -76.9995473535353},
  {"name": "LMJL111","y": -11.9772255,"x": -77.0025040496162},
  {"name": "LMJL114-S","y": -11.9734075,"x": -77.0134373337551},
  {"name": "LMJL119-S // LMJL119","y": -11.971916,"x": -77.0028998801732},
  {"name": "LMVS106-F","y": -12.22167,"x": -76.9255867284814},
  {"name": "LMJL121-S // LMJL121","y": -11.9726855,"x": -76.9990900181501},
  {"name": "LMJL122-S // LMJL122","y": -11.977562,"x": -76.9999775432316},
  {"name": "LMJL123-S // LMJL123","y": -11.976628,"x": -76.9977109876855},
  {"name": "LMJL124-S // LMJL124","y": -11.9748255,"x": -76.9964708183009},
  {"name": "LMJL131-S // LMJL131","y": -11.9612765,"x": -77.0032225117187},
  {"name": "LMVS107-F","y": -12.224159,"x": -76.9253033847131},
  {"name": "LMJL132-S","y": -11.959522,"x": -77.0042912667981},
  {"name": "LMJL132","y": -11.959905,"x": -77.0033632830196},
  {"name": "LMJL125","y": -11.974474,"x": -76.9941016636879},
  {"name": "LMJL126-S // LMJL126","y": -11.969392,"x": -76.9966552560391},
  {"name": "LMJL169-S // LMJL169","y": -11.9402155,"x": -76.9877323529705},
  {"name": "LMJL128-S // LMJL128","y": -11.965839,"x": -77.0060047409366},
  {"name": "LMJL129-S // LMJL129","y": -11.964501,"x": -77.0076180103756},
  {"name": "LMJL165-S // LMJL165","y": -11.947328,"x": -76.988458849911},
  {"name": "LMJL130-S // LMJL130","y": -11.9624995,"x": -77.0048453076923},
  {"name": "LMJL135-S // LMJL135","y": -11.969154,"x": -76.9920039313114},
  {"name": "LMJL138-S // LMJL138","y": -11.9735735,"x": -76.9897607600491},
  {"name": "LMJL139","y": -11.974338,"x": -76.9873185519014},
  {"name": "LMJL148-S // LMJL148","y": -11.961648,"x": -76.9901065287187},
  {"name": "LMJL149-S // LMJL149","y": -11.9636605,"x": -76.9879134761364},
  {"name": "LMJL161-S // LMJL161","y": -11.9543105,"x": -76.9895943694035},
  {"name": "LMJL140","y": -11.9771545,"x": -76.9898936574074},
  {"name": "LMJL184","y": -11.9394155,"x": -76.9708114564348},
  {"name": "LMJL141-S // LMJL141","y": -11.978808,"x": -76.9863256602113},
  {"name": "LMJL150-S // LMJL150","y": -11.9656685,"x": -76.9855474164604},
  {"name": "LMJL166-S // LMJL166","y": -11.9460115,"x": -76.9881745074303},
  {"name": "LMJL142-S // LMJL142","y": -11.979244,"x": -76.9898748384035},
  {"name": "LMJL143-S // LMJL143","y": -11.963466,"x": -76.9919817150602},
  {"name": "LMJL144-S // LMJL144","y": -11.9656975,"x": -76.9902417540598},
  {"name": "LMVS132-F","y": -12.2043295,"x": -76.9463661170027},
  {"name": "LMJL145-S // LMJL145","y": -11.9667365,"x": -76.989209792432},
  {"name": "LMJL146-S // LMJL146","y": -11.968163,"x": -76.9883650726487},
  {"name": "LMJL151-S // LMJL151","y": -11.968334,"x": -76.9825173017209},
  {"name": "LMJL153","y": -11.962054,"x": -76.9873940989367},
  {"name": "LMJL154","y": -11.960787,"x": -76.9852660792736},
  {"name": "LMJL155-S // LMJL155","y": -11.9626245,"x": -76.9834038719048},
  {"name": "LMJL227-F","y": -11.9577865,"x": -76.9936701242124},
  {"name": "LMJL156-S // LMJL156","y": -11.958932,"x": -76.9830273141429},
  {"name": "LMJL157-S // LMJL157","y": -11.9596845,"x": -76.9820169688393},
  {"name": "LMJL167-S // LMJL167","y": -11.943312,"x": -76.9894341539464},
  {"name": "LMJL168","y": -11.9411895,"x": -76.990096112},
  {"name": "LMJL170","y": -11.9425225,"x": -76.9867296454146},
  {"name": "LMJL171-S // LMJL171","y": -11.9455615,"x": -76.9865614970283},
  {"name": "LMJL179-S // LMJL179","y": -11.9480315,"x": -76.9779781458956},
  {"name": "LMJR106-F","y": -12.1734816,"x": -76.9604281186549},
  {"name": "LMJL172","y": -11.943753,"x": -76.9840819347301},
  {"name": "LMJL173","y": -11.942074,"x": -76.9836072377973},
  {"name": "LMJL174-S // LMJL174","y": -11.9541245,"x": -76.9812005084172},
  {"name": "LMJL175-S // LMJL175","y": -11.952019,"x": -76.9811284798793},
  {"name": "LMJL176-S // LMJL176","y": -11.953296,"x": -76.9777663042564},
  {"name": "LMJL226-F","y": -11.957366,"x": -76.9963658515965},
  {"name": "LMJL185-S // LMJL185","y": -11.967022,"x": -76.9841243399029},
  {"name": "LMJL186-S // LMJL186","y": -11.953015,"x": -76.9850673708761},
  {"name": "LMVS151-F","y": -12.2077975,"x": -76.9343299195946},
  {"name": "LMJL228-F","y": -11.959022,"x": -76.9914241014784},
  {"name": "LMJL177","y": -11.949822,"x": -76.9758255094494},
  {"name": "LMJL178-S // LMJL178","y": -11.950096,"x": -76.9792082430653},
  {"name": "LMJL181-S // LMJL181","y": -11.944858,"x": -76.9759815983146},
  {"name": "LMJL182-S","y": -11.9416255,"x": -76.9727816951929},
  {"name": "LMJL183-S // LMJL183","y": -11.9403175,"x": -76.9752057443289},
  {"name": "LMJL186-S // LMJL186","y": -11.955363,"x": -76.9839751129393},
  {"name": "LMJL190-F","y": -12.009288,"x": -76.9982374768908},
  {"name": "LMJL191-F","y": -12.003267,"x": -76.9963340926017},
  {"name": "LMJL192-F","y": -11.9938575,"x": -77.0181334562841},
  {"name": "LMVS124-F","y": -12.1944465,"x": -76.943192377536},
  {"name": "LMJL201-F","y": -12.029365,"x": -77.0152375193357},
  {"name": "LMJL202-F","y": -12.027725,"x": -77.0171734508355},
  {"name": "LMJL229-F","y": -11.9588355,"x": -76.9888093395074},
  {"name": "LMJL207-F","y": -12.0129715,"x": -76.9985641189112},
  {"name": "LMJL230-F","y": -11.960852,"x": -76.976982736731},
  {"name": "LMJL203-F","y": -12.0258115,"x": -77.0166063381754},
  {"name": "LMJR025","y": -12.1585445,"x": -76.9693930056932},
  {"name": "LMJL231-F","y": -11.9632665,"x": -76.9781636564345},
  {"name": "LMJL204-F","y": -12.0270385,"x": -77.0127811478914},
  {"name": "LMJL205-F","y": -12.0222165,"x": -77.0035398219231},
  {"name": "LMJL206-F","y": -12.014956,"x": -77.0003093835857},
  {"name": "LMJR114-F","y": -12.144108,"x": -76.9666153912556},
  {"name": "LMJL208-F","y": -12.0152915,"x": -76.9979406628276},
  {"name": "LMJL217-F","y": -12.007391,"x": -76.9923103440983},
  {"name": "LMJL218-F","y": -12.0044025,"x": -76.9917929630156},
  {"name": "LMJL232-F","y": -11.9568025,"x": -76.9792240522365},
  {"name": "LMJL233-F","y": -11.9563945,"x": -76.9759945860616},
  {"name": "LMJL209-F","y": -12.0111315,"x": -76.9958342349624},
  {"name": "LMJL243-F","y": -11.9361475,"x": -76.9688844883438},
  {"name": "LMJL210-F","y": -12.012881,"x": -76.9929593137931},
  {"name": "CHI101-S // CHI101","y": -6.7984895,"x": -79.841889747015},
  {"name": "LMJL211-F","y": -12.0137745,"x": -76.9913811152655},
  {"name": "LMJL212-F","y": -12.015573,"x": -76.9916417877359},
  {"name": "LMJL213-F","y": -12.005527,"x": -77.0183044579646},
  {"name": "LMJL214-F","y": -12.0045395,"x": -77.0168924667345},
  {"name": "LMJL216-F","y": -12.0069615,"x": -76.9951511970003},
  {"name": "LMJL219-F","y": -12.0058345,"x": -76.9907317675473},
  {"name": "LMVS119-F","y": -12.19301,"x": -76.9469504202287},
  {"name": "LMJL220-F","y": -12.007691,"x": -76.9901088202593},
  {"name": "LMJL221-F","y": -12.000949,"x": -76.9984289410556},
  {"name": "LMJL222-F","y": -11.997893,"x": -76.9991818010357},
  {"name": "LMJL223-F","y": -11.996977,"x": -76.9967649430336},
  {"name": "LMJL224-F","y": -11.9668265,"x": -76.9984582471708},
  {"name": "LMJL242-F","y": -11.9343845,"x": -76.9707964588296},
  {"name": "LMJL225-F","y": -11.963601,"x": -76.9998306233854},
  {"name": "LMJL234-F","y": -11.940616,"x": -76.9990799411765},
  {"name": "LMJL235-F","y": -11.940096,"x": -76.9969190607665},
  {"name": "LMJL236-F","y": -11.941002,"x": -76.9937077464789},
  {"name": "LMJL237-F","y": -11.938619,"x": -76.9916087342367},
  {"name": "LMJL238-F","y": -11.937354,"x": -76.9882412496879},
  {"name": "LMJL239-F","y": -11.941244,"x": -76.9819359411826},
  {"name": "LMVS115-F","y": -12.1899075,"x": -76.9458650869864},
  {"name": "LMJL240-F","y": -11.936796,"x": -76.9783357204194},
  {"name": "LMJL241-F","y": -11.937164,"x": -76.9762917051827},
  {"name": "LMVS123-F","y": -12.192237,"x": -76.9442039062888},
  {"name": "LMJR001-S // LMJR001","y": -12.14399085,"x": -76.9751603171949},
  {"name": "LMJR029","y": -12.159905,"x": -76.9604831131935},
  {"name": "LMVS144-F","y": -12.1912515,"x": -76.9401715822812},
  {"name": "LMJR028-S // LMJR028","y": -12.159359,"x": -76.9626727681714},
  {"name": "LMJR002","y": -12.1463515,"x": -76.9764064245415},
  {"name": "LMJR003","y": -12.1463515,"x": -76.9738989036983},
  {"name": "LMJR004","y": -12.147595,"x": -76.9729652838639},
  {"name": "LMJR005-S // LMJR005","y": -12.148505,"x": -76.9719503960224},
  {"name": "LMJR006-S // LMJR006","y": -12.1499335,"x": -76.9727957692377},
  {"name": "LMJR111-F","y": -12.144547,"x": -76.9708275509195},
  {"name": "LMJR007","y": -12.151079,"x": -76.9730921567905},
  {"name": "LMJR008-S // LMJR008","y": -12.1503245,"x": -76.9755899619184},
  {"name": "LMJR009","y": -12.152683,"x": -76.9732124809756},
  {"name": "LMJR010","y": -12.1502335,"x": -76.9689764702842},
  {"name": "LMJR011-S // LMJR011","y": -12.152905,"x": -76.9698419401858},
  {"name": "LMJR012","y": -12.1530335,"x": -76.968375173236},
  {"name": "LMJR013","y": -12.1538565,"x": -76.9665537785631},
  {"name": "LMJR030","y": -12.1619835,"x": -76.9614654618076},
  {"name": "LMJR014-S // LMJR014","y": -12.154954,"x": -76.9643702692788},
  {"name": "LMJR016","y": -12.152193,"x": -76.9809589523438},
  {"name": "LMJR017-S // LMJR017","y": -12.1542775,"x": -76.9791776459342},
  {"name": "LMJR109-F","y": -12.148469,"x": -76.967377190049},
  {"name": "LMJR018","y": -12.1524355,"x": -76.9786322898937},
  {"name": "LMJR019","y": -12.1545315,"x": -76.9762475228321},
  {"name": "LMJR020","y": -12.1537105,"x": -76.9747721773961},
  {"name": "LMJR021-S // LMJR021","y": -12.1556745,"x": -76.9738760979689},
  {"name": "LMJR022-S // LMJR022","y": -12.1556575,"x": -76.971246723034},
  {"name": "LMJR024","y": -12.156775,"x": -76.9689729188034},
  {"name": "LMJR026-S // LMJR026","y": -12.1581125,"x": -76.9656383468916},
  {"name": "LMJR043","y": -12.167832,"x": -76.9766172509096},
  {"name": "LMJR037-S // LMJR037","y": -12.1615425,"x": -76.9709851837076},
  {"name": "LMJR027","y": -12.160152,"x": -76.9657068450132},
  {"name": "LMVS155-F","y": -12.217536,"x": -76.9239630324752},
  {"name": "LMJR076-S // LMJR076","y": -12.1828495,"x": -76.9630565854644},
  {"name": "LMJR031-S // LMJR031","y": -12.1582768,"x": -76.974210231383},
  {"name": "LMJR032","y": -12.1616765,"x": -76.9778603660365},
  {"name": "LMJR033","y": -12.161204,"x": -76.9748733627696},
  {"name": "LMJR034","y": -12.163789,"x": -76.9774367365437},
  {"name": "LMVS152-F","y": -12.2097405,"x": -76.9335491752717},
  {"name": "LMJR035-S // LMJR035","y": -12.1628765,"x": -76.9748067909643},
  {"name": "LMJR038-S // LMJR038","y": -12.1621925,"x": -76.9653842790698},
  {"name": "LMJR039","y": -12.163118,"x": -76.9668892041093},
  {"name": "LMJR040","y": -12.165251,"x": -76.9673387507792},
  {"name": "LMJR041","y": -12.1650865,"x": -76.9642057136297},
  {"name": "LMJR042-S // LMJR042","y": -12.1660085,"x": -76.9617661720517},
  {"name": "LMJR131-F","y": -12.1807085,"x": -76.9774733661479},
  {"name": "LMJR147-F","y": -12.1745341,"x": -76.9678308562783},
  {"name": "LMJR044-S // LMJR044","y": -12.1672335,"x": -76.9731896505797},
  {"name": "LMJR045-S // LMJR045","y": -12.1661805,"x": -76.9703664268734},
  {"name": "LMJR046-S // LMJR046","y": -12.169895,"x": -76.9753083484914},
  {"name": "LMJR047-S // LMJR047","y": -12.1697185,"x": -76.9737132143128},
  {"name": "LMJR048-S // LMJR048","y": -12.1688075,"x": -76.9701020451907},
  {"name": "LMVS172-F","y": -12.2363625,"x": -76.9151258094126},
  {"name": "LMJR049-S // LMJR049","y": -12.167875,"x": -76.9667586516705},
  {"name": "LMJR148-F","y": -12.176074,"x": -76.968133578247},
  {"name": "LMJR149-F","y": -12.17345165,"x": -76.9664451831057},
  {"name": "LMJR050","y": -12.1682315,"x": -76.9633485938055},
  {"name": "LMJR051","y": -12.163768,"x": -76.961113194871},
  {"name": "LMJR075-S // LMJR075","y": -12.1821655,"x": -76.9652839646849},
  {"name": "AQPP059-F","y": -16.4310275,"x": -71.5106276652114},
  {"name": "LMJR084","y": -12.170985,"x": -76.9669583793103},
  {"name": "LMJR132-F","y": -12.1822545,"x": -76.9795865005219},
  {"name": "LMJR133-F","y": -12.184735,"x": -76.9819808283582},
  {"name": "LMJR133-F","y": -12.183884,"x": -76.9801801495992},
  {"name": "LMJR134-F","y": -12.1841426,"x": -76.9785904207279},
  {"name": "LMJR085","y": -12.1713131,"x": -76.9633035266338},
  {"name": "LMJR142-F","y": -12.190341,"x": -76.9767415243125},
  {"name": "LMJR143-F","y": -12.189959,"x": -76.9747225369967},
  {"name": "LMJR086","y": -12.1718618,"x": -76.9692334489683},
  {"name": "LMJR087","y": -12.1738835,"x": -76.9640834547531},
  {"name": "LMJR089","y": -12.1755215,"x": -76.9642745764538},
  {"name": "LMJR090","y": -12.176074,"x": -76.970333501596},
  {"name": "LMJR134-F","y": -12.1829135,"x": -76.9769993831169},
  {"name": "LMJR095-F","y": -12.1416445,"x": -76.9760676602232},
  {"name": "LMJR096-F","y": -12.1498525,"x": -76.9794176075055},
  {"name": "LMJR097-F","y": -12.149258,"x": -76.9772427231806},
  {"name": "LMJR098-F","y": -12.1895875,"x": -76.9591183723404},
  {"name": "LMJR099-F","y": -12.190779,"x": -76.9572536428133},
  {"name": "LMJR115-F","y": -12.1425435,"x": -76.9686772759672},
  {"name": "LMJR100-F","y": -12.1629775,"x": -76.9577069294822},
  {"name": "LMJR127-F","y": -12.133065,"x": -76.9593247414818},
  {"name": "LMJR128-F","y": -12.1319755,"x": -76.9616584686411},
  {"name": "LMJR101-F","y": -12.165615,"x": -76.9571124860656},
  {"name": "LMJR102-F","y": -12.166549,"x": -76.9589224776137},
  {"name": "LMJR103-F","y": -12.1699125,"x": -76.9599414786005},
  {"name": "LMJR144-F","y": -12.1917415,"x": -76.9740602677431},
  {"name": "LMJR104-F","y": -12.1693525,"x": -76.9578818911714},
  {"name": "LMJR105","y": -12.177941,"x": -76.9650659210526},
  {"name": "LMJR129-F","y": -12.173899,"x": -76.9791890508391},
  {"name": "LMJR130-F","y": -12.177024,"x": -76.9782304501304},
  {"name": "LMJR107-F","y": -12.176138,"x": -76.960492441056},
  {"name": "LMJR140-F","y": -12.1884635,"x": -76.9760137994317},
  {"name": "LMJR108-F","y": -12.176919,"x": -76.9573855846183},
  {"name": "LMJR112-F","y": -12.1424355,"x": -76.9713282863512},
  {"name": "LMJR113-F","y": -12.1462705,"x": -76.9657791180531},
  {"name": "LMJR137-F","y": -12.1872785,"x": -76.9790249555453},
  {"name": "LMJR138-F","y": -12.185866,"x": -76.97763536446},
  {"name": "LMJR139-F","y": -12.187069,"x": -76.9758070505427},
  {"name": "ZONA SATURADA","y": -12.2113505,"x": -76.9350931050178},
  {"name": "LMJR141-F","y": -12.1916245,"x": -76.9778672912076},
  {"name": "LMJR145-F","y": -12.1935605,"x": -76.9759617916667},
  {"name": "LMJR146-F","y": -12.193914,"x": -76.973421929868},
  {"name": "LMJR150-F","y": -12.172619,"x": -76.9575093793081},
  {"name": "LMJR151-F","y": -12.175859,"x": -76.9562255092005},
  {"name": "LMJR152-F","y": -12.1794915,"x": -76.9569388390625},
  {"name": "LMJR153-F","y": -12.1795975,"x": -76.9600461938764},
  {"name": "LMJR161-F","y": -12.184834,"x": -76.9585947668232},
  {"name": "LMJR174-F","y": -12.16073415,"x": -76.9837014661072},
  {"name": "LMJR162-F","y": -12.18668535,"x": -76.9585810086823},
  {"name": "LMJR163-F","y": -12.187864,"x": -76.9557228946804},
  {"name": "LMJR164-F","y": -12.1437385,"x": -76.9617504015148},
  {"name": "LMJR165-F","y": -12.1463365,"x": -76.9627622245394},
  {"name": "LMJR166-F","y": -12.149175,"x": -76.9650899932689},
  {"name": "LMVS010-S // LMVS010","y": -12.19901375,"x": -76.9504028457641},
  {"name": "LMJR167-F","y": -12.1503545,"x": -76.9642002937015},
  {"name": "LMVS127-F","y": -12.2162997,"x": -76.954601375},
  {"name": "LMJR168-F","y": -12.1523295,"x": -76.9640796218096},
  {"name": "LMJR169-F","y": -12.1576725,"x": -76.9719918190527},
  {"name": "LMVS059","y": -12.1950355,"x": -76.9610316197247},
  {"name": "LMJR170-F","y": -12.15878565,"x": -76.975510192292},
  {"name": "LMJR171-F","y": -12.1569885,"x": -76.9766923006979},
  {"name": "LMJR172-F","y": -12.159895,"x": -76.9809460793512},
  {"name": "LMJR173-F","y": -12.158689,"x": -76.9839838405594},
  {"name": "LMVS009-S // LMVS009","y": -12.200921,"x": -76.953932648406},
  {"name": "LMJR175-F","y": -12.1625655,"x": -76.9833240704347},
  {"name": "LMJR177-F","y": -12.1666055,"x": -76.9823821786427},
  {"name": "LMJR176-F","y": -12.1655485,"x": -76.983277069606},
  {"name": "LMVS001","y": -12.193197,"x": -76.956806219489},
  {"name": "LMVS002","y": -12.190746,"x": -76.9528868991838},
  {"name": "LMVS003","y": -12.195985,"x": -76.95743086331},
  {"name": "LMVS004","y": -12.195065,"x": -76.9554508415258},
  {"name": "LMVS058","y": -12.195682,"x": -76.9635748781006},
  {"name": "LMVS060-S // LMVS060","y": -12.1978695,"x": -76.9603777802607},
  {"name": "LMVS061-S // LMVS061","y": -12.208788,"x": -76.9545942736771},
  {"name": "LMVS062","y": -12.2054835,"x": -76.9497073955202},
  {"name": "LMVS063","y": -12.2135035,"x": -76.9510734977769},
  {"name": "LMVS064","y": -12.2079565,"x": -76.9495900866101},
  {"name": "LMVS126-F","y": -12.21355995,"x": -76.9553043982797},
  {"name": "LMVS086-F","y": -12.2118395,"x": -76.937805392066},
  {"name": "LMVS065","y": -12.21087,"x": -76.9514508395045},
  {"name": "LMVS077-F","y": -12.21215,"x": -76.9439795907136},
  {"name": "LMVS078-F","y": -12.2146475,"x": -76.9407584412941},
  {"name": "LMVS068-S // LMVS068","y": -12.210748,"x": -76.9478049425957},
  {"name": "LMVS069-F","y": -12.2188465,"x": -76.9522028616219},
  {"name": "LMVS070-F","y": -12.215829,"x": -76.9493041154619},
  {"name": "LMVS071-F","y": -12.218296,"x": -76.948154176731},
  {"name": "LMVS072-F","y": -12.2218055,"x": -76.9503644436396},
  {"name": "LMVS073-F","y": -12.214445,"x": -76.9468246362876},
  {"name": "LMVS074-F","y": -12.216114,"x": -76.9448881033714},
  {"name": "LMVS075-F","y": -12.220865,"x": -76.945672076169},
  {"name": "LMVS079-F","y": -12.21765,"x": -76.9423745885604},
  {"name": "LMVS080-F","y": -12.219954,"x": -76.9423012926617},
  {"name": "LMVS081-F","y": -12.223298,"x": -76.9456264736875},
  {"name": "LMVS082-F","y": -12.2107035,"x": -76.9406800884259},
  {"name": "LMVS083-F","y": -12.2161225,"x": -76.9378930613748},
  {"name": "LMVS084-F","y": -12.2189035,"x": -76.9384898928304},
  {"name": "LMVS085-F","y": -12.2089505,"x": -76.9396867745215},
  {"name": "JNPL001-F","y": -12.054081,"x": -75.261179872276},
  {"name": "LMVS091-F","y": -12.226245,"x": -76.9455008137992},
  {"name": "LMVS094-F","y": -12.222445,"x": -76.9404986176471},
  {"name": "LMVS116-F","y": -12.1926255,"x": -76.9511449696007},
  {"name": "LMVS095-F","y": -12.225418,"x": -76.9411774523276},
  {"name": "LMVS096-F","y": -12.22873,"x": -76.9420436928058},
  {"name": "LMVS097-F","y": -12.231347,"x": -76.9394237800971},
  {"name": "LMVS099-F","y": -12.2225405,"x": -76.9330696905839},
  {"name": "LMVS100-F","y": -12.224563,"x": -76.9356601012068},
  {"name": "LMVS108-F","y": -12.2261275,"x": -76.9245225882092},
  {"name": "LMVS101-F","y": -12.2262985,"x": -76.9341774087302},
  {"name": "LMVS102-F","y": -12.2197885,"x": -76.9322860128465},
  {"name": "LMVS103-F","y": -12.221667,"x": -76.9297475335949},
  {"name": "LMVS104-F","y": -12.2247833,"x": -76.9293582785433},
  {"name": "LMVS120-F","y": -12.1950445,"x": -76.9460724097811},
  {"name": "LMVS109-F","y": -12.227604,"x": -76.9289071179691},
  {"name": "LMVS110-F","y": -12.2280935,"x": -76.9328125359589},
  {"name": "LMVS111-F","y": -12.22775,"x": -76.9230248354465},
  {"name": "LMVS112-F","y": -12.2282935,"x": -76.9244537862747},
  {"name": "LMVS113-F","y": -12.230324,"x": -76.9246169677024},
  {"name": "LMVS114-F","y": -12.2106132,"x": -76.9573085346326},
  {"name": "LMVS130-F","y": -12.2077,"x": -76.9463135470938},
  {"name": "LMVS131-F","y": -12.20973,"x": -76.9455051275687},
  {"name": "LMVS134-F","y": -12.2090515,"x": -76.9439643918356},
  {"name": "LMVS135-F","y": -12.2024075,"x": -76.9449309707847},
  {"name": "LMVS136-F","y": -12.2037885,"x": -76.943953402307},
  {"name": "LMVS137-F","y": -12.2056875,"x": -76.9439035634351},
  {"name": "LMVS156-F","y": -12.219296,"x": -76.9236229838178},
  {"name": "LMVS138-F","y": -12.2081305,"x": -76.9425605219311},
  {"name": "LMVS139-F","y": -12.2013808,"x": -76.9422669965192},
  {"name": "LMVS140-F","y": -12.203301,"x": -76.9411051089604},
  {"name": "LMVS141-F","y": -12.204562,"x": -76.9401880099165},
  {"name": "LMVS142-F","y": -12.206057,"x": -76.9397883677383},
  {"name": "LMVS143-F","y": -12.2071685,"x": -76.939323492882},
  {"name": "LMVS145-F","y": -12.196463,"x": -76.9367824129213},
  {"name": "LMVS146-F","y": -12.205565,"x": -76.9320532683541},
  {"name": "LMVS147-F","y": -12.2075165,"x": -76.9286910464159},
  {"name": "LMVS148-F","y": -12.1999201,"x": -76.9397086518631},
  {"name": "LMVS149-F","y": -12.202715,"x": -76.9380250625348},
  {"name": "LMVS150-F","y": -12.205576,"x": -76.9368459559229},
  {"name": "LMVS153-F","y": -12.2008075,"x": -76.9349863050851},
  {"name": "LMVS154-F","y": -12.1898055,"x": -76.9478734456897},
  {"name": "LMVS157-F","y": -12.2213095,"x": -76.923107490544},
  {"name": "LMVS158-F","y": -12.2228975,"x": -76.9223670995743},
  {"name": "LMSQ093-R","y": -12.1136345,"x": -77.0121140672299},
  {"name": "LMVS159-F","y": -12.2254505,"x": -76.9208460237805},
  {"name": "LMVS160-F","y": -12.227671,"x": -76.9193300335622},
  {"name": "LMVS161-F","y": -12.2295365,"x": -76.9180373679222},
  {"name": "LMVS162-F","y": -12.231478,"x": -76.9172849157353},
  {"name": "LMVS163-F","y": -12.234793,"x": -76.9189611442006},
  {"name": "LMVS164-F","y": -12.2363595,"x": -76.9213350772125},
  {"name": "LMVS165-F","y": -12.237218,"x": -76.9190351138147},
  {"name": "LMVS166-F","y": -12.23358025,"x": -76.9160662226063},
  {"name": "LMVS167-F","y": -12.2299575,"x": -76.9150638826772},
  {"name": "LMVS168-F","y": -12.1946685,"x": -76.9688767892951},
  {"name": "LMHU034-S","y": -11.127707,"x": -77.6098494342916},
  {"name": "PIOC014-F","y": -5.1901925,"x": -80.6678036061568},
  {"name": "PIOC019-F","y": -5.2019025,"x": -80.6464685882159},
  {"name": "LMVS169-F","y": -12.1965795,"x": -76.9678776319463},
  {"name": "LMVS170-F","y": -12.1974715,"x": -76.9666499558566},
  {"name": "LMVS171-F","y": -12.2353425,"x": -76.9129574363672},
  {"name": "LMVS175-F","y": -12.2411215,"x": -76.9159876209607},
  {"name": "LMVM001-S // LMVM001","y": -12.138275,"x": -76.9485838644995},
  {"name": "LMVM002","y": -12.1416285,"x": -76.9507941337296},
  {"name": "LMVM012","y": -12.165121,"x": -76.9478962968705},
  {"name": "LMVM013-S // LMVM013","y": -12.162021,"x": -76.9457548269231},
  {"name": "5420B04AS // 5420B04-A","y": -12.119484,"x": -77.0093435089327},
  {"name": "LMVM003","y": -12.1443405,"x": -76.9521044845649},
  {"name": "LMVM030-S // LMVM030","y": -12.1870125,"x": -76.9273341741833},
  {"name": "LMVM005-S // LMVM005","y": -12.148047,"x": -76.9492329303226},
  {"name": "LMVM036-F","y": -12.1534549,"x": -76.9551208932442},
  {"name": "LMVM047-F","y": -12.19374125,"x": -76.9303155407183},
  {"name": "LMVM006","y": -12.1526175,"x": -76.9501528426524},
  {"name": "LMVM007","y": -12.1550235,"x": -76.9519562983596},
  {"name": "LMVM029-S // LMVM029","y": -12.1896015,"x": -76.9310694593111},
  {"name": "LMVM008","y": -12.15662,"x": -76.9555564160601},
  {"name": "LMVM009-S // LMVM009","y": -12.158583,"x": -76.9526451704139},
  {"name": "LMVM037-F","y": -12.15525315,"x": -76.9566725379094},
  {"name": "LMVM011-S // LMVM011","y": -12.1616465,"x": -76.9506581437887},
  {"name": "LMVM012","y": -12.163918,"x": -76.9489862153615},
  {"name": "LMVM014-S // LMVM014","y": -12.1603935,"x": -76.9434852479639},
  {"name": "LMVM061-F","y": -12.1415445,"x": -76.9413573527553},
  {"name": "55200000","y": -12.128878,"x": -77.0118934952155},
  {"name": "LMVM015-S // LMVM015","y": -12.158971,"x": -76.9414574105522},
  {"name": "LMVM016","y": -12.158868,"x": -76.9372984718372},
  {"name": "LMVM017","y": -12.1697515,"x": -76.9479299958965},
  {"name": "LMVM048-F","y": -12.1925728,"x": -76.9245685920241},
  {"name": "LMVM024-S // LMVM024","y": -12.1779035,"x": -76.9369436019081},
  {"name": "JNPL002-F","y": -12.052856,"x": -75.2560072209939},
  {"name": "LMVM018","y": -12.1664505,"x": -76.9485387335714},
  {"name": "LMVM038-F","y": -12.156686,"x": -76.9575108361325},
  {"name": "LMVM019-S // LMVM019","y": -12.1691325,"x": -76.9444270481194},
  {"name": "LMVM023-S // LMVM023","y": -12.1758405,"x": -76.9338513848896},
  {"name": "LMVM068-F","y": -12.154155,"x": -76.9609925231096},
  {"name": "LMVM050-F","y": -12.1983705,"x": -76.9313688262},
  {"name": "LMVM025-S // LMVM025","y": -12.1810125,"x": -76.9382695360654},
  {"name": "LMVM026-S // LMVM026","y": -12.181646,"x": -76.9413573771956},
  {"name": "LMVM046-F","y": -12.174706,"x": -76.9366483075643},
  {"name": "LMVM027","y": -12.187331,"x": -76.9370265827015},
  {"name": "LMVM028-S // LMVM028","y": -12.187141,"x": -76.9351166098534},
  {"name": "LMVM063-F","y": -12.143446,"x": -76.9482528396996},
  {"name": "LMVM031-S // LMVM031","y": -12.189914,"x": -76.9260090287978},
  {"name": "LMVM032-S // LMVM032","y": -12.1867695,"x": -76.9212903724344},
  {"name": "LMVM033","y": -12.174924,"x": -76.9442432157202},
  {"name": "LMVM035","y": -12.1799035,"x": -76.9419586842885},
  {"name": "LMVM049-F","y": -12.1960469,"x": -76.9293522924102},
  {"name": "LMJR158-F","y": -12.1726315,"x": -76.9526959548387},
  {"name": "LMBY002","y": -11.87098,"x": -77.017451848461},
  {"name": "LMVM039-F","y": -12.1621159,"x": -76.9390789754012},
  {"name": "LMVM040-F","y": -12.170444,"x": -76.9420920084524},
  {"name": "LMVM041-F","y": -12.1739775,"x": -76.9423202920507},
  {"name": "LMVM042-F","y": -12.1793684,"x": -76.9457993713473},
  {"name": "LMVM043-F","y": -12.175134,"x": -76.9479786229588},
  {"name": "LMVM044-F","y": -12.1680615,"x": -76.9297433438941},
  {"name": "LMVM045-F","y": -12.170695,"x": -76.9314952419786},
  {"name": "LMVM051-F","y": -12.1948535,"x": -76.9246303833333},
  {"name": "LMVM052-F","y": -12.199259,"x": -76.9265113636372},
  {"name": "LMVM052-F","y": -12.198551,"x": -76.9253886066194},
  {"name": "LMVM052-F","y": -12.1981894,"x": -76.9273224298696},
  {"name": "LMBY029-S // LMBY029","y": -11.879859,"x": -77.0296024546866},
  {"name": "LMVM078-F","y": -12.233159,"x": -76.9088690547088},
  {"name": "LMVM053-F","y": -12.194694,"x": -76.9204320388693},
  {"name": "LMVM054-F","y": -12.1968745,"x": -76.9248227256944},
  {"name": "LMVM054-F","y": -12.200061,"x": -76.9252005002942},
  {"name": "LMBY003-S // LMBY003","y": -11.871736,"x": -77.0138503273393},
  {"name": "LMVM062-F","y": -12.142595,"x": -76.9448695673844},
  {"name": "LMVM084-F","y": -12.2115495,"x": -76.9047481779209},
  {"name": "LMVM055-F","y": -12.201437,"x": -76.9270846289611},
  {"name": "LMVM056-F","y": -12.1985685,"x": -76.9215680848624},
  {"name": "LMVM057-F","y": -12.2020565,"x": -76.923649291561},
  {"name": "LMVM058-F","y": -12.133259,"x": -76.9422569523445},
  {"name": "LMBY065-F","y": -11.8858055,"x": -77.0248613960519},
  {"name": "LMVM059-F","y": -12.135631,"x": -76.9425790163934},
  {"name": "LMVM060-F","y": -12.135571,"x": -76.9447871611988},
  {"name": "LMVM064-F","y": -12.143917,"x": -76.9541490749821},
  {"name": "LMVM065-F","y": -12.148538,"x": -76.9555245016263},
  {"name": "LMVM066-F","y": -12.1524352,"x": -76.9535146116628},
  {"name": "LMVM067-F","y": -12.15542595,"x": -76.9593948023709},
  {"name": "LMVM077-F","y": -12.2307495,"x": -76.9085761730769},
  {"name": "LMVM083-F","y": -12.2066985,"x": -76.905477984088},
  {"name": "LMJR159-F","y": -12.1733495,"x": -76.9506719957798},
  {"name": "LMVM069-F","y": -12.1526155,"x": -76.9550849955608},
  {"name": "LMVM070-F","y": -12.144051,"x": -76.9450470798109},
  {"name": "LMVM071-F","y": -12.146803,"x": -76.9457075215883},
  {"name": "LMVM072-F","y": -12.1414955,"x": -76.9376532339228},
  {"name": "LMVM073-F","y": -12.1646535,"x": -76.9438247848466},
  {"name": "LMVM074-F","y": -12.167278,"x": -76.9416999352686},
  {"name": "LMVM075-F","y": -12.182482,"x": -76.9446568480292},
  {"name": "LMVM076-F","y": -12.2058886,"x": -76.9256283758302},
  {"name": "LMVM085-F","y": -12.211205,"x": -76.9079317819345},
  {"name": "LMBY030-S // LMBY030","y": -11.882077,"x": -77.0310592371589},
  {"name": "LMVM087-F","y": -12.2152075,"x": -76.9094607543923},
  {"name": "LMVM088-F","y": -12.2156529,"x": -76.9045017140084},
  {"name": "LMVM089-F","y": -12.2181659,"x": -76.904367064017},
  {"name": "LMAS006-F","y": -12.7513982,"x": -76.6221529304194},
  {"name": "LMBY036","y": -11.888014,"x": -77.0412230725103},
  {"name": "LMJR156-F","y": -12.168539,"x": -76.9524724818034},
  {"name": "LMVM090-F","y": -12.2224922,"x": -76.9035985309224},
  {"name": "LMVM091-F","y": -12.2201047,"x": -76.909064250375},
  {"name": "LMVM092-F","y": -12.2230846,"x": -76.9090302762564},
  {"name": "LMVM093-F","y": -12.2225027,"x": -76.9065497818651},
  {"name": "LMVM094-F","y": -12.226894,"x": -76.9084508662702},
  {"name": "LMJR155-F","y": -12.1651275,"x": -76.9547758469551},
  {"name": "LMJR157-F","y": -12.1706365,"x": -76.9514162739006},
  {"name": "LMJR183-F","y": -12.175753,"x": -76.9518681815791},
  {"name": "LMJR184-F","y": -12.179214,"x": -76.9521076667146},
  {"name": "LMJR185-F","y": -12.1774739,"x": -76.9499048124518},
  {"name": "LMJR186-F","y": -12.1799291,"x": -76.9492185850151},
  {"name": "LMJR187-F","y": -12.1814675,"x": -76.9493779672582},
  {"name": "LMAS005-F","y": -12.7490995,"x": -76.611671274794},
  {"name": "LMBY042","y": -11.8943755,"x": -77.0343729227078},
  {"name": "LMBY001-S // LMBY001","y": -11.869513,"x": -77.0146198325563},
  {"name": "LMBY004-S // LMBY004","y": -11.8735965,"x": -77.0185210620409},
  {"name": "LMBY005","y": -11.8762205,"x": -77.013326436466},
  {"name": "LMBY010","y": -11.8800955,"x": -77.0178408096081},
  {"name": "LMBY006-S // LMBY006","y": -11.876544,"x": -77.0088583637392},
  {"name": "LMBY012","y": -11.8820085,"x": -77.0180054009077},
  {"name": "LMBY013-S // LMBY013","y": -11.883563,"x": -77.0197319027581},
  {"name": "LMBY007-S // LMBY007","y": -11.876325,"x": -77.0200367619048},
  {"name": "LMBY008-S // LMBY008","y": -11.87847,"x": -77.0142105470588},
  {"name": "LMBY009-S // LMBY009","y": -11.8781055,"x": -77.0216446209564},
  {"name": "LMBY011","y": -11.87955,"x": -77.023545190288},
  {"name": "LMBY037","y": -11.8881375,"x": -77.0380934223204},
  {"name": "LMBY041-S // LMBY041","y": -11.8907505,"x": -77.0328951374846},
  {"name": "LMCO042","y": -11.895744,"x": -77.0462218152238},
  {"name": "LMBY031-S // LMBY031","y": -11.88258,"x": -77.034731267205},
  {"name": "LMBY014-S // LMBY014","y": -11.88574,"x": -77.0220305786982},
  {"name": "LMBY018-S // LMBY018","y": -11.8924895,"x": -77.0267670863048},
  {"name": "LMBY015-S // LMBY015","y": -11.889202,"x": -77.0235971237374},
  {"name": "LMBY016-S // LMBY016","y": -11.893345,"x": -77.0195025289806},
  {"name": "LMBY017","y": -11.889851,"x": -77.0297713511306},
  {"name": "LMBY017","y": -11.891185,"x": -77.0289979627139},
  {"name": "LMBY023","y": -11.898763,"x": -77.0353738106821},
  {"name": "LMBY039","y": -11.8896945,"x": -77.0353347967165},
  {"name": "LMBY040","y": -11.892453,"x": -77.0369879697912},
  {"name": "LMBY019","y": -11.893339,"x": -77.0232120472857},
  {"name": "LMBY020-S // LMBY020","y": -11.895793,"x": -77.0199142464632},
  {"name": "LMBY026-S // LMBY026","y": -11.876558,"x": -77.0282456},
  {"name": "LMBY021-S // LMBY021","y": -11.897079,"x": -77.0286694318185},
  {"name": "LMBY022","y": -11.8940265,"x": -77.0315203072511},
  {"name": "LMBY038","y": -11.8903785,"x": -77.0395767084296},
  {"name": "LMBY024","y": -11.903482,"x": -77.0335843368883},
  {"name": "LMBY025","y": -11.8753825,"x": -77.0302289049584},
  {"name": "AQCC061-F","y": -16.3872345,"x": -71.5648748419442},
  {"name": "LMBY032","y": -11.8840065,"x": -77.0364980507117},
  {"name": "LMBY033-S // LMBY033","y": -11.885682,"x": -77.0376754383698},
  {"name": "LMBY034","y": -11.884289,"x": -77.0322323019164},
  {"name": "5519A04","y": -12.1277875,"x": -77.0160228723583},
  {"name": "LMBY043","y": -11.8956265,"x": -77.0310424909339},
  {"name": "LMBY044","y": -11.9017575,"x": -77.03418299631},
  {"name": "LMBY045","y": -11.8997335,"x": -77.0333093401428},
  {"name": "LMAG069-F","y": -12.0508355,"x": -77.0002339958212},
  {"name": "LMBY046","y": -11.898037,"x": -77.0378839477349},
  {"name": "LMBY048","y": -11.8945805,"x": -77.0382227562482},
  {"name": "LMBY049","y": -11.8929965,"x": -77.0412351631288},
  {"name": "LMBY050","y": -11.8923285,"x": -77.0442185048985},
  {"name": "LMBY064-F","y": -11.887351,"x": -77.027350923619},
  {"name": "LMCO254-F","y": -11.88949,"x": -77.0456013747178},
  {"name": "LMHU025","y": -11.0990945,"x": -77.595108142229},
  {"name": "LMBY066-F","y": -11.8834765,"x": -77.027313630547},
  {"name": "5518G04AS // 5518G04-A","y": -12.1291415,"x": -77.0250666368836},
  {"name": "LMBY067-F","y": -11.8824555,"x": -77.0252258327681},
  {"name": "LMBY068-F","y": -11.879508,"x": -77.0261536212555},
  {"name": "LMBY070-F","y": -11.8741705,"x": -77.0227438639602},
  {"name": "LMBY082-F","y": -11.8722335,"x": -77.0246896409824},
  {"name": "LMCL001","y": -12.038869,"x": -77.0853154446047},
  {"name": "LMBY071-F","y": -11.873543,"x": -77.0265811166201},
  {"name": "LMBY075-F","y": -11.878586,"x": -77.0365325832323},
  {"name": "5520A04-A","y": -12.124411,"x": -77.0069353908869},
  {"name": "LMBY076-F","y": -11.8766105,"x": -77.0352109655309},
  {"name": "LMBY077-F","y": -11.874255,"x": -77.032114619036},
  {"name": "LMST002-F","y": -12.4111895,"x": -76.7769170292899},
  {"name": "LMBY078-F","y": -11.872182,"x": -77.0310289496075},
  {"name": "LMBY079-F","y": -11.8687225,"x": -77.0278473909574},
  {"name": "LMPH008-F","y": -12.329784,"x": -76.8256701653619},
  {"name": "LMBY080-F","y": -11.8660945,"x": -77.0248081356998},
  {"name": "LMBY081-F","y": -11.8631265,"x": -77.0218785118626},
  {"name": "LMBY083-F","y": -11.870591,"x": -77.0228561403075},
  {"name": "LMBY084-F","y": -11.8664655,"x": -77.0227965272979},
  {"name": "LMBY085-F","y": -11.8675205,"x": -77.0203233403171},
  {"name": "LMBR003-F","y": -10.7447294,"x": -77.7604048244517},
  {"name": "LMBY086-F","y": -11.863808,"x": -77.017242327342},
  {"name": "LMBY087-F","y": -11.85975,"x": -77.0139265428583},
  {"name": "LMST003-F","y": -12.3998335,"x": -76.7760403563795},
  {"name": "LMBY088-F","y": -11.857469,"x": -77.011071235699},
  {"name": "LMBY089-F","y": -11.868335,"x": -77.0175659982022},
  {"name": "LMBY090-F","y": -11.865619,"x": -77.0148371762274},
  {"name": "LMCL002","y": -12.0398915,"x": -77.089271840289},
  {"name": "LMBY091-F","y": -11.853147,"x": -77.0006272923873},
  {"name": "LMBY092-F","y": -11.8791905,"x": -77.0040601153646},
  {"name": "LMBY093-F","y": -11.879191,"x": -77.000174931856},
  {"name": "LMBY094-F","y": -11.8643245,"x": -77.0112490825369},
  {"name": "5318A03","y": -12.1108965,"x": -77.0320569976295},
  {"name": "LMBY095-F","y": -11.8459355,"x": -76.9986501077315},
  {"name": "LMBY096-F","y": -11.8438035,"x": -76.9984476625059},
  {"name": "LMST001-F","y": -12.4045355,"x": -76.774800341768},
  {"name": "5417A04-S // 5417A04","y": -12.1204315,"x": -77.041959103169},
  {"name": "LMBY097-F","y": -11.8493545,"x": -77.0021480357143},
  {"name": "LMBY098-F","y": -11.9047215,"x": -77.0297607816742},
  {"name": "5418A04","y": -12.1239505,"x": -77.0312961638693},
  {"name": "LMBY099-F","y": -11.90471,"x": -77.0275525788084},
  {"name": "LMBR011-F","y": -10.7529562,"x": -77.7600252301214},
  {"name": "LMBY100-F","y": -11.885076,"x": -77.0146676921222},
  {"name": "LMCL003","y": -12.040995,"x": -77.0914281242092},
  {"name": "LMCL004","y": -12.039735,"x": -77.0935947525597},
  {"name": "LMCL005","y": -12.042727,"x": -77.0934461610273},
  {"name": "LLFM013-F","y": -8.0783245,"x": -79.0217827893197},
  {"name": "LMCI007-F","y": -12.543424,"x": -76.723823902081},
  {"name": "LMCL006","y": -12.040679,"x": -77.0958966572544},
  {"name": "LMCL007","y": -12.0433385,"x": -77.095669817898},
  {"name": "LMCL008","y": -12.043883,"x": -77.0976263250934},
  {"name": "LMCI001-F","y": -12.514283,"x": -76.7367777504683},
  {"name": "5420A04","y": -12.1218235,"x": -77.0112350036153},
  {"name": "5518A04","y": -12.125651,"x": -77.0311545301932},
  {"name": "LMCI002-F","y": -12.5193775,"x": -76.7383496821608},
  {"name": "LMCI003-F","y": -12.52063195,"x": -76.7333844216873},
  {"name": "LMCI004-F","y": -12.5175944,"x": -76.7325870439376},
  {"name": "LMCI005-F","y": -12.51747695,"x": -76.7288878547724},
  {"name": "LMCI006-F","y": -12.51307475,"x": -76.7312533858887},
  {"name": "LMPT001","y": -12.072486,"x": -77.1634229157723},
  {"name": "LMPT002-S // LMPT002","y": -12.0705435,"x": -77.161429527503},
  {"name": "5317A03-S // 5317A03","y": -12.113466,"x": -77.0425743967007},
  {"name": "5419A04","y": -12.1218405,"x": -77.0155641485297},
  {"name": "5517A04","y": -12.1270295,"x": -77.033434488683},
  {"name": "5420B04-B","y": -12.121548,"x": -77.0078896065436},
  {"name": "5618A04","y": -12.1339405,"x": -77.0255785044285},
  {"name": "5518B04","y": -12.126014,"x": -77.0282188233518},
  {"name": "5417B04","y": -12.1222175,"x": -77.0388781135057},
  {"name": "5517B04","y": -12.129166,"x": -77.0334374878224},
  {"name": "5418B04","y": -12.1236705,"x": -77.0292729073072},
  {"name": "LMBR004-F","y": -10.7463419,"x": -77.7592091388264},
  {"name": "5520B04-S // 5520B04","y": -12.1261585,"x": -77.01209560631},
  {"name": "5218C03","y": -12.107202,"x": -77.0289555004793},
  {"name": "5417C04-S // 5417C04","y": -12.124979,"x": -77.0352991367159},
  {"name": "5418C04","y": -12.1240275,"x": -77.0279377112676},
  {"name": "5518C04","y": -12.1266535,"x": -77.0264353700884},
  {"name": "5418D04","y": -12.122829,"x": -77.0274142460687},
  {"name": "55180000","y": -12.134809,"x": -77.0245802222222},
  {"name": "LMPH005-F","y": -12.3317615,"x": -76.826277089191},
  {"name": "55180000","y": -12.130542,"x": -77.023890859852},
  {"name": "LMMF077-S","y": -12.122262,"x": -77.0212235765096},
  {"name": "54180000","y": -12.123558,"x": -77.0253464595715},
  {"name": "5518F04","y": -12.132361,"x": -77.0281847155483},
  {"name": "5518G04","y": -12.1286955,"x": -77.028016633954},
  {"name": "LMBR006-F","y": -10.75103395,"x": -77.7589377602155},
  {"name": "5518H04-S // 5518H04","y": -12.1297915,"x": -77.0308908077967},
  {"name": "5518I04","y": -12.1274815,"x": -77.0310866317471},
  {"name": "LMPU001-F","y": -12.4823785,"x": -76.7978008953265},
  {"name": "LMPH004-F","y": -12.338154,"x": -76.8255845873708},
  {"name": "SMNC009-F","y": -5.939847,"x": -77.305824571741},
  {"name": "LMPU002-F","y": -12.484264,"x": -76.7967926479724},
  {"name": "LMPU004-F","y": -12.4708925,"x": -76.7517621986474},
  {"name": "LMPH002-F","y": -12.3323858,"x": -76.8237609692853},
  {"name": "LMBR005-F","y": -10.74784495,"x": -77.7580489291659},
  {"name": "LMPH003-F","y": -12.3343682,"x": -76.8266311312789},
  {"name": "LMST004-F","y": -12.392404,"x": -76.7743338747409},
  {"name": "LMBT002-F","y": -12.387657,"x": -76.7796716921119},
  {"name": "LMBT003-F","y": -12.386976,"x": -76.7762613293303},
  {"name": "LMBR007-F","y": -10.746089,"x": -77.7565313180491},
  {"name": "LMBT004-F","y": -12.388298,"x": -76.7744799681271},
  {"name": "JNPL003-F","y": -12.0524055,"x": -75.2526518583993},
  {"name": "LMBT005-F","y": -12.3939315,"x": -76.7757352426173},
  {"name": "LMBT006-F","y": -12.384407,"x": -76.7784420887872},
  {"name": "LMBT007-F","y": -12.384225,"x": -76.7860108507159},
  {"name": "LMBR001-F","y": -10.74426115,"x": -77.7657114935948},
  {"name": "LMBR002-F","y": -10.7468179,"x": -77.7642886259494},
  {"name": "LMBR008-F","y": -10.7440799,"x": -77.7546919677437},
  {"name": "LMBR010-F","y": -10.74628,"x": -77.7531989085542},
  {"name": "LMBR012-F","y": -10.749712,"x": -77.7566238946357},
  {"name": "LMBR013-F","y": -10.7490115,"x": -77.7529115926672},
  {"name": "LMBR014-F","y": -10.7552006,"x": -77.7585074785448},
  {"name": "LMBR015-F","y": -10.75217965,"x": -77.756694612385},
  {"name": "LMBR017-F","y": -10.755699,"x": -77.7603539055879},
  {"name": "LMBR057-F","y": -10.729447,"x": -77.7711046883969},
  {"name": "LMVT042-F","y": -11.8526145,"x": -77.1253394448732},
  {"name": "LMBR018-F","y": -10.75723285,"x": -77.7550349695812},
  {"name": "ZONA SATURADA","y": -10.7550255,"x": -77.7530351666093},
  {"name": "LMBR019-F","y": -10.75862295,"x": -77.75955481347},
  {"name": "LMBR020-F","y": -10.7505419,"x": -77.7622960168117},
  {"name": "LMBR047-F","y": -10.7511271,"x": -77.7672951905738},
  {"name": "LMBR048-F","y": -10.74857925,"x": -77.7629846777132},
  {"name": "LMCC008-F","y": -11.569801,"x": -77.2700720747958},
  {"name": "LMBR049-F","y": -10.7543055,"x": -77.7665113784},
  {"name": "LMCC001-F","y": -11.5594655,"x": -77.268625343524},
  {"name": "LMBR050-F","y": -10.755013,"x": -77.7629868647118},
  {"name": "LMBR051-F","y": -10.7588908,"x": -77.7616301193115},
  {"name": "LMBR052-F","y": -10.742355,"x": -77.7507323582005},
  {"name": "LMBR053-F","y": -10.747394,"x": -77.7505950690829},
  {"name": "LMBR054-F","y": -10.749698,"x": -77.7480132758132},
  {"name": "LMBR055-F","y": -10.7428725,"x": -77.7724148186125},
  {"name": "LMBR056-F","y": -10.7306255,"x": -77.7741378193147},
  {"name": "LMCC002-F","y": -11.5603465,"x": -77.272695680141},
  {"name": "LMAG073-F","y": -12.029469,"x": -76.988482859589},
  {"name": "LMCC013-F","y": -11.5949765,"x": -77.2570547358021},
  {"name": "LMCQ002","y": -11.096018,"x": -77.6255398387446},
  {"name": "LMHU022-S // LMHU022","y": -11.099983,"x": -77.6059162917407},
  {"name": "LMHU010","y": -11.108663,"x": -77.6090449372711},
  {"name": "LMHU010","y": -11.1086295,"x": -77.6035947838084},
  {"name": "LMCC003-F","y": -11.5626667,"x": -77.2686904490135},
  {"name": "LMCC004-F","y": -11.5640835,"x": -77.2718852269174},
  {"name": "LMHU019-S // LMHU019","y": -11.103631,"x": -77.6017419506058},
  {"name": "LMCC016-F","y": -11.58213595,"x": -77.2616643166535},
  {"name": "LMCC005-F","y": -11.5645937,"x": -77.266492903035},
  {"name": "LMCC006-F","y": -11.56673095,"x": -77.2712470830833},
  {"name": "LMCC007-F","y": -11.5672005,"x": -77.2678862012319},
  {"name": "LMCC009-F","y": -11.5721668,"x": -77.2682832806522},
  {"name": "LMCC012-F","y": -11.590226,"x": -77.2616301863953},
  {"name": "LMCC018-F","y": -11.55485305,"x": -77.2679224609987},
  {"name": "LMLV126-F","y": -12.065834,"x": -77.0133904349315},
  {"name": "LMCC010-F","y": -11.584879,"x": -77.2698762324493},
  {"name": "LMHU023","y": -11.1006125,"x": -77.600889901297},
  {"name": "LMHU024-S // LMHU024","y": -11.098581,"x": -77.5976417691128},
  {"name": "LMHU010","y": -11.1077215,"x": -77.6055327558691},
  {"name": "LMCC011-F","y": -11.588604,"x": -77.2669553177969},
  {"name": "LMHU007-S // LMHU007","y": -11.1095,"x": -77.6116055386965},
  {"name": "LMCC014-F","y": -11.5961902,"x": -77.2530512942509},
  {"name": "LMCC015-F","y": -11.587223,"x": -77.2579545418618},
  {"name": "LMHU010","y": -11.1082815,"x": -77.603036644772},
  {"name": "LMHU004-S // LMHU004","y": -11.1180925,"x": -77.6098454533999},
  {"name": "LMHU027-S // LMHU027","y": -11.1005685,"x": -77.6092805246115},
  {"name": "LMHU006-S // LMHU006","y": -11.1132345,"x": -77.6100207193639},
  {"name": "LMHU008-S // LMHU008","y": -11.112018,"x": -77.6073812853017},
  {"name": "LMHU028-S // LMHU028","y": -11.0981225,"x": -77.6124830836082},
  {"name": "LMVT048-F","y": -11.856559,"x": -77.1232948804912},
  {"name": "LMHU018-S // LMHU018","y": -11.1038695,"x": -77.6060298407373},
  {"name": "LMHU010-S","y": -11.108553,"x": -77.6059264503264},
  {"name": "LMHU010","y": -11.1091655,"x": -77.6071992699275},
  {"name": "LMHU010","y": -11.1090285,"x": -77.6045082725625},
  {"name": "LMHU013-S // LMHU013","y": -11.106922,"x": -77.6112155100544},
  {"name": "LMHU014","y": -11.106463,"x": -77.6051741247744},
  {"name": "LMHU015","y": -11.106463,"x": -77.5999652346154},
  {"name": "LMHU017","y": -11.10351,"x": -77.6093649682551},
  {"name": "LMLV128-F","y": -12.065398,"x": -77.0135754216543},
  {"name": "LMHU020-S // LMHU020","y": -11.1033655,"x": -77.59763297231},
  {"name": "LMHU029","y": -11.093561,"x": -77.6073611283654},
  {"name": "LMML005-F","y": -12.663614,"x": -76.6169716666667},
  {"name": "LMHU030","y": -11.0975495,"x": -77.6024021146343},
  {"name": "LMHU031","y": -11.094899,"x": -77.5989774713031},
  {"name": "LMHU032","y": -11.116085,"x": -77.6012129794691},
  {"name": "LMHU033-S // LMHU033","y": -11.120369,"x": -77.5960282905573},
  {"name": "LMHU035-S","y": -11.130227,"x": -77.611352181686},
  {"name": "LMHU036-F","y": -11.1250545,"x": -77.5967046631579},
  {"name": "LMHU037-F","y": -11.125918,"x": -77.6019400955709},
  {"name": "LMHU038-F","y": -11.127561,"x": -77.605564869524},
  {"name": "LMHU041-F","y": -11.132611,"x": -77.6120747135279},
  {"name": "LMHU042-F","y": -11.1299585,"x": -77.6058111573784},
  {"name": "LMHU043-F","y": -11.129917,"x": -77.5982108192576},
  {"name": "5519B04-S // 5519B04","y": -12.1285135,"x": -77.0205307204134},
  {"name": "LMVT039-F","y": -11.85058,"x": -77.1235516905473},
  {"name": "LMHU044-F","y": -11.1356335,"x": -77.6069008943005},
  {"name": "LMHU045-F","y": -11.1326295,"x": -77.6056153668094},
  {"name": "LMHU046-F","y": -11.133913,"x": -77.5993891631275},
  {"name": "LMHU047-F","y": -11.13762,"x": -77.6021264572972},
  {"name": "LMHU048-F","y": -11.141419,"x": -77.6025157240077},
  {"name": "LMHU049-F","y": -11.1392945,"x": -77.5990340554765},
  {"name": "LMHU050-F","y": -11.1467745,"x": -77.5994214007634},
  {"name": "LMHU016-S // LMHU016","y": -11.1024888,"x": -77.6119861774523},
  {"name": "LMHR001","y": -11.0701645,"x": -77.5930995713098},
  {"name": "LMHR002","y": -11.0714915,"x": -77.5962294343112},
  {"name": "LMHR003","y": -11.069374,"x": -77.5968111875706},
  {"name": "LMHR004","y": -11.0663145,"x": -77.5962549197735},
  {"name": "LMHR005","y": -11.066091,"x": -77.600441614854},
  {"name": "LMAT210-F","y": -12.0129135,"x": -76.8188125537407},
  {"name": "LMHR006","y": -11.0698655,"x": -77.600622801948},
  {"name": "LMHR007","y": -11.071969,"x": -77.5992227249443},
  {"name": "LMHR008","y": -11.0697945,"x": -77.6039182105136},
  {"name": "LMHR009-S // LMHR009","y": -11.067641,"x": -77.6047443069444},
  {"name": "LMML004-F","y": -12.66688,"x": -76.6207816100863},
  {"name": "LMML001-F","y": -12.655375,"x": -76.6360215364467},
  {"name": "LMML008-F","y": -12.65323,"x": -76.6244314723659},
  {"name": "LMML002-F","y": -12.657365,"x": -76.6319238799635},
  {"name": "LMML003-F","y": -12.661261,"x": -76.6307994429083},
  {"name": "LMVT040-F","y": -11.850022,"x": -77.1210570952523},
  {"name": "LMML006-F","y": -12.6536465,"x": -76.6302319800444},
  {"name": "LMML007-F","y": -12.652107,"x": -76.6265886277628},
  {"name": "LMML009-F","y": -12.6569195,"x": -76.6238000718532},
  {"name": "LMML010-F","y": -12.6591595,"x": -76.6268193318868},
  {"name": "LMML011-F","y": -12.6634265,"x": -76.6286609745153},
  {"name": "LMVT041-F","y": -11.852392,"x": -77.1274488826082},
  {"name": "LMML012-F","y": -12.6687425,"x": -76.6130368737116},
  {"name": "LMMI001-F","y": -11.8546875,"x": -77.1253576098673},
  {"name": "LMMI002-F","y": -11.857358,"x": -77.1222374744898},
  {"name": "LMMR001-F","y": -11.105104,"x": -77.5874655408291},
  {"name": "LMVT047-F","y": -11.8566945,"x": -77.1250440565083},
  {"name": "LMMI003-F","y": -11.8594295,"x": -77.124874729572},
  {"name": "LMVT043-F","y": -11.8526145,"x": -77.1229491731391},
  {"name": "LMVT044-F","y": -11.852861,"x": -77.1210169120203},
  {"name": "LMVT045-F","y": -11.854431,"x": -77.1274057475222},
  {"name": "LMVT046-F","y": -11.8569445,"x": -77.1271825763905},
  {"name": "LMMR002-F","y": -11.109469,"x": -77.5891688348999},
  {"name": "LMMR003-F","y": -11.107001,"x": -77.5834226457867},
  {"name": "LMMR004-F","y": -11.105727,"x": -77.5771220954889},
  {"name": "LMMR005-F","y": -11.084624,"x": -77.5959265682441},
  {"name": "LMMR006-F","y": -11.0828964,"x": -77.5872527819739},
  {"name": "AQCL004-F","y": -15.8494135,"x": -74.2453372751442},
  {"name": "BRSU002-F","y": -10.796871,"x": -77.7158836968043},
  {"name": "BRSU003-F","y": -10.796646,"x": -77.711966860921},
  {"name": "LMSI101-F","y": -12.0930215,"x": -77.0119296505428},
  {"name": "LMMR007-F","y": -11.0892878,"x": -77.5921456314421},
  {"name": "LMMR008-F","y": -11.09330645,"x": -77.5911895948881},
  {"name": "LMHU021","y": -11.1063297,"x": -77.5943605239975},
  {"name": "BRSP001-F","y": -10.798355,"x": -77.733560481915},
  {"name": "BRSP002-F","y": -10.7962575,"x": -77.7300643290178},
  {"name": "LMLV112-F","y": -12.067246,"x": -77.0126116034237},
  {"name": "BRSU004-F","y": -10.800681,"x": -77.7144126906889},
  {"name": "APCH001-F","y": -14.1227165,"x": -72.2594300734536},
  {"name": "BRSP003-F","y": -10.795726,"x": -77.7394336484283},
  {"name": "JNPL004-F","y": -12.0510795,"x": -75.2503408030676},
  {"name": "BRSP004-F","y": -10.8006735,"x": -77.741496300236},
  {"name": "BRSP005-F","y": -10.8023855,"x": -77.744956474088},
  {"name": "BRSP006-F","y": -10.805124,"x": -77.7437101879443},
  {"name": "BRSU001-F","y": -10.7915645,"x": -77.7145911300859},
  {"name": "LMCQ001","y": -11.091956,"x": -77.6271884703405},
  {"name": "LMPM003-F","y": -10.6734395,"x": -77.815203907576},
  {"name": "BRSU005-F","y": -10.8045745,"x": -77.7136271396057},
  {"name": "LMSM001","y": -12.06338,"x": -77.0977164344123},
  {"name": "BRSU006-F","y": -10.801684,"x": -77.6995006473573},
  {"name": "BRSU007-F","y": -10.8094175,"x": -77.6937609545125},
  {"name": "LMPM001-F","y": -10.674549,"x": -77.830260141753},
  {"name": "PIUR050-S // PIUR050","y": -5.175224,"x": -80.6417832069672},
  {"name": "PIOC013-F","y": -5.1893715,"x": -80.6731342862481},
  {"name": "PUSD002-F","y": -14.321812,"x": -69.4665893664308},
  {"name": "LMPM002-F","y": -10.6751127,"x": -77.8202024100395},
  {"name": "LMPM004-F","y": -10.6765899,"x": -77.8167971414406},
  {"name": "LMPM005-F","y": -10.6821295,"x": -77.8215707316604},
  {"name": "LMPM006-F","y": -10.680581,"x": -77.8186177179368},
  {"name": "PUSD004-F","y": -14.326248,"x": -69.4654336618143},
  {"name": "LMPM007-F","y": -10.678077,"x": -77.8135459276139},
  {"name": "LMPM008-F","y": -10.676539,"x": -77.8077509570318},
  {"name": "LMSM001","y": -12.063694,"x": -77.099015605613},
  {"name": "5017B03-S�","y": -12.090728,"x": -77.03674647369},
  {"name": "LMPM008-F","y": -10.6770371,"x": -77.8099612369458},
  {"name": "LMPM009-F","y": -10.6757217,"x": -77.8047645488191},
  {"name": "PUSD005-F","y": -14.33105,"x": -69.4669565974265},
  {"name": "PUSD003-F","y": -14.323831,"x": -69.4650074681939},
  {"name": "LMLC078-F","y": -12.0914695,"x": -77.0317477726183},
  {"name": "PUSD001-F","y": -14.319015,"x": -69.4606845783654},
  {"name": "PIUC110-S // PIUC110","y": -5.2301175,"x": -80.637443279494},
  {"name": "LMSC335-F","y": -12.1442475,"x": -77.0134307197652},
  {"name": "5520C04-S // 5520C04","y": -12.129754,"x": -77.0039260900605},
  {"name": "AQCC037-S //�AQCC037","y": -16.365241,"x": -71.5597286512685},
  {"name": "5520D04-S // 5520D04","y": -12.129174,"x": -77.0078168633026},
  {"name": "LMSC004-S // LMSC004","y": -12.1316765,"x": -77.0079348850862},
  {"name": "5120C03-S // 5120C03","y": -12.0986475,"x": -77.0109762607061},
  {"name": "LMAT209-F","y": -12.008779,"x": -76.8205900343327},
  {"name": "AQCL002-F","y": -15.8442605,"x": -74.2533076616924},
  {"name": "LMAT208-F","y": -12.008327,"x": -76.822880798103},
  {"name": "LMAT250-F","y": -12.0264105,"x": -76.9510364701495},
  {"name": "LMAT251-F","y": -12.02527,"x": -76.950117639697},
  {"name": "LMAN010-F","y": -11.7744825,"x": -77.1871970228398},
  {"name": "LMCH068-R","y": -12.192539,"x": -77.005412328521},
  {"name": "LMCH084-R","y": -12.174859,"x": -77.0231416381001},
  {"name": "LMHU034-R","y": -11.129929,"x": -77.6087299804619},
  {"name": "AQCL003-F","y": -15.8467825,"x": -74.2562328206721},
  {"name": "AQCL005-F","y": -15.851431,"x": -74.2505989051522},
  {"name": "LMAT252-F","y": -12.027155,"x": -76.9491353082717},
  {"name": "AQCL006-F","y": -15.8545025,"x": -74.2469910375494},
  {"name": "AQCL007-F","y": -15.861686,"x": -74.2453281199052},
  {"name": "AQCL008-F","y": -15.865655,"x": -74.243182582175},
  {"name": "APCH004-F","y": -14.114615,"x": -72.2440935104402},
  {"name": "APCH003-F","y": -14.1200595,"x": -72.2508338899675},
  {"name": "APCH002-F","y": -14.1219885,"x": -72.2542503776917},
  {"name": "CZES023-F","y": -14.8017215,"x": -71.4196913539035},
  {"name": "CZES022-F","y": -14.8027745,"x": -71.4153593538584},
  {"name": "LBMT004-F","y": -6.148713,"x": -79.7160839938064},
  {"name": "CZES021-F","y": -14.802737,"x": -71.4117046273313},
  {"name": "LMMP068","y": -12.013502,"x": -77.0705105597001},
  {"name": "LMMP068","y": -12.0149035,"x": -77.0721559835766},
  {"name": "CZES020-F","y": -14.8017755,"x": -71.4078770327857},
  {"name": "MQMN056-F","y": -17.2050414796607,"x": -70.930659369859},
  {"name": "MQMN062-F","y": -17.2080236908387,"x": -70.9158744991757},
  {"name": "LBMT003-F","y": -6.1539023,"x": -79.7071026886127},
  {"name": "LMLV111-F","y": -12.0674905,"x": -77.0138632151163},
  {"name": "LBMT003-F","y": -6.1536696,"x": -79.7091434541071},
  {"name": "LMMP068-S // LMMP068","y": -12.012842,"x": -77.0722676839619},
  {"name": "LMLO076","y": -11.9640355,"x": -77.0737157845213},
  {"name": "MDHP001-F","y": -13.0010525,"x": -70.5311490248796},
  {"name": "MDHP002-F","y": -13.0016865,"x": -70.5270740755289},
  {"name": "MDHP003-F","y": -12.99893,"x": -70.5240301629962},
  {"name": "LMLV133-F","y": -12.0646495,"x": -77.0142671485148},
  {"name": "MDHP004-F","y": -12.9969155,"x": -70.5339195793059},
  {"name": "MDHP005-F","y": -12.9928975,"x": -70.5278962015321},
  {"name": "MDHP006-F","y": -12.9931795,"x": -70.5226865518905},
  {"name": "CHCH014-F","y": -13.414494,"x": -76.1373679645304},
  {"name": "PIOC009-F","y": -5.1721105,"x": -80.6706553653932},
  {"name": "PIOC010-F","y": -5.1831835,"x": -80.6861340525159},
  {"name": "PIOC011-F","y": -5.184483,"x": -80.6812180872025},
  {"name": "LMPP072-F","y": -11.9003945,"x": -77.0692400081359},
  {"name": "LMLV072-F","y": -12.069515,"x": -77.0150148974359},
  {"name": "LMPP073-F","y": -11.9021015,"x": -77.0704489949597},
  {"name": "LMAG070-F","y": -12.046996,"x": -76.9990816286263},
  {"name": "LMAG068-F","y": -12.0530975,"x": -77.0022288316327},
  {"name": "LMLO076-S","y": -11.963521,"x": -77.0734409300348},
  {"name": "LMLO076","y": -11.9623565,"x": -77.0757867776715},
  {"name": "LMLO076","y": -11.9638235,"x": -77.0721650498221},
  {"name": "LMLV109-F","y": -12.068645,"x": -77.0157463872549},
  {"name": "LMLM012","y": -12.060313,"x": -77.0589208719008},
  {"name": "LMAT211-F","y": -12.0130025,"x": -76.8141446667794},
  {"name": "LMAT253-F","y": -12.0243615,"x": -76.9468563224677},
  {"name": "LMAT215-F","y": -12.016294,"x": -76.8155443820872},
  {"name": "LMAT010","y": -12.080171,"x": -76.982153542033},
  {"name": "LMAT010","y": -12.0805035,"x": -76.9838123048872},
  {"name": "LMAT007-S // LMAT007","y": -12.0784585,"x": -76.9863766132695},
  {"name": "LMAT008-S // LMAT008","y": -12.0770075,"x": -76.9806119603129},
  {"name": "LAMO027-S // LAMO027","y": -12.0746735,"x": -76.9591358094495},
  {"name": "LMAT009-S // LMAT009","y": -12.0822045,"x": -76.9841465507531},
  {"name": "LMAT010-S","y": -12.0812035,"x": -76.9835413362069},
  {"name": "LMAT010-S","y": -12.080146,"x": -76.982872878866},
  {"name": "LMMP149-S","y": -11.999181,"x": -77.0958997183662},
  {"name": "LMAT059","y": -12.0783125,"x": -76.9777367294459},
  {"name": "LMAT011","y": -12.0817195,"x": -76.9806893349799},
  {"name": "LMJM034","y": -12.084772,"x": -77.0537188055315},
  {"name": "LMJM004-S","y": -12.0848085,"x": -77.0497733375744},
  {"name": "LMLM012-S","y": -12.059645,"x": -77.0600181354309},
  {"name": "LMLM012","y": -12.0618745,"x": -77.0628973076002},
  {"name": "LMLM012","y": -12.0626835,"x": -77.0606880365292},
  {"name": "LMLM012","y": -12.0573875,"x": -77.0585449496904},
  {"name": "LMSM001-S","y": -12.0636365,"x": -77.1018548151377},
  {"name": "LMSC041-S","y": -12.132354,"x": -76.9939002740853},
  {"name": "LMSC041","y": -12.129022,"x": -76.9924484076763},
  {"name": "LMCH032","y": -12.2060815,"x": -77.0169869032928},
  {"name": "LMCH032-S","y": -12.2059975,"x": -77.0138767096548},
  {"name": "LAMO014-S //�LAMO014","y": -12.07846585,"x": -76.9679620885894},
  {"name": "LMCO121-S // LMCO121","y": -11.9659025,"x": -77.059702755082},
  {"name": "LAMO068-S // LAMO068","y": -12.073313,"x": -76.9095959655845},
  {"name": "LMAT258-F","y": -12.024763,"x": -76.9312046044206},
  {"name": "LMAT259-F","y": -12.024415,"x": -76.9273913609961},
  {"name": "LMAT257-F","y": -12.0247625,"x": -76.9342468099071},
  {"name": "LMAT254-F","y": -12.0271915,"x": -76.9463702740582},
  {"name": "LMAT255-F","y": -12.0261295,"x": -76.9417449098081},
  {"name": "LMSC433-F","y": -12.097881,"x": -76.96342262},
  {"name": "LMAT256-F","y": -12.023781,"x": -76.9436987442724},
  {"name": "LMLV120-F","y": -12.0662195,"x": -77.0132684194811},
  {"name": "LMSC318-F","y": -12.165252,"x": -76.996609995401},
  {"name": "5520A04BS","y": -12.126108,"x": -77.0054179376291},
  {"name": "LMCO113-S","y": -11.9578855,"x": -77.0544031478728},
  {"name": "LMSC454-F","y": -12.148539,"x": -77.015536119593},
  {"name": "LMAT212-F","y": -12.013959,"x": -76.815393483945},
  {"name": "AYCA011-F","y": -13.1902665,"x": -74.2197888319498},
  {"name": "PUMC009-F","y": -14.067591,"x": -70.4348813650426},
  {"name": "PUPU090-F","y": -15.8265285,"x": -70.0356624407846},
  {"name": "MQMN052-F","y": -17.2038547577519,"x": -70.9373526315213},
  {"name": "PUPU089-F","y": -15.8295605,"x": -70.0357705643476},
  {"name": "LMCO104-S // LMCO104","y": -11.94902,"x": -77.0505144880261},
  {"name": "PUMC008-F","y": -14.065957,"x": -70.4337986603028},
  {"name": "PUAN006-F","y": -14.6387465,"x": -69.4467521039873},
  {"name": "AQAQ031-R","y": -16.4094096690511,"x": -71.5159511731994},
  {"name": "PIUR036-S // PIUR036","y": -5.201081,"x": -80.6421267141447},
  {"name": "LAMO073","y": -12.0977935,"x": -76.9273743778027},
  {"name": "LAMO073","y": -12.0964845,"x": -76.9212821635945},
  {"name": "LAMO073","y": -12.092489,"x": -76.9229851757932},
  {"name": "HVLI002-F","y": -12.987454,"x": -74.7196422054569},
  {"name": "LAMO073-S","y": -12.095953,"x": -76.9247329273092},
  {"name": "LMSI004-S","y": -12.100777,"x": -77.0539415394292},
  {"name": "LMSI004","y": -12.1003445,"x": -77.0558347544743},
  {"name": "LMSI004","y": -12.0992235,"x": -77.0554087978707},
  {"name": "LMSC328-F","y": -12.1674455,"x": -76.9905900135689},
  {"name": "LMSC315-F","y": -12.163916,"x": -76.9941205381041},
  {"name": "HVLI004-F","y": -13.000127,"x": -74.7237997894366},
  {"name": "LMCO147-S // LMCO147","y": -11.947657,"x": -77.0478638365579},
  {"name": "LMCO164","y": -11.949575,"x": -77.0477752483062},
  {"name": "LMSC327-F","y": -12.16470215,"x": -76.9895058883214},
  {"name": "LMSC353-F","y": -12.1638986,"x": -76.9911716894329},
  {"name": "LMMP150-S // LMMP150","y": -11.998459,"x": -77.0914037010114},
  {"name": "LMSC320-F","y": -12.16792,"x": -76.9960753923853},
  {"name": "LMMP029-S // LMMP029","y": -12.030575,"x": -77.0746354840658},
  {"name": "PIUR201-F","y": -5.1597745,"x": -80.6531815770821},
  {"name": "AYCA001-S // AYCA001","y": -13.1730055,"x": -74.2235280261387},
  {"name": "AYCA003-S // AYCA003","y": -13.1807245,"x": -74.2226139496069},
  {"name": "AYCA004-S // AYCA004","y": -13.176292,"x": -74.221337267579},
  {"name": "AYCA005-F","y": -13.1807775,"x": -74.2189517566518},
  {"name": "AYCA006-F","y": -13.184717,"x": -74.2184094463256},
  {"name": "ZONA SATURADA","y": -13.1833105,"x": -74.2137989238754},
  {"name": "AYCA008-F","y": -13.17908415,"x": -74.2260713713989},
  {"name": "AYCA009-F","y": -13.187789,"x": -74.2194506127202},
  {"name": "AYCA010-F","y": -13.1890555,"x": -74.2153406097462},
  {"name": "AYSB018-S // AYSB018","y": -13.180797,"x": -74.2154983994631},
  {"name": "LMCO134-S // LMCO134","y": -11.9592015,"x": -77.0497891110778},
  {"name": "LMMP049-S // LMMP049","y": -12.026601,"x": -77.08043148049},
  {"name": "LMMP053-S // LMMP053","y": -12.0177125,"x": -77.0877001991526},
  {"name": "AQYA024-F","y": -16.4015045393685,"x": -71.5546295260134},
  {"name": "HVLI003-F","y": -12.9960695,"x": -74.7210025207403},
  {"name": "AQSC023-F","y": -16.436249893925,"x": -71.5693892585982},
  {"name": "AQYA023-F","y": -16.4012739583928,"x": -71.55752284632},
  {"name": "LMLC079-F","y": -12.0831685,"x": -77.0373393909768},
  {"name": "LMRC061-F","y": -12.0392725,"x": -77.0279335597627},
  {"name": "5118B03","y": -12.1022425,"x": -77.0295909383107},
  {"name": "LMRC064-F","y": -12.0360345,"x": -77.0226143926079},
  {"name": "TCGA018-F","y": -18.0566350068467,"x": -70.2581542437147},
  {"name": "LMSQ151-F","y": -12.115025,"x": -77.0187005681338},
  {"name": "LMSQ152-F","y": -12.114711,"x": -77.0213543530909},
  {"name": "LMSQ156-F","y": -12.1172015,"x": -77.0188378596205},
  {"name": "LMSQ156-F","y": -12.118915,"x": -77.0201993813042},
  {"name": "LMSQ154-F","y": -12.1175455,"x": -77.0217031407647},
  {"name": "5217C03-S // 5217C03","y": -12.1076065,"x": -77.0370488137813},
  {"name": "5218B03","y": -12.10474,"x": -77.0294259},
  {"name": "5218A03-S // 5218A03","y": -12.1067875,"x": -77.0324440494655},
  {"name": "5317C03","y": -12.1110155,"x": -77.0353452119883},
  {"name": "LMSC441-F","y": -12.14687595,"x": -76.9965272397829},
  {"name": "LMLR029-F","y": -12.295142,"x": -76.853471429287},
  {"name": "LMLR030-F","y": -12.2945765,"x": -76.8570742132567},
  {"name": "JNJA001-F","y": -11.7791265,"x": -75.4968498039656},
  {"name": "JNJA003-F","y": -11.7754582,"x": -75.4974133181239},
  {"name": "JNJA004-F","y": -11.772814,"x": -75.5014609620849},
  {"name": "JNJA005-F","y": -11.7716275,"x": -75.4975282728854},
  {"name": "JNJA006-F","y": -11.769817,"x": -75.5022963271547},
  {"name": "TCNA096-S // TCNA096","y": -18.042421,"x": -70.2461275961316},
  {"name": "SMMY022-F","y": -6.050093,"x": -76.9732263243093},
  {"name": "JNJA007-F","y": -11.7693535,"x": -75.4985663454072},
  {"name": "JNPL005-F","y": -12.056948,"x": -75.2591830074074},
  {"name": "JNPL006-F","y": -12.055508,"x": -75.2511801502154},
  {"name": "JNPL007-F","y": -12.0530175,"x": -75.2466947181407},
  {"name": "JNPL008-F","y": -12.049048,"x": -75.2518606312347},
  {"name": "LMLM053-S // LMLM053","y": -12.053931,"x": -77.0581750798785},
  {"name": "LAMO045-S // LAMO045","y": -12.108502,"x": -76.939627744936},
  {"name": "LAMO084-S // LAMO084","y": -12.112677,"x": -76.9382317572179},
  {"name": "LMVT004-S // LMVT004","y": -11.883556,"x": -77.1318508037852},
  {"name": "LMMP035-S // LMMP035","y": -12.035041,"x": -77.0856498055556},
  {"name": "SMMY003-F","y": -6.029378,"x": -76.9774475436066},
  {"name": "LAMO043-S // LAMO043","y": -12.113281,"x": -76.9401513681403},
  {"name": "LMMP052-S // LMMP052","y": -12.0221305,"x": -77.0869773449486},
  {"name": "LAMO044-S // LAMO044","y": -12.1031735,"x": -76.9439617289896},
  {"name": "SMMY001-F","y": -6.026936,"x": -76.9844212625786},
  {"name": "SMMY002-F","y": -6.028582,"x": -76.9811604327865},
  {"name": "SMMY004-F","y": -6.031471,"x": -76.9788840519065},
  {"name": "SMMY010-F","y": -6.0274935,"x": -76.9683469249556},
  {"name": "SMMY005-F","y": -6.0351135,"x": -76.9809989646284},
  {"name": "SMMY006-F","y": -6.0369805,"x": -76.9769223800857},
  {"name": "SMMY007-F","y": -6.034586,"x": -76.9752362435562},
  {"name": "SMMY008-F","y": -6.0316275,"x": -76.9739411762864},
  {"name": "SMMY016-F","y": -6.0377745,"x": -76.9675789538961},
  {"name": "SMMY009-F","y": -6.0296955,"x": -76.9695991558971},
  {"name": "HVLI005-F","y": -12.996374,"x": -74.7240035299417},
  {"name": "SMMY011-F","y": -6.0301085,"x": -76.9658084502596},
  {"name": "SMMY012-F","y": -6.0338815,"x": -76.9666515761506},
  {"name": "SMMY013-F","y": -6.031831,"x": -76.970141112283},
  {"name": "SMMY014-F","y": -6.034739,"x": -76.971420635055},
  {"name": "SMMY015-F","y": -6.035755,"x": -76.9693349775711},
  {"name": "SMMY017-F","y": -6.037962,"x": -76.972002715026},
  {"name": "SMMY018-F","y": -6.04140765,"x": -76.96858987312},
  {"name": "SMMY019-F","y": -6.04124515,"x": -76.9728667861241},
  {"name": "SMMY020-F","y": -6.044865,"x": -76.973582503453},
  {"name": "SMMY021-F","y": -6.051551,"x": -76.9758655189992},
  {"name": "SMTP051-F","y": -6.492861,"x": -76.3829470713775},
  {"name": "SMMY023-F","y": -6.048465,"x": -76.9770165954841},
  {"name": "SMMY024-F","y": -6.044967,"x": -76.978901609626},
  {"name": "SMMY025-F","y": -6.042335,"x": -76.9792184381868},
  {"name": "SMMY026-F","y": -6.039934,"x": -76.9813269064551},
  {"name": "LMCN011-F","y": -13.071923,"x": -76.3671349879425},
  {"name": "SMMY027-F","y": -6.0374415,"x": -76.9837316342554},
  {"name": "SMMY028-F","y": -6.033228,"x": -76.9621900708847},
  {"name": "LMCN001-F","y": -13.0851205,"x": -76.3870754063368},
  {"name": "LMCN002-F","y": -13.0808788,"x": -76.386309094101},
  {"name": "LMCN003-F","y": -13.0782065,"x": -76.3885578034351},
  {"name": "LMCN004-F","y": -13.0770125,"x": -76.3861189647113},
  {"name": "LMCN005-F","y": -13.073914,"x": -76.3885148588957},
  {"name": "LMCN006-F","y": -13.073029,"x": -76.383176459781},
  {"name": "LMCN007-F","y": -13.0747345,"x": -76.3835858237768},
  {"name": "LMCN008-F","y": -13.077518,"x": -76.3818796414057},
  {"name": "LMCN009-F","y": -13.0736875,"x": -76.3744685295643},
  {"name": "LMCN010-F","y": -13.076242,"x": -76.3756164302714},
  {"name": "LMCN013-F","y": -13.0676935,"x": -76.3576499408198},
  {"name": "SMTP001-F","y": -6.47594,"x": -76.3759435816327},
  {"name": "SMTP040-F","y": -6.4743415,"x": -76.3873439512582},
  {"name": "SMTP041-F","y": -6.4786135,"x": -76.38893065313},
  {"name": "SMTP042-F","y": -6.4756885,"x": -76.3841205159412},
  {"name": "SMTP043-F","y": -6.475919,"x": -76.3807167945627},
  {"name": "ICNZ019-F","y": -14.8364465,"x": -74.9212284815063},
  {"name": "SMTP044-F","y": -6.479709,"x": -76.3864740276973},
  {"name": "SMTP045-F","y": -6.483222,"x": -76.3877516872954},
  {"name": "SMTP046-F","y": -6.480484,"x": -76.3834231298553},
  {"name": "SMTP047-F","y": -6.478804,"x": -76.3787243042767},
  {"name": "SMTP048-F","y": -6.48262,"x": -76.3791989232597},
  {"name": "ICGP001-F","y": -13.396122,"x": -76.1653286985019},
  {"name": "SMTP049-F","y": -6.484272,"x": -76.382843970382},
  {"name": "SMTP050-F","y": -6.487696,"x": -76.3849795924105},
  {"name": "SMTP052-F","y": -6.4907455,"x": -76.3804989064434},
  {"name": "ICNZ001-F","y": -14.82454,"x": -74.9317257163847},
  {"name": "ICNZ002-F","y": -14.827884,"x": -74.932320579023},
  {"name": "ICNZ003-F","y": -14.8251845,"x": -74.9361850217745},
  {"name": "JNSR001-F","y": -11.1207415,"x": -75.3608165461227},
  {"name": "ICVA003-F","y": -14.8422306,"x": -74.939910764097},
  {"name": "ICNZ004-F","y": -14.827884,"x": -74.9358236739865},
  {"name": "ICNZ005-F","y": -14.8294685,"x": -74.9378475000228},
  {"name": "ICNZ006-F","y": -14.8269785,"x": -74.9388636898814},
  {"name": "ICNZ007-F","y": -14.824725,"x": -74.9399529721935},
  {"name": "ICNZ008-F","y": -14.8268695,"x": -74.942313109834},
  {"name": "JNSR002-F","y": -11.1222495,"x": -75.3597748571521},
  {"name": "ICNZ009-F","y": -14.8298055,"x": -74.941280911082},
  {"name": "ICNZ010-F","y": -14.8318285,"x": -74.9352168879692},
  {"name": "ICNZ011-F","y": -14.833375,"x": -74.9380714762464},
  {"name": "ICNZ012-F","y": -14.83241215,"x": -74.93987667888},
  {"name": "ICNZ013-F","y": -14.8262575,"x": -74.9465476963011},
  {"name": "ICNZ016-F","y": -14.8380175,"x": -74.9263600070287},
  {"name": "ICNZ017-F","y": -14.839543,"x": -74.9251059798025},
  {"name": "ICNZ018-F","y": -14.8367865,"x": -74.9240449586237},
  {"name": "ICGP002-F","y": -13.3972645,"x": -76.158439539386},
  {"name": "ICGP003-F","y": -13.400602,"x": -76.1577773594188},
  {"name": "HVLI006-F","y": -12.990408,"x": -74.7251263081788},
  {"name": "ICGP004-F","y": -13.405671,"x": -76.1590251336177},
  {"name": "ICGP005-F","y": -13.4006735,"x": -76.1613917495907},
  {"name": "PAYN001-F","y": -10.661339,"x": -76.2514779810873},
  {"name": "JNSR008-F","y": -11.1249095,"x": -75.3669959860854},
  {"name": "PAYN002-F","y": -10.66318465,"x": -76.2538945072718},
  {"name": "PAYN003-F","y": -10.66686795,"x": -76.2573709795472},
  {"name": "PAYN004-F","y": -10.66671645,"x": -76.2531849340799},
  {"name": "PAYN005-F","y": -10.667628,"x": -76.2503638738108},
  {"name": "PAYN006-F","y": -10.670507,"x": -76.2483164354018},
  {"name": "JNSR009-F","y": -11.1261955,"x": -75.3643546113158},
  {"name": "PAYN007-F","y": -10.6710845,"x": -76.251216048233},
  {"name": "PAYN008-F","y": -10.6718845,"x": -76.2553016974659},
  {"name": "PAYN009-F","y": -10.674826,"x": -76.251911364532},
  {"name": "PAYN010-F","y": -10.669362,"x": -76.2566062958624},
  {"name": "PAYN011-F","y": -10.6656295,"x": -76.2587644193432},
  {"name": "PAYN012-F","y": -10.661357,"x": -76.2566848925747},
  {"name": "PAYN013-F","y": -10.6590775,"x": -76.2531100146287},
  {"name": "PAYN014-F","y": -10.664212,"x": -76.2510502963259},
  {"name": "HVLI007-F","y": -12.9873515,"x": -74.7233050192175},
  {"name": "LMCN012-F","y": -13.061098,"x": -76.3484977794118},
  {"name": "HURP010-F","y": -9.306433,"x": -76.0005553265349},
  {"name": "LMCN015-F","y": -13.063185,"x": -76.3509222671053},
  {"name": "LMCN016-F","y": -13.062535,"x": -76.3497317342728},
  {"name": "LMCN017-F","y": -13.0612123,"x": -76.353898785161},
  {"name": "LMCN018-F","y": -13.059805,"x": -76.3509826736412},
  {"name": "LMCN019-F","y": -13.059303,"x": -76.3575402253575},
  {"name": "LMCN020-F","y": -13.0584585,"x": -76.3529137975658},
  {"name": "JNSR003-F","y": -11.119983,"x": -75.3555009391892},
  {"name": "JNSR004-F","y": -11.122938,"x": -75.3540051172297},
  {"name": "JNSR005-F","y": -11.1241575,"x": -75.3591272631875},
  {"name": "JNCP001-F","y": -12.0593535,"x": -75.2733438535799},
  {"name": "JNSR006-F","y": -11.121767,"x": -75.3523468800912},
  {"name": "JNSR007-F","y": -11.12137,"x": -75.3648410732524},
  {"name": "JNSR010-F","y": -11.12904,"x": -75.3658678718579},
  {"name": "JNSR011-F","y": -11.1276775,"x": -75.361218265373},
  {"name": "JNSR012-F","y": -11.12034,"x": -75.3479964992683},
  {"name": "JNSR013-F","y": -11.1316085,"x": -75.3530765623143},
  {"name": "JNSR014-F","y": -11.128288,"x": -75.3549365494453},
  {"name": "JNSR015-F","y": -11.130889,"x": -75.3648498410692},
  {"name": "JNSR016-F","y": -11.127294,"x": -75.3725763242682},
  {"name": "JNSR017-F","y": -11.130825,"x": -75.3763605704158},
  {"name": "JNSR018-F","y": -11.1319525,"x": -75.370060959517},
  {"name": "ICVA001-F","y": -14.84124105,"x": -74.9439456882197},
  {"name": "ICVA002-F","y": -14.8445665,"x": -74.9469580966903},
  {"name": "ICVA004-F","y": -14.845799,"x": -74.9415168688438},
  {"name": "ICVA005-F","y": -14.847021,"x": -74.9466243225626},
  {"name": "JNCP004-F","y": -12.0599875,"x": -75.2917388560305},
  {"name": "ICVA006-F","y": -14.848392,"x": -74.9434640073918},
  {"name": "ICVA007-F","y": -14.85118,"x": -74.9431318027344},
  {"name": "ICVA008-F","y": -14.853532,"x": -74.9405059089092},
  {"name": "ICVA009-F","y": -14.8513235,"x": -74.9378044801013},
  {"name": "ICVA010-F","y": -14.8539715,"x": -74.9355942069082},
  {"name": "HURP007-F","y": -9.2921381,"x": -75.9992307835494},
  {"name": "HURP008-F","y": -9.2973515,"x": -76.0024666205216},
  {"name": "HURP009-F","y": -9.3079251,"x": -76.0026316460273},
  {"name": "HURP011-F","y": -9.289886,"x": -75.9760386562752},
  {"name": "HURP012-F","y": -9.2869555,"x": -75.9739377597305},
  {"name": "LLEP017-F","y": -8.074453,"x": -78.993448050676},
  {"name": "HURP013-F","y": -9.286377,"x": -75.9908955780802},
  {"name": "HURP014-F","y": -9.297881,"x": -75.9965144048529},
  {"name": "HURP015-F","y": -9.3020525,"x": -75.9989368697917},
  {"name": "HURP016-F","y": -9.30327835,"x": -76.0051327723885},
  {"name": "AQSC006-R","y": -16.4298305,"x": -71.5693895013077},
  {"name": "AQSC006-S // AQSC006","y": -16.426962,"x": -71.5666112215097},
  {"name": "UCPA001-F","y": -9.0348615,"x": -75.5142598530195},
  {"name": "UCPA002-F","y": -9.035526,"x": -75.5104582806864},
  {"name": "CJBI003","y": -7.1636445,"x": -78.4615505118704},
  {"name": "UCPA003-F","y": -9.036002,"x": -75.5072606660695},
  {"name": "UCPA004-F","y": -9.040571,"x": -75.5098124356138},
  {"name": "UCPA005-F","y": -9.0408225,"x": -75.5140968547771},
  {"name": "UCPA006-F","y": -9.048138,"x": -75.5102150830442},
  {"name": "UCPA007-F","y": -9.050383,"x": -75.5151706478475},
  {"name": "TRUJ148","y": -8.1219905,"x": -79.0361754912735},
  {"name": "JNCP002-F","y": -12.0600135,"x": -75.2843572987672},
  {"name": "JNCP003-F","y": -12.058264,"x": -75.2885829337349},
  {"name": "JNCP005-F","y": -12.0627485,"x": -75.2912996301327},
  {"name": "JNCP006-F","y": -12.066708,"x": -75.2904771902655},
  {"name": "JNCP007-F","y": -12.0675855,"x": -75.2873618150346},
  {"name": "JNCP008-F","y": -12.066433,"x": -75.2835592144822},
  {"name": "JNCP009-F","y": -12.063381,"x": -75.2827528448718},
  {"name": "SMNC007-F","y": -5.9414075,"x": -77.3082485979149},
  {"name": "JNCP010-F","y": -12.0671335,"x": -75.275485445362},
  {"name": "PAVR001-F","y": -10.740277,"x": -75.2780201979742},
  {"name": "PAVR002-F","y": -10.741534,"x": -75.2740321911193},
  {"name": "PAVR003-F","y": -10.7378405,"x": -75.2709380471536},
  {"name": "PAVR004-F","y": -10.735311,"x": -75.2670353871644},
  {"name": "PAPB001-F","y": -10.291489,"x": -74.9413489137931},
  {"name": "PAPB002-F","y": -10.293589,"x": -74.9452469678903},
  {"name": "PAPB003-F","y": -10.2931295,"x": -74.9374249373327},
  {"name": "CJBI007-F","y": -7.140072,"x": -78.5128558891162},
  {"name": "PAPB004-F","y": -10.298791,"x": -74.9360759367838},
  {"name": "PAPB005-F","y": -10.299476,"x": -74.9413326395684},
  {"name": "PAPB006-F","y": -10.3055375,"x": -74.9431163136431},
  {"name": "JNSS001-F","y": -11.555844,"x": -75.949350104654},
  {"name": "CJBI002","y": -7.1667875,"x": -78.4672584409533},
  {"name": "SMNC002-F","y": -5.9497055,"x": -77.3086399833175},
  {"name": "JNLO002-F","y": -11.543865,"x": -75.9271973064787},
  {"name": "JNSS002-F","y": -11.552353,"x": -75.9443920080421},
  {"name": "JNSS003-F","y": -11.547747,"x": -75.9345217275833},
  {"name": "JNSS004-F","y": -11.5413855,"x": -75.9269626322837},
  {"name": "JNSS005-F","y": -11.540698,"x": -75.9289690394737},
  {"name": "SMNC001-F","y": -5.955684,"x": -77.3019112947761},
  {"name": "ZONA SATURADA","y": -6.8069775,"x": -79.883801518449},
  {"name": "SMNC003-F","y": -5.9477185,"x": -77.2994053596598},
  {"name": "SMNC004-F","y": -5.9460055,"x": -77.3094671199982},
  {"name": "SMNC005-F","y": -5.9432945,"x": -77.3003061415465},
  {"name": "SMNC006-F","y": -5.9439055,"x": -77.3129839260417},
  {"name": "SMNC008-F","y": -5.9419585,"x": -77.3042079986983},
  {"name": "SMNC010-F","y": -5.939977,"x": -77.3122650672553},
  {"name": "SMNC011-F","y": -5.934547,"x": -77.3137621454709},
  {"name": "SMNC012-F","y": -5.9351775,"x": -77.3041797621119},
  {"name": "SMNC013-F","y": -5.9290035,"x": -77.310728426301},
  {"name": "SMNC014-F","y": -5.9312455,"x": -77.3167114102167},
  {"name": "CJBI004","y": -7.1606155,"x": -78.4603563372059},
  {"name": "HUJC006-F","y": -8.9347655,"x": -76.1153796629045},
  {"name": "SMNC015-F","y": -5.921212,"x": -77.3173003901901},
  {"name": "SMNC016-F","y": -5.9218905,"x": -77.3137092871576},
  {"name": "SMNC017-F","y": -5.9121775,"x": -77.3192661336116},
  {"name": "SMNC018-F","y": -5.906131,"x": -77.3237431303281},
  {"name": "SMNC019-F","y": -5.962224,"x": -77.2959669345344},
  {"name": "HUJC001-F","y": -8.932462,"x": -76.1078684835821},
  {"name": "HUJC002-F","y": -8.927502,"x": -76.106636412844},
  {"name": "HUJC003-F","y": -8.9276945,"x": -76.1138486521483},
  {"name": "HUJC004-F","y": -8.9294305,"x": -76.1192363413558},
  {"name": "HUJC005-F","y": -8.9323025,"x": -76.1193141779612},
  {"name": "CJBI006-F","y": -7.139525,"x": -78.5161396635243},
  {"name": "HUJC007-F","y": -8.9327815,"x": -76.1126872784047},
  {"name": "CBNV018-S // CBNV018","y": -9.133313,"x": -78.52267511065},
  {"name": "CBNV065-S // CBNV065","y": -9.1336675,"x": -78.5124906217905},
  {"name": "CBNV028-S // CBNV028","y": -9.127239,"x": -78.5188928945183},
  {"name": "CBNV016-S // CBNV016","y": -9.1287435,"x": -78.5265186424966},
  {"name": "CJBI001","y": -7.1630225,"x": -78.4694731918719},
  {"name": "CJBI008-F","y": -7.139643,"x": -78.5063589967004},
  {"name": "CJBI009-F","y": -7.163709,"x": -78.4555154405296},
  {"name": "CJBI010-F","y": -7.158209,"x": -78.4625673640812},
  {"name": "LLSP004-F","y": -7.4310795,"x": -79.5059029160532},
  {"name": "CJBI011-F","y": -7.1548255,"x": -78.4562646507084},
  {"name": "CJBI012-F","y": -7.149287,"x": -78.4527322686058},
  {"name": "LLSP001-F","y": -7.422073,"x": -79.5038855050528},
  {"name": "LLSP002-F","y": -7.4262445,"x": -79.5086106678276},
  {"name": "LLSP003-F","y": -7.425396,"x": -79.5034074475138},
  {"name": "LMLR024-F","y": -12.2741225,"x": -76.8359110287128},
  {"name": "LLSP005-F","y": -7.430593,"x": -79.5026855703366},
  {"name": "CPYC003-S //�CPYC003","y": -8.3599005,"x": -74.5787382255747},
  {"name": "LMPP081-F","y": -11.8571705,"x": -77.0898380017076},
  {"name": "LMPP082-F","y": -11.8601205,"x": -77.0872364962871},
  {"name": "LMPP076-F","y": -11.9416435,"x": -77.0931945741537},
  {"name": "LMPP080-F","y": -11.9356995,"x": -77.0882992271635},
  {"name": "LMLR035-F","y": -12.301494,"x": -76.8499650614466},
  {"name": "LBLB007-F","y": -6.7021635,"x": -79.9028214967618},
  {"name": "CHPI003-S // CHPI003","y": -6.834994,"x": -79.9344547762136},
  {"name": "LMRC065-F","y": -12.038638,"x": -77.0226169936342},
  {"name": "LMPP083-F","y": -11.9187635,"x": -77.0904434131912},
  {"name": "LMPP085-F","y": -11.920932,"x": -77.0900974555871},
  {"name": "LMPP084-F","y": -11.9196595,"x": -77.0852692089004},
  {"name": "LMLR036-F","y": -12.2992585,"x": -76.8532121978306},
  {"name": "LMPP077-F","y": -11.929908,"x": -77.095357956213},
  {"name": "LMPP079-F","y": -11.933951,"x": -77.0894264114901},
  {"name": "5117C03-S // 5117C03","y": -12.098742,"x": -77.0347007051282},
  {"name": "AQAQ038-F","y": -16.4049625,"x": -71.5375553858138},
  {"name": "AQAQ038-F","y": -16.399952,"x": -71.5360993998697},
  {"name": "AQAQ038-F","y": -16.401938,"x": -71.5363514650008},
  {"name": "LBTC001-F","y": -6.500397,"x": -79.8548341086776},
  {"name": "LBTC002-F","y": -6.5052035,"x": -79.858896775539},
  {"name": "LBTC003-F","y": -6.50879935,"x": -79.8606986783748},
  {"name": "LBTC004-F","y": -6.51015,"x": -79.8570719115789},
  {"name": "LAMB007-S // LAMB007","y": -6.699058,"x": -79.9007704714541},
  {"name": "LBTC005-F","y": -6.5120435,"x": -79.861945533659},
  {"name": "LBTC006-F","y": -6.5123267,"x": -79.859793102463},
  {"name": "LBLB001-F","y": -6.6968925,"x": -79.9094752873766},
  {"name": "LAMB001-S // LAMB001","y": -6.698021,"x": -79.9063222688642},
  {"name": "LBLB002-F","y": -6.698679,"x": -79.912903022774},
  {"name": "LAMB002-S // LAMB002","y": -6.7013055,"x": -79.909248874837},
  {"name": "LBLB003-F","y": -6.700419,"x": -79.912503772081},
  {"name": "LAMB003-S // LAMB003","y": -6.7021205,"x": -79.9060184773413},
  {"name": "LBLB004-F","y": -6.7031345,"x": -79.9129452027128},
  {"name": "LAMB004-S // LAMB004","y": -6.703184,"x": -79.9010292762935},
  {"name": "LBLB005-F","y": -6.7054815,"x": -79.9128136930548},
  {"name": "LAMB005-S // LAMB005","y": -6.7049202,"x": -79.9070632699689},
  {"name": "LBLB006-F","y": -6.7097235,"x": -79.9155882875093},
  {"name": "LAMB006-S // LAMB006","y": -6.7061385,"x": -79.9007274758621},
  {"name": "LBLB008-F","y": -6.708973,"x": -79.9014311982759},
  {"name": "LBLB009-F","y": -6.7085765,"x": -79.8983310775468},
  {"name": "LBLB010-F","y": -6.7009705,"x": -79.8984687914248},
  {"name": "LBPI001-F","y": -6.792415,"x": -79.8918089942138},
  {"name": "ZONA SATURADA","y": -6.790073,"x": -79.8918803425433},
  {"name": "ZONA SATURADA","y": -6.7901505,"x": -79.8931049669444},
  {"name": "CHPI002-S // CHPI002","y": -6.8319605,"x": -79.9369483407871},
  {"name": "ZONA SATURADA","y": -6.805827,"x": -79.8842028067369},
  {"name": "CHPI004-S // CHPI004","y": -6.8336729,"x": -79.9291415869366},
  {"name": "CHPI005-S // CHPI005","y": -6.8193805,"x": -79.9091608702065},
  {"name": "CHPI006-S // CHPI006","y": -6.778899,"x": -79.8829714349174},
  {"name": "LBPI006-F","y": -6.7858235,"x": -79.8717719974928},
  {"name": "CHPI007","y": -6.785454,"x": -79.8823132080915},
  {"name": "CHI007-S // CHI007","y": -6.770081,"x": -79.8738564406912},
  {"name": "LLEP005-F","y": -8.0724355,"x": -79.0058041378676},
  {"name": "LLEP018-F","y": -8.0721975,"x": -78.9916203797926},
  {"name": "CHPI008","y": -6.7945655,"x": -79.8872122008604},
  {"name": "CHPI009","y": -6.7918635,"x": -79.8841210821991},
  {"name": "LBCH018-F","y": -6.762678,"x": -79.8723932933255},
  {"name": "LBCH021-F","y": -6.7638825,"x": -79.8749035521001},
  {"name": "CHI121","y": -6.7543625,"x": -79.8694112569252},
  {"name": "LBCH022-F","y": -6.766388,"x": -79.8760531098234},
  {"name": "LBCH023-F","y": -6.765635,"x": -79.8732748200993},
  {"name": "ZONA SATURADA","y": -6.768903,"x": -79.8749937704017},
  {"name": "LLTR021-F","y": -8.09549435,"x": -79.0470693580534},
  {"name": "LBCH025-F","y": -6.7679805,"x": -79.8733678810395},
  {"name": "CHI122","y": -6.7539645,"x": -79.8709248452381},
  {"name": "CHI123","y": -6.7529655,"x": -79.8720361926055},
  {"name": "LBOL001-F","y": -5.9855705,"x": -79.7535187411949},
  {"name": "LBOL002-F","y": -5.985501,"x": -79.7496536103611},
  {"name": "LBOL003-F","y": -5.984441,"x": -79.7470654361579},
  {"name": "LBOL007-F","y": -5.9886045,"x": -79.7424659325459},
  {"name": "LBOL008-F","y": -5.993293,"x": -79.7506125017109},
  {"name": "LBOL004-F","y": -5.9836135,"x": -79.7416955471114},
  {"name": "LBOL005-F","y": -5.9894515,"x": -79.7515775571587},
  {"name": "LBOL006-F","y": -5.987996,"x": -79.7467845638889},
  {"name": "LBCH059-F","y": -6.759954,"x": -79.8199953383424},
  {"name": "LBMO006-F","y": -6.8795455,"x": -79.8665088784012},
  {"name": "LBOL009-F","y": -5.992915,"x": -79.7453689596117},
  {"name": "LBOL010-F","y": -5.9917765,"x": -79.7409878133858},
  {"name": "LBOL011-F","y": -5.995482,"x": -79.7341817525126},
  {"name": "LBOL012-F","y": -5.9928715,"x": -79.7294544500326},
  {"name": "LBMO007-F","y": -6.8765655,"x": -79.8748885842813},
  {"name": "LBOL013-F","y": -5.9970175,"x": -79.7307879519081},
  {"name": "LBMO001-F","y": -6.8828535,"x": -79.8747429686073},
  {"name": "LBMO002-F","y": -6.882439,"x": -79.8700456958486},
  {"name": "LBMO003-F","y": -6.8791315,"x": -79.875187365457},
  {"name": "LBMO004-F","y": -6.879558,"x": -79.8726808086795},
  {"name": "LBMO005-F","y": -6.879987,"x": -79.8698269507152},
  {"name": "LBMO008-F","y": -6.8759685,"x": -79.8709783652309},
  {"name": "LBMO009-F","y": -6.87606,"x": -79.8677116544428},
  {"name": "LBMO010-F","y": -6.871779,"x": -79.8704075708255},
  {"name": "LBMO011-F","y": -6.87305,"x": -79.8686542674129},
  {"name": "LBMO012-F","y": -6.8655375,"x": -79.871084016111},
  {"name": "LBCH054-F","y": -6.764948,"x": -79.8169815501672},
  {"name": "LBCH055-F","y": -6.7656075,"x": -79.8191647164863},
  {"name": "LBCH056-F","y": -6.765599,"x": -79.8216217510834},
  {"name": "LBCH057-F","y": -6.762061,"x": -79.8184538539326},
  {"name": "LBCH058-F","y": -6.760676,"x": -79.8166896609475},
  {"name": "LBCH059-F","y": -6.761088,"x": -79.8194368737362},
  {"name": "LBCH061-F","y": -6.7572845,"x": -79.8165189206949},
  {"name": "TREP001-S // TREP001","y": -8.086485,"x": -78.9980623243372},
  {"name": "TREP002","y": -8.0856545,"x": -79.0012369915965},
  {"name": "TREP003-S // TREP003","y": -8.0828755,"x": -78.9993417102476},
  {"name": "TREP004","y": -8.078367,"x": -78.9994942121536},
  {"name": "TREP005","y": -8.0820515,"x": -79.001868986189},
  {"name": "LLEP004-F","y": -8.07395,"x": -79.0113502790116},
  {"name": "TREP006-S // TREP006","y": -8.085679,"x": -79.0045838542814},
  {"name": "LLEP006-F","y": -8.075207,"x": -79.0069928764104},
  {"name": "LLEP007-F","y": -8.07779565,"x": -79.00771848142},
  {"name": "TREP007-S // TREP007","y": -8.0863535,"x": -79.0093856524091},
  {"name": "LLEP008-F","y": -8.08008165,"x": -79.0092761765603},
  {"name": "LLEP009-F","y": -8.073426,"x": -79.000489400933},
  {"name": "LLEP015-F","y": -8.079225,"x": -78.9990616916471},
  {"name": "LLEP010-F","y": -8.075707,"x": -79.0028205948105},
  {"name": "LLEP011-F","y": -8.0773255,"x": -79.0039765375326},
  {"name": "LLEP012-F","y": -8.071008,"x": -78.9968634046357},
  {"name": "LLEP013-F","y": -8.073426,"x": -78.9966948008475},
  {"name": "LLEP014-F","y": -8.076413,"x": -78.9956823373016},
  {"name": "LLEP016-F","y": -8.070817,"x": -78.9943330055181},
  {"name": "LLEP019-F","y": -8.070025,"x": -78.987938940889},
  {"name": "LLEP020-F","y": -8.0762305,"x": -79.0311298300027},
  {"name": "LLEP022-F","y": -8.0692885,"x": -78.9912559143222},
  {"name": "TRUJ101","y": -8.1107965,"x": -79.0150091921654},
  {"name": "LLTR002-F","y": -8.084951,"x": -79.0472889046218},
  {"name": "LLTR003-F","y": -8.08752,"x": -79.0371913346939},
  {"name": "LLTR023-F","y": -8.0991715,"x": -79.0462422978329},
  {"name": "TRUJ145","y": -8.0979195,"x": -79.0054588998847},
  {"name": "LLTR004-F","y": -8.0870365,"x": -79.0486055655139},
  {"name": "LLTR005-F","y": -8.0890165,"x": -79.0465991292373},
  {"name": "LLTR006-F","y": -8.087595,"x": -79.0513109432668},
  {"name": "LLTR018-F","y": -8.1169025,"x": -79.0049463695308},
  {"name": "TRUJ125","y": -8.095428,"x": -79.0285721169973},
  {"name": "TRUJ076","y": -8.1190525,"x": -79.0156830402739},
  {"name": "TRUJ076-S","y": -8.120938,"x": -79.0148363452306},
  {"name": "TRUJ053-S // TRUJ053","y": -8.1179385,"x": -79.036549093319},
  {"name": "TRUJ111","y": -8.0985813,"x": -79.0092832105705},
  {"name": "TRUJ112","y": -8.0999415,"x": -79.0114139386865},
  {"name": "TRUJ126-S // TRUJ126","y": -8.0956615,"x": -79.0347936906232},
  {"name": "TRUJ154","y": -8.112211,"x": -79.0278695230769},
  {"name": "TRUJ058-S // TRUJ058","y": -8.110402,"x": -79.0462097090773},
  {"name": "TRUJ134-S // TRUJ134","y": -8.094784,"x": -79.0202714369248},
  {"name": "TRUJ157-S // TRUJ157","y": -8.09371,"x": -79.0529381863953},
  {"name": "TRUJ133-S // TRUJ133","y": -8.0979281,"x": -79.0490671890489},
  {"name": "TRUJ059-S // TRUJ059","y": -8.1056465,"x": -79.0431831271398},
  {"name": "TRUJ149","y": -8.1318195,"x": -79.0320882628206},
  {"name": "TRUJ175","y": -8.1171095,"x": -79.0455479206922},
  {"name": "TRUJ142","y": -8.0959965,"x": -79.0068098487446},
  {"name": "TRUJ158","y": -8.094801,"x": -79.0497808934663},
  {"name": "TRUJ152","y": -8.138637,"x": -79.0179604434903},
  {"name": "TRUJ153","y": -8.0973405,"x": -79.0244195814697},
  {"name": "TRUJ150","y": -8.093299,"x": -79.0066991153786},
  {"name": "TRUJ151","y": -8.0949565,"x": -79.0100096614583},
  {"name": "TRUJ171","y": -8.1019635,"x": -79.0043655296344},
  {"name": "TRUJ116","y": -8.0983215,"x": -79.0175126866851},
  {"name": "TRUJ137-S // TRUJ137","y": -8.088952,"x": -79.0091871096514},
  {"name": "TRUJ138","y": -8.0903175,"x": -79.0112883196968},
  {"name": "TRUJ139","y": -8.093504,"x": -79.0130812954858},
  {"name": "TRUJ160","y": -8.0925265,"x": -79.04894717003},
  {"name": "TRUJ140","y": -8.089042,"x": -79.0016146447726},
  {"name": "TRUJ141","y": -8.0912695,"x": -79.0049963605882},
  {"name": "TRUJ143","y": -8.0925235,"x": -79.001350869347},
  {"name": "TRUJ144","y": -8.094909,"x": -79.0034281073588},
  {"name": "TRUJ147","y": -8.091186,"x": -79.0080194688808},
  {"name": "TRUJ159-S // TRUJ159","y": -8.0920275,"x": -79.0521558729157},
  {"name": "TRUJ161","y": -8.088245,"x": -79.0432830636839},
  {"name": "TRUJ162","y": -8.089965,"x": -79.042964562427},
  {"name": "TRUJ163","y": -8.0886355,"x": -79.0396672259144},
  {"name": "TRUJ165","y": -8.0898875,"x": -79.0141231067712},
  {"name": "TRUJ166","y": -8.091841,"x": -79.0160414692394},
  {"name": "TRUJ167-S // TRUJ167","y": -8.0870775,"x": -79.013520331166},
  {"name": "TRUJ168","y": -8.1045055,"x": -79.0048364008043},
  {"name": "TRUJ169","y": -8.1102545,"x": -79.0484785207261},
  {"name": "TRUJ047-S // TRUJ047","y": -8.1242,"x": -79.0267621101815},
  {"name": "TRUJ115","y": -8.095193,"x": -79.017338770311},
  {"name": "TRUJ129-S // TRUJ129","y": -8.0951565,"x": -79.0439510462657},
  {"name": "TRUJ090-S // TRUJ090","y": -8.100886,"x": -79.0336303485827},
  {"name": "TRUJ091-S // TRUJ091","y": -8.10202,"x": -79.0307844170994},
  {"name": "TRUJ102-S // TRUJ102","y": -8.1117485,"x": -79.0111580488761},
  {"name": "TRUJ114","y": -8.096077,"x": -79.0143933724916},
  {"name": "TRUJ018","y": -8.1353175,"x": -79.0287178531957},
  {"name": "TRUJ029-S // TRUJ029","y": -8.1295315,"x": -79.0301920661058},
  {"name": "TRUJ031-S // TRUJ031","y": -8.12791755,"x": -79.0387726306848},
  {"name": "TRUJ032-S // TRUJ032","y": -8.125994,"x": -79.03775487695},
  {"name": "TRUJ033-S // TRUJ033","y": -8.12705605,"x": -79.0425847932078},
  {"name": "TRUJ034-S // TRUJ034","y": -8.120261,"x": -79.0462516064815},
  {"name": "TRUJ035-S // TRUJ035","y": -8.120261,"x": -79.0429510575221},
  {"name": "TRUJ036-S // TRUJ036","y": -8.1220395,"x": -79.0418862671743},
  {"name": "TRUJ037-S // TRUJ037","y": -8.123693,"x": -79.0406548904485},
  {"name": "TRUJ038-S // TRUJ038","y": -8.121006,"x": -79.0378448089885},
  {"name": "TRUJ046","y": -8.122542,"x": -79.0271955602766},
  {"name": "TRUJ039-S // TRUJ039","y": -8.1215615,"x": -79.0348365317998},
  {"name": "TRUJ040","y": -8.1243675,"x": -79.0343967548206},
  {"name": "TRUJ041","y": -8.1212995,"x": -79.0331533692051},
  {"name": "TRUJ042","y": -8.1216945,"x": -79.0318243230634},
  {"name": "TRUJ061-S // TRUJ061","y": -8.103498,"x": -79.041620397802},
  {"name": "TRUJ043-S // TRUJ043","y": -8.125173,"x": -79.0314141515395},
  {"name": "TRUJ044-S // TRUJ044","y": -8.1218285,"x": -79.0295141873844},
  {"name": "TRUJ045","y": -8.125247,"x": -79.0293607463402},
  {"name": "TRUJ048","y": -8.1259815,"x": -79.0250694342105},
  {"name": "TRUJ049","y": -8.128244,"x": -79.020368136599},
  {"name": "TRUJ050","y": -8.123544,"x": -79.0205771350267},
  {"name": "TRUJ123-S // TRUJ123","y": -8.0999295,"x": -79.029261864143},
  {"name": "TRUJ051-S // TRUJ051","y": -8.1214525,"x": -79.0243299156648},
  {"name": "TRUJ052-S // TRUJ052","y": -8.118382,"x": -79.0302269823442},
  {"name": "TRUJ054-S // TRUJ054","y": -8.1144425,"x": -79.0341402621062},
  {"name": "TRUJ055-S // TRUJ055","y": -8.112787,"x": -79.0403505839448},
  {"name": "TRUJ056-S // TRUJ056","y": -8.1137335,"x": -79.0451013307243},
  {"name": "TRUJ113","y": -8.0984915,"x": -79.0138705013429},
  {"name": "TRUJ057-S // TRUJ057","y": -8.1100255,"x": -79.0420860360757},
  {"name": "TRUJ062-S // TRUJ062","y": -8.105,"x": -79.0383517218346},
  {"name": "TRUJ063","y": -8.1082465,"x": -79.0387058679884},
  {"name": "TRUJ064-S // TRUJ064","y": -8.110561,"x": -79.0358276763496},
  {"name": "TRUJ065-S // TRUJ065","y": -8.1072175,"x": -79.0343646333946},
  {"name": "TRUJ068","y": -8.117655,"x": -79.0277630909091},
  {"name": "TRUJ124-S // TRUJ124","y": -8.0978555,"x": -79.0319643097731},
  {"name": "TRUJ071-S // TRUJ071","y": -8.115227,"x": -79.0234207518058},
  {"name": "TRUJ072-S // TRUJ072","y": -8.118323,"x": -79.0262631095238},
  {"name": "TRUJ073-S // TRUJ073","y": -8.11791,"x": -79.0237674050633},
  {"name": "TRUJ074-S // TRUJ074","y": -8.11882,"x": -79.0209727258575},
  {"name": "TRUJ075-S // TRUJ075","y": -8.122524,"x": -79.016814755801},
  {"name": "TRUJ077","y": -8.117081,"x": -79.0147726333333},
  {"name": "TRUJ078","y": -8.1140665,"x": -79.0178302644213},
  {"name": "TRUJ103-S // TRUJ103","y": -8.113684,"x": -79.0049285957476},
  {"name": "TRUJ079","y": -8.116695,"x": -79.0185084167987},
  {"name": "TRUJ080","y": -8.112,"x": -79.0206402755244},
  {"name": "TRUJ084","y": -8.1035165,"x": -79.0336382379182},
  {"name": "TRUJ086-S // TRUJ086","y": -8.102173,"x": -79.0379519662143},
  {"name": "TBTB004-S // TBTB004","y": -3.566618,"x": -80.4592134332409},
  {"name": "TRUJ087-S // TRUJ087","y": -8.099644,"x": -79.0413837958274},
  {"name": "TRUJ088-S // TRUJ088","y": -8.0972495,"x": -79.0395917663818},
  {"name": "TRUJ089-S // TRUJ089","y": -8.097829,"x": -79.0367320031125},
  {"name": "TRUJ092-S // TRUJ092","y": -8.1034485,"x": -79.0255634801255},
  {"name": "TRUJ093","y": -8.1045885,"x": -79.022733977244},
  {"name": "TRUJ094","y": -8.1035865,"x": -79.0195435950335},
  {"name": "TBTB005-S // TBTB005","y": -3.5621585,"x": -80.4562747967182},
  {"name": "TRUJ095","y": -8.106433,"x": -79.0192413866008},
  {"name": "TRUJ096","y": -8.1035025,"x": -79.0162733574138},
  {"name": "TRUJ097-S // TRUJ097","y": -8.1060555,"x": -79.0155804533114},
  {"name": "TRUJ098","y": -8.1094575,"x": -79.0188337428478},
  {"name": "TRUJ100","y": -8.1147775,"x": -79.012715090493},
  {"name": "TRUJ130-S // TRUJ130","y": -8.0927355,"x": -79.0433738564767},
  {"name": "TRUJ104-S // TRUJ104","y": -8.108655,"x": -79.0047403603837},
  {"name": "TRUJ105-S // TRUJ105","y": -8.1103445,"x": -79.007671078584},
  {"name": "TRUJ106-S // TRUJ106","y": -8.1083805,"x": -79.0098643129554},
  {"name": "TRUJ108-S // TRUJ108","y": -8.1055795,"x": -79.0086253340932},
  {"name": "TRUJ109","y": -8.103578,"x": -79.0063603872645},
  {"name": "TRUJ128","y": -8.0980895,"x": -79.0440224052397},
  {"name": "TRUJ110-S // TRUJ110","y": -8.100707,"x": -79.0076140776349},
  {"name": "TRUJ117-S // TRUJ117","y": -8.1013305,"x": -79.0203745815789},
  {"name": "TRUJ118","y": -8.0983215,"x": -79.0194525637512},
  {"name": "TRUJ119-S // TRUJ119","y": -8.0970575,"x": -79.0213920444107},
  {"name": "LMJM017","y": -12.0760925,"x": -77.0469765969211},
  {"name": "TRUJ120-S // TRUJ120","y": -8.1009085,"x": -79.0239413571429},
  {"name": "TRUJ121","y": -8.0953935,"x": -79.0246795500107},
  {"name": "TRUJ122-S // TRUJ122","y": -8.097843,"x": -79.026879620607},
  {"name": "TBTB007-S // TBTB007","y": -3.5630365,"x": -80.4538639816671},
  {"name": "TBTB008","y": -3.564941,"x": -80.4539120328004},
  {"name": "TBTB009","y": -3.5673445,"x": -80.456772928057},
  {"name": "TBTB010","y": -3.568106,"x": -80.4563446925182},
  {"name": "TBTB011-S // TBTB011","y": -3.570766,"x": -80.4585950744314},
  {"name": "CHIO136-F","y": -6.803076,"x": -79.8494138122362},
  {"name": "TBTB012-S // TBTB012","y": -3.57178,"x": -80.457638837304},
  {"name": "TBTB013-S // TBTB013","y": -3.573647,"x": -80.4550315961209},
  {"name": "TBTB018-S // TBTB018","y": -3.5660965,"x": -80.4519272403528},
  {"name": "TBTB014-S // TBTB014","y": -3.572856,"x": -80.4535963206522},
  {"name": "TBTB015-S // TBTB015","y": -3.5688265,"x": -80.4537074746911},
  {"name": "TBTB016-S // TBTB016","y": -3.569489,"x": -80.4507458306518},
  {"name": "CHI105","y": -6.8087935,"x": -79.831804865709},
  {"name": "TBTB017-S // TBTB017","y": -3.570865,"x": -80.4513521725806},
  {"name": "PIUR030-S","y": -5.1970745,"x": -80.6292822242379},
  {"name": "TBTB019-S // TBTB019","y": -3.564734,"x": -80.450525577838},
  {"name": "TBTB020-S // TBTB020","y": -3.556888,"x": -80.4290457698735},
  {"name": "TBTB021-S // TBTB021","y": -3.554786,"x": -80.426625801773},
  {"name": "TBTB022-S // TBTB022","y": -3.556452,"x": -80.426153129962},
  {"name": "TBTB023-S // TBTB023","y": -3.560717,"x": -80.4259084084898},
  {"name": "TBTB030-S // TBTB030","y": -3.560785,"x": -80.4223520916445},
  {"name": "TBTB024-S // TBTB024","y": -3.562834,"x": -80.4265146523852},
  {"name": "TBTB025-S // TBTB025","y": -3.5654365,"x": -80.4247313169186},
  {"name": "TBTB026","y": -3.5598205,"x": -80.4541457057665},
  {"name": "TBTB027-S // TBTB027","y": -3.5649995,"x": -80.4218139628342},
  {"name": "TBTB028-S // TBTB028","y": -3.568062,"x": -80.4232164922392},
  {"name": "TBTB029-S // TBTB029","y": -3.571989,"x": -80.4229687376601},
  {"name": "TBTB031","y": -3.565748,"x": -80.4616956954541},
  {"name": "TBTB032-F","y": -3.562004,"x": -80.458348065975},
  {"name": "TBTB033","y": -3.560357,"x": -80.4596176825843},
  {"name": "TBTB034-F","y": -3.560535,"x": -80.4519946026145},
  {"name": "TBTB036-F","y": -3.581213,"x": -80.4500378148299},
  {"name": "TBTB037-F","y": -3.583439,"x": -80.449143927444},
  {"name": "TBTB038-F","y": -3.5584165,"x": -80.4245847202968},
  {"name": "TBTB038-F","y": -3.562622,"x": -80.4234483199144},
  {"name": "TBTB039-F","y": -3.575394,"x": -80.4512358825191},
  {"name": "TBTB040-F","y": -3.5736455,"x": -80.4505439186992},
  {"name": "TBTB041-F","y": -3.567726,"x": -80.4496162586207},
  {"name": "TBTB042-F","y": -3.555319,"x": -80.4481655961941},
  {"name": "TBTB043-F","y": -3.5573865,"x": -80.4313973032759},
  {"name": "CHI098-S // CHI098","y": -6.7954625,"x": -79.8392433185914},
  {"name": "CHI094","y": -6.789824,"x": -79.8469547276632},
  {"name": "CHI104","y": -6.80601,"x": -79.8335128554207},
  {"name": "ZONA SATURADA","y": -16.3947145,"x": -71.5119312723485},
  {"name": "TBTB044-F","y": -3.567015,"x": -80.4263356835464},
  {"name": "TBTB045-F","y": -3.56138,"x": -80.4205490086207},
  {"name": "TBTB047-F","y": -3.56685,"x": -80.4200891205528},
  {"name": "CHIO131-F","y": -6.7983565,"x": -79.8469318053535},
  {"name": "CHIO134-F","y": -6.80487435,"x": -79.8441698097144},
  {"name": "CHIO135-F","y": -6.8035715,"x": -79.8465735682566},
  {"name": "LBLV007-F","y": -6.80367385,"x": -79.8322410811856},
  {"name": "LBLV008-F","y": -6.8056575,"x": -79.8414837080125},
  {"name": "LBLV001-F","y": -6.800958,"x": -79.8412742761438},
  {"name": "LBLV002-F","y": -6.8034005,"x": -79.8420493219966},
  {"name": "LBLV003-F","y": -6.804514,"x": -79.8389667999002},
  {"name": "LBLV004-F","y": -6.801727,"x": -79.8376054524902},
  {"name": "LBLV005-F","y": -6.8036825,"x": -79.8368802448454},
  {"name": "LBLV006-F","y": -6.80565,"x": -79.8368084404934},
  {"name": "LBLV009-F","y": -6.8069625,"x": -79.8460648007898},
  {"name": "PIUR123-S // PIUR123","y": -5.1729075,"x": -80.6583375865145},
  {"name": "LBLV009-F","y": -6.8066395,"x": -79.8428921044804},
  {"name": "CHIO132-F","y": -6.800032,"x": -79.8447713616844},
  {"name": "TBZA001-F","y": -3.4948155,"x": -80.2749863134838},
  {"name": "TBZA002-F","y": -3.49590855,"x": -80.271463188335},
  {"name": "TBZA003-F","y": -3.4951078,"x": -80.2784601870191},
  {"name": "TBZA004-F","y": -3.49907295,"x": -80.2737426766862},
  {"name": "TBZA005-F","y": -3.502879,"x": -80.2737603199266},
  {"name": "PIUC134","y": -5.184377,"x": -80.5916094654946},
  {"name": "TBZA006-F","y": -3.505865,"x": -80.278975406813},
  {"name": "TBZA007-F","y": -3.490574,"x": -80.2749250456986},
  {"name": "TBZA008-F","y": -3.493543,"x": -80.2688399940915},
  {"name": "TBZA009-F","y": -3.500216,"x": -80.2687536912647},
  {"name": "TBZA010-F","y": -3.50426,"x": -80.2686531308931},
  {"name": "TBZA011-F","y": -3.507297,"x": -80.2719162574153},
  {"name": "PIUR064","y": -5.2049105,"x": -80.6303587839722},
  {"name": "TBZA012-F","y": -3.508813,"x": -80.2826315715326},
  {"name": "TBZA013-F","y": -3.49862645,"x": -80.2800736304653},
  {"name": "AQMF026-F","y": -16.392432,"x": -71.5133150398686},
  {"name": "ZONA SATURADA","y": -16.393562,"x": -71.5115859511551},
  {"name": "AQBR069-F","y": -16.4248755,"x": -71.5432087321494},
  {"name": "ZONA SATURADA","y": -16.4247015,"x": -71.5438948177974},
  {"name": "AQBR075-F","y": -16.4178085,"x": -71.5166645862553},
  {"name": "ZONA SATURADA","y": -16.4192695,"x": -71.5163580151165},
  {"name": "AQCA033-F","y": -16.3480585,"x": -71.5469600394676},
  {"name": "ZONA SATURADA","y": -16.3480585,"x": -71.5478994331724},
  {"name": "AQCC060-F","y": -16.3820835,"x": -71.5612716235459},
  {"name": "ZONA SATURADA","y": -16.3813645,"x": -71.5618876341058},
  {"name": "AQCC063-F","y": -16.373444,"x": -71.5575658},
  {"name": "ZONA SATURADA","y": -16.3731965,"x": -71.5563018762712},
  {"name": "AQMD008-F","y": -17.020614,"x": -72.0137560313651},
  {"name": "ZONA SATURADA","y": -17.020842,"x": -72.0151689712124},
  {"name": "AQMF028-F","y": -16.3945075,"x": -71.5134553691667},
  {"name": "AQMF028-F","y": -16.395383,"x": -71.5102829800022},
  {"name": "LMJM001","y": -12.087693,"x": -77.0564426674707},
  {"name": "AQCC061-F","y": -16.38993,"x": -71.5655279767658},
  {"name": "ZONA SATURADA","y": -16.386774,"x": -71.5653633349995},
  {"name": "TRUJ030-S // TRUJ030","y": -8.1288495,"x": -79.0338178340941},
  {"name": "LMLV104-F","y": -12.0673645,"x": -77.0107585032768},
  {"name": "LMLV136-F","y": -12.065417,"x": -77.0114794720083},
  {"name": "LMSC292-F","y": -12.149658,"x": -76.9900982026088},
  {"name": "LMSC303-F","y": -12.1482285,"x": -76.9903360544301},
  {"name": "LMJR094-F","y": -12.139649,"x": -76.9769452480989},
  {"name": "LMSC112-S","y": -12.131969,"x": -76.9766489801711},
  {"name": "LMSC112-S","y": -12.135003,"x": -76.9771687671525},
  {"name": "LMSC501-F","y": -12.135534,"x": -76.9753920382199},
  {"name": "LMSC502-F","y": -12.1405465,"x": -76.974721570738},
  {"name": "LMSC458-F","y": -12.149957,"x": -76.9905450831003},
  {"name": "LMMP016","y": -12.028462,"x": -77.0536305815077},
  {"name": "LMMP282-F","y": -12.0272195,"x": -77.055804098108},
  {"name": "LMMP283-F","y": -12.025468,"x": -77.0532181478638},
  {"name": "LMJM088-F","y": -12.075889,"x": -77.043416412714},
  {"name": "LMVS182-F","y": -12.239284,"x": -76.9312963737872},
  {"name": "LMHU003-S // LMHU003","y": -11.1260925,"x": -77.6122405836735},
  {"name": "LMHU011-S // LMHU011","y": -11.109631,"x": -77.6016114435136},
  {"name": "LMHU026","y": -11.09347,"x": -77.5958986160927},
  {"name": "PIUR026-S // PIUR026","y": -5.194457,"x": -80.6284436493576},
  {"name": "PIUR025-S // PIUR025","y": -5.1927435,"x": -80.631084139283},
  {"name": "LMVS176-F","y": -12.1892915,"x": -76.9490316328853},
  {"name": "AQBR081-F","y": -16.440129,"x": -71.51977209062},
  {"name": "PUAC001-F","y": -15.9754935,"x": -69.7988013618642},
  {"name": "PUAC002-F","y": -15.975153,"x": -69.7953068364799},
  {"name": "PUAC003-F","y": -15.970075,"x": -69.7940949554897},
  {"name": "PUAC004-F","y": -15.972151,"x": -69.7902991617948},
  {"name": "LMSQ075","y": -12.1143465,"x": -77.0079785275029},
  {"name": "AQCC092-F","y": -16.3533565,"x": -71.5706259819531},
  {"name": "ANCR007-F","y": -9.049717,"x": -77.8148692688974},
  {"name": "LMVS177-F","y": -12.187829,"x": -76.9471444641304},
  {"name": "PIUR040-S","y": -5.185483,"x": -80.6285567830719},
  {"name": "CHI034-S // CHI034","y": -6.755741,"x": -79.8366595393175},
  {"name": "CHI057","y": -6.760838,"x": -79.8346759704832},
  {"name": "AYHU004-F","y": -12.9376925,"x": -74.2522787254213},
  {"name": "PIUC058-S","y": -5.185646,"x": -80.6217813921537},
  {"name": "PIUC058","y": -5.186965,"x": -80.6192437533666},
  {"name": "PIUC058","y": -5.1869785,"x": -80.6223069023589},
  {"name": "PIUC058","y": -5.18413,"x": -80.6212116431161},
  {"name": "PIUC134-S","y": -5.1842315,"x": -80.590349807327},
  {"name": "PIUR040","y": -5.1847535,"x": -80.6257623988625},
  {"name": "PIUR075-S","y": -5.194618,"x": -80.6560917845992},
  {"name": "PIUR075","y": -5.195807,"x": -80.6562548608434},
  {"name": "PIUR072-S","y": -5.196159,"x": -80.6496543733028},
  {"name": "PIUR072","y": -5.196532,"x": -80.6518267882409},
  {"name": "PIUR072","y": -5.194349,"x": -80.6509768637725},
  {"name": "PIUR022-S","y": -5.197991,"x": -80.6471789810437},
  {"name": "PIUR022","y": -5.1990875,"x": -80.6491788748713},
  {"name": "PIUR022","y": -5.1973315,"x": -80.6454385846512},
  {"name": "PIUR028-S","y": -5.1949375,"x": -80.6376797114475},
  {"name": "PIUR028","y": -5.196549,"x": -80.6387150069586},
  {"name": "PIUR064-S","y": -5.203804,"x": -80.6309412377179},
  {"name": "CHI051-S","y": -6.773197,"x": -79.8462039834764},
  {"name": "CHI054-S // CHI054","y": -6.764931,"x": -79.8437499758428},
  {"name": "LMLM014-S // LMLM014","y": -12.052023,"x": -77.072550254025},
  {"name": "LMLM225-F","y": -12.0532735,"x": -77.0708110643452},
  {"name": "LMAT261-F","y": -12.004347,"x": -76.8384014545965},
  {"name": "LMAT262-F","y": -12.003548,"x": -76.8376073517373},
  {"name": "LMMP275-F","y": -11.976987,"x": -77.1084977821564},
  {"name": "LMAT263-F","y": -12.0079475,"x": -76.8273414427825},
  {"name": "LMAT264-F","y": -12.008999,"x": -76.8250446341108},
  {"name": "LMJR190-F","y": -12.1864845,"x": -76.9812916624125},
  {"name": "LMLC083-F","y": -12.08718,"x": -77.0414485273127},
  {"name": "LMMP273-F","y": -11.9728555,"x": -77.1039066721933},
  {"name": "LMMP274-F","y": -11.9749405,"x": -77.1061466028381},
  {"name": "LBPI015-F","y": -6.794863,"x": -79.8809832134146},
  {"name": "LMMP276-F","y": -11.979162,"x": -77.1069761946594},
  {"name": "LMMP277-F","y": -11.9777535,"x": -77.1044997304742},
  {"name": "LMMP278-F","y": -11.9754735,"x": -77.103962974444},
  {"name": "LMMP279-F","y": -11.977084,"x": -77.1015347385321},
  {"name": "LMMP280-F","y": -11.9792075,"x": -77.1028546820631},
  {"name": "LMVM095-F","y": -12.169669,"x": -76.9281716782268},
  {"name": "LMJM001","y": -12.086106,"x": -77.0600697428065},
  {"name": "LMVM096-F","y": -12.167297,"x": -76.920013064079},
  {"name": "LMVM097-F","y": -12.1682875,"x": -76.9223920514397},
  {"name": "LMVM098-F","y": -12.170809,"x": -76.9165001833333},
  {"name": "LMVM098-F","y": -12.173154,"x": -76.9169411413391},
  {"name": "LMVM099-F","y": -12.220094,"x": -76.9200340479262},
  {"name": "LMJM095-F","y": -12.0695125,"x": -77.0470112816381},
  {"name": "LMVM100-F","y": -12.2262775,"x": -76.9154839080106},
  {"name": "LMJM010","y": -12.0800725,"x": -77.0486341036271},
  {"name": "LMJM011-S // LMJM011","y": -12.0799115,"x": -77.0464045216146},
  {"name": "LBTU006-F","y": -6.744299,"x": -79.6983623966235},
  {"name": "LBTU005-F","y": -6.743976,"x": -79.7025720669145},
  {"name": "LBTU005-F","y": -6.7441025,"x": -79.7048704525881},
  {"name": "LBTU014-F","y": -6.750161,"x": -79.6961257044146},
  {"name": "LBTU002-F","y": -6.7414025,"x": -79.699256036426},
  {"name": "LBTU003-F","y": -6.7419235,"x": -79.6959000858774},
  {"name": "LBTU001-F","y": -6.7408015,"x": -79.7029636394809},
  {"name": "LBTU004-F","y": -6.7420555,"x": -79.6904372089915},
  {"name": "LMJM001","y": -12.088609,"x": -77.058624341637},
  {"name": "LMJM001","y": -12.0867965,"x": -77.0553153136059},
  {"name": "LBLO060-F","y": -6.74418,"x": -79.839940113227},
  {"name": "LBTU007-F","y": -6.746123,"x": -79.696119928953},
  {"name": "CBNV014","y": -9.1215925,"x": -78.5320667640419},
  {"name": "CBNV014","y": -9.1220405,"x": -78.5342215322767},
  {"name": "TRUJ164","y": -8.0930108,"x": -79.0379348739939},
  {"name": "LMJM001-S","y": -12.087389,"x": -77.0584172312368},
  {"name": "LBLV010-F","y": -6.7913365,"x": -79.8501153795784},
  {"name": "LBLV012-F","y": -6.811237,"x": -79.8353382997699},
  {"name": "LBLO057-F","y": -6.746673,"x": -79.8486608098073},
  {"name": "LBLO058-F","y": -6.7466295,"x": -79.845791336286},
  {"name": "CHI064","y": -6.766984,"x": -79.8392619865599},
  {"name": "LBLO059-F","y": -6.7445735,"x": -79.8432923841269},
  {"name": "CHI062-S // CHI062","y": -6.767972,"x": -79.8335197116996},
  {"name": "CHI060-S","y": -6.773587,"x": -79.8416637417655},
  {"name": "CHI060","y": -6.7738505,"x": -79.8408720097164},
  {"name": "CHI060","y": -6.773987,"x": -79.8427281759178},
  {"name": "CHI065-S","y": -6.7639345,"x": -79.8383810126841},
  {"name": "CHI065","y": -6.76346,"x": -79.8400753097484},
  {"name": "CHI070-S","y": -6.746321,"x": -79.8323915470459},
  {"name": "CHI070","y": -6.7446315,"x": -79.8322377689636},
  {"name": "CHI070","y": -6.746139,"x": -79.8346022982288},
  {"name": "CHI070","y": -6.746566,"x": -79.8327607606374},
  {"name": "CHI052-S","y": -6.764944,"x": -79.8393625883758},
  {"name": "CHI052-S","y": -6.766465,"x": -79.8412713396389},
  {"name": "CHI052-S","y": -6.7636935,"x": -79.8408479633957},
  {"name": "ICAX065","y": -14.038524,"x": -75.7356296441678},
  {"name": "ICAX064","y": -14.0419815,"x": -75.734958938768},
  {"name": "LMJL257-F","y": -11.986357,"x": -76.997381297471},
  {"name": "LMVM086-F","y": -12.210767,"x": -76.9120775551181},
  {"name": "LMHU040-F","y": -11.1304335,"x": -77.6151717040631},
  {"name": "LMJL251-F","y": -11.980124,"x": -76.9836435592758},
  {"name": "LMJL252-F","y": -11.9811315,"x": -76.9795505472142},
  {"name": "LMJL253-F","y": -11.97863,"x": -76.9940583488513},
  {"name": "LMJL255-F","y": -11.980809,"x": -76.9950516681906},
  {"name": "LMJL256-F","y": -11.9830235,"x": -76.9977304731535},
  {"name": "LMJL258-F","y": -11.983109,"x": -77.002957309126},
  {"name": "LMJL259-F","y": -11.9793265,"x": -77.0075729422698},
  {"name": "LMJL261-F","y": -11.9848945,"x": -77.0170921721082},
  {"name": "LMJL264-F","y": -11.988008,"x": -77.0163033930484},
  {"name": "LMJM094-F","y": -12.0685255,"x": -77.0464136882048},
  {"name": "LMVS189-F","y": -12.237822,"x": -76.9227007320576},
  {"name": "LMJR188-F","y": -12.1406625,"x": -76.9737439888337},
  {"name": "LMAT266-F","y": -12.0105855,"x": -76.8274775107123},
  {"name": "LMAT267-F","y": -12.011825,"x": -76.8250358373576},
  {"name": "LMAT268-F","y": -12.0150265,"x": -76.8246426145725},
  {"name": "LMAT271-F","y": -12.020393,"x": -76.8232003333333},
  {"name": "LMAT272-F","y": -12.0221715,"x": -76.8214044756567},
  {"name": "LMJM096-F","y": -12.0708745,"x": -77.0450369205801},
  {"name": "LMVS187-F","y": -12.2327875,"x": -76.9198838367728},
  {"name": "LMAT270-F","y": -12.018418,"x": -76.8224943796981},
  {"name": "LMAT265-F","y": -12.0099005,"x": -76.8235551025842},
  {"name": "CHI092-S // CHI092","y": -6.790573,"x": -79.8338555503872},
  {"name": "CHI090","y": -6.787059,"x": -79.8373811741313},
  {"name": "LLFM014-F","y": -8.0801625,"x": -79.0169787285185},
  {"name": "LMAT269-F","y": -12.016569,"x": -76.822621687827},
  {"name": "CHI068-S","y": -6.767352,"x": -79.8547308100447},
  {"name": "CHI068","y": -6.7689025,"x": -79.851638704918},
  {"name": "CHI068","y": -6.766941,"x": -79.8563437349016},
  {"name": "CHI075-S // CHI075","y": -6.765602,"x": -79.8644038056588},
  {"name": "CHI091-S","y": -6.786785,"x": -79.8339323856775},
  {"name": "CHI093-S","y": -6.791159,"x": -79.8431465545302},
  {"name": "CHI093","y": -6.7884625,"x": -79.844551908801},
  {"name": "CHI093","y": -6.7898145,"x": -79.8448945722905},
  {"name": "CHI094-S","y": -6.7928605,"x": -79.8450135415945},
  {"name": "CHI094","y": -6.7927695,"x": -79.846482832425},
  {"name": "CHI094","y": -6.7911485,"x": -79.846115294279},
  {"name": "CHI094","y": -6.790053,"x": -79.8470777015318},
  {"name": "LBPI020-F","y": -6.83624,"x": -79.9315086815425},
  {"name": "LBPI015-F","y": -6.7945635,"x": -79.8829125848446},
  {"name": "LBPI021-F","y": -6.839543,"x": -79.9337258661615},
  {"name": "LBPI018-F","y": -6.83135,"x": -79.9190592919227},
  {"name": "LBPI019-F","y": -6.8431475,"x": -79.9357423637954},
  {"name": "CHI066-S","y": -6.770085,"x": -79.8668233896161},
  {"name": "CHI066-S","y": -6.768243,"x": -79.8670706582832},
  {"name": "CHI066","y": -6.7709505,"x": -79.867521732529},
  {"name": "CHI066","y": -6.7662145,"x": -79.8673279494042},
  {"name": "LMBV032-F","y": -12.0621625,"x": -77.132411935472},
  {"name": "ZONA SATURADA","y": -12.061327,"x": -77.1306807806423},
  {"name": "LMBV033-F","y": -12.065353,"x": -77.1326607295495},
  {"name": "HCHC017","y": -9.921019,"x": -76.2388808473575},
  {"name": "LMHU005-S // LMHU005","y": -11.1188795,"x": -77.6059304376938},
  {"name": "LMHU005-S // LMHU005","y": -11.11508685,"x": -77.6059128772632},
  {"name": "LMHU009-S // LMHU009","y": -11.1118217,"x": -77.6039408235564},
  {"name": "LLEP023-F","y": -8.075485,"x": -79.0195547404488},
  {"name": "LLFM015-F","y": -8.077233,"x": -79.0166610996818},
  {"name": "LLFM016-F","y": -8.075077,"x": -79.0155718594638},
  {"name": "LMSC364-F","y": -12.1606645,"x": -76.9884959763246},
  {"name": "AQHU019-S // AQHU019","y": -16.437973,"x": -71.5598526974093},
  {"name": "ZONA SATURADA","y": -12.1605165,"x": -76.9874953683842},
  {"name": "LLEP021-F","y": -8.076844,"x": -79.0273128580893},
  {"name": "CHPI010","y": -6.80881405,"x": -79.9107766050281},
  {"name": "LBPI017-F","y": -6.8091585,"x": -79.9129774706222},
  {"name": "LBPI017-F","y": -6.8121555,"x": -79.9116690687669},
  {"name": "LBRQ002-F","y": -6.8684385,"x": -79.8155334124535},
  {"name": "LBRQ003-F","y": -6.8634565,"x": -79.8189124790541},
  {"name": "LBRQ004-F","y": -6.8672755,"x": -79.8191530354251},
  {"name": "CHI083-S // CHI083","y": -6.777455,"x": -79.8309187268024},
  {"name": "LBRQ001-F","y": -6.863013,"x": -79.8162700904984},
  {"name": "CHI084-S // CHI084","y": -6.775128,"x": -79.8346209044586},
  {"name": "CHI082-S // CHI082","y": -6.7716055,"x": -79.8302414653795},
  {"name": "CHI081-S // CHI081","y": -6.7725235,"x": -79.8350830201118},
  {"name": "CHI083-S // CHI083","y": -6.77402165,"x": -79.8319252307253},
  {"name": "CHI083-S // CHI083","y": -6.772938,"x": -79.8329094327891},
  {"name": "CHI083-S // CHI083","y": -6.77547335,"x": -79.832337071583},
  {"name": "LMAG020-F","y": -12.042678,"x": -77.002937311284},
  {"name": "LBPI012-F","y": -6.783364,"x": -79.886242516129},
  {"name": "LBPI013-F","y": -6.782465,"x": -79.8837159095637},
  {"name": "LBPI014-F","y": -6.790473,"x": -79.8879089930859},
  {"name": "LBPI015-F","y": -6.796771,"x": -79.8811415612128},
  {"name": "LBPI009-F","y": -6.777277,"x": -79.8883608712562},
  {"name": "LBPI016-F","y": -6.795644,"x": -79.888095525},
  {"name": "LBPI010-F","y": -6.77966,"x": -79.8888522077236},
  {"name": "CBCB003","y": -9.0838455,"x": -78.5738735831497},
  {"name": "LMMP268-F","y": -11.962457,"x": -77.1033439983193},
  {"name": "LBPI011-F","y": -6.7802125,"x": -79.8858529172808},
  {"name": "LMLO055-S // LMLO055","y": -11.976403,"x": -77.0790287369462},
  {"name": "HUPI001-F","y": -9.378111,"x": -74.9652104733422},
  {"name": "HUPI002-F","y": -9.378775,"x": -74.95977824604},
  {"name": "HUPI003-F","y": -9.3872365,"x": -74.9634715007673},
  {"name": "LMJM030","y": -12.0897725,"x": -77.0526655845584},
  {"name": "LMMP261-F","y": -11.965546,"x": -77.0990600928307},
  {"name": "LMJL262-F","y": -11.9879755,"x": -77.020045781708},
  {"name": "LMJL263-F","y": -11.987957,"x": -77.0182511102129},
  {"name": "LMMP264-F","y": -11.970555,"x": -77.0935133848449},
  {"name": "LMJL265-F","y": -11.9935525,"x": -77.0017028172363},
  {"name": "LMMP267-F","y": -11.9657345,"x": -77.1025968099878},
  {"name": "AQSA049-F","y": -16.373175,"x": -71.5253651063988},
  {"name": "LMMP269-F","y": -11.964473,"x": -77.1053063090413},
  {"name": "LMMP270-F","y": -11.9656015,"x": -77.1090779019404},
  {"name": "LMMP272-F","y": -11.968746,"x": -77.1041771301909},
  {"name": "LMVT065-F","y": -11.8995145,"x": -77.1273654792691},
  {"name": "LMVT066-F","y": -11.8967105,"x": -77.1265995251449},
  {"name": "LMVT067-F","y": -11.877679,"x": -77.1307028282724},
  {"name": "LMMP265-F","y": -11.970563,"x": -77.1014651307935},
  {"name": "LMVT068-F","y": -11.8669325,"x": -77.1153158769531},
  {"name": "LMVT069-F","y": -11.864498,"x": -77.1138394143209},
  {"name": "LMVS185-F","y": -12.231141,"x": -76.9208795849069},
  {"name": "LMJL254-F","y": -11.9844565,"x": -76.9939054861493},
  {"name": "LMJL266-F","y": -11.995248,"x": -77.0001876860252},
  {"name": "LMJL260-F","y": -11.981686,"x": -77.0098305345912},
  {"name": "LMMP262-F","y": -11.966448,"x": -77.097028592443},
  {"name": "LMVS184-F","y": -12.232506,"x": -76.9235664620125},
  {"name": "LMVS186-F","y": -12.2342445,"x": -76.9223299427517},
  {"name": "AQCC149-F","y": -16.3281965,"x": -71.5946569400207},
  {"name": "AQSA043-F","y": -16.3630325,"x": -71.5270447126042},
  {"name": "AQSA045-F","y": -16.35764,"x": -71.5170534221182},
  {"name": "AQSA046-F","y": -16.352761,"x": -71.511380257324},
  {"name": "LBLB012-F","y": -6.7034375,"x": -79.8946317483812},
  {"name": "LBLB012-F","y": -6.7055895,"x": -79.8958043114641},
  {"name": "LBLB013-F","y": -6.6957295,"x": -79.9025930194672},
  {"name": "LBLB013-F","y": -6.6952635,"x": -79.9007356672026},
  {"name": "LBLB014-F","y": -6.695959,"x": -79.9042869370739},
  {"name": "LBLB014-F","y": -6.6948135,"x": -79.9051311178562},
  {"name": "LBLB015-F","y": -6.699297,"x": -79.9158387249181},
  {"name": "LBLB016-F","y": -6.70386,"x": -79.9164628181818},
  {"name": "LBLB017-F","y": -6.7059255,"x": -79.9165588935002},
  {"name": "LBLB018-F","y": -6.708424,"x": -79.9166813824841},
  {"name": "LBET001-F","y": -6.909279,"x": -79.8676217549669},
  {"name": "LBET002-F","y": -6.905695,"x": -79.8666674271089},
  {"name": "LBET004-F","y": -6.9068315,"x": -79.8635967989503},
  {"name": "LBET007-F","y": -6.90955,"x": -79.8587575},
  {"name": "LBET007-F","y": -6.907508,"x": -79.8593711020206},
  {"name": "LBLB011-F","y": -6.703628,"x": -79.893317829804},
  {"name": "LBLB011-F","y": -6.704172,"x": -79.8920182741331},
  {"name": "AQYU010-F","y": -16.303595,"x": -71.6245261747409},
  {"name": "AQMF030-F","y": -16.38358,"x": -71.5078528683308},
  {"name": "AQMF031-F","y": -16.381196,"x": -71.5057052611418},
  {"name": "AQYU008-F","y": -16.29891,"x": -71.6224274519802},
  {"name": "AQYA025-F","y": -16.3930545,"x": -71.5572030568182},
  {"name": "AQYU007-F","y": -16.295036,"x": -71.6255524177456},
  {"name": "AQYU009-F","y": -16.299727,"x": -71.6280700739857},
  {"name": "LLTR025-F","y": -8.102171,"x": -79.0131076320256},
  {"name": "TRUJ107-S // TRUJ107","y": -8.1074485,"x": -79.0136976474185},
  {"name": "LLTR024-F","y": -8.099947,"x": -79.0154252438993},
  {"name": "LLTR026-F","y": -8.1054985,"x": -79.0116170808058},
  {"name": "LLTR027-F","y": -8.1024275,"x": -79.0100763697917},
  {"name": "AYAY023-S // AYAY023","y": -13.160461,"x": -74.235394913556},
  {"name": "APAN001-F","y": -13.533677,"x": -73.6844884148403},
  {"name": "APAN002-F","y": -13.5294495,"x": -73.6772037665095},
  {"name": "APAN003-F","y": -13.534127,"x": -73.6772103064516},
  {"name": "APAN004-F","y": -13.5317555,"x": -73.673903392408},
  {"name": "AQSB053-F","y": -16.4443517373803,"x": -71.5283644493938},
  {"name": "ICPC012-F","y": -13.714545,"x": -76.2017290783695},
  {"name": "LMJM033-S // LMJM033","y": -12.091639,"x": -77.0538603437203},
  {"name": "APCU006-F","y": -13.546387,"x": -72.6943969125656},
  {"name": "APCU005-F","y": -13.5442775,"x": -72.6985907424812},
  {"name": "APCU004-F","y": -13.5421555,"x": -72.6956961915635},
  {"name": "APCU003-F","y": -13.539238,"x": -72.6958594220604},
  {"name": "APCU002-F","y": -13.538768,"x": -72.6994358124333},
  {"name": "LMCS029-F","y": -11.985816,"x": -76.8318974608225},
  {"name": "APCU001-F","y": -13.535423,"x": -72.6967658642769},
  {"name": "SMTC001-F","y": -8.186298,"x": -76.524425557783},
  {"name": "SMTC002-F","y": -8.1847855,"x": -76.5183711722912},
  {"name": "LBET006-F","y": -6.91161365,"x": -79.8639761073555},
  {"name": "LBMR001-F","y": -6.5397135,"x": -80.0147573788136},
  {"name": "LBMR002-F","y": -6.5392005,"x": -80.0117400674506},
  {"name": "LMCA200-F","y": -11.9420615,"x": -77.1345657522067},
  {"name": "LMCH177-F","y": -12.2049205,"x": -77.0250839954674},
  {"name": "LMCH178-F","y": -12.1758455,"x": -77.0005039212213},
  {"name": "LMCS030-F","y": -11.9883235,"x": -76.8351562791511},
  {"name": "LMCS031-F","y": -11.9837875,"x": -76.8323750738162},
  {"name": "LMVS194-F","y": -12.2410835,"x": -76.9199565222922},
  {"name": "LMVS197-F","y": -12.2434905,"x": -76.917368161635},
  {"name": "LMMP271-F","y": -11.9675285,"x": -77.1068365808587},
  {"name": "LMSC504-F","y": -12.127353,"x": -76.9694708015635},
  {"name": "LMVS198-F","y": -12.2417435,"x": -76.9150543873758},
  {"name": "LMCH086-F","y": -12.172255,"x": -76.9979312632424},
  {"name": "LMCA197-F","y": -11.940203,"x": -77.1348680347752},
  {"name": "LMCA198-F","y": -11.940204,"x": -77.1331781350549},
  {"name": "LMCA199-F","y": -11.9399025,"x": -77.1320227910773},
  {"name": "LMVS203-F","y": -12.2345075,"x": -76.9424373851719},
  {"name": "LMCS036-F","y": -12.017782,"x": -76.9442129344189},
  {"name": "LMCS037-F","y": -12.0188895,"x": -76.9368872447274},
  {"name": "LMPH014-F","y": -12.321092,"x": -76.8287935922181},
  {"name": "LMVM101-F","y": -12.170333,"x": -76.9490939987161},
  {"name": "LMVS206-F","y": -12.235938,"x": -76.9378617741713},
  {"name": "LMVS205-F","y": -12.236518,"x": -76.9412115783784},
  {"name": "LMVS204-F","y": -12.2336945,"x": -76.9402370830123},
  {"name": "LMPH015-F","y": -12.314767,"x": -76.8341163732052},
  {"name": "LMMP266-F","y": -11.968246,"x": -77.1003512982379},
  {"name": "LMJR196-F","y": -12.136267,"x": -76.9735722727273},
  {"name": "LMCH176-F","y": -12.2032985,"x": -77.0257608387097},
  {"name": "LLCG003-F","y": -7.7396988,"x": -79.190811738815},
  {"name": "LMJR197-F","y": -12.139099,"x": -76.9730888152149},
  {"name": "LMJR198-F","y": -12.142076,"x": -76.9781205350779},
  {"name": "LMJR199-F","y": -12.145621,"x": -76.9781554615824},
  {"name": "LMCA201-F","y": -11.9441425,"x": -77.1352100508718},
  {"name": "LMCA202-F","y": -11.942081,"x": -77.1324309177092},
  {"name": "LMAT273-F","y": -12.0777185,"x": -76.9793610609518},
  {"name": "LMVS195-F","y": -12.245416,"x": -76.9213139842831},
  {"name": "LMVS199-F","y": -12.232476,"x": -76.9125400762173},
  {"name": "LMVS202-F","y": -12.2187255,"x": -76.9294080846956},
  {"name": "LMVS204-F","y": -12.233695,"x": -76.9402275559077},
  {"name": "LMVS205-F","y": -12.236518,"x": -76.9412115783784},
  {"name": "LBMR003-F","y": -6.542978,"x": -80.0150013507785},
  {"name": "LBMR004-F","y": -6.5440385,"x": -80.0124573715491},
  {"name": "AQCA052-F","y": -16.384228,"x": -71.5515782694099},
  {"name": "LLCG001-F","y": -7.7367507,"x": -79.1885910680766},
  {"name": "LLCG002-F","y": -7.7378264,"x": -79.185681093733},
  {"name": "LLCG004-F","y": -7.7411158,"x": -79.1890339082136},
  {"name": "LLCG005-F","y": -7.7421234,"x": -79.1865321654401},
  {"name": "LLCG006-F","y": -7.7432762,"x": -79.1940104726506},
  {"name": "LLCG007-F","y": -7.74377675,"x": -79.1914394945658},
  {"name": "LLCG008-F","y": -7.7456043,"x": -79.189208128125},
  {"name": "LLCG009-F","y": -7.7466964,"x": -79.1918521117966},
  {"name": "LMCA208-F","y": -11.9785715,"x": -77.123171858209}
]
export default dataSectores;